/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFrontPageLocale:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFrontPageLocale:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFrontPageLocale:{
			data:{
				type:"FrontPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FrontPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPrimaryLinkItem:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePrimaryLinkItem:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePrimaryLinkItem:{
			data:{
				type:"PrimaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PrimaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLinks:{
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinksOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLinks:{
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinksOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLinks:{
			data:{
				type:"FooterLinksCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLinksUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterContact:{
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterContact:{
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterContact:{
			data:{
				type:"FooterContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTitleList:{
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTitleList:{
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTitleList:{
			data:{
				type:"TitleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TitleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTitleItem:{
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTitleItem:{
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTitleItem:{
			data:{
				type:"TitleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TitleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSecondaryLinkList:{
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSecondaryLinkList:{
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSecondaryLinkList:{
			data:{
				type:"SecondaryLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SecondaryLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSecondaryLinkItem:{
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSecondaryLinkItem:{
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSecondaryLinkItem:{
			data:{
				type:"SecondaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SecondaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurant:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurant:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurant:{
			data:{
				type:"RestaurantCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantLocale:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantLocale:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantLocale:{
			data:{
				type:"RestaurantLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantItem:{
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantItem:{
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantItem:{
			data:{
				type:"RestaurantItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantTag:{
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantTag:{
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantTag:{
			data:{
				type:"RestaurantTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantTagLocale:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantTagLocale:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantTagLocale:{
			data:{
				type:"RestaurantTagLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantTagLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBanner:{
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBanner:{
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBanner:{
			data:{
				type:"BannerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BannerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBannerLocale:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBannerLocale:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBannerLocale:{
			data:{
				type:"BannerLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BannerLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCategoryLocale:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategoryLocale:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCategoryLocale:{
			data:{
				type:"CategoryLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CategoryLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubRestaurantsPage:{
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubRestaurantsPage:{
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubRestaurantsPage:{
			data:{
				type:"SubRestaurantsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubRestaurantsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubRestaurantsPageLocale:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubRestaurantsPageLocale:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubRestaurantsPageLocale:{
			data:{
				type:"SubRestaurantsPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubRestaurantsPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	FrontPage:{
		locales:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		banner:{
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"FrontPageLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"FrontPageLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"FrontPageLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UUID: "String",
	One: "enum",
	FrontPageLocale:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		root:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Linkable:{
		frontPage:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subRestaurantsPage:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FrontPageLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FrontPageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FrontPageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FrontPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"FrontPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPage:{
			type:"SubRestaurantsPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SubRestaurantsPageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SubRestaurantsPageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SubRestaurantsPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SubRestaurantsPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		parentRestaurant:{
			type:"RestaurantWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SubRestaurantsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SubRestaurantsPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SubRestaurantsPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"CategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RestaurantWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RestaurantWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RestaurantWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RestaurantLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RestaurantLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RestaurantLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"FrontPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		headers:{
			type:"HeaderLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		footers:{
			type:"FooterLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurantTags:{
			type:"RestaurantTagLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		banners:{
			type:"BannerLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"CategoryLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPages:{
			type:"SubRestaurantsPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		menuButtonText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"PrimaryLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryLinks:{
			type:"SecondaryLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		navigationLogo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OneCondition:{
		and:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SocialLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkTypeCondition:{
		and:{
			type:"SocialLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"SocialLinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"SocialLinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"SocialLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"SocialLinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkType: "enum",
	PrimaryLinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		header:{
			type:"HeaderLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PrimaryLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PrimaryLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PrimaryLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	SecondaryLinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SecondaryLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SecondaryLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SecondaryLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SecondaryLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		iconType:{
			type:"IconTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SecondaryLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SecondaryLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SecondaryLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SecondaryLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconTypeCondition:{
		and:{
			type:"IconTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IconTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IconTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"IconType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"IconType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IconType: "enum",
	FooterLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLinksWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterContactWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttonsTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkList:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleList:{
			type:"TitleListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterLinksWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterLinksWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterLinksWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"TitleItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TitleListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TitleListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TitleListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TitleListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TitleItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TitleItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TitleItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationNumber:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		valueAddedTaxNumber:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		bussinessRegister:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterContactWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterContactWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterContactWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RestaurantTagLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RestaurantTagLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RestaurantTagLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantTagLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundColor:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RestaurantTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RestaurantTagWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RestaurantTagWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BannerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BannerLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BannerLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BannerLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BannerLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		textColor:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BannerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BannerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BannerWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"CategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CategoryLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CategoryLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CategoryLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"CategoryLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"CategoryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"CategoryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"CategoryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BooleanCondition:{
		and:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"RestaurantWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurant:{
			type:"RestaurantWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RestaurantItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RestaurantItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RestaurantItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FrontPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		banner:{
			type:"BannerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FrontPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FrontPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FrontPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocale:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		root:{
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SubRestaurantsPage:{
		locales:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		parentRestaurant:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"SubRestaurantsPageLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"SubRestaurantsPageLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"SubRestaurantsPageLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SubRestaurantsPageLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	LinkableOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"FrontPageLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPage:{
			type:"SubRestaurantsPageLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		banner:{
			type:"BannerOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		textColor:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		parentRestaurant:{
			type:"RestaurantOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantItemOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"RestaurantOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurant:{
			type:"RestaurantOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Restaurant:{
		locales:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subItems:{
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		item:{
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		tags:{
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		categories:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"RestaurantLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subItemsByRestaurant:{
			by:{
				type:"RestaurantSubItemsByRestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubItems:{
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTags:{
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategories:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	RestaurantLocale:{
		root:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Locale:{
		frontPages:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headers:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		footers:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		restaurants:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		restaurantTags:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		banners:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		categories:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subRestaurantsPages:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		frontPagesByRoot:{
			by:{
				type:"LocaleFrontPagesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		frontPagesByLink:{
			by:{
				type:"LocaleFrontPagesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		frontPagesBySeo:{
			by:{
				type:"LocaleFrontPagesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headersByRoot:{
			by:{
				type:"LocaleHeadersByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headersBySocialLinks:{
			by:{
				type:"LocaleHeadersBySocialLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headersByPrimaryLinkItems:{
			by:{
				type:"LocaleHeadersByPrimaryLinkItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headersBySecondaryLinks:{
			by:{
				type:"LocaleHeadersBySecondaryLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		footersByRoot:{
			by:{
				type:"LocaleFootersByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		footersByLinksSection:{
			by:{
				type:"LocaleFootersByLinksSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		footersByContactSection:{
			by:{
				type:"LocaleFootersByContactSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		restaurantsByRoot:{
			by:{
				type:"LocaleRestaurantsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		restaurantTagsByRoot:{
			by:{
				type:"LocaleRestaurantTagsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		bannersByRoot:{
			by:{
				type:"LocaleBannersByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		categoriesByRoot:{
			by:{
				type:"LocaleCategoriesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		categoriesBySlug:{
			by:{
				type:"LocaleCategoriesBySlugUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subRestaurantsPagesByRoot:{
			by:{
				type:"LocaleSubRestaurantsPagesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subRestaurantsPagesByLink:{
			by:{
				type:"LocaleSubRestaurantsPagesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subRestaurantsPagesBySeo:{
			by:{
				type:"LocaleSubRestaurantsPagesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFrontPages:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaders:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooters:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurants:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantTags:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBanners:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategories:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubRestaurantsPages:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLocale:{
		root:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialLinks:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		primaryLinkItems:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		secondaryLinks:{
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		primaryLinkItemsByLink:{
			by:{
				type:"HeaderLocalePrimaryLinkItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		primaryLinkItemsBySubItems:{
			by:{
				type:"HeaderLocalePrimaryLinkItemsBySubItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePrimaryLinkItems:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Header:{
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locales:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		navigationLogo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"HeaderLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySocialLinks:{
			by:{
				type:"HeaderLocalesBySocialLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByPrimaryLinkItems:{
			by:{
				type:"HeaderLocalesByPrimaryLinkItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySecondaryLinks:{
			by:{
				type:"HeaderLocalesBySecondaryLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		menuButtonText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryLinks:{
			type:"SecondaryLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		navigationLogo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		headers:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		footers:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurantTags:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		banners:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPages:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		banner:{
			type:"BannerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BannerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPage:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		parentRestaurant:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurant:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryLinks:{
			type:"SecondaryLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SecondaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLinksUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkList:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleList:{
			type:"TitleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"TitleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalesBySocialLinksUniqueWhere:{
		socialLinks:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalesByPrimaryLinkItemsUniqueWhere:{
		primaryLinkItems:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalesBySecondaryLinksUniqueWhere:{
		secondaryLinks:{
			type:"SecondaryLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkList:{
		items:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsBySocialLink:{
			by:{
				type:"SocialLinkListItemsBySocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkItem:{
		list:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListItemsBySocialLinkUniqueWhere:{
		socialLink:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItem:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		parent:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subItems:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		header:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subItemsByLink:{
			by:{
				type:"PrimaryLinkItemSubItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subItemsBySubItems:{
			by:{
				type:"PrimaryLinkItemSubItemsBySubItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubItems:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Link:{
		internalLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PrimaryLinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		header:{
			type:"HeaderLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemSubItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemSubItemsBySubItemsUniqueWhere:{
		subItems:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkList:{
		items:{
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByLink:{
			by:{
				type:"SecondaryLinkListItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SecondaryLinkItem:{
		list:{
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SecondaryLinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		iconType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SecondaryLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalePrimaryLinkItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalePrimaryLinkItemsBySubItemsUniqueWhere:{
		subItems:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocale:{
		root:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		linksSection:{
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactSection:{
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Footer:{
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locales:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"FooterLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLinksSection:{
			by:{
				type:"FooterLocalesByLinksSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByContactSection:{
			by:{
				type:"FooterLocalesByContactSectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLinksOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterContactOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttonsTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkList:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleList:{
			type:"TitleListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationNumber:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		valueAddedTaxNumber:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		bussinessRegister:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocalesByLinksSectionUniqueWhere:{
		linksSection:{
			type:"FooterLinksUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocalesByContactSectionUniqueWhere:{
		contactSection:{
			type:"FooterContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinks:{
		linkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		buttons:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		titleList:{
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkList:{
		items:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByLink:{
			by:{
				type:"LinkListItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkItem:{
		list:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		icon:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleList:{
		items:{
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TitleItem:{
		list:{
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		icon:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TitleItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TitleListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContact:{
		phoneImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	RestaurantLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocale:{
		root:{
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	RestaurantTag:{
		locales:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		restaurants:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"RestaurantTagLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurants:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	RestaurantTagLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantTagOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundColor:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocale:{
		root:{
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Banner:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locales:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"BannerLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BannerLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BannerOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocale:{
		root:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Category:{
		locales:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		restaurants:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"CategoryLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySlug:{
			by:{
				type:"CategoryLocalesBySlugUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurants:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	CategoryLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"CategoryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocalesBySlugUniqueWhere:{
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFrontPagesByRootUniqueWhere:{
		root:{
			type:"FrontPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFrontPagesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFrontPagesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHeadersByRootUniqueWhere:{
		root:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHeadersBySocialLinksUniqueWhere:{
		socialLinks:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHeadersByPrimaryLinkItemsUniqueWhere:{
		primaryLinkItems:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHeadersBySecondaryLinksUniqueWhere:{
		secondaryLinks:{
			type:"SecondaryLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFootersByRootUniqueWhere:{
		root:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFootersByLinksSectionUniqueWhere:{
		linksSection:{
			type:"FooterLinksUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFootersByContactSectionUniqueWhere:{
		contactSection:{
			type:"FooterContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleRestaurantsByRootUniqueWhere:{
		root:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleRestaurantTagsByRootUniqueWhere:{
		root:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleBannersByRootUniqueWhere:{
		root:{
			type:"BannerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCategoriesByRootUniqueWhere:{
		root:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCategoriesBySlugUniqueWhere:{
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleSubRestaurantsPagesByRootUniqueWhere:{
		root:{
			type:"SubRestaurantsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleSubRestaurantsPagesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleSubRestaurantsPagesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItem:{
		parent:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		restaurant:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	RestaurantLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantSubItemsByRestaurantUniqueWhere:{
		restaurant:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Seo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FrontPageLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FrontPageCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banner:{
			type:"FrontPageCreateBannerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateLocalesEntityRelationInput:{
		connect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FrontPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutFrontPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutFrontPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPage:{
			type:"LinkableCreateSubRestaurantsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateSubRestaurantsPageEntityRelationInput:{
		connect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SubRestaurantsPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"SubRestaurantsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		parentRestaurant:{
			type:"SubRestaurantsPageCreateParentRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageCreateParentRestaurantEntityRelationInput:{
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantCreateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantCreateLocalesEntityRelationInput:{
		connect:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutRestaurantsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateFrontPagesEntityRelationInput:{
		connect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"FrontPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		banner:{
			type:"FrontPageCreateBannerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageCreateBannerEntityRelationInput:{
		connect:{
			type:"BannerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"BannerCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BannerCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		textColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerCreateLocalesEntityRelationInput:{
		connect:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BannerLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutBannersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutBannersCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateHeadersEntityRelationInput:{
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleCreateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		secondaryLinks:{
			type:"HeaderLocaleCreateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		navigationLogo:{
			type:"HeaderCreateNavigationLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateNavigationLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateSocialLinksEntityRelationInput:{
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemCreateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateSocialLinkEntityRelationInput:{
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput:{
		connect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrimaryLinkItemWithoutHeaderCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemWithoutHeaderCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemCreateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkCreateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPage:{
			type:"LinkableCreateSubRestaurantsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateFrontPageEntityRelationInput:{
		connect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FrontPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutFrontPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutFrontPagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateFootersEntityRelationInput:{
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLocaleCreateLinksSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterLocaleCreateContactSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateLinksSectionEntityRelationInput:{
		connect:{
			type:"FooterLinksUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLinksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttonsTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkList:{
			type:"FooterLinksCreateLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"FooterLinksCreateButtonsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleList:{
			type:"FooterLinksCreateTitleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksCreateLinkListEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"LinkItemCreateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateIconEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksCreateButtonsEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksCreateTitleListEntityRelationInput:{
		connect:{
			type:"TitleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TitleListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"TitleListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListCreateItemsEntityRelationInput:{
		connect:{
			type:"TitleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TitleItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"TitleItemCreateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemCreateIconEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateContactSectionEntityRelationInput:{
		connect:{
			type:"FooterContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		valueAddedTaxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		bussinessRegister:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneImage:{
			type:"FooterContactCreatePhoneImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactCreatePhoneImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateRestaurantsEntityRelationInput:{
		connect:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"RestaurantCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantCreateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantCreateSubItemsEntityRelationInput:{
		connect:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantItemWithoutParentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemWithoutParentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurant:{
			type:"RestaurantItemCreateRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemCreateRestaurantEntityRelationInput:{
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutItemCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantCreateTagsEntityRelationInput:{
		connect:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagWithoutRestaurantsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantTagCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagCreateLocalesEntityRelationInput:{
		connect:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantTagLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutRestaurantTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutRestaurantTagsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateBannersEntityRelationInput:{
		connect:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BannerLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"BannerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"BannerCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		textColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateCategoriesEntityRelationInput:{
		connect:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"CategoryLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"CategoryCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryCreateRestaurantsEntityRelationInput:{
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutCategoriesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantCreateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantCreateItemEntityRelationInput:{
		connect:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantItemWithoutRestaurantCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemWithoutRestaurantCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"RestaurantItemCreateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemCreateParentEntityRelationInput:{
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutSubItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutSubItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantCreateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantCreateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantCreateCategoriesEntityRelationInput:{
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutRestaurantsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"CategoryCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryCreateLocalesEntityRelationInput:{
		connect:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"CategoryLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutCategoriesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateRestaurantTagsEntityRelationInput:{
		connect:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantTagLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantTagCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagCreateRestaurantsEntityRelationInput:{
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutTagsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantCreateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"RestaurantCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateSubRestaurantsPagesEntityRelationInput:{
		connect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SubRestaurantsPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutSubRestaurantsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutSubRestaurantsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableCreateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemCreateParentEntityRelationInput:{
		connect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrimaryLinkItemWithoutSubItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemWithoutSubItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemCreateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		header:{
			type:"PrimaryLinkItemCreateHeaderEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemCreateHeaderEntityRelationInput:{
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutPrimaryLinkItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutPrimaryLinkItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleCreateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryLinks:{
			type:"HeaderLocaleCreateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutHeadersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutHeadersCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateSecondaryLinksEntityRelationInput:{
		connect:{
			type:"SecondaryLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SecondaryLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SecondaryLinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"SecondaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SecondaryLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iconType:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SecondaryLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemCreateSubItemsEntityRelationInput:{
		connect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrimaryLinkItemWithoutParentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemWithoutParentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		header:{
			type:"PrimaryLinkItemCreateHeaderEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutSubRestaurantsPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutSubRestaurantsPagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FrontPageUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banner:{
			type:"FrontPageUpdateBannerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateLocalesEntityRelationInput:{
		create:{
			type:"FrontPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FrontPageUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateLocalesRelationInput:{
		by:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FrontPageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FrontPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutFrontPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutFrontPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutFrontPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPage:{
			type:"LinkableUpdateSubRestaurantsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateSubRestaurantsPageEntityRelationInput:{
		create:{
			type:"SubRestaurantsPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubRestaurantsPageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertSubRestaurantsPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"SubRestaurantsPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubRestaurantsPageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubRestaurantsPageLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubRestaurantsPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		parentRestaurant:{
			type:"SubRestaurantsPageUpdateParentRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageUpdateParentRestaurantEntityRelationInput:{
		create:{
			type:"RestaurantCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubRestaurantsPageUpsertParentRestaurantRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateInput:{
		locales:{
			type:"RestaurantUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantUpdateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateLocalesEntityRelationInput:{
		create:{
			type:"RestaurantLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateLocalesRelationInput:{
		by:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutRestaurantsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutRestaurantsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateFrontPagesEntityRelationInput:{
		create:{
			type:"FrontPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateFrontPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertFrontPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateFrontPagesRelationInput:{
		by:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FrontPageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"FrontPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FrontPageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FrontPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		banner:{
			type:"FrontPageUpdateBannerEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpdateBannerEntityRelationInput:{
		create:{
			type:"BannerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BannerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageUpsertBannerRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BannerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerUpdateInput:{
		image:{
			type:"BannerUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"BannerUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		textColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BannerUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		fileName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerUpdateLocalesEntityRelationInput:{
		create:{
			type:"BannerLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BannerUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BannerUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerUpdateLocalesRelationInput:{
		by:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BannerLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleWithoutRootUpdateInput:{
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BannerLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutBannersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutBannersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BannerLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutBannersUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateHeadersEntityRelationInput:{
		create:{
			type:"HeaderLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateHeadersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertHeadersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateHeadersRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HeaderLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutLocaleUpdateInput:{
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleUpdateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		secondaryLinks:{
			type:"HeaderLocaleUpdateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"HeaderWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		navigationLogo:{
			type:"HeaderUpdateNavigationLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateNavigationLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertNavigationLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertNavigationLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertRootRelationInput:{
		update:{
			type:"HeaderWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateSocialLinksEntityRelationInput:{
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertSocialLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateInput:{
		items:{
			type:"SocialLinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateItemsRelationInput:{
		by:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SocialLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemUpdateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateSocialLinkEntityRelationInput:{
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkItemUpsertSocialLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpdateInput:{
		type:{
			type:"SocialLinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpsertSocialLinkRelationInput:{
		update:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpsertItemsRelationInput:{
		by:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertSocialLinksRelationInput:{
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput:{
		create:{
			type:"PrimaryLinkItemWithoutHeaderCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLocaleUpdatePrimaryLinkItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertPrimaryLinkItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdatePrimaryLinkItemsRelationInput:{
		by:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PrimaryLinkItemWithoutHeaderUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemWithoutHeaderUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemUpdateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrimaryLinkItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkUpdateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subRestaurantsPage:{
			type:"LinkableUpdateSubRestaurantsPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateFrontPageEntityRelationInput:{
		create:{
			type:"FrontPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FrontPageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertFrontPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FrontPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutFrontPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutFrontPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutFrontPagesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateFootersEntityRelationInput:{
		create:{
			type:"FooterLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateFootersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertFootersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateFootersRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FooterLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutLocaleUpdateInput:{
		root:{
			type:"FooterLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLocaleUpdateLinksSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterLocaleUpdateContactSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"FooterWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertRootRelationInput:{
		update:{
			type:"FooterWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateLinksSectionEntityRelationInput:{
		create:{
			type:"FooterLinksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLinksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertLinksSectionRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterLinksUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUpdateInput:{
		buttonsTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkList:{
			type:"FooterLinksUpdateLinkListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		buttons:{
			type:"FooterLinksUpdateButtonsEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleList:{
			type:"FooterLinksUpdateTitleListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUpdateLinkListEntityRelationInput:{
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLinksUpsertLinkListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateInput:{
		items:{
			type:"LinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpdateItemsRelationInput:{
		by:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"LinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"LinkItemUpdateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateIconEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertIconRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertIconRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListUpsertItemsRelationInput:{
		by:{
			type:"LinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUpsertLinkListRelationInput:{
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUpdateButtonsEntityRelationInput:{
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLinksUpsertButtonsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUpsertButtonsRelationInput:{
		update:{
			type:"LinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUpdateTitleListEntityRelationInput:{
		create:{
			type:"TitleListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TitleListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLinksUpsertTitleListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TitleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListUpdateInput:{
		items:{
			type:"TitleListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListUpdateItemsEntityRelationInput:{
		create:{
			type:"TitleItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TitleListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TitleListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TitleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TitleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TitleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListUpdateItemsRelationInput:{
		by:{
			type:"TitleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TitleItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"TitleItemUpdateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemUpdateIconEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TitleItemUpsertIconRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemUpsertIconRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListUpsertItemsRelationInput:{
		by:{
			type:"TitleItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TitleItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TitleItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLinksUpsertTitleListRelationInput:{
		update:{
			type:"TitleListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TitleListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertLinksSectionRelationInput:{
		update:{
			type:"FooterLinksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLinksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateContactSectionEntityRelationInput:{
		create:{
			type:"FooterContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterContactUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertContactSectionRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactUpdateInput:{
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		valueAddedTaxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		bussinessRegister:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneImage:{
			type:"FooterContactUpdatePhoneImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactUpdatePhoneImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterContactUpsertPhoneImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterContactUpsertPhoneImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertContactSectionRelationInput:{
		update:{
			type:"FooterContactUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertFootersRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateRestaurantsEntityRelationInput:{
		create:{
			type:"RestaurantLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateRestaurantsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertRestaurantsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateRestaurantsRelationInput:{
		by:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"RestaurantWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutLocalesUpdateInput:{
		image:{
			type:"RestaurantUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantUpdateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateSubItemsEntityRelationInput:{
		create:{
			type:"RestaurantItemWithoutParentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantUpdateSubItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantUpsertSubItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateSubItemsRelationInput:{
		by:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantItemWithoutParentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemWithoutParentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurant:{
			type:"RestaurantItemUpdateRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemUpdateRestaurantEntityRelationInput:{
		create:{
			type:"RestaurantWithoutItemCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantWithoutItemUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantItemUpsertRestaurantRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutItemUpdateInput:{
		locales:{
			type:"RestaurantUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateTagsEntityRelationInput:{
		create:{
			type:"RestaurantTagWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantUpdateTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantUpsertTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateTagsRelationInput:{
		by:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantTagWithoutRestaurantsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagWithoutRestaurantsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantTagUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUpdateLocalesEntityRelationInput:{
		create:{
			type:"RestaurantTagLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantTagUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantTagUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUpdateLocalesRelationInput:{
		by:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantTagLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantTagLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutRestaurantTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutRestaurantTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantTagLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutRestaurantTagsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateBannersEntityRelationInput:{
		create:{
			type:"BannerLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateBannersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertBannersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateBannersRelationInput:{
		by:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BannerLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleWithoutLocaleUpdateInput:{
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BannerLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"BannerWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BannerWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BannerLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BannerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerWithoutLocalesUpdateInput:{
		image:{
			type:"BannerUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		textColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleUpsertRootRelationInput:{
		update:{
			type:"BannerWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertBannersRelationInput:{
		by:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BannerLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateCategoriesEntityRelationInput:{
		create:{
			type:"CategoryLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateCategoriesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertCategoriesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateCategoriesRelationInput:{
		by:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"CategoryLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"CategoryLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"CategoryWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CategoryLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"CategoryUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateRestaurantsEntityRelationInput:{
		create:{
			type:"RestaurantWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryUpdateRestaurantsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CategoryUpsertRestaurantsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateRestaurantsRelationInput:{
		by:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantWithoutCategoriesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutCategoriesUpdateInput:{
		locales:{
			type:"RestaurantUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantUpdateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateItemEntityRelationInput:{
		create:{
			type:"RestaurantItemWithoutRestaurantCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantItemWithoutRestaurantUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantUpsertItemRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemWithoutRestaurantUpdateInput:{
		parent:{
			type:"RestaurantItemUpdateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemUpdateParentEntityRelationInput:{
		create:{
			type:"RestaurantWithoutSubItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantWithoutSubItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantItemUpsertParentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutSubItemsUpdateInput:{
		locales:{
			type:"RestaurantUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantUpdateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		tags:{
			type:"RestaurantUpdateTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"RestaurantUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateCategoriesEntityRelationInput:{
		create:{
			type:"CategoryWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantUpdateCategoriesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantUpsertCategoriesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpdateCategoriesRelationInput:{
		by:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"CategoryWithoutRestaurantsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryWithoutRestaurantsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"CategoryUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateLocalesEntityRelationInput:{
		create:{
			type:"CategoryLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CategoryUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateLocalesRelationInput:{
		by:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"CategoryLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"CategoryLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutCategoriesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"CategoryLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutCategoriesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateRestaurantTagsEntityRelationInput:{
		create:{
			type:"RestaurantTagLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateRestaurantTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertRestaurantTagsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateRestaurantTagsRelationInput:{
		by:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantTagLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantTagLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"RestaurantTagWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantTagWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantTagLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		backgroundColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantTagUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUpdateRestaurantsEntityRelationInput:{
		create:{
			type:"RestaurantWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantTagUpdateRestaurantsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RestaurantTagUpsertRestaurantsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUpdateRestaurantsRelationInput:{
		by:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"RestaurantWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantWithoutTagsUpdateInput:{
		locales:{
			type:"RestaurantUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"RestaurantUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"RestaurantUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		item:{
			type:"RestaurantUpdateItemEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		categories:{
			type:"RestaurantUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUpsertRestaurantsRelationInput:{
		by:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantWithoutTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleUpsertRootRelationInput:{
		update:{
			type:"RestaurantTagWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertRestaurantTagsRelationInput:{
		by:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantTagLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateSubRestaurantsPagesEntityRelationInput:{
		create:{
			type:"SubRestaurantsPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateSubRestaurantsPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertSubRestaurantsPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateSubRestaurantsPagesRelationInput:{
		by:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SubRestaurantsPageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SubRestaurantsPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutSubRestaurantsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutSubRestaurantsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubRestaurantsPageLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutSubRestaurantsPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPage:{
			type:"LinkableUpdateFrontPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutSubRestaurantsPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutSubRestaurantsPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubRestaurantsPageLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertSubRestaurantsPagesRelationInput:{
		by:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubRestaurantsPageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutCategoriesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpsertLocalesRelationInput:{
		by:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpsertCategoriesRelationInput:{
		by:{
			type:"CategoryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryWithoutRestaurantsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemUpsertParentRelationInput:{
		update:{
			type:"RestaurantWithoutSubItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutSubItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpsertItemRelationInput:{
		update:{
			type:"RestaurantItemWithoutRestaurantUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantItemWithoutRestaurantCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpsertRestaurantsRelationInput:{
		by:{
			type:"RestaurantUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantWithoutCategoriesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutCategoriesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleUpsertRootRelationInput:{
		update:{
			type:"CategoryWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertCategoriesRelationInput:{
		by:{
			type:"CategoryLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"CategoryLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"CategoryLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutRestaurantTagsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutRestaurantTagsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUpsertLocalesRelationInput:{
		by:{
			type:"RestaurantTagLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantTagLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpsertTagsRelationInput:{
		by:{
			type:"RestaurantTagUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantTagWithoutRestaurantsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantTagWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemUpsertRestaurantRelationInput:{
		update:{
			type:"RestaurantWithoutItemUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutItemCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpsertSubItemsRelationInput:{
		by:{
			type:"RestaurantItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantItemWithoutParentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantItemWithoutParentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleUpsertRootRelationInput:{
		update:{
			type:"RestaurantWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertRestaurantsRelationInput:{
		by:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutFrontPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutFrontPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FrontPageLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertFrontPageRelationInput:{
		update:{
			type:"FrontPageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpdateParentEntityRelationInput:{
		create:{
			type:"PrimaryLinkItemWithoutSubItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrimaryLinkItemWithoutSubItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrimaryLinkItemUpsertParentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemWithoutSubItemsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemUpdateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		header:{
			type:"PrimaryLinkItemUpdateHeaderEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpdateHeaderEntityRelationInput:{
		create:{
			type:"HeaderLocaleWithoutPrimaryLinkItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLocaleWithoutPrimaryLinkItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrimaryLinkItemUpsertHeaderRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutPrimaryLinkItemsUpdateInput:{
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleUpdateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryLinks:{
			type:"HeaderLocaleUpdateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutHeadersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutHeadersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutHeadersUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutHeadersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutHeadersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateSecondaryLinksEntityRelationInput:{
		create:{
			type:"SecondaryLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SecondaryLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertSecondaryLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SecondaryLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListUpdateInput:{
		items:{
			type:"SecondaryLinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"SecondaryLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SecondaryLinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SecondaryLinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SecondaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SecondaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SecondaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListUpdateItemsRelationInput:{
		by:{
			type:"SecondaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SecondaryLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iconType:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SecondaryLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SecondaryLinkItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListUpsertItemsRelationInput:{
		by:{
			type:"SecondaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SecondaryLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SecondaryLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertSecondaryLinksRelationInput:{
		update:{
			type:"SecondaryLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SecondaryLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpsertHeaderRelationInput:{
		update:{
			type:"HeaderLocaleWithoutPrimaryLinkItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutPrimaryLinkItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpsertParentRelationInput:{
		update:{
			type:"PrimaryLinkItemWithoutSubItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrimaryLinkItemWithoutSubItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpdateSubItemsEntityRelationInput:{
		create:{
			type:"PrimaryLinkItemWithoutParentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrimaryLinkItemUpdateSubItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PrimaryLinkItemUpsertSubItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpdateSubItemsRelationInput:{
		by:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PrimaryLinkItemWithoutParentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemWithoutParentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		header:{
			type:"PrimaryLinkItemUpdateHeaderEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpsertSubItemsRelationInput:{
		by:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrimaryLinkItemWithoutParentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrimaryLinkItemWithoutParentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertPrimaryLinkItemsRelationInput:{
		by:{
			type:"PrimaryLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PrimaryLinkItemWithoutHeaderUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PrimaryLinkItemWithoutHeaderCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertHeadersRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutBannersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutBannersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerUpsertLocalesRelationInput:{
		by:{
			type:"BannerLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BannerLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertBannerRelationInput:{
		update:{
			type:"BannerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BannerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpsertRootRelationInput:{
		update:{
			type:"FrontPageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertFrontPagesRelationInput:{
		by:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FrontPageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutRestaurantsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutRestaurantsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantUpsertLocalesRelationInput:{
		by:{
			type:"RestaurantLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RestaurantLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageUpsertParentRestaurantRelationInput:{
		update:{
			type:"RestaurantUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RestaurantCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpsertRootRelationInput:{
		update:{
			type:"SubRestaurantsPageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutSubRestaurantsPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutSubRestaurantsPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubRestaurantsPageLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutSubRestaurantsPagesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutSubRestaurantsPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutSubRestaurantsPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertSubRestaurantsPageRelationInput:{
		update:{
			type:"SubRestaurantsPageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutFrontPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutFrontPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageUpsertLocalesRelationInput:{
		by:{
			type:"FrontPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FrontPageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FrontPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		navigationLogo:{
			type:"HeaderCreateNavigationLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLocalesEntityRelationInput:{
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleCreateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		secondaryLinks:{
			type:"HeaderLocaleCreateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		navigationLogo:{
			type:"HeaderUpdateNavigationLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLocalesEntityRelationInput:{
		create:{
			type:"HeaderLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLocalesRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HeaderLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutRootUpdateInput:{
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleUpdateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		secondaryLinks:{
			type:"HeaderLocaleUpdateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLocalesRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FrontPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FrontPageLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"FrontPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FrontPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FrontPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"FrontPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"LinkItemCreateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemCreateListEntityRelationInput:{
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"LinkItemUpdateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpdateListEntityRelationInput:{
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkItemUpsertListRelationInput:{
		update:{
			type:"LinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemCreateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateListEntityRelationInput:{
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemUpdateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateListEntityRelationInput:{
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpsertListRelationInput:{
		update:{
			type:"SocialLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemCreateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemCreateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		header:{
			type:"PrimaryLinkItemCreateHeaderEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PrimaryLinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PrimaryLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"PrimaryLinkItemUpdateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subItems:{
			type:"PrimaryLinkItemUpdateSubItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		header:{
			type:"PrimaryLinkItemUpdateHeaderEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleCreateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		secondaryLinks:{
			type:"HeaderLocaleCreateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateInput:{
		menuButtonText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderLocaleUpdateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryLinkItems:{
			type:"HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		secondaryLinks:{
			type:"HeaderLocaleUpdateSecondaryLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLocalesEntityRelationInput:{
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FooterLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLocaleCreateLinksSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterLocaleCreateContactSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutFootersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutFootersCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleCreateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleCreateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleCreateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleCreateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleCreateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLocalesEntityRelationInput:{
		create:{
			type:"FooterLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLocalesRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FooterLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutRootUpdateInput:{
		locale:{
			type:"FooterLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLocaleUpdateLinksSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterLocaleUpdateContactSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutFootersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutFootersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutFootersUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		frontPages:{
			type:"LocaleUpdateFrontPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"LocaleUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurantTags:{
			type:"LocaleUpdateRestaurantTagsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		banners:{
			type:"LocaleUpdateBannersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		categories:{
			type:"LocaleUpdateCategoriesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		subRestaurantsPages:{
			type:"LocaleUpdateSubRestaurantsPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutFootersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutFootersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLocalesRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FooterLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLocaleCreateLinksSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterLocaleCreateContactSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateInput:{
		root:{
			type:"FooterLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FooterLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		linksSection:{
			type:"FooterLocaleUpdateLinksSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactSection:{
			type:"FooterLocaleUpdateContactSectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TitleItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"TitleItemCreateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemCreateListEntityRelationInput:{
		connect:{
			type:"TitleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TitleListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"TitleItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"TitleItemUpdateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemUpdateListEntityRelationInput:{
		create:{
			type:"TitleListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TitleListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TitleItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TitleListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TitleItemUpsertListRelationInput:{
		update:{
			type:"TitleListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TitleListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iconType:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SecondaryLinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SecondaryLinkItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemCreateListEntityRelationInput:{
		connect:{
			type:"SecondaryLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SecondaryLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		iconType:{
			type:"IconType",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SecondaryLinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SecondaryLinkItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemUpdateListEntityRelationInput:{
		create:{
			type:"SecondaryLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SecondaryLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SecondaryLinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SecondaryLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SecondaryLinkItemUpsertListRelationInput:{
		update:{
			type:"SecondaryLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SecondaryLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		location:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isEshopActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDeliveryActive:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryUrl:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomain:{
		catalogues:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		keys:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cataloguesByIdentifier:{
			by:{
				type:"TranslationDomainCataloguesByIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cataloguesByValues:{
			by:{
				type:"TranslationDomainCataloguesByValuesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		keysByIdentifier:{
			by:{
				type:"TranslationDomainKeysByIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		keysByValues:{
			by:{
				type:"TranslationDomainKeysByValuesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCatalogues:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateKeys:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationCatalogue:{
		domain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		identifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		fallback:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		values:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		valuesByKey:{
			by:{
				type:"TranslationCatalogueValuesByKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateValues:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationDomainWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationKeyWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationDomainWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationDomainWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationDomainWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCataloguesIdentifierWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationCatalogueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationCatalogueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationCataloguesIdentifierWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationCataloguesIdentifierWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationCataloguesIdentifierWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationKeyWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationValueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationValueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationValueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationKeyWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationKeyWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationKeyWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationContentTypeCondition:{
		and:{
			type:"TranslationContentTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"TranslationContentTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"TranslationContentTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"TranslationContentType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"TranslationContentType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationContentType: "enum",
	TranslationCataloguesIdentifier:{
		catalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		catalogueByDomain:{
			by:{
				type:"TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		catalogueByValues:{
			by:{
				type:"TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationCatalogueOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCataloguesIdentifierOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere:{
		domain:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere:{
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValue:{
		catalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		key:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationKey:{
		domain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		values:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		valuesByCatalogue:{
			by:{
				type:"TranslationKeyValuesByCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateValues:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationValueOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationKeyOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyValuesByCatalogueUniqueWhere:{
		catalogue:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueValuesByKeyUniqueWhere:{
		key:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCataloguesByIdentifierUniqueWhere:{
		identifier:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCataloguesByValuesUniqueWhere:{
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainKeysByIdentifierUniqueWhere:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainKeysByValuesUniqueWhere:{
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainCreateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		keys:{
			type:"TranslationDomainCreateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCreateCataloguesEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutDomainCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueCreateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateIdentifierEntityRelationInput:{
		connect:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierWithoutCatalogueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateFallbackEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationCatalogueCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueCreateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateDomainEntityRelationInput:{
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutCataloguesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutCataloguesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationDomainCreateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCreateKeysEntityRelationInput:{
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutDomainCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyCreateValuesEntityRelationInput:{
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutKeyCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutKeyCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueCreateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueCreateCatalogueEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutValuesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationCatalogueCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueCreateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateValuesEntityRelationInput:{
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutCatalogueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueCreateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueCreateKeyEntityRelationInput:{
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutValuesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyCreateDomainEntityRelationInput:{
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutKeysCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutKeysCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainCreateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainUpdateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		keys:{
			type:"TranslationDomainUpdateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateCataloguesEntityRelationInput:{
		create:{
			type:"TranslationCatalogueWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainUpdateCataloguesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationDomainUpsertCataloguesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateCataloguesRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationCatalogueWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutDomainUpdateInput:{
		identifier:{
			type:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateIdentifierEntityRelationInput:{
		create:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertIdentifierRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierWithoutCatalogueUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertIdentifierRelationInput:{
		update:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateFallbackEntityRelationInput:{
		create:{
			type:"TranslationCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertFallbackRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateInput:{
		domain:{
			type:"TranslationCatalogueUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateDomainEntityRelationInput:{
		create:{
			type:"TranslationDomainWithoutCataloguesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainWithoutCataloguesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertDomainRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutCataloguesUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationDomainUpdateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateKeysEntityRelationInput:{
		create:{
			type:"TranslationKeyWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainUpdateKeysRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationDomainUpsertKeysRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateKeysRelationInput:{
		by:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationKeyWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutDomainUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateValuesEntityRelationInput:{
		create:{
			type:"TranslationValueWithoutKeyCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationKeyUpdateValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationKeyUpsertValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationValueWithoutKeyUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutKeyUpdateInput:{
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueUpdateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpdateCatalogueEntityRelationInput:{
		create:{
			type:"TranslationCatalogueWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationValueUpsertCatalogueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutValuesUpdateInput:{
		domain:{
			type:"TranslationCatalogueUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpsertCatalogueRelationInput:{
		update:{
			type:"TranslationCatalogueWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpsertValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationValueWithoutKeyUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutKeyCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpsertKeysRelationInput:{
		by:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationKeyWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertDomainRelationInput:{
		update:{
			type:"TranslationDomainWithoutCataloguesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutCataloguesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateValuesEntityRelationInput:{
		create:{
			type:"TranslationValueWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueUpdateValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationValueWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutCatalogueUpdateInput:{
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueUpdateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpdateKeyEntityRelationInput:{
		create:{
			type:"TranslationKeyWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationKeyWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationValueUpsertKeyRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutValuesUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateDomainEntityRelationInput:{
		create:{
			type:"TranslationDomainWithoutKeysCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainWithoutKeysUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationKeyUpsertDomainRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutKeysUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainUpdateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpsertDomainRelationInput:{
		update:{
			type:"TranslationDomainWithoutKeysUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutKeysCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpsertKeyRelationInput:{
		update:{
			type:"TranslationKeyWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationValueWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertFallbackRelationInput:{
		update:{
			type:"TranslationCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpsertCataloguesRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutIdentifierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutIdentifierCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationCatalogueCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput:{
		create:{
			type:"TranslationCatalogueWithoutIdentifierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCataloguesIdentifierUpdateCatalogueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCataloguesIdentifierUpsertCatalogueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpdateCatalogueRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationCatalogueWithoutIdentifierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutIdentifierUpdateInput:{
		domain:{
			type:"TranslationCatalogueUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpsertCatalogueRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueWithoutIdentifierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutIdentifierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueCreateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueCreateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpdateInput:{
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueUpdateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueUpdateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		parent:{
			type:"RestaurantItemCreateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurant:{
			type:"RestaurantItemCreateRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantItemUpdateInput:{
		parent:{
			type:"RestaurantItemUpdateParentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurant:{
			type:"RestaurantItemUpdateRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantTagCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantTagCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"RestaurantTagUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		backgroundColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		titleColor:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		restaurants:{
			type:"RestaurantTagUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantTagLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantTagLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RestaurantTagLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"RestaurantTagLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"RestaurantTagLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BannerLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BannerLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BannerLocaleUpdateInput:{
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"BannerLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"BannerLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"CategoryCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"CategoryCreateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"CategoryUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		restaurants:{
			type:"CategoryUpdateRestaurantsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"CategoryLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"CategoryLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CategoryLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"CategoryLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"CategoryLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		slug:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SubRestaurantsPageCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		parentRestaurant:{
			type:"SubRestaurantsPageCreateParentRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageCreateLocalesEntityRelationInput:{
		connect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SubRestaurantsPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SubRestaurantsPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageUpdateInput:{
		locales:{
			type:"SubRestaurantsPageUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		parentRestaurant:{
			type:"SubRestaurantsPageUpdateParentRestaurantEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageUpdateLocalesEntityRelationInput:{
		create:{
			type:"SubRestaurantsPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubRestaurantsPageUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SubRestaurantsPageUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageUpdateLocalesRelationInput:{
		by:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SubRestaurantsPageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SubRestaurantsPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageUpsertLocalesRelationInput:{
		by:{
			type:"SubRestaurantsPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SubRestaurantsPageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SubRestaurantsPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SubRestaurantsPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SubRestaurantsPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SubRestaurantsPageLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SubRestaurantsPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SubRestaurantsPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SubRestaurantsPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageList:{
		items:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByImage:{
			by:{
				type:"ImageListItemsByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageListItem:{
		list:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ImageListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageListItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageListItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemsByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ImageListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListCreateItemsEntityRelationInput:{
		connect:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateInput:{
		items:{
			type:"ImageListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateItemsEntityRelationInput:{
		create:{
			type:"ImageListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpdateItemsRelationInput:{
		by:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ImageListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageListItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListUpsertItemsRelationInput:{
		by:{
			type:"ImageListItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemCreateListEntityRelationInput:{
		connect:{
			type:"ImageListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ImageListItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageListItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpdateListEntityRelationInput:{
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ImageListItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageListItemUpsertListRelationInput:{
		update:{
			type:"ImageListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFrontPage:{
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFrontPageLocale:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFrontPageLocale:{
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FrontPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFrontPageLocale:{
			data:{
				type:"FrontPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FrontPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkList:{
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkItem:{
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPrimaryLinkItem:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePrimaryLinkItem:{
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PrimaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePrimaryLinkItem:{
			data:{
				type:"PrimaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PrimaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLinks:{
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinksOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLinks:{
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLinksOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLinks:{
			data:{
				type:"FooterLinksCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLinksUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterContact:{
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterContact:{
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterContact:{
			data:{
				type:"FooterContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTitleList:{
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTitleList:{
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTitleList:{
			data:{
				type:"TitleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TitleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTitleItem:{
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTitleItem:{
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TitleItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTitleItem:{
			data:{
				type:"TitleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TitleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSecondaryLinkList:{
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSecondaryLinkList:{
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSecondaryLinkList:{
			data:{
				type:"SecondaryLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SecondaryLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSecondaryLinkItem:{
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSecondaryLinkItem:{
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SecondaryLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSecondaryLinkItem:{
			data:{
				type:"SecondaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SecondaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurant:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurant:{
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurant:{
			data:{
				type:"RestaurantCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantLocale:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantLocale:{
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantLocale:{
			data:{
				type:"RestaurantLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantItem:{
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantItem:{
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantItem:{
			data:{
				type:"RestaurantItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantTag:{
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantTag:{
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantTag:{
			data:{
				type:"RestaurantTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRestaurantTagLocale:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRestaurantTagLocale:{
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RestaurantTagLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRestaurantTagLocale:{
			data:{
				type:"RestaurantTagLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RestaurantTagLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBanner:{
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBanner:{
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBanner:{
			data:{
				type:"BannerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BannerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBannerLocale:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBannerLocale:{
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BannerLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBannerLocale:{
			data:{
				type:"BannerLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BannerLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategory:{
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listCategoryLocale:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCategoryLocale:{
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"CategoryLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateCategoryLocale:{
			data:{
				type:"CategoryLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"CategoryLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubRestaurantsPage:{
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubRestaurantsPage:{
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubRestaurantsPage:{
			data:{
				type:"SubRestaurantsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubRestaurantsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSubRestaurantsPageLocale:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubRestaurantsPageLocale:{
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SubRestaurantsPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSubRestaurantsPageLocale:{
			data:{
				type:"SubRestaurantsPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SubRestaurantsPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageList:{
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImageListItem:{
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageListItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFrontPageLocale:{
			data:{
				type:"FrontPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FrontPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FrontPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FrontPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPrimaryLinkItem:{
			data:{
				type:"PrimaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PrimaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PrimaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PrimaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLinks:{
			data:{
				type:"FooterLinksCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLinksUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLinksUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLinksCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterContact:{
			data:{
				type:"FooterContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTitleList:{
			data:{
				type:"TitleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TitleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TitleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TitleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTitleItem:{
			data:{
				type:"TitleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TitleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TitleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TitleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSecondaryLinkList:{
			data:{
				type:"SecondaryLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SecondaryLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SecondaryLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SecondaryLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSecondaryLinkItem:{
			data:{
				type:"SecondaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SecondaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SecondaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SecondaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurant:{
			data:{
				type:"RestaurantCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantLocale:{
			data:{
				type:"RestaurantLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantItem:{
			data:{
				type:"RestaurantItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantTag:{
			data:{
				type:"RestaurantTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantTagLocale:{
			data:{
				type:"RestaurantTagLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantTagLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantTagLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantTagLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBanner:{
			data:{
				type:"BannerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BannerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BannerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BannerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBannerLocale:{
			data:{
				type:"BannerLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BannerLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BannerLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BannerLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCategoryLocale:{
			data:{
				type:"CategoryLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CategoryLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CategoryLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CategoryLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubRestaurantsPage:{
			data:{
				type:"SubRestaurantsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubRestaurantsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubRestaurantsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubRestaurantsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubRestaurantsPageLocale:{
			data:{
				type:"SubRestaurantsPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubRestaurantsPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubRestaurantsPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubRestaurantsPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		transaction:{
			options:{
				type:"MutationTransactionOptions",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createFrontPage:{
			data:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFrontPage:{
			by:{
				type:"FrontPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FrontPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FrontPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFrontPageLocale:{
			data:{
				type:"FrontPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FrontPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFrontPageLocale:{
			by:{
				type:"FrontPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FrontPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FrontPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FrontPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkList:{
			data:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkList:{
			by:{
				type:"LinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkItem:{
			data:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkItem:{
			by:{
				type:"LinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPrimaryLinkItem:{
			data:{
				type:"PrimaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PrimaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPrimaryLinkItem:{
			by:{
				type:"PrimaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PrimaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PrimaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PrimaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLinks:{
			data:{
				type:"FooterLinksCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLinksUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLinks:{
			by:{
				type:"FooterLinksUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLinksWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLinksUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLinksCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterContact:{
			data:{
				type:"FooterContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterContact:{
			by:{
				type:"FooterContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTitleList:{
			data:{
				type:"TitleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TitleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTitleList:{
			by:{
				type:"TitleListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TitleListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TitleListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTitleItem:{
			data:{
				type:"TitleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TitleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTitleItem:{
			by:{
				type:"TitleItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TitleItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TitleItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TitleItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSecondaryLinkList:{
			data:{
				type:"SecondaryLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SecondaryLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSecondaryLinkList:{
			by:{
				type:"SecondaryLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SecondaryLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SecondaryLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSecondaryLinkItem:{
			data:{
				type:"SecondaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SecondaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSecondaryLinkItem:{
			by:{
				type:"SecondaryLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SecondaryLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SecondaryLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SecondaryLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurant:{
			data:{
				type:"RestaurantCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurant:{
			by:{
				type:"RestaurantUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantLocale:{
			data:{
				type:"RestaurantLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantLocale:{
			by:{
				type:"RestaurantLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantItem:{
			data:{
				type:"RestaurantItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantItem:{
			by:{
				type:"RestaurantItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantTag:{
			data:{
				type:"RestaurantTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantTag:{
			by:{
				type:"RestaurantTagUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantTagUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantTagCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRestaurantTagLocale:{
			data:{
				type:"RestaurantTagLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RestaurantTagLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRestaurantTagLocale:{
			by:{
				type:"RestaurantTagLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RestaurantTagLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RestaurantTagLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RestaurantTagLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBanner:{
			data:{
				type:"BannerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BannerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBanner:{
			by:{
				type:"BannerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BannerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BannerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBannerLocale:{
			data:{
				type:"BannerLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BannerLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBannerLocale:{
			by:{
				type:"BannerLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BannerLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BannerLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BannerLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCategory:{
			data:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCategory:{
			by:{
				type:"CategoryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CategoryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CategoryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createCategoryLocale:{
			data:{
				type:"CategoryLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"CategoryLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertCategoryLocale:{
			by:{
				type:"CategoryLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"CategoryLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"CategoryLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"CategoryLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubRestaurantsPage:{
			data:{
				type:"SubRestaurantsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubRestaurantsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubRestaurantsPage:{
			by:{
				type:"SubRestaurantsPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubRestaurantsPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubRestaurantsPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSubRestaurantsPageLocale:{
			data:{
				type:"SubRestaurantsPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SubRestaurantsPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSubRestaurantsPageLocale:{
			by:{
				type:"SubRestaurantsPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SubRestaurantsPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SubRestaurantsPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SubRestaurantsPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageList:{
			data:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageList:{
			by:{
				type:"ImageListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImageListItem:{
			data:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImageListItem:{
			by:{
				type:"ImageListItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageListItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageListItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageListItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	MutationTransactionOptions:{
		deferForeignKeyConstraints:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getFrontPage:"FrontPage",
		listFrontPage:"FrontPage",
		paginateFrontPage:"FrontPageConnection",
		validateCreateFrontPage:"_ValidationResult",
		validateUpdateFrontPage:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getFrontPageLocale:"FrontPageLocale",
		listFrontPageLocale:"FrontPageLocale",
		paginateFrontPageLocale:"FrontPageLocaleConnection",
		validateCreateFrontPageLocale:"_ValidationResult",
		validateUpdateFrontPageLocale:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getSocialLinkList:"SocialLinkList",
		listSocialLinkList:"SocialLinkList",
		paginateSocialLinkList:"SocialLinkListConnection",
		validateCreateSocialLinkList:"_ValidationResult",
		validateUpdateSocialLinkList:"_ValidationResult",
		getSocialLinkItem:"SocialLinkItem",
		listSocialLinkItem:"SocialLinkItem",
		paginateSocialLinkItem:"SocialLinkItemConnection",
		validateCreateSocialLinkItem:"_ValidationResult",
		validateUpdateSocialLinkItem:"_ValidationResult",
		getPrimaryLinkItem:"PrimaryLinkItem",
		listPrimaryLinkItem:"PrimaryLinkItem",
		paginatePrimaryLinkItem:"PrimaryLinkItemConnection",
		validateCreatePrimaryLinkItem:"_ValidationResult",
		validateUpdatePrimaryLinkItem:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getFooterLinks:"FooterLinks",
		listFooterLinks:"FooterLinks",
		paginateFooterLinks:"FooterLinksConnection",
		validateCreateFooterLinks:"_ValidationResult",
		validateUpdateFooterLinks:"_ValidationResult",
		getFooterContact:"FooterContact",
		listFooterContact:"FooterContact",
		paginateFooterContact:"FooterContactConnection",
		validateCreateFooterContact:"_ValidationResult",
		validateUpdateFooterContact:"_ValidationResult",
		getTitleList:"TitleList",
		listTitleList:"TitleList",
		paginateTitleList:"TitleListConnection",
		validateCreateTitleList:"_ValidationResult",
		validateUpdateTitleList:"_ValidationResult",
		getTitleItem:"TitleItem",
		listTitleItem:"TitleItem",
		paginateTitleItem:"TitleItemConnection",
		validateCreateTitleItem:"_ValidationResult",
		validateUpdateTitleItem:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getSecondaryLinkList:"SecondaryLinkList",
		listSecondaryLinkList:"SecondaryLinkList",
		paginateSecondaryLinkList:"SecondaryLinkListConnection",
		validateCreateSecondaryLinkList:"_ValidationResult",
		validateUpdateSecondaryLinkList:"_ValidationResult",
		getSecondaryLinkItem:"SecondaryLinkItem",
		listSecondaryLinkItem:"SecondaryLinkItem",
		paginateSecondaryLinkItem:"SecondaryLinkItemConnection",
		validateCreateSecondaryLinkItem:"_ValidationResult",
		validateUpdateSecondaryLinkItem:"_ValidationResult",
		getRestaurant:"Restaurant",
		listRestaurant:"Restaurant",
		paginateRestaurant:"RestaurantConnection",
		validateCreateRestaurant:"_ValidationResult",
		validateUpdateRestaurant:"_ValidationResult",
		getRestaurantLocale:"RestaurantLocale",
		listRestaurantLocale:"RestaurantLocale",
		paginateRestaurantLocale:"RestaurantLocaleConnection",
		validateCreateRestaurantLocale:"_ValidationResult",
		validateUpdateRestaurantLocale:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getRestaurantItem:"RestaurantItem",
		listRestaurantItem:"RestaurantItem",
		paginateRestaurantItem:"RestaurantItemConnection",
		validateCreateRestaurantItem:"_ValidationResult",
		validateUpdateRestaurantItem:"_ValidationResult",
		getRestaurantTag:"RestaurantTag",
		listRestaurantTag:"RestaurantTag",
		paginateRestaurantTag:"RestaurantTagConnection",
		validateCreateRestaurantTag:"_ValidationResult",
		validateUpdateRestaurantTag:"_ValidationResult",
		getRestaurantTagLocale:"RestaurantTagLocale",
		listRestaurantTagLocale:"RestaurantTagLocale",
		paginateRestaurantTagLocale:"RestaurantTagLocaleConnection",
		validateCreateRestaurantTagLocale:"_ValidationResult",
		validateUpdateRestaurantTagLocale:"_ValidationResult",
		getBanner:"Banner",
		listBanner:"Banner",
		paginateBanner:"BannerConnection",
		validateCreateBanner:"_ValidationResult",
		validateUpdateBanner:"_ValidationResult",
		getBannerLocale:"BannerLocale",
		listBannerLocale:"BannerLocale",
		paginateBannerLocale:"BannerLocaleConnection",
		validateCreateBannerLocale:"_ValidationResult",
		validateUpdateBannerLocale:"_ValidationResult",
		getCategory:"Category",
		listCategory:"Category",
		paginateCategory:"CategoryConnection",
		validateCreateCategory:"_ValidationResult",
		validateUpdateCategory:"_ValidationResult",
		getCategoryLocale:"CategoryLocale",
		listCategoryLocale:"CategoryLocale",
		paginateCategoryLocale:"CategoryLocaleConnection",
		validateCreateCategoryLocale:"_ValidationResult",
		validateUpdateCategoryLocale:"_ValidationResult",
		getSubRestaurantsPage:"SubRestaurantsPage",
		listSubRestaurantsPage:"SubRestaurantsPage",
		paginateSubRestaurantsPage:"SubRestaurantsPageConnection",
		validateCreateSubRestaurantsPage:"_ValidationResult",
		validateUpdateSubRestaurantsPage:"_ValidationResult",
		getSubRestaurantsPageLocale:"SubRestaurantsPageLocale",
		listSubRestaurantsPageLocale:"SubRestaurantsPageLocale",
		paginateSubRestaurantsPageLocale:"SubRestaurantsPageLocaleConnection",
		validateCreateSubRestaurantsPageLocale:"_ValidationResult",
		validateUpdateSubRestaurantsPageLocale:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	FrontPage:{
		_meta:"FrontPageMeta",
		id:"UUID",
		unique:"One",
		locales:"FrontPageLocale",
		banner:"Banner",
		localesByLocale:"FrontPageLocale",
		localesByLink:"FrontPageLocale",
		localesBySeo:"FrontPageLocale",
		paginateLocales:"FrontPageLocaleConnection"
	},
	FrontPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		banner:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	FrontPageLocale:{
		_meta:"FrontPageLocaleMeta",
		id:"UUID",
		title:"String",
		link:"Linkable",
		root:"FrontPage",
		locale:"Locale",
		seo:"Seo",
		socialLinks:"String"
	},
	FrontPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta",
		socialLinks:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		frontPage:"FrontPageLocale",
		subRestaurantsPage:"SubRestaurantsPageLocale"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		frontPage:"FieldMeta",
		subRestaurantsPage:"FieldMeta"
	},
	SubRestaurantsPageLocale:{
		_meta:"SubRestaurantsPageLocaleMeta",
		id:"UUID",
		title:"String",
		link:"Linkable",
		root:"SubRestaurantsPage",
		locale:"Locale",
		seo:"Seo"
	},
	SubRestaurantsPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta"
	},
	SubRestaurantsPage:{
		_meta:"SubRestaurantsPageMeta",
		id:"UUID",
		locales:"SubRestaurantsPageLocale",
		order:"Int",
		parentRestaurant:"Restaurant",
		localesByLocale:"SubRestaurantsPageLocale",
		localesByLink:"SubRestaurantsPageLocale",
		localesBySeo:"SubRestaurantsPageLocale",
		paginateLocales:"SubRestaurantsPageLocaleConnection"
	},
	SubRestaurantsPageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		order:"FieldMeta",
		parentRestaurant:"FieldMeta"
	},
	Restaurant:{
		_meta:"RestaurantMeta",
		id:"UUID",
		locales:"RestaurantLocale",
		image:"Image",
		subItems:"RestaurantItem",
		order:"Int",
		item:"RestaurantItem",
		openingHours:"String",
		tags:"RestaurantTag",
		categories:"Category",
		localesByLocale:"RestaurantLocale",
		subItemsByRestaurant:"RestaurantItem",
		paginateLocales:"RestaurantLocaleConnection",
		paginateSubItems:"RestaurantItemConnection",
		paginateTags:"RestaurantTagConnection",
		paginateCategories:"CategoryConnection"
	},
	RestaurantMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		image:"FieldMeta",
		subItems:"FieldMeta",
		order:"FieldMeta",
		item:"FieldMeta",
		openingHours:"FieldMeta",
		tags:"FieldMeta",
		categories:"FieldMeta"
	},
	RestaurantLocale:{
		_meta:"RestaurantLocaleMeta",
		id:"UUID",
		title:"String",
		root:"Restaurant",
		locale:"Locale",
		description:"String",
		url:"String",
		location:"String",
		isEshopActive:"Boolean",
		isDeliveryActive:"Boolean",
		secondaryUrl:"String"
	},
	RestaurantLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		description:"FieldMeta",
		url:"FieldMeta",
		location:"FieldMeta",
		isEshopActive:"FieldMeta",
		isDeliveryActive:"FieldMeta",
		secondaryUrl:"FieldMeta"
	},
	Locale:{
		_meta:"LocaleMeta",
		id:"UUID",
		code:"String",
		label:"String",
		frontPages:"FrontPageLocale",
		headers:"HeaderLocale",
		footers:"FooterLocale",
		restaurants:"RestaurantLocale",
		restaurantTags:"RestaurantTagLocale",
		banners:"BannerLocale",
		categories:"CategoryLocale",
		subRestaurantsPages:"SubRestaurantsPageLocale",
		frontPagesByRoot:"FrontPageLocale",
		frontPagesByLink:"FrontPageLocale",
		frontPagesBySeo:"FrontPageLocale",
		headersByRoot:"HeaderLocale",
		headersBySocialLinks:"HeaderLocale",
		headersByPrimaryLinkItems:"HeaderLocale",
		headersBySecondaryLinks:"HeaderLocale",
		footersByRoot:"FooterLocale",
		footersByLinksSection:"FooterLocale",
		footersByContactSection:"FooterLocale",
		restaurantsByRoot:"RestaurantLocale",
		restaurantTagsByRoot:"RestaurantTagLocale",
		bannersByRoot:"BannerLocale",
		categoriesByRoot:"CategoryLocale",
		categoriesBySlug:"CategoryLocale",
		subRestaurantsPagesByRoot:"SubRestaurantsPageLocale",
		subRestaurantsPagesByLink:"SubRestaurantsPageLocale",
		subRestaurantsPagesBySeo:"SubRestaurantsPageLocale",
		paginateFrontPages:"FrontPageLocaleConnection",
		paginateHeaders:"HeaderLocaleConnection",
		paginateFooters:"FooterLocaleConnection",
		paginateRestaurants:"RestaurantLocaleConnection",
		paginateRestaurantTags:"RestaurantTagLocaleConnection",
		paginateBanners:"BannerLocaleConnection",
		paginateCategories:"CategoryLocaleConnection",
		paginateSubRestaurantsPages:"SubRestaurantsPageLocaleConnection"
	},
	LocaleMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		label:"FieldMeta",
		frontPages:"FieldMeta",
		headers:"FieldMeta",
		footers:"FieldMeta",
		restaurants:"FieldMeta",
		restaurantTags:"FieldMeta",
		banners:"FieldMeta",
		categories:"FieldMeta",
		subRestaurantsPages:"FieldMeta"
	},
	HeaderLocale:{
		_meta:"HeaderLocaleMeta",
		id:"UUID",
		menuButtonText:"String",
		root:"Header",
		locale:"Locale",
		socialLinks:"SocialLinkList",
		primaryLinkItems:"PrimaryLinkItem",
		secondaryLinks:"SecondaryLinkList",
		primaryLinkItemsByLink:"PrimaryLinkItem",
		primaryLinkItemsBySubItems:"PrimaryLinkItem",
		paginatePrimaryLinkItems:"PrimaryLinkItemConnection"
	},
	HeaderLocaleMeta:{
		id:"FieldMeta",
		menuButtonText:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		socialLinks:"FieldMeta",
		primaryLinkItems:"FieldMeta",
		secondaryLinks:"FieldMeta"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		unique:"One",
		logo:"Image",
		locales:"HeaderLocale",
		navigationLogo:"Image",
		localesByLocale:"HeaderLocale",
		localesBySocialLinks:"HeaderLocale",
		localesByPrimaryLinkItems:"HeaderLocale",
		localesBySecondaryLinks:"HeaderLocale",
		paginateLocales:"HeaderLocaleConnection"
	},
	HeaderMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		logo:"FieldMeta",
		locales:"FieldMeta",
		navigationLogo:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String",
		fileName:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta",
		fileName:"FieldMeta"
	},
	HeaderLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderLocaleEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	HeaderLocaleEdge:{
		node:"HeaderLocale"
	},
	SocialLinkList:{
		_meta:"SocialLinkListMeta",
		id:"UUID",
		items:"SocialLinkItem",
		itemsBySocialLink:"SocialLinkItem",
		paginateItems:"SocialLinkItemConnection"
	},
	SocialLinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	SocialLinkItem:{
		_meta:"SocialLinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"SocialLinkList",
		socialLink:"SocialLink"
	},
	SocialLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		socialLink:"FieldMeta"
	},
	SocialLink:{
		_meta:"SocialLinkMeta",
		id:"UUID",
		type:"SocialLinkType",
		url:"String"
	},
	SocialLinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		url:"FieldMeta"
	},
	SocialLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkItemEdge"
	},
	SocialLinkItemEdge:{
		node:"SocialLinkItem"
	},
	PrimaryLinkItem:{
		_meta:"PrimaryLinkItemMeta",
		id:"UUID",
		order:"Int",
		link:"Link",
		parent:"PrimaryLinkItem",
		subItems:"PrimaryLinkItem",
		header:"HeaderLocale",
		subItemsByLink:"PrimaryLinkItem",
		subItemsBySubItems:"PrimaryLinkItem",
		paginateSubItems:"PrimaryLinkItemConnection"
	},
	PrimaryLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta",
		parent:"FieldMeta",
		subItems:"FieldMeta",
		header:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta"
	},
	PrimaryLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"PrimaryLinkItemEdge"
	},
	PrimaryLinkItemEdge:{
		node:"PrimaryLinkItem"
	},
	SecondaryLinkList:{
		_meta:"SecondaryLinkListMeta",
		id:"UUID",
		items:"SecondaryLinkItem",
		itemsByLink:"SecondaryLinkItem",
		paginateItems:"SecondaryLinkItemConnection"
	},
	SecondaryLinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	SecondaryLinkItem:{
		_meta:"SecondaryLinkItemMeta",
		id:"UUID",
		order:"Int",
		iconType:"IconType",
		list:"SecondaryLinkList",
		link:"Link"
	},
	SecondaryLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		iconType:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta"
	},
	SecondaryLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"SecondaryLinkItemEdge"
	},
	SecondaryLinkItemEdge:{
		node:"SecondaryLinkItem"
	},
	FooterLocale:{
		_meta:"FooterLocaleMeta",
		id:"UUID",
		root:"Footer",
		locale:"Locale",
		linksSection:"FooterLinks",
		contactSection:"FooterContact"
	},
	FooterLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		linksSection:"FieldMeta",
		contactSection:"FieldMeta"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		unique:"One",
		logo:"Image",
		locales:"FooterLocale",
		localesByLocale:"FooterLocale",
		localesByLinksSection:"FooterLocale",
		localesByContactSection:"FooterLocale",
		paginateLocales:"FooterLocaleConnection"
	},
	FooterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		logo:"FieldMeta",
		locales:"FieldMeta"
	},
	FooterLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLocaleEdge"
	},
	FooterLocaleEdge:{
		node:"FooterLocale"
	},
	FooterLinks:{
		_meta:"FooterLinksMeta",
		id:"UUID",
		buttonsTitle:"String",
		linkList:"LinkList",
		buttons:"LinkList",
		titleList:"TitleList"
	},
	FooterLinksMeta:{
		id:"FieldMeta",
		buttonsTitle:"FieldMeta",
		linkList:"FieldMeta",
		buttons:"FieldMeta",
		titleList:"FieldMeta"
	},
	LinkList:{
		_meta:"LinkListMeta",
		id:"UUID",
		items:"LinkItem",
		itemsByLink:"LinkItem",
		paginateItems:"LinkItemConnection"
	},
	LinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	LinkItem:{
		_meta:"LinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"LinkList",
		link:"Link",
		icon:"Image"
	},
	LinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta",
		icon:"FieldMeta"
	},
	LinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"LinkItemEdge"
	},
	LinkItemEdge:{
		node:"LinkItem"
	},
	TitleList:{
		_meta:"TitleListMeta",
		id:"UUID",
		items:"TitleItem",
		paginateItems:"TitleItemConnection"
	},
	TitleListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	TitleItem:{
		_meta:"TitleItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		list:"TitleList",
		icon:"Image"
	},
	TitleItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		list:"FieldMeta",
		icon:"FieldMeta"
	},
	TitleItemConnection:{
		pageInfo:"PageInfo",
		edges:"TitleItemEdge"
	},
	TitleItemEdge:{
		node:"TitleItem"
	},
	FooterContact:{
		_meta:"FooterContactMeta",
		id:"UUID",
		email:"String",
		phone:"String",
		note:"String",
		openingHours:"String",
		identificationNumber:"String",
		valueAddedTaxNumber:"String",
		bussinessRegister:"String",
		phoneImage:"Image",
		address:"String"
	},
	FooterContactMeta:{
		id:"FieldMeta",
		email:"FieldMeta",
		phone:"FieldMeta",
		note:"FieldMeta",
		openingHours:"FieldMeta",
		identificationNumber:"FieldMeta",
		valueAddedTaxNumber:"FieldMeta",
		bussinessRegister:"FieldMeta",
		phoneImage:"FieldMeta",
		address:"FieldMeta"
	},
	RestaurantTagLocale:{
		_meta:"RestaurantTagLocaleMeta",
		id:"UUID",
		title:"String",
		root:"RestaurantTag",
		locale:"Locale"
	},
	RestaurantTagLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	RestaurantTag:{
		_meta:"RestaurantTagMeta",
		id:"UUID",
		order:"Int",
		locales:"RestaurantTagLocale",
		backgroundColor:"String",
		titleColor:"String",
		restaurants:"Restaurant",
		localesByLocale:"RestaurantTagLocale",
		paginateLocales:"RestaurantTagLocaleConnection",
		paginateRestaurants:"RestaurantConnection"
	},
	RestaurantTagMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta",
		backgroundColor:"FieldMeta",
		titleColor:"FieldMeta",
		restaurants:"FieldMeta"
	},
	RestaurantTagLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"RestaurantTagLocaleEdge"
	},
	RestaurantTagLocaleEdge:{
		node:"RestaurantTagLocale"
	},
	RestaurantConnection:{
		pageInfo:"PageInfo",
		edges:"RestaurantEdge"
	},
	RestaurantEdge:{
		node:"Restaurant"
	},
	BannerLocale:{
		_meta:"BannerLocaleMeta",
		id:"UUID",
		text:"String",
		root:"Banner",
		locale:"Locale",
		title:"String",
		url:"String"
	},
	BannerLocaleMeta:{
		id:"FieldMeta",
		text:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		title:"FieldMeta",
		url:"FieldMeta"
	},
	Banner:{
		_meta:"BannerMeta",
		id:"UUID",
		image:"Image",
		locales:"BannerLocale",
		order:"Int",
		textColor:"String",
		localesByLocale:"BannerLocale",
		paginateLocales:"BannerLocaleConnection"
	},
	BannerMeta:{
		id:"FieldMeta",
		image:"FieldMeta",
		locales:"FieldMeta",
		order:"FieldMeta",
		textColor:"FieldMeta"
	},
	BannerLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"BannerLocaleEdge"
	},
	BannerLocaleEdge:{
		node:"BannerLocale"
	},
	CategoryLocale:{
		_meta:"CategoryLocaleMeta",
		id:"UUID",
		title:"String",
		root:"Category",
		locale:"Locale",
		slug:"String"
	},
	CategoryLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		slug:"FieldMeta"
	},
	Category:{
		_meta:"CategoryMeta",
		id:"UUID",
		order:"Int",
		locales:"CategoryLocale",
		restaurants:"Restaurant",
		localesByLocale:"CategoryLocale",
		localesBySlug:"CategoryLocale",
		paginateLocales:"CategoryLocaleConnection",
		paginateRestaurants:"RestaurantConnection"
	},
	CategoryMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta",
		restaurants:"FieldMeta"
	},
	CategoryLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"CategoryLocaleEdge"
	},
	CategoryLocaleEdge:{
		node:"CategoryLocale"
	},
	FrontPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"FrontPageLocaleEdge"
	},
	FrontPageLocaleEdge:{
		node:"FrontPageLocale"
	},
	RestaurantLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"RestaurantLocaleEdge"
	},
	RestaurantLocaleEdge:{
		node:"RestaurantLocale"
	},
	SubRestaurantsPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"SubRestaurantsPageLocaleEdge"
	},
	SubRestaurantsPageLocaleEdge:{
		node:"SubRestaurantsPageLocale"
	},
	RestaurantItem:{
		_meta:"RestaurantItemMeta",
		id:"UUID",
		parent:"Restaurant",
		order:"Int",
		restaurant:"Restaurant"
	},
	RestaurantItemMeta:{
		id:"FieldMeta",
		parent:"FieldMeta",
		order:"FieldMeta",
		restaurant:"FieldMeta"
	},
	RestaurantItemConnection:{
		pageInfo:"PageInfo",
		edges:"RestaurantItemEdge"
	},
	RestaurantItemEdge:{
		node:"RestaurantItem"
	},
	RestaurantTagConnection:{
		pageInfo:"PageInfo",
		edges:"RestaurantTagEdge"
	},
	RestaurantTagEdge:{
		node:"RestaurantTag"
	},
	CategoryConnection:{
		pageInfo:"PageInfo",
		edges:"CategoryEdge"
	},
	CategoryEdge:{
		node:"Category"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		ogImage:"Image",
		noIndex:"Boolean",
		noFollow:"Boolean"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		ogImage:"FieldMeta",
		noIndex:"FieldMeta",
		noFollow:"FieldMeta"
	},
	FrontPageConnection:{
		pageInfo:"PageInfo",
		edges:"FrontPageEdge"
	},
	FrontPageEdge:{
		node:"FrontPage"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	LocaleConnection:{
		pageInfo:"PageInfo",
		edges:"LocaleEdge"
	},
	LocaleEdge:{
		node:"Locale"
	},
	LinkListConnection:{
		pageInfo:"PageInfo",
		edges:"LinkListEdge"
	},
	LinkListEdge:{
		node:"LinkList"
	},
	SocialLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkListEdge"
	},
	SocialLinkListEdge:{
		node:"SocialLinkList"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	FooterLinksConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLinksEdge"
	},
	FooterLinksEdge:{
		node:"FooterLinks"
	},
	FooterContactConnection:{
		pageInfo:"PageInfo",
		edges:"FooterContactEdge"
	},
	FooterContactEdge:{
		node:"FooterContact"
	},
	TitleListConnection:{
		pageInfo:"PageInfo",
		edges:"TitleListEdge"
	},
	TitleListEdge:{
		node:"TitleList"
	},
	SocialLinkConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkEdge"
	},
	SocialLinkEdge:{
		node:"SocialLink"
	},
	SecondaryLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"SecondaryLinkListEdge"
	},
	SecondaryLinkListEdge:{
		node:"SecondaryLinkList"
	},
	TranslationDomain:{
		_meta:"TranslationDomainMeta",
		id:"UUID",
		identifier:"String",
		name:"String",
		catalogues:"TranslationCatalogue",
		keys:"TranslationKey",
		cataloguesByIdentifier:"TranslationCatalogue",
		cataloguesByValues:"TranslationCatalogue",
		keysByIdentifier:"TranslationKey",
		keysByValues:"TranslationKey",
		paginateCatalogues:"TranslationCatalogueConnection",
		paginateKeys:"TranslationKeyConnection"
	},
	TranslationDomainMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		name:"FieldMeta",
		catalogues:"FieldMeta",
		keys:"FieldMeta"
	},
	TranslationCatalogue:{
		_meta:"TranslationCatalogueMeta",
		id:"UUID",
		domain:"TranslationDomain",
		identifier:"TranslationCataloguesIdentifier",
		fallback:"TranslationCatalogue",
		values:"TranslationValue",
		valuesByKey:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationCatalogueMeta:{
		id:"FieldMeta",
		domain:"FieldMeta",
		identifier:"FieldMeta",
		fallback:"FieldMeta",
		values:"FieldMeta"
	},
	TranslationCataloguesIdentifier:{
		_meta:"TranslationCataloguesIdentifierMeta",
		id:"UUID",
		name:"String",
		code:"String",
		catalogue:"TranslationCatalogue",
		catalogueByDomain:"TranslationCatalogue",
		catalogueByValues:"TranslationCatalogue",
		paginateCatalogue:"TranslationCatalogueConnection"
	},
	TranslationCataloguesIdentifierMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		catalogue:"FieldMeta"
	},
	TranslationCatalogueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCatalogueEdge"
	},
	TranslationCatalogueEdge:{
		node:"TranslationCatalogue"
	},
	TranslationValue:{
		_meta:"TranslationValueMeta",
		id:"UUID",
		value:"String",
		catalogue:"TranslationCatalogue",
		key:"TranslationKey"
	},
	TranslationValueMeta:{
		id:"FieldMeta",
		value:"FieldMeta",
		catalogue:"FieldMeta",
		key:"FieldMeta"
	},
	TranslationKey:{
		_meta:"TranslationKeyMeta",
		id:"UUID",
		identifier:"String",
		contentType:"TranslationContentType",
		note:"String",
		domain:"TranslationDomain",
		values:"TranslationValue",
		valuesByCatalogue:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationKeyMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		contentType:"FieldMeta",
		note:"FieldMeta",
		domain:"FieldMeta",
		values:"FieldMeta"
	},
	TranslationValueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationValueEdge"
	},
	TranslationValueEdge:{
		node:"TranslationValue"
	},
	TranslationKeyConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationKeyEdge"
	},
	TranslationKeyEdge:{
		node:"TranslationKey"
	},
	TranslationDomainConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationDomainEdge"
	},
	TranslationDomainEdge:{
		node:"TranslationDomain"
	},
	TranslationCataloguesIdentifierConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCataloguesIdentifierEdge"
	},
	TranslationCataloguesIdentifierEdge:{
		node:"TranslationCataloguesIdentifier"
	},
	BannerConnection:{
		pageInfo:"PageInfo",
		edges:"BannerEdge"
	},
	BannerEdge:{
		node:"Banner"
	},
	SubRestaurantsPageConnection:{
		pageInfo:"PageInfo",
		edges:"SubRestaurantsPageEdge"
	},
	SubRestaurantsPageEdge:{
		node:"SubRestaurantsPage"
	},
	ImageList:{
		_meta:"ImageListMeta",
		id:"UUID",
		items:"ImageListItem",
		itemsByImage:"ImageListItem",
		paginateItems:"ImageListItemConnection"
	},
	ImageListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ImageListItem:{
		_meta:"ImageListItemMeta",
		id:"UUID",
		order:"Int",
		list:"ImageList",
		image:"Image"
	},
	ImageListItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	ImageListItemConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListItemEdge"
	},
	ImageListItemEdge:{
		node:"ImageListItem"
	},
	ImageListConnection:{
		pageInfo:"PageInfo",
		edges:"ImageListEdge"
	},
	ImageListEdge:{
		node:"ImageList"
	},
	QueryTransaction:{
		getFrontPage:"FrontPage",
		listFrontPage:"FrontPage",
		paginateFrontPage:"FrontPageConnection",
		validateCreateFrontPage:"_ValidationResult",
		validateUpdateFrontPage:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getFrontPageLocale:"FrontPageLocale",
		listFrontPageLocale:"FrontPageLocale",
		paginateFrontPageLocale:"FrontPageLocaleConnection",
		validateCreateFrontPageLocale:"_ValidationResult",
		validateUpdateFrontPageLocale:"_ValidationResult",
		getLinkList:"LinkList",
		listLinkList:"LinkList",
		paginateLinkList:"LinkListConnection",
		validateCreateLinkList:"_ValidationResult",
		validateUpdateLinkList:"_ValidationResult",
		getLinkItem:"LinkItem",
		listLinkItem:"LinkItem",
		paginateLinkItem:"LinkItemConnection",
		validateCreateLinkItem:"_ValidationResult",
		validateUpdateLinkItem:"_ValidationResult",
		getSocialLinkList:"SocialLinkList",
		listSocialLinkList:"SocialLinkList",
		paginateSocialLinkList:"SocialLinkListConnection",
		validateCreateSocialLinkList:"_ValidationResult",
		validateUpdateSocialLinkList:"_ValidationResult",
		getSocialLinkItem:"SocialLinkItem",
		listSocialLinkItem:"SocialLinkItem",
		paginateSocialLinkItem:"SocialLinkItemConnection",
		validateCreateSocialLinkItem:"_ValidationResult",
		validateUpdateSocialLinkItem:"_ValidationResult",
		getPrimaryLinkItem:"PrimaryLinkItem",
		listPrimaryLinkItem:"PrimaryLinkItem",
		paginatePrimaryLinkItem:"PrimaryLinkItemConnection",
		validateCreatePrimaryLinkItem:"_ValidationResult",
		validateUpdatePrimaryLinkItem:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getFooterLinks:"FooterLinks",
		listFooterLinks:"FooterLinks",
		paginateFooterLinks:"FooterLinksConnection",
		validateCreateFooterLinks:"_ValidationResult",
		validateUpdateFooterLinks:"_ValidationResult",
		getFooterContact:"FooterContact",
		listFooterContact:"FooterContact",
		paginateFooterContact:"FooterContactConnection",
		validateCreateFooterContact:"_ValidationResult",
		validateUpdateFooterContact:"_ValidationResult",
		getTitleList:"TitleList",
		listTitleList:"TitleList",
		paginateTitleList:"TitleListConnection",
		validateCreateTitleList:"_ValidationResult",
		validateUpdateTitleList:"_ValidationResult",
		getTitleItem:"TitleItem",
		listTitleItem:"TitleItem",
		paginateTitleItem:"TitleItemConnection",
		validateCreateTitleItem:"_ValidationResult",
		validateUpdateTitleItem:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getSecondaryLinkList:"SecondaryLinkList",
		listSecondaryLinkList:"SecondaryLinkList",
		paginateSecondaryLinkList:"SecondaryLinkListConnection",
		validateCreateSecondaryLinkList:"_ValidationResult",
		validateUpdateSecondaryLinkList:"_ValidationResult",
		getSecondaryLinkItem:"SecondaryLinkItem",
		listSecondaryLinkItem:"SecondaryLinkItem",
		paginateSecondaryLinkItem:"SecondaryLinkItemConnection",
		validateCreateSecondaryLinkItem:"_ValidationResult",
		validateUpdateSecondaryLinkItem:"_ValidationResult",
		getRestaurant:"Restaurant",
		listRestaurant:"Restaurant",
		paginateRestaurant:"RestaurantConnection",
		validateCreateRestaurant:"_ValidationResult",
		validateUpdateRestaurant:"_ValidationResult",
		getRestaurantLocale:"RestaurantLocale",
		listRestaurantLocale:"RestaurantLocale",
		paginateRestaurantLocale:"RestaurantLocaleConnection",
		validateCreateRestaurantLocale:"_ValidationResult",
		validateUpdateRestaurantLocale:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getRestaurantItem:"RestaurantItem",
		listRestaurantItem:"RestaurantItem",
		paginateRestaurantItem:"RestaurantItemConnection",
		validateCreateRestaurantItem:"_ValidationResult",
		validateUpdateRestaurantItem:"_ValidationResult",
		getRestaurantTag:"RestaurantTag",
		listRestaurantTag:"RestaurantTag",
		paginateRestaurantTag:"RestaurantTagConnection",
		validateCreateRestaurantTag:"_ValidationResult",
		validateUpdateRestaurantTag:"_ValidationResult",
		getRestaurantTagLocale:"RestaurantTagLocale",
		listRestaurantTagLocale:"RestaurantTagLocale",
		paginateRestaurantTagLocale:"RestaurantTagLocaleConnection",
		validateCreateRestaurantTagLocale:"_ValidationResult",
		validateUpdateRestaurantTagLocale:"_ValidationResult",
		getBanner:"Banner",
		listBanner:"Banner",
		paginateBanner:"BannerConnection",
		validateCreateBanner:"_ValidationResult",
		validateUpdateBanner:"_ValidationResult",
		getBannerLocale:"BannerLocale",
		listBannerLocale:"BannerLocale",
		paginateBannerLocale:"BannerLocaleConnection",
		validateCreateBannerLocale:"_ValidationResult",
		validateUpdateBannerLocale:"_ValidationResult",
		getCategory:"Category",
		listCategory:"Category",
		paginateCategory:"CategoryConnection",
		validateCreateCategory:"_ValidationResult",
		validateUpdateCategory:"_ValidationResult",
		getCategoryLocale:"CategoryLocale",
		listCategoryLocale:"CategoryLocale",
		paginateCategoryLocale:"CategoryLocaleConnection",
		validateCreateCategoryLocale:"_ValidationResult",
		validateUpdateCategoryLocale:"_ValidationResult",
		getSubRestaurantsPage:"SubRestaurantsPage",
		listSubRestaurantsPage:"SubRestaurantsPage",
		paginateSubRestaurantsPage:"SubRestaurantsPageConnection",
		validateCreateSubRestaurantsPage:"_ValidationResult",
		validateUpdateSubRestaurantsPage:"_ValidationResult",
		getSubRestaurantsPageLocale:"SubRestaurantsPageLocale",
		listSubRestaurantsPageLocale:"SubRestaurantsPageLocale",
		paginateSubRestaurantsPageLocale:"SubRestaurantsPageLocaleConnection",
		validateCreateSubRestaurantsPageLocale:"_ValidationResult",
		validateUpdateSubRestaurantsPageLocale:"_ValidationResult",
		getImageList:"ImageList",
		listImageList:"ImageList",
		paginateImageList:"ImageListConnection",
		validateCreateImageList:"_ValidationResult",
		validateUpdateImageList:"_ValidationResult",
		getImageListItem:"ImageListItem",
		listImageListItem:"ImageListItem",
		paginateImageListItem:"ImageListItemConnection",
		validateCreateImageListItem:"_ValidationResult",
		validateUpdateImageListItem:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createFrontPage:"FrontPageCreateResult",
		deleteFrontPage:"FrontPageDeleteResult",
		updateFrontPage:"FrontPageUpdateResult",
		upsertFrontPage:"FrontPageUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createFrontPageLocale:"FrontPageLocaleCreateResult",
		deleteFrontPageLocale:"FrontPageLocaleDeleteResult",
		updateFrontPageLocale:"FrontPageLocaleUpdateResult",
		upsertFrontPageLocale:"FrontPageLocaleUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createSocialLinkList:"SocialLinkListCreateResult",
		deleteSocialLinkList:"SocialLinkListDeleteResult",
		updateSocialLinkList:"SocialLinkListUpdateResult",
		upsertSocialLinkList:"SocialLinkListUpsertResult",
		createSocialLinkItem:"SocialLinkItemCreateResult",
		deleteSocialLinkItem:"SocialLinkItemDeleteResult",
		updateSocialLinkItem:"SocialLinkItemUpdateResult",
		upsertSocialLinkItem:"SocialLinkItemUpsertResult",
		createPrimaryLinkItem:"PrimaryLinkItemCreateResult",
		deletePrimaryLinkItem:"PrimaryLinkItemDeleteResult",
		updatePrimaryLinkItem:"PrimaryLinkItemUpdateResult",
		upsertPrimaryLinkItem:"PrimaryLinkItemUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createFooterLinks:"FooterLinksCreateResult",
		deleteFooterLinks:"FooterLinksDeleteResult",
		updateFooterLinks:"FooterLinksUpdateResult",
		upsertFooterLinks:"FooterLinksUpsertResult",
		createFooterContact:"FooterContactCreateResult",
		deleteFooterContact:"FooterContactDeleteResult",
		updateFooterContact:"FooterContactUpdateResult",
		upsertFooterContact:"FooterContactUpsertResult",
		createTitleList:"TitleListCreateResult",
		deleteTitleList:"TitleListDeleteResult",
		updateTitleList:"TitleListUpdateResult",
		upsertTitleList:"TitleListUpsertResult",
		createTitleItem:"TitleItemCreateResult",
		deleteTitleItem:"TitleItemDeleteResult",
		updateTitleItem:"TitleItemUpdateResult",
		upsertTitleItem:"TitleItemUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createSecondaryLinkList:"SecondaryLinkListCreateResult",
		deleteSecondaryLinkList:"SecondaryLinkListDeleteResult",
		updateSecondaryLinkList:"SecondaryLinkListUpdateResult",
		upsertSecondaryLinkList:"SecondaryLinkListUpsertResult",
		createSecondaryLinkItem:"SecondaryLinkItemCreateResult",
		deleteSecondaryLinkItem:"SecondaryLinkItemDeleteResult",
		updateSecondaryLinkItem:"SecondaryLinkItemUpdateResult",
		upsertSecondaryLinkItem:"SecondaryLinkItemUpsertResult",
		createRestaurant:"RestaurantCreateResult",
		deleteRestaurant:"RestaurantDeleteResult",
		updateRestaurant:"RestaurantUpdateResult",
		upsertRestaurant:"RestaurantUpsertResult",
		createRestaurantLocale:"RestaurantLocaleCreateResult",
		deleteRestaurantLocale:"RestaurantLocaleDeleteResult",
		updateRestaurantLocale:"RestaurantLocaleUpdateResult",
		upsertRestaurantLocale:"RestaurantLocaleUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createRestaurantItem:"RestaurantItemCreateResult",
		deleteRestaurantItem:"RestaurantItemDeleteResult",
		updateRestaurantItem:"RestaurantItemUpdateResult",
		upsertRestaurantItem:"RestaurantItemUpsertResult",
		createRestaurantTag:"RestaurantTagCreateResult",
		deleteRestaurantTag:"RestaurantTagDeleteResult",
		updateRestaurantTag:"RestaurantTagUpdateResult",
		upsertRestaurantTag:"RestaurantTagUpsertResult",
		createRestaurantTagLocale:"RestaurantTagLocaleCreateResult",
		deleteRestaurantTagLocale:"RestaurantTagLocaleDeleteResult",
		updateRestaurantTagLocale:"RestaurantTagLocaleUpdateResult",
		upsertRestaurantTagLocale:"RestaurantTagLocaleUpsertResult",
		createBanner:"BannerCreateResult",
		deleteBanner:"BannerDeleteResult",
		updateBanner:"BannerUpdateResult",
		upsertBanner:"BannerUpsertResult",
		createBannerLocale:"BannerLocaleCreateResult",
		deleteBannerLocale:"BannerLocaleDeleteResult",
		updateBannerLocale:"BannerLocaleUpdateResult",
		upsertBannerLocale:"BannerLocaleUpsertResult",
		createCategory:"CategoryCreateResult",
		deleteCategory:"CategoryDeleteResult",
		updateCategory:"CategoryUpdateResult",
		upsertCategory:"CategoryUpsertResult",
		createCategoryLocale:"CategoryLocaleCreateResult",
		deleteCategoryLocale:"CategoryLocaleDeleteResult",
		updateCategoryLocale:"CategoryLocaleUpdateResult",
		upsertCategoryLocale:"CategoryLocaleUpsertResult",
		createSubRestaurantsPage:"SubRestaurantsPageCreateResult",
		deleteSubRestaurantsPage:"SubRestaurantsPageDeleteResult",
		updateSubRestaurantsPage:"SubRestaurantsPageUpdateResult",
		upsertSubRestaurantsPage:"SubRestaurantsPageUpsertResult",
		createSubRestaurantsPageLocale:"SubRestaurantsPageLocaleCreateResult",
		deleteSubRestaurantsPageLocale:"SubRestaurantsPageLocaleDeleteResult",
		updateSubRestaurantsPageLocale:"SubRestaurantsPageLocaleUpdateResult",
		upsertSubRestaurantsPageLocale:"SubRestaurantsPageLocaleUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	FrontPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on FrontPageCreateResult": "FrontPageCreateResult",
		"...on FrontPageDeleteResult": "FrontPageDeleteResult",
		"...on FrontPageUpdateResult": "FrontPageUpdateResult",
		"...on FrontPageUpsertResult": "FrontPageUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on LocaleCreateResult": "LocaleCreateResult",
		"...on LocaleDeleteResult": "LocaleDeleteResult",
		"...on LocaleUpdateResult": "LocaleUpdateResult",
		"...on LocaleUpsertResult": "LocaleUpsertResult",
		"...on FrontPageLocaleCreateResult": "FrontPageLocaleCreateResult",
		"...on FrontPageLocaleDeleteResult": "FrontPageLocaleDeleteResult",
		"...on FrontPageLocaleUpdateResult": "FrontPageLocaleUpdateResult",
		"...on FrontPageLocaleUpsertResult": "FrontPageLocaleUpsertResult",
		"...on LinkListCreateResult": "LinkListCreateResult",
		"...on LinkListDeleteResult": "LinkListDeleteResult",
		"...on LinkListUpdateResult": "LinkListUpdateResult",
		"...on LinkListUpsertResult": "LinkListUpsertResult",
		"...on LinkItemCreateResult": "LinkItemCreateResult",
		"...on LinkItemDeleteResult": "LinkItemDeleteResult",
		"...on LinkItemUpdateResult": "LinkItemUpdateResult",
		"...on LinkItemUpsertResult": "LinkItemUpsertResult",
		"...on SocialLinkListCreateResult": "SocialLinkListCreateResult",
		"...on SocialLinkListDeleteResult": "SocialLinkListDeleteResult",
		"...on SocialLinkListUpdateResult": "SocialLinkListUpdateResult",
		"...on SocialLinkListUpsertResult": "SocialLinkListUpsertResult",
		"...on SocialLinkItemCreateResult": "SocialLinkItemCreateResult",
		"...on SocialLinkItemDeleteResult": "SocialLinkItemDeleteResult",
		"...on SocialLinkItemUpdateResult": "SocialLinkItemUpdateResult",
		"...on SocialLinkItemUpsertResult": "SocialLinkItemUpsertResult",
		"...on PrimaryLinkItemCreateResult": "PrimaryLinkItemCreateResult",
		"...on PrimaryLinkItemDeleteResult": "PrimaryLinkItemDeleteResult",
		"...on PrimaryLinkItemUpdateResult": "PrimaryLinkItemUpdateResult",
		"...on PrimaryLinkItemUpsertResult": "PrimaryLinkItemUpsertResult",
		"...on HeaderLocaleCreateResult": "HeaderLocaleCreateResult",
		"...on HeaderLocaleDeleteResult": "HeaderLocaleDeleteResult",
		"...on HeaderLocaleUpdateResult": "HeaderLocaleUpdateResult",
		"...on HeaderLocaleUpsertResult": "HeaderLocaleUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on FooterLocaleCreateResult": "FooterLocaleCreateResult",
		"...on FooterLocaleDeleteResult": "FooterLocaleDeleteResult",
		"...on FooterLocaleUpdateResult": "FooterLocaleUpdateResult",
		"...on FooterLocaleUpsertResult": "FooterLocaleUpsertResult",
		"...on FooterLinksCreateResult": "FooterLinksCreateResult",
		"...on FooterLinksDeleteResult": "FooterLinksDeleteResult",
		"...on FooterLinksUpdateResult": "FooterLinksUpdateResult",
		"...on FooterLinksUpsertResult": "FooterLinksUpsertResult",
		"...on FooterContactCreateResult": "FooterContactCreateResult",
		"...on FooterContactDeleteResult": "FooterContactDeleteResult",
		"...on FooterContactUpdateResult": "FooterContactUpdateResult",
		"...on FooterContactUpsertResult": "FooterContactUpsertResult",
		"...on TitleListCreateResult": "TitleListCreateResult",
		"...on TitleListDeleteResult": "TitleListDeleteResult",
		"...on TitleListUpdateResult": "TitleListUpdateResult",
		"...on TitleListUpsertResult": "TitleListUpsertResult",
		"...on TitleItemCreateResult": "TitleItemCreateResult",
		"...on TitleItemDeleteResult": "TitleItemDeleteResult",
		"...on TitleItemUpdateResult": "TitleItemUpdateResult",
		"...on TitleItemUpsertResult": "TitleItemUpsertResult",
		"...on SocialLinkCreateResult": "SocialLinkCreateResult",
		"...on SocialLinkDeleteResult": "SocialLinkDeleteResult",
		"...on SocialLinkUpdateResult": "SocialLinkUpdateResult",
		"...on SocialLinkUpsertResult": "SocialLinkUpsertResult",
		"...on SecondaryLinkListCreateResult": "SecondaryLinkListCreateResult",
		"...on SecondaryLinkListDeleteResult": "SecondaryLinkListDeleteResult",
		"...on SecondaryLinkListUpdateResult": "SecondaryLinkListUpdateResult",
		"...on SecondaryLinkListUpsertResult": "SecondaryLinkListUpsertResult",
		"...on SecondaryLinkItemCreateResult": "SecondaryLinkItemCreateResult",
		"...on SecondaryLinkItemDeleteResult": "SecondaryLinkItemDeleteResult",
		"...on SecondaryLinkItemUpdateResult": "SecondaryLinkItemUpdateResult",
		"...on SecondaryLinkItemUpsertResult": "SecondaryLinkItemUpsertResult",
		"...on RestaurantCreateResult": "RestaurantCreateResult",
		"...on RestaurantDeleteResult": "RestaurantDeleteResult",
		"...on RestaurantUpdateResult": "RestaurantUpdateResult",
		"...on RestaurantUpsertResult": "RestaurantUpsertResult",
		"...on RestaurantLocaleCreateResult": "RestaurantLocaleCreateResult",
		"...on RestaurantLocaleDeleteResult": "RestaurantLocaleDeleteResult",
		"...on RestaurantLocaleUpdateResult": "RestaurantLocaleUpdateResult",
		"...on RestaurantLocaleUpsertResult": "RestaurantLocaleUpsertResult",
		"...on TranslationDomainCreateResult": "TranslationDomainCreateResult",
		"...on TranslationDomainDeleteResult": "TranslationDomainDeleteResult",
		"...on TranslationDomainUpdateResult": "TranslationDomainUpdateResult",
		"...on TranslationDomainUpsertResult": "TranslationDomainUpsertResult",
		"...on TranslationCatalogueCreateResult": "TranslationCatalogueCreateResult",
		"...on TranslationCatalogueDeleteResult": "TranslationCatalogueDeleteResult",
		"...on TranslationCatalogueUpdateResult": "TranslationCatalogueUpdateResult",
		"...on TranslationCatalogueUpsertResult": "TranslationCatalogueUpsertResult",
		"...on TranslationCataloguesIdentifierCreateResult": "TranslationCataloguesIdentifierCreateResult",
		"...on TranslationCataloguesIdentifierDeleteResult": "TranslationCataloguesIdentifierDeleteResult",
		"...on TranslationCataloguesIdentifierUpdateResult": "TranslationCataloguesIdentifierUpdateResult",
		"...on TranslationCataloguesIdentifierUpsertResult": "TranslationCataloguesIdentifierUpsertResult",
		"...on TranslationKeyCreateResult": "TranslationKeyCreateResult",
		"...on TranslationKeyDeleteResult": "TranslationKeyDeleteResult",
		"...on TranslationKeyUpdateResult": "TranslationKeyUpdateResult",
		"...on TranslationKeyUpsertResult": "TranslationKeyUpsertResult",
		"...on TranslationValueCreateResult": "TranslationValueCreateResult",
		"...on TranslationValueDeleteResult": "TranslationValueDeleteResult",
		"...on TranslationValueUpdateResult": "TranslationValueUpdateResult",
		"...on TranslationValueUpsertResult": "TranslationValueUpsertResult",
		"...on RestaurantItemCreateResult": "RestaurantItemCreateResult",
		"...on RestaurantItemDeleteResult": "RestaurantItemDeleteResult",
		"...on RestaurantItemUpdateResult": "RestaurantItemUpdateResult",
		"...on RestaurantItemUpsertResult": "RestaurantItemUpsertResult",
		"...on RestaurantTagCreateResult": "RestaurantTagCreateResult",
		"...on RestaurantTagDeleteResult": "RestaurantTagDeleteResult",
		"...on RestaurantTagUpdateResult": "RestaurantTagUpdateResult",
		"...on RestaurantTagUpsertResult": "RestaurantTagUpsertResult",
		"...on RestaurantTagLocaleCreateResult": "RestaurantTagLocaleCreateResult",
		"...on RestaurantTagLocaleDeleteResult": "RestaurantTagLocaleDeleteResult",
		"...on RestaurantTagLocaleUpdateResult": "RestaurantTagLocaleUpdateResult",
		"...on RestaurantTagLocaleUpsertResult": "RestaurantTagLocaleUpsertResult",
		"...on BannerCreateResult": "BannerCreateResult",
		"...on BannerDeleteResult": "BannerDeleteResult",
		"...on BannerUpdateResult": "BannerUpdateResult",
		"...on BannerUpsertResult": "BannerUpsertResult",
		"...on BannerLocaleCreateResult": "BannerLocaleCreateResult",
		"...on BannerLocaleDeleteResult": "BannerLocaleDeleteResult",
		"...on BannerLocaleUpdateResult": "BannerLocaleUpdateResult",
		"...on BannerLocaleUpsertResult": "BannerLocaleUpsertResult",
		"...on CategoryCreateResult": "CategoryCreateResult",
		"...on CategoryDeleteResult": "CategoryDeleteResult",
		"...on CategoryUpdateResult": "CategoryUpdateResult",
		"...on CategoryUpsertResult": "CategoryUpsertResult",
		"...on CategoryLocaleCreateResult": "CategoryLocaleCreateResult",
		"...on CategoryLocaleDeleteResult": "CategoryLocaleDeleteResult",
		"...on CategoryLocaleUpdateResult": "CategoryLocaleUpdateResult",
		"...on CategoryLocaleUpsertResult": "CategoryLocaleUpsertResult",
		"...on SubRestaurantsPageCreateResult": "SubRestaurantsPageCreateResult",
		"...on SubRestaurantsPageDeleteResult": "SubRestaurantsPageDeleteResult",
		"...on SubRestaurantsPageUpdateResult": "SubRestaurantsPageUpdateResult",
		"...on SubRestaurantsPageUpsertResult": "SubRestaurantsPageUpsertResult",
		"...on SubRestaurantsPageLocaleCreateResult": "SubRestaurantsPageLocaleCreateResult",
		"...on SubRestaurantsPageLocaleDeleteResult": "SubRestaurantsPageLocaleDeleteResult",
		"...on SubRestaurantsPageLocaleUpdateResult": "SubRestaurantsPageLocaleUpdateResult",
		"...on SubRestaurantsPageLocaleUpsertResult": "SubRestaurantsPageLocaleUpsertResult",
		"...on ImageListCreateResult": "ImageListCreateResult",
		"...on ImageListDeleteResult": "ImageListDeleteResult",
		"...on ImageListUpdateResult": "ImageListUpdateResult",
		"...on ImageListUpsertResult": "ImageListUpsertResult",
		"...on ImageListItemCreateResult": "ImageListItemCreateResult",
		"...on ImageListItemDeleteResult": "ImageListItemDeleteResult",
		"...on ImageListItemUpdateResult": "ImageListItemUpdateResult",
		"...on ImageListItemUpsertResult": "ImageListItemUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	FrontPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage"
	},
	FrontPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage",
		validation:"_ValidationResult"
	},
	FrontPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPage",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	LocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale"
	},
	LocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	FrontPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPageLocale",
		validation:"_ValidationResult"
	},
	FrontPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPageLocale"
	},
	FrontPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPageLocale",
		validation:"_ValidationResult"
	},
	FrontPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FrontPageLocale",
		validation:"_ValidationResult"
	},
	LinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList"
	},
	LinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkList",
		validation:"_ValidationResult"
	},
	LinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem"
	},
	LinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	LinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList"
	},
	SocialLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem"
	},
	SocialLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	PrimaryLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrimaryLinkItem",
		validation:"_ValidationResult"
	},
	PrimaryLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrimaryLinkItem"
	},
	PrimaryLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrimaryLinkItem",
		validation:"_ValidationResult"
	},
	PrimaryLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PrimaryLinkItem",
		validation:"_ValidationResult"
	},
	HeaderLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale"
	},
	HeaderLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale"
	},
	FooterLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLinksCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinks",
		validation:"_ValidationResult"
	},
	FooterLinksDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinks"
	},
	FooterLinksUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinks",
		validation:"_ValidationResult"
	},
	FooterLinksUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLinks",
		validation:"_ValidationResult"
	},
	FooterContactCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterContact",
		validation:"_ValidationResult"
	},
	FooterContactDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterContact"
	},
	FooterContactUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterContact",
		validation:"_ValidationResult"
	},
	FooterContactUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterContact",
		validation:"_ValidationResult"
	},
	TitleListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleList",
		validation:"_ValidationResult"
	},
	TitleListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleList"
	},
	TitleListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleList",
		validation:"_ValidationResult"
	},
	TitleListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleList",
		validation:"_ValidationResult"
	},
	TitleItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleItem",
		validation:"_ValidationResult"
	},
	TitleItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleItem"
	},
	TitleItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleItem",
		validation:"_ValidationResult"
	},
	TitleItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TitleItem",
		validation:"_ValidationResult"
	},
	SocialLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink"
	},
	SocialLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SecondaryLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkList",
		validation:"_ValidationResult"
	},
	SecondaryLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkList"
	},
	SecondaryLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkList",
		validation:"_ValidationResult"
	},
	SecondaryLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkList",
		validation:"_ValidationResult"
	},
	SecondaryLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkItem",
		validation:"_ValidationResult"
	},
	SecondaryLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkItem"
	},
	SecondaryLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkItem",
		validation:"_ValidationResult"
	},
	SecondaryLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SecondaryLinkItem",
		validation:"_ValidationResult"
	},
	RestaurantCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Restaurant",
		validation:"_ValidationResult"
	},
	RestaurantDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Restaurant"
	},
	RestaurantUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Restaurant",
		validation:"_ValidationResult"
	},
	RestaurantUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Restaurant",
		validation:"_ValidationResult"
	},
	RestaurantLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantLocale",
		validation:"_ValidationResult"
	},
	RestaurantLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantLocale"
	},
	RestaurantLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantLocale",
		validation:"_ValidationResult"
	},
	RestaurantLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantLocale",
		validation:"_ValidationResult"
	},
	TranslationDomainCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain"
	},
	TranslationDomainUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationCatalogueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue"
	},
	TranslationCatalogueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier"
	},
	TranslationCataloguesIdentifierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationKeyCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey"
	},
	TranslationKeyUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationValueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue"
	},
	TranslationValueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	RestaurantItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantItem",
		validation:"_ValidationResult"
	},
	RestaurantItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantItem"
	},
	RestaurantItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantItem",
		validation:"_ValidationResult"
	},
	RestaurantItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantItem",
		validation:"_ValidationResult"
	},
	RestaurantTagCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTag",
		validation:"_ValidationResult"
	},
	RestaurantTagDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTag"
	},
	RestaurantTagUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTag",
		validation:"_ValidationResult"
	},
	RestaurantTagUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTag",
		validation:"_ValidationResult"
	},
	RestaurantTagLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTagLocale",
		validation:"_ValidationResult"
	},
	RestaurantTagLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTagLocale"
	},
	RestaurantTagLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTagLocale",
		validation:"_ValidationResult"
	},
	RestaurantTagLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"RestaurantTagLocale",
		validation:"_ValidationResult"
	},
	BannerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Banner",
		validation:"_ValidationResult"
	},
	BannerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Banner"
	},
	BannerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Banner",
		validation:"_ValidationResult"
	},
	BannerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Banner",
		validation:"_ValidationResult"
	},
	BannerLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BannerLocale",
		validation:"_ValidationResult"
	},
	BannerLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BannerLocale"
	},
	BannerLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BannerLocale",
		validation:"_ValidationResult"
	},
	BannerLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BannerLocale",
		validation:"_ValidationResult"
	},
	CategoryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category",
		validation:"_ValidationResult"
	},
	CategoryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category"
	},
	CategoryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category",
		validation:"_ValidationResult"
	},
	CategoryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Category",
		validation:"_ValidationResult"
	},
	CategoryLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CategoryLocale",
		validation:"_ValidationResult"
	},
	CategoryLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CategoryLocale"
	},
	CategoryLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CategoryLocale",
		validation:"_ValidationResult"
	},
	CategoryLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"CategoryLocale",
		validation:"_ValidationResult"
	},
	SubRestaurantsPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPage",
		validation:"_ValidationResult"
	},
	SubRestaurantsPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPage"
	},
	SubRestaurantsPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPage",
		validation:"_ValidationResult"
	},
	SubRestaurantsPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPage",
		validation:"_ValidationResult"
	},
	SubRestaurantsPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPageLocale",
		validation:"_ValidationResult"
	},
	SubRestaurantsPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPageLocale"
	},
	SubRestaurantsPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPageLocale",
		validation:"_ValidationResult"
	},
	SubRestaurantsPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SubRestaurantsPageLocale",
		validation:"_ValidationResult"
	},
	ImageListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList"
	},
	ImageListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageList",
		validation:"_ValidationResult"
	},
	ImageListItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem"
	},
	ImageListItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	ImageListItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ImageListItem",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createFrontPage:"FrontPageCreateResult",
		deleteFrontPage:"FrontPageDeleteResult",
		updateFrontPage:"FrontPageUpdateResult",
		upsertFrontPage:"FrontPageUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createFrontPageLocale:"FrontPageLocaleCreateResult",
		deleteFrontPageLocale:"FrontPageLocaleDeleteResult",
		updateFrontPageLocale:"FrontPageLocaleUpdateResult",
		upsertFrontPageLocale:"FrontPageLocaleUpsertResult",
		createLinkList:"LinkListCreateResult",
		deleteLinkList:"LinkListDeleteResult",
		updateLinkList:"LinkListUpdateResult",
		upsertLinkList:"LinkListUpsertResult",
		createLinkItem:"LinkItemCreateResult",
		deleteLinkItem:"LinkItemDeleteResult",
		updateLinkItem:"LinkItemUpdateResult",
		upsertLinkItem:"LinkItemUpsertResult",
		createSocialLinkList:"SocialLinkListCreateResult",
		deleteSocialLinkList:"SocialLinkListDeleteResult",
		updateSocialLinkList:"SocialLinkListUpdateResult",
		upsertSocialLinkList:"SocialLinkListUpsertResult",
		createSocialLinkItem:"SocialLinkItemCreateResult",
		deleteSocialLinkItem:"SocialLinkItemDeleteResult",
		updateSocialLinkItem:"SocialLinkItemUpdateResult",
		upsertSocialLinkItem:"SocialLinkItemUpsertResult",
		createPrimaryLinkItem:"PrimaryLinkItemCreateResult",
		deletePrimaryLinkItem:"PrimaryLinkItemDeleteResult",
		updatePrimaryLinkItem:"PrimaryLinkItemUpdateResult",
		upsertPrimaryLinkItem:"PrimaryLinkItemUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createFooterLinks:"FooterLinksCreateResult",
		deleteFooterLinks:"FooterLinksDeleteResult",
		updateFooterLinks:"FooterLinksUpdateResult",
		upsertFooterLinks:"FooterLinksUpsertResult",
		createFooterContact:"FooterContactCreateResult",
		deleteFooterContact:"FooterContactDeleteResult",
		updateFooterContact:"FooterContactUpdateResult",
		upsertFooterContact:"FooterContactUpsertResult",
		createTitleList:"TitleListCreateResult",
		deleteTitleList:"TitleListDeleteResult",
		updateTitleList:"TitleListUpdateResult",
		upsertTitleList:"TitleListUpsertResult",
		createTitleItem:"TitleItemCreateResult",
		deleteTitleItem:"TitleItemDeleteResult",
		updateTitleItem:"TitleItemUpdateResult",
		upsertTitleItem:"TitleItemUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createSecondaryLinkList:"SecondaryLinkListCreateResult",
		deleteSecondaryLinkList:"SecondaryLinkListDeleteResult",
		updateSecondaryLinkList:"SecondaryLinkListUpdateResult",
		upsertSecondaryLinkList:"SecondaryLinkListUpsertResult",
		createSecondaryLinkItem:"SecondaryLinkItemCreateResult",
		deleteSecondaryLinkItem:"SecondaryLinkItemDeleteResult",
		updateSecondaryLinkItem:"SecondaryLinkItemUpdateResult",
		upsertSecondaryLinkItem:"SecondaryLinkItemUpsertResult",
		createRestaurant:"RestaurantCreateResult",
		deleteRestaurant:"RestaurantDeleteResult",
		updateRestaurant:"RestaurantUpdateResult",
		upsertRestaurant:"RestaurantUpsertResult",
		createRestaurantLocale:"RestaurantLocaleCreateResult",
		deleteRestaurantLocale:"RestaurantLocaleDeleteResult",
		updateRestaurantLocale:"RestaurantLocaleUpdateResult",
		upsertRestaurantLocale:"RestaurantLocaleUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createRestaurantItem:"RestaurantItemCreateResult",
		deleteRestaurantItem:"RestaurantItemDeleteResult",
		updateRestaurantItem:"RestaurantItemUpdateResult",
		upsertRestaurantItem:"RestaurantItemUpsertResult",
		createRestaurantTag:"RestaurantTagCreateResult",
		deleteRestaurantTag:"RestaurantTagDeleteResult",
		updateRestaurantTag:"RestaurantTagUpdateResult",
		upsertRestaurantTag:"RestaurantTagUpsertResult",
		createRestaurantTagLocale:"RestaurantTagLocaleCreateResult",
		deleteRestaurantTagLocale:"RestaurantTagLocaleDeleteResult",
		updateRestaurantTagLocale:"RestaurantTagLocaleUpdateResult",
		upsertRestaurantTagLocale:"RestaurantTagLocaleUpsertResult",
		createBanner:"BannerCreateResult",
		deleteBanner:"BannerDeleteResult",
		updateBanner:"BannerUpdateResult",
		upsertBanner:"BannerUpsertResult",
		createBannerLocale:"BannerLocaleCreateResult",
		deleteBannerLocale:"BannerLocaleDeleteResult",
		updateBannerLocale:"BannerLocaleUpdateResult",
		upsertBannerLocale:"BannerLocaleUpsertResult",
		createCategory:"CategoryCreateResult",
		deleteCategory:"CategoryDeleteResult",
		updateCategory:"CategoryUpdateResult",
		upsertCategory:"CategoryUpsertResult",
		createCategoryLocale:"CategoryLocaleCreateResult",
		deleteCategoryLocale:"CategoryLocaleDeleteResult",
		updateCategoryLocale:"CategoryLocaleUpdateResult",
		upsertCategoryLocale:"CategoryLocaleUpsertResult",
		createSubRestaurantsPage:"SubRestaurantsPageCreateResult",
		deleteSubRestaurantsPage:"SubRestaurantsPageDeleteResult",
		updateSubRestaurantsPage:"SubRestaurantsPageUpdateResult",
		upsertSubRestaurantsPage:"SubRestaurantsPageUpsertResult",
		createSubRestaurantsPageLocale:"SubRestaurantsPageLocaleCreateResult",
		deleteSubRestaurantsPageLocale:"SubRestaurantsPageLocaleDeleteResult",
		updateSubRestaurantsPageLocale:"SubRestaurantsPageLocaleUpdateResult",
		upsertSubRestaurantsPageLocale:"SubRestaurantsPageLocaleUpsertResult",
		createImageList:"ImageListCreateResult",
		deleteImageList:"ImageListDeleteResult",
		updateImageList:"ImageListUpdateResult",
		upsertImageList:"ImageListUpsertResult",
		createImageListItem:"ImageListItemCreateResult",
		deleteImageListItem:"ImageListItemDeleteResult",
		updateImageListItem:"ImageListItemUpdateResult",
		upsertImageListItem:"ImageListItemUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPage"]],
listFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPage"]],
paginateFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageConnection"]],
validateCreateFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
listLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
listFrontPageLocale?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPageLocale"]],
paginateFrontPageLocale?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageLocaleConnection"]],
validateCreateFrontPageLocale?: [{	data:ValueTypes["FrontPageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	data:ValueTypes["FrontPageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
listSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkList"]],
paginateSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkListConnection"]],
validateCreateSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
listSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
paginateSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
validateCreateSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItem"]],
listPrimaryLinkItem?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrimaryLinkItem"]],
paginatePrimaryLinkItem?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrimaryLinkItemConnection"]],
validateCreatePrimaryLinkItem?: [{	data:ValueTypes["PrimaryLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	data:ValueTypes["PrimaryLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null},ValueTypes["FooterLinks"]],
listFooterLinks?: [{	filter?:ValueTypes["FooterLinksWhere"] | null,	orderBy?:ValueTypes["FooterLinksOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLinks"]],
paginateFooterLinks?: [{	filter?:ValueTypes["FooterLinksWhere"] | null,	orderBy?:ValueTypes["FooterLinksOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinksConnection"]],
validateCreateFooterLinks?: [{	data:ValueTypes["FooterLinksCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	data:ValueTypes["FooterLinksUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null},ValueTypes["FooterContact"]],
listFooterContact?: [{	filter?:ValueTypes["FooterContactWhere"] | null,	orderBy?:ValueTypes["FooterContactOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterContact"]],
paginateFooterContact?: [{	filter?:ValueTypes["FooterContactWhere"] | null,	orderBy?:ValueTypes["FooterContactOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterContactConnection"]],
validateCreateFooterContact?: [{	data:ValueTypes["FooterContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	data:ValueTypes["FooterContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null},ValueTypes["TitleList"]],
listTitleList?: [{	filter?:ValueTypes["TitleListWhere"] | null,	orderBy?:ValueTypes["TitleListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TitleList"]],
paginateTitleList?: [{	filter?:ValueTypes["TitleListWhere"] | null,	orderBy?:ValueTypes["TitleListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TitleListConnection"]],
validateCreateTitleList?: [{	data:ValueTypes["TitleListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	data:ValueTypes["TitleListUpdateInput"]},ValueTypes["_ValidationResult"]],
getTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null},ValueTypes["TitleItem"]],
listTitleItem?: [{	filter?:ValueTypes["TitleItemWhere"] | null,	orderBy?:ValueTypes["TitleItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TitleItem"]],
paginateTitleItem?: [{	filter?:ValueTypes["TitleItemWhere"] | null,	orderBy?:ValueTypes["TitleItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TitleItemConnection"]],
validateCreateTitleItem?: [{	data:ValueTypes["TitleItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	data:ValueTypes["TitleItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null},ValueTypes["SecondaryLinkList"]],
listSecondaryLinkList?: [{	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SecondaryLinkList"]],
paginateSecondaryLinkList?: [{	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SecondaryLinkListConnection"]],
validateCreateSecondaryLinkList?: [{	data:ValueTypes["SecondaryLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	data:ValueTypes["SecondaryLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null},ValueTypes["SecondaryLinkItem"]],
listSecondaryLinkItem?: [{	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SecondaryLinkItem"]],
paginateSecondaryLinkItem?: [{	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SecondaryLinkItemConnection"]],
validateCreateSecondaryLinkItem?: [{	data:ValueTypes["SecondaryLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	data:ValueTypes["SecondaryLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["Restaurant"]],
listRestaurant?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Restaurant"]],
paginateRestaurant?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantConnection"]],
validateCreateRestaurant?: [{	data:ValueTypes["RestaurantCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	data:ValueTypes["RestaurantUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null},ValueTypes["RestaurantLocale"]],
listRestaurantLocale?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantLocale"]],
paginateRestaurantLocale?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantLocaleConnection"]],
validateCreateRestaurantLocale?: [{	data:ValueTypes["RestaurantLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	data:ValueTypes["RestaurantLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null},ValueTypes["RestaurantItem"]],
listRestaurantItem?: [{	filter?:ValueTypes["RestaurantItemWhere"] | null,	orderBy?:ValueTypes["RestaurantItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantItem"]],
paginateRestaurantItem?: [{	filter?:ValueTypes["RestaurantItemWhere"] | null,	orderBy?:ValueTypes["RestaurantItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantItemConnection"]],
validateCreateRestaurantItem?: [{	data:ValueTypes["RestaurantItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	data:ValueTypes["RestaurantItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null},ValueTypes["RestaurantTag"]],
listRestaurantTag?: [{	filter?:ValueTypes["RestaurantTagWhere"] | null,	orderBy?:ValueTypes["RestaurantTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantTag"]],
paginateRestaurantTag?: [{	filter?:ValueTypes["RestaurantTagWhere"] | null,	orderBy?:ValueTypes["RestaurantTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantTagConnection"]],
validateCreateRestaurantTag?: [{	data:ValueTypes["RestaurantTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	data:ValueTypes["RestaurantTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null},ValueTypes["RestaurantTagLocale"]],
listRestaurantTagLocale?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantTagLocale"]],
paginateRestaurantTagLocale?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantTagLocaleConnection"]],
validateCreateRestaurantTagLocale?: [{	data:ValueTypes["RestaurantTagLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	data:ValueTypes["RestaurantTagLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null},ValueTypes["Banner"]],
listBanner?: [{	filter?:ValueTypes["BannerWhere"] | null,	orderBy?:ValueTypes["BannerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Banner"]],
paginateBanner?: [{	filter?:ValueTypes["BannerWhere"] | null,	orderBy?:ValueTypes["BannerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BannerConnection"]],
validateCreateBanner?: [{	data:ValueTypes["BannerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	data:ValueTypes["BannerUpdateInput"]},ValueTypes["_ValidationResult"]],
getBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null},ValueTypes["BannerLocale"]],
listBannerLocale?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BannerLocale"]],
paginateBannerLocale?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BannerLocaleConnection"]],
validateCreateBannerLocale?: [{	data:ValueTypes["BannerLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	data:ValueTypes["BannerLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["Category"]],
listCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Category"]],
paginateCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryConnection"]],
validateCreateCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocale"]],
listCategoryLocale?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CategoryLocale"]],
paginateCategoryLocale?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryLocaleConnection"]],
validateCreateCategoryLocale?: [{	data:ValueTypes["CategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	data:ValueTypes["CategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null},ValueTypes["SubRestaurantsPage"]],
listSubRestaurantsPage?: [{	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubRestaurantsPage"]],
paginateSubRestaurantsPage?: [{	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubRestaurantsPageConnection"]],
validateCreateSubRestaurantsPage?: [{	data:ValueTypes["SubRestaurantsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	data:ValueTypes["SubRestaurantsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
listSubRestaurantsPageLocale?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubRestaurantsPageLocale"]],
paginateSubRestaurantsPageLocale?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubRestaurantsPageLocaleConnection"]],
validateCreateSubRestaurantsPageLocale?: [{	data:ValueTypes["SubRestaurantsPageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	data:ValueTypes["SubRestaurantsPageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:boolean,
		__typename?: boolean
}>;
	["FrontPage"]: AliasType<{
	_meta?:ValueTypes["FrontPageMeta"],
	id?:boolean,
	unique?:boolean,
locales?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPageLocale"]],
banner?: [{	filter?:ValueTypes["BannerWhere"] | null},ValueTypes["Banner"]],
localesByLocale?: [{	by:ValueTypes["FrontPageLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
localesByLink?: [{	by:ValueTypes["FrontPageLocalesByLinkUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
localesBySeo?: [{	by:ValueTypes["FrontPageLocalesBySeoUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
paginateLocales?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageLocaleConnection"]],
		__typename?: boolean
}>;
	["FrontPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	banner?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FieldMeta"]: AliasType<{
	readable?:boolean,
	updatable?:boolean,
		__typename?: boolean
}>;
	["UUID"]:unknown;
	["One"]:One;
	["FrontPageLocale"]: AliasType<{
	_meta?:ValueTypes["FrontPageLocaleMeta"],
	id?:boolean,
	title?:boolean,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
root?: [{	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPage"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	socialLinks?:boolean,
		__typename?: boolean
}>;
	["FrontPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	socialLinks?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:boolean,
	url?:boolean,
frontPage?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
subRestaurantsPage?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
		__typename?: boolean
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	frontPage?:ValueTypes["FieldMeta"],
	subRestaurantsPage?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FrontPageLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	root?:ValueTypes["FrontPageWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	socialLinks?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["FrontPageLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["FrontPageLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["FrontPageLocaleWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	frontPage?:ValueTypes["FrontPageLocaleWhere"] | null,
	subRestaurantsPage?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["SubRestaurantsPageLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	root?:ValueTypes["SubRestaurantsPageWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["SubRestaurantsPageLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["SubRestaurantsPageLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null
};
	["SubRestaurantsPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	locales?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	parentRestaurant?:ValueTypes["RestaurantWhere"] | null,
	and?:(ValueTypes["SubRestaurantsPageWhere"] | undefined | null)[],
	or?:(ValueTypes["SubRestaurantsPageWhere"] | undefined | null)[],
	not?:ValueTypes["SubRestaurantsPageWhere"] | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["RestaurantWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	locales?:ValueTypes["RestaurantLocaleWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	subItems?:ValueTypes["RestaurantItemWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	item?:ValueTypes["RestaurantItemWhere"] | null,
	openingHours?:ValueTypes["StringCondition"] | null,
	tags?:ValueTypes["RestaurantTagWhere"] | null,
	categories?:ValueTypes["CategoryWhere"] | null,
	and?:(ValueTypes["RestaurantWhere"] | undefined | null)[],
	or?:(ValueTypes["RestaurantWhere"] | undefined | null)[],
	not?:ValueTypes["RestaurantWhere"] | null
};
	["RestaurantLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["RestaurantWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	description?:ValueTypes["StringCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	location?:ValueTypes["StringCondition"] | null,
	isEshopActive?:ValueTypes["BooleanCondition"] | null,
	isDeliveryActive?:ValueTypes["BooleanCondition"] | null,
	secondaryUrl?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["RestaurantLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["RestaurantLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["RestaurantLocaleWhere"] | null
};
	["LocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	code?:ValueTypes["StringCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	frontPages?:ValueTypes["FrontPageLocaleWhere"] | null,
	headers?:ValueTypes["HeaderLocaleWhere"] | null,
	footers?:ValueTypes["FooterLocaleWhere"] | null,
	restaurants?:ValueTypes["RestaurantLocaleWhere"] | null,
	restaurantTags?:ValueTypes["RestaurantTagLocaleWhere"] | null,
	banners?:ValueTypes["BannerLocaleWhere"] | null,
	categories?:ValueTypes["CategoryLocaleWhere"] | null,
	subRestaurantsPages?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,
	and?:(ValueTypes["LocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["LocaleWhere"] | undefined | null)[],
	not?:ValueTypes["LocaleWhere"] | null
};
	["HeaderLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	menuButtonText?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["HeaderWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	socialLinks?:ValueTypes["SocialLinkListWhere"] | null,
	primaryLinkItems?:ValueTypes["PrimaryLinkItemWhere"] | null,
	secondaryLinks?:ValueTypes["SecondaryLinkListWhere"] | null,
	and?:(ValueTypes["HeaderLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderLocaleWhere"] | null
};
	["HeaderWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	locales?:ValueTypes["HeaderLocaleWhere"] | null,
	navigationLogo?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderWhere"] | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	fileName?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["SocialLinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["SocialLinkItemWhere"] | null,
	and?:(ValueTypes["SocialLinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkListWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkListWhere"] | null
};
	["SocialLinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["SocialLinkListWhere"] | null,
	socialLink?:ValueTypes["SocialLinkWhere"] | null,
	and?:(ValueTypes["SocialLinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkItemWhere"] | null
};
	["SocialLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["SocialLinkTypeCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkWhere"] | null
};
	["SocialLinkTypeCondition"]: {
	and?:ValueTypes["SocialLinkTypeCondition"][],
	or?:ValueTypes["SocialLinkTypeCondition"][],
	not?:ValueTypes["SocialLinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["SocialLinkType"] | null,
	notEq?:ValueTypes["SocialLinkType"] | null,
	in?:ValueTypes["SocialLinkType"][],
	notIn?:ValueTypes["SocialLinkType"][],
	lt?:ValueTypes["SocialLinkType"] | null,
	lte?:ValueTypes["SocialLinkType"] | null,
	gt?:ValueTypes["SocialLinkType"] | null,
	gte?:ValueTypes["SocialLinkType"] | null
};
	["SocialLinkType"]:SocialLinkType;
	["PrimaryLinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	parent?:ValueTypes["PrimaryLinkItemWhere"] | null,
	subItems?:ValueTypes["PrimaryLinkItemWhere"] | null,
	header?:ValueTypes["HeaderLocaleWhere"] | null,
	and?:(ValueTypes["PrimaryLinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["PrimaryLinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["PrimaryLinkItemWhere"] | null
};
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	internalLink?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["SecondaryLinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["SecondaryLinkItemWhere"] | null,
	and?:(ValueTypes["SecondaryLinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["SecondaryLinkListWhere"] | undefined | null)[],
	not?:ValueTypes["SecondaryLinkListWhere"] | null
};
	["SecondaryLinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	iconType?:ValueTypes["IconTypeCondition"] | null,
	list?:ValueTypes["SecondaryLinkListWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["SecondaryLinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["SecondaryLinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["SecondaryLinkItemWhere"] | null
};
	["IconTypeCondition"]: {
	and?:ValueTypes["IconTypeCondition"][],
	or?:ValueTypes["IconTypeCondition"][],
	not?:ValueTypes["IconTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["IconType"] | null,
	notEq?:ValueTypes["IconType"] | null,
	in?:ValueTypes["IconType"][],
	notIn?:ValueTypes["IconType"][],
	lt?:ValueTypes["IconType"] | null,
	lte?:ValueTypes["IconType"] | null,
	gt?:ValueTypes["IconType"] | null,
	gte?:ValueTypes["IconType"] | null
};
	["IconType"]:IconType;
	["FooterLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	root?:ValueTypes["FooterWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	linksSection?:ValueTypes["FooterLinksWhere"] | null,
	contactSection?:ValueTypes["FooterContactWhere"] | null,
	and?:(ValueTypes["FooterLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["FooterLocaleWhere"] | null
};
	["FooterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	locales?:ValueTypes["FooterLocaleWhere"] | null,
	and?:(ValueTypes["FooterWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterWhere"] | undefined | null)[],
	not?:ValueTypes["FooterWhere"] | null
};
	["FooterLinksWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	buttonsTitle?:ValueTypes["StringCondition"] | null,
	linkList?:ValueTypes["LinkListWhere"] | null,
	buttons?:ValueTypes["LinkListWhere"] | null,
	titleList?:ValueTypes["TitleListWhere"] | null,
	and?:(ValueTypes["FooterLinksWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterLinksWhere"] | undefined | null)[],
	not?:ValueTypes["FooterLinksWhere"] | null
};
	["LinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["LinkItemWhere"] | null,
	and?:(ValueTypes["LinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkListWhere"] | undefined | null)[],
	not?:ValueTypes["LinkListWhere"] | null
};
	["LinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["LinkListWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	icon?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["LinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["LinkItemWhere"] | null
};
	["TitleListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["TitleItemWhere"] | null,
	and?:(ValueTypes["TitleListWhere"] | undefined | null)[],
	or?:(ValueTypes["TitleListWhere"] | undefined | null)[],
	not?:ValueTypes["TitleListWhere"] | null
};
	["TitleItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["TitleListWhere"] | null,
	icon?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["TitleItemWhere"] | undefined | null)[],
	or?:(ValueTypes["TitleItemWhere"] | undefined | null)[],
	not?:ValueTypes["TitleItemWhere"] | null
};
	["FooterContactWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	note?:ValueTypes["StringCondition"] | null,
	openingHours?:ValueTypes["StringCondition"] | null,
	identificationNumber?:ValueTypes["StringCondition"] | null,
	valueAddedTaxNumber?:ValueTypes["StringCondition"] | null,
	bussinessRegister?:ValueTypes["StringCondition"] | null,
	phoneImage?:ValueTypes["ImageWhere"] | null,
	address?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["FooterContactWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterContactWhere"] | undefined | null)[],
	not?:ValueTypes["FooterContactWhere"] | null
};
	["RestaurantTagLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["RestaurantTagWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	and?:(ValueTypes["RestaurantTagLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["RestaurantTagLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["RestaurantTagLocaleWhere"] | null
};
	["RestaurantTagWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	locales?:ValueTypes["RestaurantTagLocaleWhere"] | null,
	backgroundColor?:ValueTypes["StringCondition"] | null,
	titleColor?:ValueTypes["StringCondition"] | null,
	restaurants?:ValueTypes["RestaurantWhere"] | null,
	and?:(ValueTypes["RestaurantTagWhere"] | undefined | null)[],
	or?:(ValueTypes["RestaurantTagWhere"] | undefined | null)[],
	not?:ValueTypes["RestaurantTagWhere"] | null
};
	["BannerLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["BannerWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	title?:ValueTypes["StringCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["BannerLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["BannerLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["BannerLocaleWhere"] | null
};
	["BannerWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	locales?:ValueTypes["BannerLocaleWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	textColor?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["BannerWhere"] | undefined | null)[],
	or?:(ValueTypes["BannerWhere"] | undefined | null)[],
	not?:ValueTypes["BannerWhere"] | null
};
	["CategoryLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["CategoryWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	slug?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["CategoryLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["CategoryLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["CategoryLocaleWhere"] | null
};
	["CategoryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	locales?:ValueTypes["CategoryLocaleWhere"] | null,
	restaurants?:ValueTypes["RestaurantWhere"] | null,
	and?:(ValueTypes["CategoryWhere"] | undefined | null)[],
	or?:(ValueTypes["CategoryWhere"] | undefined | null)[],
	not?:ValueTypes["CategoryWhere"] | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["RestaurantItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	parent?:ValueTypes["RestaurantWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	restaurant?:ValueTypes["RestaurantWhere"] | null,
	and?:(ValueTypes["RestaurantItemWhere"] | undefined | null)[],
	or?:(ValueTypes["RestaurantItemWhere"] | undefined | null)[],
	not?:ValueTypes["RestaurantItemWhere"] | null
};
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	noIndex?:ValueTypes["BooleanCondition"] | null,
	noFollow?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["FrontPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["FrontPageLocaleWhere"] | null,
	banner?:ValueTypes["BannerWhere"] | null,
	and?:(ValueTypes["FrontPageWhere"] | undefined | null)[],
	or?:(ValueTypes["FrontPageWhere"] | undefined | null)[],
	not?:ValueTypes["FrontPageWhere"] | null
};
	["SubRestaurantsPageLocale"]: AliasType<{
	_meta?:ValueTypes["SubRestaurantsPageLocaleMeta"],
	id?:boolean,
	title?:boolean,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
root?: [{	filter?:ValueTypes["SubRestaurantsPageWhere"] | null},ValueTypes["SubRestaurantsPage"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SubRestaurantsPage"]: AliasType<{
	_meta?:ValueTypes["SubRestaurantsPageMeta"],
	id?:boolean,
locales?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubRestaurantsPageLocale"]],
	order?:boolean,
parentRestaurant?: [{	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["Restaurant"]],
localesByLocale?: [{	by:ValueTypes["SubRestaurantsPageLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
localesByLink?: [{	by:ValueTypes["SubRestaurantsPageLocalesByLinkUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
localesBySeo?: [{	by:ValueTypes["SubRestaurantsPageLocalesBySeoUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
paginateLocales?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubRestaurantsPageLocaleConnection"]],
		__typename?: boolean
}>;
	["SubRestaurantsPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	parentRestaurant?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	root?:ValueTypes["SubRestaurantsPageOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["OrderDirection"]:OrderDirection;
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	frontPage?:ValueTypes["FrontPageLocaleOrderBy"] | null,
	subRestaurantsPage?:ValueTypes["SubRestaurantsPageLocaleOrderBy"] | null
};
	["FrontPageLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	root?:ValueTypes["FrontPageOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	socialLinks?:ValueTypes["OrderDirection"] | null
};
	["FrontPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	banner?:ValueTypes["BannerOrderBy"] | null
};
	["BannerOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	textColor?:ValueTypes["OrderDirection"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null,
	fileName?:ValueTypes["OrderDirection"] | null
};
	["LocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	code?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null,
	noIndex?:ValueTypes["OrderDirection"] | null,
	noFollow?:ValueTypes["OrderDirection"] | null
};
	["SubRestaurantsPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	parentRestaurant?:ValueTypes["RestaurantOrderBy"] | null
};
	["RestaurantOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	item?:ValueTypes["RestaurantItemOrderBy"] | null,
	openingHours?:ValueTypes["OrderDirection"] | null
};
	["RestaurantItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	parent?:ValueTypes["RestaurantOrderBy"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	restaurant?:ValueTypes["RestaurantOrderBy"] | null
};
	["Restaurant"]: AliasType<{
	_meta?:ValueTypes["RestaurantMeta"],
	id?:boolean,
locales?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantLocale"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
subItems?: [{	filter?:ValueTypes["RestaurantItemWhere"] | null,	orderBy?:ValueTypes["RestaurantItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantItem"]],
	order?:boolean,
item?: [{	filter?:ValueTypes["RestaurantItemWhere"] | null},ValueTypes["RestaurantItem"]],
	openingHours?:boolean,
tags?: [{	filter?:ValueTypes["RestaurantTagWhere"] | null,	orderBy?:ValueTypes["RestaurantTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantTag"]],
categories?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Category"]],
localesByLocale?: [{	by:ValueTypes["RestaurantLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null},ValueTypes["RestaurantLocale"]],
subItemsByRestaurant?: [{	by:ValueTypes["RestaurantSubItemsByRestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null},ValueTypes["RestaurantItem"]],
paginateLocales?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantLocaleConnection"]],
paginateSubItems?: [{	filter?:ValueTypes["RestaurantItemWhere"] | null,	orderBy?:ValueTypes["RestaurantItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantItemConnection"]],
paginateTags?: [{	filter?:ValueTypes["RestaurantTagWhere"] | null,	orderBy?:ValueTypes["RestaurantTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantTagConnection"]],
paginateCategories?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryConnection"]],
		__typename?: boolean
}>;
	["RestaurantMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	subItems?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	item?:ValueTypes["FieldMeta"],
	openingHours?:ValueTypes["FieldMeta"],
	tags?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["RestaurantLocale"]: AliasType<{
	_meta?:ValueTypes["RestaurantLocaleMeta"],
	id?:boolean,
	title?:boolean,
root?: [{	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["Restaurant"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
	description?:boolean,
	url?:boolean,
	location?:boolean,
	isEshopActive?:boolean,
	isDeliveryActive?:boolean,
	secondaryUrl?:boolean,
		__typename?: boolean
}>;
	["RestaurantLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	location?:ValueTypes["FieldMeta"],
	isEshopActive?:ValueTypes["FieldMeta"],
	isDeliveryActive?:ValueTypes["FieldMeta"],
	secondaryUrl?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Locale"]: AliasType<{
	_meta?:ValueTypes["LocaleMeta"],
	id?:boolean,
	code?:boolean,
	label?:boolean,
frontPages?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPageLocale"]],
headers?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
footers?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
restaurants?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantLocale"]],
restaurantTags?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantTagLocale"]],
banners?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BannerLocale"]],
categories?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CategoryLocale"]],
subRestaurantsPages?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubRestaurantsPageLocale"]],
frontPagesByRoot?: [{	by:ValueTypes["LocaleFrontPagesByRootUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
frontPagesByLink?: [{	by:ValueTypes["LocaleFrontPagesByLinkUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
frontPagesBySeo?: [{	by:ValueTypes["LocaleFrontPagesBySeoUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
headersByRoot?: [{	by:ValueTypes["LocaleHeadersByRootUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
headersBySocialLinks?: [{	by:ValueTypes["LocaleHeadersBySocialLinksUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
headersByPrimaryLinkItems?: [{	by:ValueTypes["LocaleHeadersByPrimaryLinkItemsUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
headersBySecondaryLinks?: [{	by:ValueTypes["LocaleHeadersBySecondaryLinksUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
footersByRoot?: [{	by:ValueTypes["LocaleFootersByRootUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
footersByLinksSection?: [{	by:ValueTypes["LocaleFootersByLinksSectionUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
footersByContactSection?: [{	by:ValueTypes["LocaleFootersByContactSectionUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
restaurantsByRoot?: [{	by:ValueTypes["LocaleRestaurantsByRootUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null},ValueTypes["RestaurantLocale"]],
restaurantTagsByRoot?: [{	by:ValueTypes["LocaleRestaurantTagsByRootUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null},ValueTypes["RestaurantTagLocale"]],
bannersByRoot?: [{	by:ValueTypes["LocaleBannersByRootUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null},ValueTypes["BannerLocale"]],
categoriesByRoot?: [{	by:ValueTypes["LocaleCategoriesByRootUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocale"]],
categoriesBySlug?: [{	by:ValueTypes["LocaleCategoriesBySlugUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocale"]],
subRestaurantsPagesByRoot?: [{	by:ValueTypes["LocaleSubRestaurantsPagesByRootUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
subRestaurantsPagesByLink?: [{	by:ValueTypes["LocaleSubRestaurantsPagesByLinkUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
subRestaurantsPagesBySeo?: [{	by:ValueTypes["LocaleSubRestaurantsPagesBySeoUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
paginateFrontPages?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageLocaleConnection"]],
paginateHeaders?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
paginateFooters?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
paginateRestaurants?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantLocaleConnection"]],
paginateRestaurantTags?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantTagLocaleConnection"]],
paginateBanners?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BannerLocaleConnection"]],
paginateCategories?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryLocaleConnection"]],
paginateSubRestaurantsPages?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubRestaurantsPageLocaleConnection"]],
		__typename?: boolean
}>;
	["LocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	frontPages?:ValueTypes["FieldMeta"],
	headers?:ValueTypes["FieldMeta"],
	footers?:ValueTypes["FieldMeta"],
	restaurants?:ValueTypes["FieldMeta"],
	restaurantTags?:ValueTypes["FieldMeta"],
	banners?:ValueTypes["FieldMeta"],
	categories?:ValueTypes["FieldMeta"],
	subRestaurantsPages?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HeaderLocale"]: AliasType<{
	_meta?:ValueTypes["HeaderLocaleMeta"],
	id?:boolean,
	menuButtonText?:boolean,
root?: [{	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
socialLinks?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
primaryLinkItems?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrimaryLinkItem"]],
secondaryLinks?: [{	filter?:ValueTypes["SecondaryLinkListWhere"] | null},ValueTypes["SecondaryLinkList"]],
primaryLinkItemsByLink?: [{	by:ValueTypes["HeaderLocalePrimaryLinkItemsByLinkUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItem"]],
primaryLinkItemsBySubItems?: [{	by:ValueTypes["HeaderLocalePrimaryLinkItemsBySubItemsUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItem"]],
paginatePrimaryLinkItems?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrimaryLinkItemConnection"]],
		__typename?: boolean
}>;
	["HeaderLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	menuButtonText?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	socialLinks?:ValueTypes["FieldMeta"],
	primaryLinkItems?:ValueTypes["FieldMeta"],
	secondaryLinks?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:boolean,
	unique?:boolean,
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
locales?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
navigationLogo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
localesByLocale?: [{	by:ValueTypes["HeaderLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
localesBySocialLinks?: [{	by:ValueTypes["HeaderLocalesBySocialLinksUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
localesByPrimaryLinkItems?: [{	by:ValueTypes["HeaderLocalesByPrimaryLinkItemsUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
localesBySecondaryLinks?: [{	by:ValueTypes["HeaderLocalesBySecondaryLinksUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
paginateLocales?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
		__typename?: boolean
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	navigationLogo?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:boolean,
	url?:boolean,
	width?:boolean,
	height?:boolean,
	size?:boolean,
	type?:boolean,
	alt?:boolean,
	fileName?:boolean,
		__typename?: boolean
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
	fileName?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["HeaderLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	menuButtonText?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["HeaderOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	socialLinks?:ValueTypes["SocialLinkListOrderBy"] | null,
	secondaryLinks?:ValueTypes["SecondaryLinkListOrderBy"] | null
};
	["HeaderOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	navigationLogo?:ValueTypes["ImageOrderBy"] | null
};
	["SocialLinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["SecondaryLinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["LocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	frontPages?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	headers?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	footers?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	restaurants?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	restaurantTags?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	banners?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	categories?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	subRestaurantsPages?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null
};
	["FrontPageLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["FrontPageUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["FrontPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	banner?:ValueTypes["BannerUniqueWhere"] | null
};
	["BannerUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["BannerLocaleUniqueWhere"] | null
};
	["BannerLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["BannerUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	frontPage?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	subRestaurantsPage?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null
};
	["SubRestaurantsPageLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["SubRestaurantsPageUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SubRestaurantsPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	parentRestaurant?:ValueTypes["RestaurantUniqueWhere"] | null
};
	["RestaurantUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	subItems?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	item?:ValueTypes["RestaurantItemUniqueWhere"] | null
};
	["RestaurantLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["RestaurantUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["RestaurantItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	restaurant?:ValueTypes["RestaurantUniqueWhere"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["HeaderLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["HeaderUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	socialLinks?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	primaryLinkItems?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	secondaryLinks?:ValueTypes["SecondaryLinkListUniqueWhere"] | null
};
	["HeaderUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["HeaderLocaleUniqueWhere"] | null
};
	["SocialLinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SocialLinkItemUniqueWhere"] | null
};
	["SocialLinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	socialLink?:ValueTypes["SocialLinkUniqueWhere"] | null
};
	["SocialLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["PrimaryLinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null,
	subItems?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SecondaryLinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SecondaryLinkItemUniqueWhere"] | null
};
	["SecondaryLinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["FooterLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["FooterUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	linksSection?:ValueTypes["FooterLinksUniqueWhere"] | null,
	contactSection?:ValueTypes["FooterContactUniqueWhere"] | null
};
	["FooterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["FooterLocaleUniqueWhere"] | null
};
	["FooterLinksUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	linkList?:ValueTypes["LinkListUniqueWhere"] | null,
	buttons?:ValueTypes["LinkListUniqueWhere"] | null,
	titleList?:ValueTypes["TitleListUniqueWhere"] | null
};
	["LinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LinkItemUniqueWhere"] | null
};
	["LinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["TitleListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["TitleItemUniqueWhere"] | null
};
	["TitleItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FooterContactUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["RestaurantTagLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["RestaurantTagUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null
};
	["CategoryLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["CategoryUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	slug?:string | null
};
	["CategoryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["CategoryLocaleUniqueWhere"] | null
};
	["HeaderLocalesBySocialLinksUniqueWhere"]: {
	socialLinks?:ValueTypes["SocialLinkListUniqueWhere"] | null
};
	["HeaderLocalesByPrimaryLinkItemsUniqueWhere"]: {
	primaryLinkItems?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null
};
	["HeaderLocalesBySecondaryLinksUniqueWhere"]: {
	secondaryLinks?:ValueTypes["SecondaryLinkListUniqueWhere"] | null
};
	["HeaderLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderLocaleEdge"],
		__typename?: boolean
}>;
	["PageInfo"]: AliasType<{
	totalCount?:boolean,
		__typename?: boolean
}>;
	["HeaderLocaleEdge"]: AliasType<{
	node?:ValueTypes["HeaderLocale"],
		__typename?: boolean
}>;
	["SocialLinkList"]: AliasType<{
	_meta?:ValueTypes["SocialLinkListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
itemsBySocialLink?: [{	by:ValueTypes["SocialLinkListItemsBySocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
paginateItems?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
		__typename?: boolean
}>;
	["SocialLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialLinkItem"]: AliasType<{
	_meta?:ValueTypes["SocialLinkItemMeta"],
	id?:boolean,
	order?:boolean,
list?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
socialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
		__typename?: boolean
}>;
	["SocialLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	socialLink?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialLink"]: AliasType<{
	_meta?:ValueTypes["SocialLinkMeta"],
	id?:boolean,
	type?:boolean,
	url?:boolean,
		__typename?: boolean
}>;
	["SocialLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SocialLinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["SocialLinkListOrderBy"] | null,
	socialLink?:ValueTypes["SocialLinkOrderBy"] | null
};
	["SocialLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["SocialLinkListItemsBySocialLinkUniqueWhere"]: {
	socialLink?:ValueTypes["SocialLinkUniqueWhere"] | null
};
	["SocialLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkItemEdge"],
		__typename?: boolean
}>;
	["SocialLinkItemEdge"]: AliasType<{
	node?:ValueTypes["SocialLinkItem"],
		__typename?: boolean
}>;
	["PrimaryLinkItem"]: AliasType<{
	_meta?:ValueTypes["PrimaryLinkItemMeta"],
	id?:boolean,
	order?:boolean,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
parent?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItem"]],
subItems?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrimaryLinkItem"]],
header?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
subItemsByLink?: [{	by:ValueTypes["PrimaryLinkItemSubItemsByLinkUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItem"]],
subItemsBySubItems?: [{	by:ValueTypes["PrimaryLinkItemSubItemsBySubItemsUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItem"]],
paginateSubItems?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrimaryLinkItemConnection"]],
		__typename?: boolean
}>;
	["PrimaryLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	parent?:ValueTypes["FieldMeta"],
	subItems?:ValueTypes["FieldMeta"],
	header?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:boolean,
	type?:boolean,
	title?:boolean,
	externalLink?:boolean,
internalLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: boolean
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["PrimaryLinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	parent?:ValueTypes["PrimaryLinkItemOrderBy"] | null,
	header?:ValueTypes["HeaderLocaleOrderBy"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	internalLink?:ValueTypes["LinkableOrderBy"] | null
};
	["PrimaryLinkItemSubItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["PrimaryLinkItemSubItemsBySubItemsUniqueWhere"]: {
	subItems?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null
};
	["PrimaryLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PrimaryLinkItemEdge"],
		__typename?: boolean
}>;
	["PrimaryLinkItemEdge"]: AliasType<{
	node?:ValueTypes["PrimaryLinkItem"],
		__typename?: boolean
}>;
	["SecondaryLinkList"]: AliasType<{
	_meta?:ValueTypes["SecondaryLinkListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SecondaryLinkItem"]],
itemsByLink?: [{	by:ValueTypes["SecondaryLinkListItemsByLinkUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null},ValueTypes["SecondaryLinkItem"]],
paginateItems?: [{	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SecondaryLinkItemConnection"]],
		__typename?: boolean
}>;
	["SecondaryLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SecondaryLinkItem"]: AliasType<{
	_meta?:ValueTypes["SecondaryLinkItemMeta"],
	id?:boolean,
	order?:boolean,
	iconType?:boolean,
list?: [{	filter?:ValueTypes["SecondaryLinkListWhere"] | null},ValueTypes["SecondaryLinkList"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: boolean
}>;
	["SecondaryLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	iconType?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["SecondaryLinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	iconType?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["SecondaryLinkListOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["SecondaryLinkListItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["SecondaryLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SecondaryLinkItemEdge"],
		__typename?: boolean
}>;
	["SecondaryLinkItemEdge"]: AliasType<{
	node?:ValueTypes["SecondaryLinkItem"],
		__typename?: boolean
}>;
	["HeaderLocalePrimaryLinkItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["HeaderLocalePrimaryLinkItemsBySubItemsUniqueWhere"]: {
	subItems?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null
};
	["FooterLocale"]: AliasType<{
	_meta?:ValueTypes["FooterLocaleMeta"],
	id?:boolean,
root?: [{	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
linksSection?: [{	filter?:ValueTypes["FooterLinksWhere"] | null},ValueTypes["FooterLinks"]],
contactSection?: [{	filter?:ValueTypes["FooterContactWhere"] | null},ValueTypes["FooterContact"]],
		__typename?: boolean
}>;
	["FooterLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	linksSection?:ValueTypes["FieldMeta"],
	contactSection?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:boolean,
	unique?:boolean,
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
locales?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
localesByLocale?: [{	by:ValueTypes["FooterLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
localesByLinksSection?: [{	by:ValueTypes["FooterLocalesByLinksSectionUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
localesByContactSection?: [{	by:ValueTypes["FooterLocalesByContactSectionUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
paginateLocales?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
		__typename?: boolean
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FooterLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["FooterOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	linksSection?:ValueTypes["FooterLinksOrderBy"] | null,
	contactSection?:ValueTypes["FooterContactOrderBy"] | null
};
	["FooterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null
};
	["FooterLinksOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	buttonsTitle?:ValueTypes["OrderDirection"] | null,
	linkList?:ValueTypes["LinkListOrderBy"] | null,
	buttons?:ValueTypes["LinkListOrderBy"] | null,
	titleList?:ValueTypes["TitleListOrderBy"] | null
};
	["LinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["TitleListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["FooterContactOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	note?:ValueTypes["OrderDirection"] | null,
	openingHours?:ValueTypes["OrderDirection"] | null,
	identificationNumber?:ValueTypes["OrderDirection"] | null,
	valueAddedTaxNumber?:ValueTypes["OrderDirection"] | null,
	bussinessRegister?:ValueTypes["OrderDirection"] | null,
	phoneImage?:ValueTypes["ImageOrderBy"] | null,
	address?:ValueTypes["OrderDirection"] | null
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["FooterLocalesByLinksSectionUniqueWhere"]: {
	linksSection?:ValueTypes["FooterLinksUniqueWhere"] | null
};
	["FooterLocalesByContactSectionUniqueWhere"]: {
	contactSection?:ValueTypes["FooterContactUniqueWhere"] | null
};
	["FooterLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLocaleEdge"],
		__typename?: boolean
}>;
	["FooterLocaleEdge"]: AliasType<{
	node?:ValueTypes["FooterLocale"],
		__typename?: boolean
}>;
	["FooterLinks"]: AliasType<{
	_meta?:ValueTypes["FooterLinksMeta"],
	id?:boolean,
	buttonsTitle?:boolean,
linkList?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
buttons?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
titleList?: [{	filter?:ValueTypes["TitleListWhere"] | null},ValueTypes["TitleList"]],
		__typename?: boolean
}>;
	["FooterLinksMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	buttonsTitle?:ValueTypes["FieldMeta"],
	linkList?:ValueTypes["FieldMeta"],
	buttons?:ValueTypes["FieldMeta"],
	titleList?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LinkList"]: AliasType<{
	_meta?:ValueTypes["LinkListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
itemsByLink?: [{	by:ValueTypes["LinkListItemsByLinkUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
paginateItems?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
		__typename?: boolean
}>;
	["LinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LinkItem"]: AliasType<{
	_meta?:ValueTypes["LinkItemMeta"],
	id?:boolean,
	order?:boolean,
list?: [{	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
icon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: boolean
}>;
	["LinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["LinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["LinkListOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	icon?:ValueTypes["ImageOrderBy"] | null
};
	["LinkListItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["LinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkItemEdge"],
		__typename?: boolean
}>;
	["LinkItemEdge"]: AliasType<{
	node?:ValueTypes["LinkItem"],
		__typename?: boolean
}>;
	["TitleList"]: AliasType<{
	_meta?:ValueTypes["TitleListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["TitleItemWhere"] | null,	orderBy?:ValueTypes["TitleItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TitleItem"]],
paginateItems?: [{	filter?:ValueTypes["TitleItemWhere"] | null,	orderBy?:ValueTypes["TitleItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TitleItemConnection"]],
		__typename?: boolean
}>;
	["TitleListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TitleItem"]: AliasType<{
	_meta?:ValueTypes["TitleItemMeta"],
	id?:boolean,
	order?:boolean,
	title?:boolean,
list?: [{	filter?:ValueTypes["TitleListWhere"] | null},ValueTypes["TitleList"]],
icon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: boolean
}>;
	["TitleItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TitleItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["TitleListOrderBy"] | null,
	icon?:ValueTypes["ImageOrderBy"] | null
};
	["TitleItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TitleItemEdge"],
		__typename?: boolean
}>;
	["TitleItemEdge"]: AliasType<{
	node?:ValueTypes["TitleItem"],
		__typename?: boolean
}>;
	["FooterContact"]: AliasType<{
	_meta?:ValueTypes["FooterContactMeta"],
	id?:boolean,
	email?:boolean,
	phone?:boolean,
	note?:boolean,
	openingHours?:boolean,
	identificationNumber?:boolean,
	valueAddedTaxNumber?:boolean,
	bussinessRegister?:boolean,
phoneImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	address?:boolean,
		__typename?: boolean
}>;
	["FooterContactMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	openingHours?:ValueTypes["FieldMeta"],
	identificationNumber?:ValueTypes["FieldMeta"],
	valueAddedTaxNumber?:ValueTypes["FieldMeta"],
	bussinessRegister?:ValueTypes["FieldMeta"],
	phoneImage?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["RestaurantLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["RestaurantOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	location?:ValueTypes["OrderDirection"] | null,
	isEshopActive?:ValueTypes["OrderDirection"] | null,
	isDeliveryActive?:ValueTypes["OrderDirection"] | null,
	secondaryUrl?:ValueTypes["OrderDirection"] | null
};
	["RestaurantTagLocale"]: AliasType<{
	_meta?:ValueTypes["RestaurantTagLocaleMeta"],
	id?:boolean,
	title?:boolean,
root?: [{	filter?:ValueTypes["RestaurantTagWhere"] | null},ValueTypes["RestaurantTag"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
		__typename?: boolean
}>;
	["RestaurantTagLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["RestaurantTag"]: AliasType<{
	_meta?:ValueTypes["RestaurantTagMeta"],
	id?:boolean,
	order?:boolean,
locales?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantTagLocale"]],
	backgroundColor?:boolean,
	titleColor?:boolean,
restaurants?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Restaurant"]],
localesByLocale?: [{	by:ValueTypes["RestaurantTagLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null},ValueTypes["RestaurantTagLocale"]],
paginateLocales?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantTagLocaleConnection"]],
paginateRestaurants?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantConnection"]],
		__typename?: boolean
}>;
	["RestaurantTagMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	backgroundColor?:ValueTypes["FieldMeta"],
	titleColor?:ValueTypes["FieldMeta"],
	restaurants?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["RestaurantTagLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["RestaurantTagOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null
};
	["RestaurantTagOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	backgroundColor?:ValueTypes["OrderDirection"] | null,
	titleColor?:ValueTypes["OrderDirection"] | null
};
	["RestaurantTagLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["RestaurantTagLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RestaurantTagLocaleEdge"],
		__typename?: boolean
}>;
	["RestaurantTagLocaleEdge"]: AliasType<{
	node?:ValueTypes["RestaurantTagLocale"],
		__typename?: boolean
}>;
	["RestaurantConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RestaurantEdge"],
		__typename?: boolean
}>;
	["RestaurantEdge"]: AliasType<{
	node?:ValueTypes["Restaurant"],
		__typename?: boolean
}>;
	["BannerLocale"]: AliasType<{
	_meta?:ValueTypes["BannerLocaleMeta"],
	id?:boolean,
	text?:boolean,
root?: [{	filter?:ValueTypes["BannerWhere"] | null},ValueTypes["Banner"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
	title?:boolean,
	url?:boolean,
		__typename?: boolean
}>;
	["BannerLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Banner"]: AliasType<{
	_meta?:ValueTypes["BannerMeta"],
	id?:boolean,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
locales?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BannerLocale"]],
	order?:boolean,
	textColor?:boolean,
localesByLocale?: [{	by:ValueTypes["BannerLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null},ValueTypes["BannerLocale"]],
paginateLocales?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BannerLocaleConnection"]],
		__typename?: boolean
}>;
	["BannerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	textColor?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["BannerLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["BannerOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null
};
	["BannerLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["BannerLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BannerLocaleEdge"],
		__typename?: boolean
}>;
	["BannerLocaleEdge"]: AliasType<{
	node?:ValueTypes["BannerLocale"],
		__typename?: boolean
}>;
	["CategoryLocale"]: AliasType<{
	_meta?:ValueTypes["CategoryLocaleMeta"],
	id?:boolean,
	title?:boolean,
root?: [{	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["Category"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
	slug?:boolean,
		__typename?: boolean
}>;
	["CategoryLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	slug?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["Category"]: AliasType<{
	_meta?:ValueTypes["CategoryMeta"],
	id?:boolean,
	order?:boolean,
locales?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CategoryLocale"]],
restaurants?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Restaurant"]],
localesByLocale?: [{	by:ValueTypes["CategoryLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocale"]],
localesBySlug?: [{	by:ValueTypes["CategoryLocalesBySlugUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocale"]],
paginateLocales?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryLocaleConnection"]],
paginateRestaurants?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantConnection"]],
		__typename?: boolean
}>;
	["CategoryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	restaurants?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["CategoryLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["CategoryOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	slug?:ValueTypes["OrderDirection"] | null
};
	["CategoryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null
};
	["CategoryLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["CategoryLocalesBySlugUniqueWhere"]: {
	slug?:string | null
};
	["CategoryLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CategoryLocaleEdge"],
		__typename?: boolean
}>;
	["CategoryLocaleEdge"]: AliasType<{
	node?:ValueTypes["CategoryLocale"],
		__typename?: boolean
}>;
	["LocaleFrontPagesByRootUniqueWhere"]: {
	root?:ValueTypes["FrontPageUniqueWhere"] | null
};
	["LocaleFrontPagesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleFrontPagesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?:ValueTypes["HeaderUniqueWhere"] | null
};
	["LocaleHeadersBySocialLinksUniqueWhere"]: {
	socialLinks?:ValueTypes["SocialLinkListUniqueWhere"] | null
};
	["LocaleHeadersByPrimaryLinkItemsUniqueWhere"]: {
	primaryLinkItems?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null
};
	["LocaleHeadersBySecondaryLinksUniqueWhere"]: {
	secondaryLinks?:ValueTypes["SecondaryLinkListUniqueWhere"] | null
};
	["LocaleFootersByRootUniqueWhere"]: {
	root?:ValueTypes["FooterUniqueWhere"] | null
};
	["LocaleFootersByLinksSectionUniqueWhere"]: {
	linksSection?:ValueTypes["FooterLinksUniqueWhere"] | null
};
	["LocaleFootersByContactSectionUniqueWhere"]: {
	contactSection?:ValueTypes["FooterContactUniqueWhere"] | null
};
	["LocaleRestaurantsByRootUniqueWhere"]: {
	root?:ValueTypes["RestaurantUniqueWhere"] | null
};
	["LocaleRestaurantTagsByRootUniqueWhere"]: {
	root?:ValueTypes["RestaurantTagUniqueWhere"] | null
};
	["LocaleBannersByRootUniqueWhere"]: {
	root?:ValueTypes["BannerUniqueWhere"] | null
};
	["LocaleCategoriesByRootUniqueWhere"]: {
	root?:ValueTypes["CategoryUniqueWhere"] | null
};
	["LocaleCategoriesBySlugUniqueWhere"]: {
	slug?:string | null
};
	["LocaleSubRestaurantsPagesByRootUniqueWhere"]: {
	root?:ValueTypes["SubRestaurantsPageUniqueWhere"] | null
};
	["LocaleSubRestaurantsPagesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleSubRestaurantsPagesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["FrontPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FrontPageLocaleEdge"],
		__typename?: boolean
}>;
	["FrontPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["FrontPageLocale"],
		__typename?: boolean
}>;
	["RestaurantLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RestaurantLocaleEdge"],
		__typename?: boolean
}>;
	["RestaurantLocaleEdge"]: AliasType<{
	node?:ValueTypes["RestaurantLocale"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubRestaurantsPageLocaleEdge"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["SubRestaurantsPageLocale"],
		__typename?: boolean
}>;
	["RestaurantItem"]: AliasType<{
	_meta?:ValueTypes["RestaurantItemMeta"],
	id?:boolean,
parent?: [{	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["Restaurant"]],
	order?:boolean,
restaurant?: [{	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["Restaurant"]],
		__typename?: boolean
}>;
	["RestaurantItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	parent?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	restaurant?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["RestaurantLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["RestaurantSubItemsByRestaurantUniqueWhere"]: {
	restaurant?:ValueTypes["RestaurantUniqueWhere"] | null
};
	["RestaurantItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RestaurantItemEdge"],
		__typename?: boolean
}>;
	["RestaurantItemEdge"]: AliasType<{
	node?:ValueTypes["RestaurantItem"],
		__typename?: boolean
}>;
	["RestaurantTagConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RestaurantTagEdge"],
		__typename?: boolean
}>;
	["RestaurantTagEdge"]: AliasType<{
	node?:ValueTypes["RestaurantTag"],
		__typename?: boolean
}>;
	["CategoryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["CategoryEdge"],
		__typename?: boolean
}>;
	["CategoryEdge"]: AliasType<{
	node?:ValueTypes["Category"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["SubRestaurantsPageLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["SubRestaurantsPageLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:boolean,
	title?:boolean,
	description?:boolean,
	ogTitle?:boolean,
	ogDescription?:boolean,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	noIndex?:boolean,
	noFollow?:boolean,
		__typename?: boolean
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
	noIndex?:ValueTypes["FieldMeta"],
	noFollow?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["FrontPageLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["FrontPageLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["FrontPageLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["FrontPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FrontPageEdge"],
		__typename?: boolean
}>;
	["FrontPageEdge"]: AliasType<{
	node?:ValueTypes["FrontPage"],
		__typename?: boolean
}>;
	["_ValidationResult"]: AliasType<{
	valid?:boolean,
	errors?:ValueTypes["_ValidationError"],
		__typename?: boolean
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: boolean
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: boolean
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:boolean,
		__typename?: boolean
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:boolean,
	alias?:boolean,
		__typename?: boolean
}>;
	["_ValidationMessage"]: AliasType<{
	text?:boolean,
		__typename?: boolean
}>;
	["FrontPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["FrontPageCreateLocalesEntityRelationInput"][],
	banner?:ValueTypes["FrontPageCreateBannerEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["FrontPageLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["FrontPageLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["FrontPageLocaleCreateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["FrontPageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleCreateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutFrontPageCreateInput"] | null
};
	["LinkableWithoutFrontPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	subRestaurantsPage?:ValueTypes["LinkableCreateSubRestaurantsPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateSubRestaurantsPageEntityRelationInput"]: {
	connect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutLinkCreateInput"] | null
};
	["SubRestaurantsPageLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["SubRestaurantsPageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["SubRestaurantsPageUniqueWhere"] | null,
	create?:ValueTypes["SubRestaurantsPageWithoutLocalesCreateInput"] | null
};
	["SubRestaurantsPageWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	parentRestaurant?:ValueTypes["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	create?:ValueTypes["RestaurantCreateInput"] | null
};
	["RestaurantCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["RestaurantCreateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantCreateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantCreateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantCreateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantCreateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantCreateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	create?:ValueTypes["RestaurantLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["RestaurantLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["RestaurantLocaleCreateLocaleEntityRelationInput"] | null,
	description?:string | null,
	url?:string | null,
	location?:string | null,
	isEshopActive?:boolean | null,
	isDeliveryActive?:boolean | null,
	secondaryUrl?:string | null,
	_dummy_field_?:boolean | null
};
	["RestaurantLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutRestaurantsCreateInput"] | null
};
	["LocaleWithoutRestaurantsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateFrontPagesEntityRelationInput"]: {
	connect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["FrontPageLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["FrontPageLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["FrontPageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["FrontPageLocaleCreateRootEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleCreateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["FrontPageUniqueWhere"] | null,
	create?:ValueTypes["FrontPageWithoutLocalesCreateInput"] | null
};
	["FrontPageWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	banner?:ValueTypes["FrontPageCreateBannerEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageCreateBannerEntityRelationInput"]: {
	connect?:ValueTypes["BannerUniqueWhere"] | null,
	create?:ValueTypes["BannerCreateInput"] | null
};
	["BannerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["BannerCreateImageEntityRelationInput"] | null,
	locales?:ValueTypes["BannerCreateLocalesEntityRelationInput"][],
	order?:number | null,
	textColor?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	fileName?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	create?:ValueTypes["BannerLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["BannerLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	locale?:ValueTypes["BannerLocaleCreateLocaleEntityRelationInput"] | null,
	title?:string | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutBannersCreateInput"] | null
};
	["LocaleWithoutBannersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	create?:ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	menuButtonText?:string | null,
	root?:ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"] | null,
	primaryLinkItems?:ValueTypes["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"][],
	secondaryLinks?:ValueTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["HeaderUniqueWhere"] | null,
	create?:ValueTypes["HeaderWithoutLocalesCreateInput"] | null
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderCreateLogoEntityRelationInput"] | null,
	navigationLogo?:ValueTypes["HeaderCreateNavigationLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderCreateNavigationLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderLocaleCreateSocialLinksEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["SocialLinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SocialLinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SocialLinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["SocialLinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	socialLink?:ValueTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null
};
	["SocialLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["SocialLinkType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"]: {
	connect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	create?:ValueTypes["PrimaryLinkItemWithoutHeaderCreateInput"] | null,
	alias?:string | null
};
	["PrimaryLinkItemWithoutHeaderCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemCreateLinkEntityRelationInput"] | null,
	parent?:ValueTypes["PrimaryLinkItemCreateParentEntityRelationInput"] | null,
	subItems?:ValueTypes["PrimaryLinkItemCreateSubItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PrimaryLinkItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	subRestaurantsPage?:ValueTypes["LinkableCreateSubRestaurantsPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateFrontPageEntityRelationInput"]: {
	connect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["FrontPageLocaleWithoutLinkCreateInput"] | null
};
	["FrontPageLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["FrontPageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FrontPageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleCreateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutFrontPagesCreateInput"] | null
};
	["LocaleWithoutFrontPagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	create?:ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | null,
	linksSection?:ValueTypes["FooterLocaleCreateLinksSectionEntityRelationInput"] | null,
	contactSection?:ValueTypes["FooterLocaleCreateContactSectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["FooterUniqueWhere"] | null,
	create?:ValueTypes["FooterWithoutLocalesCreateInput"] | null
};
	["FooterWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterCreateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterLocaleCreateLinksSectionEntityRelationInput"]: {
	connect?:ValueTypes["FooterLinksUniqueWhere"] | null,
	create?:ValueTypes["FooterLinksCreateInput"] | null
};
	["FooterLinksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	buttonsTitle?:string | null,
	linkList?:ValueTypes["FooterLinksCreateLinkListEntityRelationInput"] | null,
	buttons?:ValueTypes["FooterLinksCreateButtonsEntityRelationInput"] | null,
	titleList?:ValueTypes["FooterLinksCreateTitleListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLinksCreateLinkListEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["LinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["LinkItemUniqueWhere"] | null,
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["LinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["LinkItemCreateLinkEntityRelationInput"] | null,
	icon?:ValueTypes["LinkItemCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkItemCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterLinksCreateButtonsEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["FooterLinksCreateTitleListEntityRelationInput"]: {
	connect?:ValueTypes["TitleListUniqueWhere"] | null,
	create?:ValueTypes["TitleListCreateInput"] | null
};
	["TitleListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["TitleListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TitleListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["TitleItemUniqueWhere"] | null,
	create?:ValueTypes["TitleItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["TitleItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	icon?:ValueTypes["TitleItemCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TitleItemCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterLocaleCreateContactSectionEntityRelationInput"]: {
	connect?:ValueTypes["FooterContactUniqueWhere"] | null,
	create?:ValueTypes["FooterContactCreateInput"] | null
};
	["FooterContactCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	email?:string | null,
	phone?:string | null,
	note?:string | null,
	openingHours?:string | null,
	identificationNumber?:string | null,
	valueAddedTaxNumber?:string | null,
	bussinessRegister?:string | null,
	phoneImage?:ValueTypes["FooterContactCreatePhoneImageEntityRelationInput"] | null,
	address?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterContactCreatePhoneImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LocaleCreateRestaurantsEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	create?:ValueTypes["RestaurantLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["RestaurantLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["RestaurantLocaleCreateRootEntityRelationInput"] | null,
	description?:string | null,
	url?:string | null,
	location?:string | null,
	isEshopActive?:boolean | null,
	isDeliveryActive?:boolean | null,
	secondaryUrl?:string | null,
	_dummy_field_?:boolean | null
};
	["RestaurantLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	create?:ValueTypes["RestaurantWithoutLocalesCreateInput"] | null
};
	["RestaurantWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["RestaurantCreateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantCreateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantCreateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantCreateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantCreateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["RestaurantCreateSubItemsEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	create?:ValueTypes["RestaurantItemWithoutParentCreateInput"] | null,
	alias?:string | null
};
	["RestaurantItemWithoutParentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	restaurant?:ValueTypes["RestaurantItemCreateRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantItemCreateRestaurantEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	create?:ValueTypes["RestaurantWithoutItemCreateInput"] | null
};
	["RestaurantWithoutItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["RestaurantCreateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantCreateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantCreateSubItemsEntityRelationInput"][],
	order?:number | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantCreateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantCreateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantCreateTagsEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	create?:ValueTypes["RestaurantTagWithoutRestaurantsCreateInput"] | null,
	alias?:string | null
};
	["RestaurantTagWithoutRestaurantsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["RestaurantTagCreateLocalesEntityRelationInput"][],
	backgroundColor?:string | null,
	titleColor?:string | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	create?:ValueTypes["RestaurantTagLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["RestaurantTagLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["RestaurantTagLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutRestaurantTagsCreateInput"] | null
};
	["LocaleWithoutRestaurantTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateBannersEntityRelationInput"]: {
	connect?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	create?:ValueTypes["BannerLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["BannerLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	root?:ValueTypes["BannerLocaleCreateRootEntityRelationInput"] | null,
	title?:string | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["BannerUniqueWhere"] | null,
	create?:ValueTypes["BannerWithoutLocalesCreateInput"] | null
};
	["BannerWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["BannerCreateImageEntityRelationInput"] | null,
	order?:number | null,
	textColor?:string | null,
	_dummy_field_?:boolean | null
};
	["LocaleCreateCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	create?:ValueTypes["CategoryLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["CategoryLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["CategoryLocaleCreateRootEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	create?:ValueTypes["CategoryWithoutLocalesCreateInput"] | null
};
	["CategoryWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	restaurants?:ValueTypes["CategoryCreateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CategoryCreateRestaurantsEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	create?:ValueTypes["RestaurantWithoutCategoriesCreateInput"] | null,
	alias?:string | null
};
	["RestaurantWithoutCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["RestaurantCreateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantCreateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantCreateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantCreateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantCreateTagsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantCreateItemEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	create?:ValueTypes["RestaurantItemWithoutRestaurantCreateInput"] | null
};
	["RestaurantItemWithoutRestaurantCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	parent?:ValueTypes["RestaurantItemCreateParentEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["RestaurantItemCreateParentEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	create?:ValueTypes["RestaurantWithoutSubItemsCreateInput"] | null
};
	["RestaurantWithoutSubItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["RestaurantCreateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantCreateImageEntityRelationInput"] | null,
	order?:number | null,
	item?:ValueTypes["RestaurantCreateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantCreateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantCreateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantCreateCategoriesEntityRelationInput"]: {
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	create?:ValueTypes["CategoryWithoutRestaurantsCreateInput"] | null,
	alias?:string | null
};
	["CategoryWithoutRestaurantsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["CategoryCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CategoryCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	create?:ValueTypes["CategoryLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["CategoryLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["CategoryLocaleCreateLocaleEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutCategoriesCreateInput"] | null
};
	["LocaleWithoutCategoriesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateRestaurantTagsEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	create?:ValueTypes["RestaurantTagLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["RestaurantTagLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["RestaurantTagLocaleCreateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	create?:ValueTypes["RestaurantTagWithoutLocalesCreateInput"] | null
};
	["RestaurantTagWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	backgroundColor?:string | null,
	titleColor?:string | null,
	restaurants?:ValueTypes["RestaurantTagCreateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantTagCreateRestaurantsEntityRelationInput"]: {
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	create?:ValueTypes["RestaurantWithoutTagsCreateInput"] | null,
	alias?:string | null
};
	["RestaurantWithoutTagsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["RestaurantCreateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantCreateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantCreateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantCreateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	categories?:ValueTypes["RestaurantCreateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateSubRestaurantsPagesEntityRelationInput"]: {
	connect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["SubRestaurantsPageLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["SubRestaurantsPageLocaleCreateRootEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutSubRestaurantsPageCreateInput"] | null
};
	["LinkableWithoutSubRestaurantsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	frontPage?:ValueTypes["LinkableCreateFrontPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FrontPageLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["PrimaryLinkItemCreateParentEntityRelationInput"]: {
	connect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	create?:ValueTypes["PrimaryLinkItemWithoutSubItemsCreateInput"] | null
};
	["PrimaryLinkItemWithoutSubItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemCreateLinkEntityRelationInput"] | null,
	parent?:ValueTypes["PrimaryLinkItemCreateParentEntityRelationInput"] | null,
	header?:ValueTypes["PrimaryLinkItemCreateHeaderEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrimaryLinkItemCreateHeaderEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	create?:ValueTypes["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"] | null
};
	["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	menuButtonText?:string | null,
	root?:ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"] | null,
	secondaryLinks?:ValueTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutHeadersCreateInput"] | null
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderLocaleCreateSecondaryLinksEntityRelationInput"]: {
	connect?:ValueTypes["SecondaryLinkListUniqueWhere"] | null,
	create?:ValueTypes["SecondaryLinkListCreateInput"] | null
};
	["SecondaryLinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SecondaryLinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SecondaryLinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["SecondaryLinkItemUniqueWhere"] | null,
	create?:ValueTypes["SecondaryLinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["SecondaryLinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	iconType?:ValueTypes["IconType"] | null,
	link?:ValueTypes["SecondaryLinkItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SecondaryLinkItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["PrimaryLinkItemCreateSubItemsEntityRelationInput"]: {
	connect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	create?:ValueTypes["PrimaryLinkItemWithoutParentCreateInput"] | null,
	alias?:string | null
};
	["PrimaryLinkItemWithoutParentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemCreateLinkEntityRelationInput"] | null,
	subItems?:ValueTypes["PrimaryLinkItemCreateSubItemsEntityRelationInput"][],
	header?:ValueTypes["PrimaryLinkItemCreateHeaderEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutSubRestaurantsPagesCreateInput"] | null
};
	["LocaleWithoutSubRestaurantsPagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FrontPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["FrontPageUpdateLocalesEntityRelationInput"][],
	banner?:ValueTypes["FrontPageUpdateBannerEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["FrontPageLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["FrontPageUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["FrontPageUpdateLocalesRelationInput"]: {
	by?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	data?:ValueTypes["FrontPageLocaleWithoutRootUpdateInput"] | null
};
	["FrontPageLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["FrontPageLocaleUpdateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["FrontPageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleUpdateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutFrontPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutFrontPageUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutFrontPageUpdateInput"]: {
	url?:string | null,
	subRestaurantsPage?:ValueTypes["LinkableUpdateSubRestaurantsPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateSubRestaurantsPageEntityRelationInput"]: {
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["SubRestaurantsPageLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertSubRestaurantsPageRelationInput"] | null,
	connect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SubRestaurantsPageLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["SubRestaurantsPageWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["SubRestaurantsPageWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["SubRestaurantsPageLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["SubRestaurantsPageUniqueWhere"] | null,
	delete?:boolean | null
};
	["SubRestaurantsPageWithoutLocalesUpdateInput"]: {
	order?:number | null,
	parentRestaurant?:ValueTypes["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"]: {
	create?:ValueTypes["RestaurantCreateInput"] | null,
	update?:ValueTypes["RestaurantUpdateInput"] | null,
	upsert?:ValueTypes["SubRestaurantsPageUpsertParentRestaurantRelationInput"] | null,
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RestaurantUpdateInput"]: {
	locales?:ValueTypes["RestaurantUpdateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantUpdateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantUpdateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantUpdateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantUpdateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantUpdateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["RestaurantLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["RestaurantUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["RestaurantUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["RestaurantUpdateLocalesRelationInput"]: {
	by?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	data?:ValueTypes["RestaurantLocaleWithoutRootUpdateInput"] | null
};
	["RestaurantLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["RestaurantLocaleUpdateLocaleEntityRelationInput"] | null,
	description?:string | null,
	url?:string | null,
	location?:string | null,
	isEshopActive?:boolean | null,
	isDeliveryActive?:boolean | null,
	secondaryUrl?:string | null,
	_dummy_field_?:boolean | null
};
	["RestaurantLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutRestaurantsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutRestaurantsUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutRestaurantsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateFrontPagesEntityRelationInput"]: {
	create?:ValueTypes["FrontPageLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateFrontPagesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertFrontPagesRelationInput"] | null,
	connect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateFrontPagesRelationInput"]: {
	by?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	data?:ValueTypes["FrontPageLocaleWithoutLocaleUpdateInput"] | null
};
	["FrontPageLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["FrontPageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["FrontPageLocaleUpdateRootEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleUpdateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["FrontPageWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["FrontPageWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["FrontPageUniqueWhere"] | null,
	delete?:boolean | null
};
	["FrontPageWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	banner?:ValueTypes["FrontPageUpdateBannerEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FrontPageUpdateBannerEntityRelationInput"]: {
	create?:ValueTypes["BannerCreateInput"] | null,
	update?:ValueTypes["BannerUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageUpsertBannerRelationInput"] | null,
	connect?:ValueTypes["BannerUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BannerUpdateInput"]: {
	image?:ValueTypes["BannerUpdateImageEntityRelationInput"] | null,
	locales?:ValueTypes["BannerUpdateLocalesEntityRelationInput"][],
	order?:number | null,
	textColor?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["BannerUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	fileName?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["BannerUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["BannerLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["BannerUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["BannerUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	delete?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["BannerUpdateLocalesRelationInput"]: {
	by?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	data?:ValueTypes["BannerLocaleWithoutRootUpdateInput"] | null
};
	["BannerLocaleWithoutRootUpdateInput"]: {
	text?:string | null,
	locale?:ValueTypes["BannerLocaleUpdateLocaleEntityRelationInput"] | null,
	title?:string | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutBannersCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutBannersUpdateInput"] | null,
	upsert?:ValueTypes["BannerLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutBannersUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?:ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateHeadersRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertHeadersRelationInput"] | null,
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	delete?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateHeadersRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	data?:ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | null
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	menuButtonText?:string | null,
	root?:ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"] | null,
	primaryLinkItems?:ValueTypes["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"][],
	secondaryLinks?:ValueTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["HeaderWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["HeaderWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["HeaderUniqueWhere"] | null,
	delete?:boolean | null
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderUpdateLogoEntityRelationInput"] | null,
	navigationLogo?:ValueTypes["HeaderUpdateNavigationLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderUpdateNavigationLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertNavigationLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertNavigationLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["HeaderWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["HeaderWithoutLocalesCreateInput"] | null
};
	["HeaderLocaleUpdateSocialLinksEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkListCreateInput"] | null,
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertSocialLinksRelationInput"] | null,
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkListUpdateInput"]: {
	items?:ValueTypes["SocialLinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SocialLinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["SocialLinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["SocialLinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["SocialLinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	data?:ValueTypes["SocialLinkItemWithoutListUpdateInput"] | null
};
	["SocialLinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	socialLink?:ValueTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkCreateInput"] | null,
	update?:ValueTypes["SocialLinkUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkItemUpsertSocialLinkRelationInput"] | null,
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkUpdateInput"]: {
	type?:ValueTypes["SocialLinkType"] | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpsertSocialLinkRelationInput"]: {
	update?:ValueTypes["SocialLinkUpdateInput"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null
};
	["SocialLinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	update?:ValueTypes["SocialLinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null
};
	["HeaderLocaleUpsertSocialLinksRelationInput"]: {
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"]: {
	create?:ValueTypes["PrimaryLinkItemWithoutHeaderCreateInput"] | null,
	update?:ValueTypes["HeaderLocaleUpdatePrimaryLinkItemsRelationInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertPrimaryLinkItemsRelationInput"] | null,
	connect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["HeaderLocaleUpdatePrimaryLinkItemsRelationInput"]: {
	by?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	data?:ValueTypes["PrimaryLinkItemWithoutHeaderUpdateInput"] | null
};
	["PrimaryLinkItemWithoutHeaderUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"] | null,
	parent?:ValueTypes["PrimaryLinkItemUpdateParentEntityRelationInput"] | null,
	subItems?:ValueTypes["PrimaryLinkItemUpdateSubItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PrimaryLinkItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["PrimaryLinkItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	subRestaurantsPage?:ValueTypes["LinkableUpdateSubRestaurantsPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateFrontPageEntityRelationInput"]: {
	create?:ValueTypes["FrontPageLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["FrontPageLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertFrontPageRelationInput"] | null,
	connect?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FrontPageLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["FrontPageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FrontPageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleUpdateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutFrontPagesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutFrontPagesUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutFrontPagesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?:ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateFootersRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertFootersRelationInput"] | null,
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	delete?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateFootersRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	data?:ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | null
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	root?:ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | null,
	linksSection?:ValueTypes["FooterLocaleUpdateLinksSectionEntityRelationInput"] | null,
	contactSection?:ValueTypes["FooterLocaleUpdateContactSectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["FooterWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["FooterWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["FooterUniqueWhere"] | null,
	delete?:boolean | null
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterUpdateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["FooterWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["FooterWithoutLocalesCreateInput"] | null
};
	["FooterLocaleUpdateLinksSectionEntityRelationInput"]: {
	create?:ValueTypes["FooterLinksCreateInput"] | null,
	update?:ValueTypes["FooterLinksUpdateInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertLinksSectionRelationInput"] | null,
	connect?:ValueTypes["FooterLinksUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterLinksUpdateInput"]: {
	buttonsTitle?:string | null,
	linkList?:ValueTypes["FooterLinksUpdateLinkListEntityRelationInput"] | null,
	buttons?:ValueTypes["FooterLinksUpdateButtonsEntityRelationInput"] | null,
	titleList?:ValueTypes["FooterLinksUpdateTitleListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLinksUpdateLinkListEntityRelationInput"]: {
	create?:ValueTypes["LinkListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateInput"] | null,
	upsert?:ValueTypes["FooterLinksUpsertLinkListRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkListUpdateInput"]: {
	items?:ValueTypes["LinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["LinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["LinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["LinkItemUniqueWhere"] | null,
	delete?:ValueTypes["LinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["LinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["LinkItemUniqueWhere"] | null,
	data?:ValueTypes["LinkItemWithoutListUpdateInput"] | null
};
	["LinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | null,
	icon?:ValueTypes["LinkItemUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkItemUpdateIconEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertIconRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkItemUpsertIconRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["LinkItemUniqueWhere"] | null,
	update?:ValueTypes["LinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["LinkItemWithoutListCreateInput"] | null
};
	["FooterLinksUpsertLinkListRelationInput"]: {
	update?:ValueTypes["LinkListUpdateInput"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["FooterLinksUpdateButtonsEntityRelationInput"]: {
	create?:ValueTypes["LinkListCreateInput"] | null,
	update?:ValueTypes["LinkListUpdateInput"] | null,
	upsert?:ValueTypes["FooterLinksUpsertButtonsRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterLinksUpsertButtonsRelationInput"]: {
	update?:ValueTypes["LinkListUpdateInput"] | null,
	create?:ValueTypes["LinkListCreateInput"] | null
};
	["FooterLinksUpdateTitleListEntityRelationInput"]: {
	create?:ValueTypes["TitleListCreateInput"] | null,
	update?:ValueTypes["TitleListUpdateInput"] | null,
	upsert?:ValueTypes["FooterLinksUpsertTitleListRelationInput"] | null,
	connect?:ValueTypes["TitleListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TitleListUpdateInput"]: {
	items?:ValueTypes["TitleListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TitleListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["TitleItemWithoutListCreateInput"] | null,
	update?:ValueTypes["TitleListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["TitleListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["TitleItemUniqueWhere"] | null,
	disconnect?:ValueTypes["TitleItemUniqueWhere"] | null,
	delete?:ValueTypes["TitleItemUniqueWhere"] | null,
	alias?:string | null
};
	["TitleListUpdateItemsRelationInput"]: {
	by?:ValueTypes["TitleItemUniqueWhere"] | null,
	data?:ValueTypes["TitleItemWithoutListUpdateInput"] | null
};
	["TitleItemWithoutListUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	icon?:ValueTypes["TitleItemUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TitleItemUpdateIconEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["TitleItemUpsertIconRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TitleItemUpsertIconRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["TitleListUpsertItemsRelationInput"]: {
	by?:ValueTypes["TitleItemUniqueWhere"] | null,
	update?:ValueTypes["TitleItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["TitleItemWithoutListCreateInput"] | null
};
	["FooterLinksUpsertTitleListRelationInput"]: {
	update?:ValueTypes["TitleListUpdateInput"] | null,
	create?:ValueTypes["TitleListCreateInput"] | null
};
	["FooterLocaleUpsertLinksSectionRelationInput"]: {
	update?:ValueTypes["FooterLinksUpdateInput"] | null,
	create?:ValueTypes["FooterLinksCreateInput"] | null
};
	["FooterLocaleUpdateContactSectionEntityRelationInput"]: {
	create?:ValueTypes["FooterContactCreateInput"] | null,
	update?:ValueTypes["FooterContactUpdateInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertContactSectionRelationInput"] | null,
	connect?:ValueTypes["FooterContactUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterContactUpdateInput"]: {
	email?:string | null,
	phone?:string | null,
	note?:string | null,
	openingHours?:string | null,
	identificationNumber?:string | null,
	valueAddedTaxNumber?:string | null,
	bussinessRegister?:string | null,
	phoneImage?:ValueTypes["FooterContactUpdatePhoneImageEntityRelationInput"] | null,
	address?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterContactUpdatePhoneImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FooterContactUpsertPhoneImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterContactUpsertPhoneImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterLocaleUpsertContactSectionRelationInput"]: {
	update?:ValueTypes["FooterContactUpdateInput"] | null,
	create?:ValueTypes["FooterContactCreateInput"] | null
};
	["LocaleUpsertFootersRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	update?:ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateRestaurantsEntityRelationInput"]: {
	create?:ValueTypes["RestaurantLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateRestaurantsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertRestaurantsRelationInput"] | null,
	connect?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateRestaurantsRelationInput"]: {
	by?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	data?:ValueTypes["RestaurantLocaleWithoutLocaleUpdateInput"] | null
};
	["RestaurantLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["RestaurantLocaleUpdateRootEntityRelationInput"] | null,
	description?:string | null,
	url?:string | null,
	location?:string | null,
	isEshopActive?:boolean | null,
	isDeliveryActive?:boolean | null,
	secondaryUrl?:string | null,
	_dummy_field_?:boolean | null
};
	["RestaurantLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["RestaurantWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["RestaurantWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	delete?:boolean | null
};
	["RestaurantWithoutLocalesUpdateInput"]: {
	image?:ValueTypes["RestaurantUpdateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantUpdateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantUpdateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantUpdateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantUpdateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RestaurantUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["RestaurantUpdateSubItemsEntityRelationInput"]: {
	create?:ValueTypes["RestaurantItemWithoutParentCreateInput"] | null,
	update?:ValueTypes["RestaurantUpdateSubItemsRelationInput"] | null,
	upsert?:ValueTypes["RestaurantUpsertSubItemsRelationInput"] | null,
	connect?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	alias?:string | null
};
	["RestaurantUpdateSubItemsRelationInput"]: {
	by?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	data?:ValueTypes["RestaurantItemWithoutParentUpdateInput"] | null
};
	["RestaurantItemWithoutParentUpdateInput"]: {
	order?:number | null,
	restaurant?:ValueTypes["RestaurantItemUpdateRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantItemUpdateRestaurantEntityRelationInput"]: {
	create?:ValueTypes["RestaurantWithoutItemCreateInput"] | null,
	update?:ValueTypes["RestaurantWithoutItemUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantItemUpsertRestaurantRelationInput"] | null,
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RestaurantWithoutItemUpdateInput"]: {
	locales?:ValueTypes["RestaurantUpdateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantUpdateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantUpdateSubItemsEntityRelationInput"][],
	order?:number | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantUpdateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantUpdateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantUpdateTagsEntityRelationInput"]: {
	create?:ValueTypes["RestaurantTagWithoutRestaurantsCreateInput"] | null,
	update?:ValueTypes["RestaurantUpdateTagsRelationInput"] | null,
	upsert?:ValueTypes["RestaurantUpsertTagsRelationInput"] | null,
	connect?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	alias?:string | null
};
	["RestaurantUpdateTagsRelationInput"]: {
	by?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	data?:ValueTypes["RestaurantTagWithoutRestaurantsUpdateInput"] | null
};
	["RestaurantTagWithoutRestaurantsUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["RestaurantTagUpdateLocalesEntityRelationInput"][],
	backgroundColor?:string | null,
	titleColor?:string | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["RestaurantTagLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["RestaurantTagUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["RestaurantTagUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["RestaurantTagUpdateLocalesRelationInput"]: {
	by?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	data?:ValueTypes["RestaurantTagLocaleWithoutRootUpdateInput"] | null
};
	["RestaurantTagLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["RestaurantTagLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutRestaurantTagsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutRestaurantTagsUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantTagLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutRestaurantTagsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateBannersEntityRelationInput"]: {
	create?:ValueTypes["BannerLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateBannersRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertBannersRelationInput"] | null,
	connect?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	delete?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateBannersRelationInput"]: {
	by?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	data?:ValueTypes["BannerLocaleWithoutLocaleUpdateInput"] | null
};
	["BannerLocaleWithoutLocaleUpdateInput"]: {
	text?:string | null,
	root?:ValueTypes["BannerLocaleUpdateRootEntityRelationInput"] | null,
	title?:string | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["BannerWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["BannerWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["BannerLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["BannerUniqueWhere"] | null,
	delete?:boolean | null
};
	["BannerWithoutLocalesUpdateInput"]: {
	image?:ValueTypes["BannerUpdateImageEntityRelationInput"] | null,
	order?:number | null,
	textColor?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["BannerWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["BannerWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertBannersRelationInput"]: {
	by?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	update?:ValueTypes["BannerLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["BannerLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateCategoriesEntityRelationInput"]: {
	create?:ValueTypes["CategoryLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateCategoriesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertCategoriesRelationInput"] | null,
	connect?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	delete?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateCategoriesRelationInput"]: {
	by?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	data?:ValueTypes["CategoryLocaleWithoutLocaleUpdateInput"] | null
};
	["CategoryLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["CategoryLocaleUpdateRootEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["CategoryWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["CategoryWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["CategoryLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	delete?:boolean | null
};
	["CategoryWithoutLocalesUpdateInput"]: {
	order?:number | null,
	restaurants?:ValueTypes["CategoryUpdateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CategoryUpdateRestaurantsEntityRelationInput"]: {
	create?:ValueTypes["RestaurantWithoutCategoriesCreateInput"] | null,
	update?:ValueTypes["CategoryUpdateRestaurantsRelationInput"] | null,
	upsert?:ValueTypes["CategoryUpsertRestaurantsRelationInput"] | null,
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantUniqueWhere"] | null,
	alias?:string | null
};
	["CategoryUpdateRestaurantsRelationInput"]: {
	by?:ValueTypes["RestaurantUniqueWhere"] | null,
	data?:ValueTypes["RestaurantWithoutCategoriesUpdateInput"] | null
};
	["RestaurantWithoutCategoriesUpdateInput"]: {
	locales?:ValueTypes["RestaurantUpdateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantUpdateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantUpdateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantUpdateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantUpdateTagsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantUpdateItemEntityRelationInput"]: {
	create?:ValueTypes["RestaurantItemWithoutRestaurantCreateInput"] | null,
	update?:ValueTypes["RestaurantItemWithoutRestaurantUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantUpsertItemRelationInput"] | null,
	connect?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RestaurantItemWithoutRestaurantUpdateInput"]: {
	parent?:ValueTypes["RestaurantItemUpdateParentEntityRelationInput"] | null,
	order?:number | null,
	_dummy_field_?:boolean | null
};
	["RestaurantItemUpdateParentEntityRelationInput"]: {
	create?:ValueTypes["RestaurantWithoutSubItemsCreateInput"] | null,
	update?:ValueTypes["RestaurantWithoutSubItemsUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantItemUpsertParentRelationInput"] | null,
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	delete?:boolean | null
};
	["RestaurantWithoutSubItemsUpdateInput"]: {
	locales?:ValueTypes["RestaurantUpdateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantUpdateImageEntityRelationInput"] | null,
	order?:number | null,
	item?:ValueTypes["RestaurantUpdateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	tags?:ValueTypes["RestaurantUpdateTagsEntityRelationInput"][],
	categories?:ValueTypes["RestaurantUpdateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantUpdateCategoriesEntityRelationInput"]: {
	create?:ValueTypes["CategoryWithoutRestaurantsCreateInput"] | null,
	update?:ValueTypes["RestaurantUpdateCategoriesRelationInput"] | null,
	upsert?:ValueTypes["RestaurantUpsertCategoriesRelationInput"] | null,
	connect?:ValueTypes["CategoryUniqueWhere"] | null,
	disconnect?:ValueTypes["CategoryUniqueWhere"] | null,
	delete?:ValueTypes["CategoryUniqueWhere"] | null,
	alias?:string | null
};
	["RestaurantUpdateCategoriesRelationInput"]: {
	by?:ValueTypes["CategoryUniqueWhere"] | null,
	data?:ValueTypes["CategoryWithoutRestaurantsUpdateInput"] | null
};
	["CategoryWithoutRestaurantsUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["CategoryUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CategoryUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["CategoryLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["CategoryUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["CategoryUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	delete?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["CategoryUpdateLocalesRelationInput"]: {
	by?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	data?:ValueTypes["CategoryLocaleWithoutRootUpdateInput"] | null
};
	["CategoryLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["CategoryLocaleUpdateLocaleEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutCategoriesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutCategoriesUpdateInput"] | null,
	upsert?:ValueTypes["CategoryLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutCategoriesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateRestaurantTagsEntityRelationInput"]: {
	create?:ValueTypes["RestaurantTagLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateRestaurantTagsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertRestaurantTagsRelationInput"] | null,
	connect?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateRestaurantTagsRelationInput"]: {
	by?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	data?:ValueTypes["RestaurantTagLocaleWithoutLocaleUpdateInput"] | null
};
	["RestaurantTagLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["RestaurantTagLocaleUpdateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["RestaurantTagWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["RestaurantTagWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["RestaurantTagLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	delete?:boolean | null
};
	["RestaurantTagWithoutLocalesUpdateInput"]: {
	order?:number | null,
	backgroundColor?:string | null,
	titleColor?:string | null,
	restaurants?:ValueTypes["RestaurantTagUpdateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantTagUpdateRestaurantsEntityRelationInput"]: {
	create?:ValueTypes["RestaurantWithoutTagsCreateInput"] | null,
	update?:ValueTypes["RestaurantTagUpdateRestaurantsRelationInput"] | null,
	upsert?:ValueTypes["RestaurantTagUpsertRestaurantsRelationInput"] | null,
	connect?:ValueTypes["RestaurantUniqueWhere"] | null,
	disconnect?:ValueTypes["RestaurantUniqueWhere"] | null,
	delete?:ValueTypes["RestaurantUniqueWhere"] | null,
	alias?:string | null
};
	["RestaurantTagUpdateRestaurantsRelationInput"]: {
	by?:ValueTypes["RestaurantUniqueWhere"] | null,
	data?:ValueTypes["RestaurantWithoutTagsUpdateInput"] | null
};
	["RestaurantWithoutTagsUpdateInput"]: {
	locales?:ValueTypes["RestaurantUpdateLocalesEntityRelationInput"][],
	image?:ValueTypes["RestaurantUpdateImageEntityRelationInput"] | null,
	subItems?:ValueTypes["RestaurantUpdateSubItemsEntityRelationInput"][],
	order?:number | null,
	item?:ValueTypes["RestaurantUpdateItemEntityRelationInput"] | null,
	openingHours?:string | null,
	categories?:ValueTypes["RestaurantUpdateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantTagUpsertRestaurantsRelationInput"]: {
	by?:ValueTypes["RestaurantUniqueWhere"] | null,
	update?:ValueTypes["RestaurantWithoutTagsUpdateInput"] | null,
	create?:ValueTypes["RestaurantWithoutTagsCreateInput"] | null
};
	["RestaurantTagLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["RestaurantTagWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["RestaurantTagWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertRestaurantTagsRelationInput"]: {
	by?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	update?:ValueTypes["RestaurantTagLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["RestaurantTagLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]: {
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateSubRestaurantsPagesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertSubRestaurantsPagesRelationInput"] | null,
	connect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateSubRestaurantsPagesRelationInput"]: {
	by?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	data?:ValueTypes["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"] | null
};
	["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutSubRestaurantsPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutSubRestaurantsPageUpdateInput"] | null,
	upsert?:ValueTypes["SubRestaurantsPageLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutSubRestaurantsPageUpdateInput"]: {
	url?:string | null,
	frontPage?:ValueTypes["LinkableUpdateFrontPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutSubRestaurantsPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutSubRestaurantsPageCreateInput"] | null
};
	["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["SubRestaurantsPageLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SubRestaurantsPageLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LocaleUpsertSubRestaurantsPagesRelationInput"]: {
	by?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	update?:ValueTypes["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutLocaleCreateInput"] | null
};
	["CategoryLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutCategoriesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutCategoriesCreateInput"] | null
};
	["CategoryUpsertLocalesRelationInput"]: {
	by?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	update?:ValueTypes["CategoryLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["CategoryLocaleWithoutRootCreateInput"] | null
};
	["RestaurantUpsertCategoriesRelationInput"]: {
	by?:ValueTypes["CategoryUniqueWhere"] | null,
	update?:ValueTypes["CategoryWithoutRestaurantsUpdateInput"] | null,
	create?:ValueTypes["CategoryWithoutRestaurantsCreateInput"] | null
};
	["RestaurantItemUpsertParentRelationInput"]: {
	update?:ValueTypes["RestaurantWithoutSubItemsUpdateInput"] | null,
	create?:ValueTypes["RestaurantWithoutSubItemsCreateInput"] | null
};
	["RestaurantUpsertItemRelationInput"]: {
	update?:ValueTypes["RestaurantItemWithoutRestaurantUpdateInput"] | null,
	create?:ValueTypes["RestaurantItemWithoutRestaurantCreateInput"] | null
};
	["CategoryUpsertRestaurantsRelationInput"]: {
	by?:ValueTypes["RestaurantUniqueWhere"] | null,
	update?:ValueTypes["RestaurantWithoutCategoriesUpdateInput"] | null,
	create?:ValueTypes["RestaurantWithoutCategoriesCreateInput"] | null
};
	["CategoryLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["CategoryWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["CategoryWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertCategoriesRelationInput"]: {
	by?:ValueTypes["CategoryLocaleUniqueWhere"] | null,
	update?:ValueTypes["CategoryLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["CategoryLocaleWithoutLocaleCreateInput"] | null
};
	["RestaurantTagLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutRestaurantTagsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutRestaurantTagsCreateInput"] | null
};
	["RestaurantTagUpsertLocalesRelationInput"]: {
	by?:ValueTypes["RestaurantTagLocaleUniqueWhere"] | null,
	update?:ValueTypes["RestaurantTagLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["RestaurantTagLocaleWithoutRootCreateInput"] | null
};
	["RestaurantUpsertTagsRelationInput"]: {
	by?:ValueTypes["RestaurantTagUniqueWhere"] | null,
	update?:ValueTypes["RestaurantTagWithoutRestaurantsUpdateInput"] | null,
	create?:ValueTypes["RestaurantTagWithoutRestaurantsCreateInput"] | null
};
	["RestaurantItemUpsertRestaurantRelationInput"]: {
	update?:ValueTypes["RestaurantWithoutItemUpdateInput"] | null,
	create?:ValueTypes["RestaurantWithoutItemCreateInput"] | null
};
	["RestaurantUpsertSubItemsRelationInput"]: {
	by?:ValueTypes["RestaurantItemUniqueWhere"] | null,
	update?:ValueTypes["RestaurantItemWithoutParentUpdateInput"] | null,
	create?:ValueTypes["RestaurantItemWithoutParentCreateInput"] | null
};
	["RestaurantLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["RestaurantWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["RestaurantWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertRestaurantsRelationInput"]: {
	by?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	update?:ValueTypes["RestaurantLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["RestaurantLocaleWithoutLocaleCreateInput"] | null
};
	["FrontPageLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutFrontPagesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutFrontPagesCreateInput"] | null
};
	["FrontPageLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["FrontPageLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FrontPageLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertFrontPageRelationInput"]: {
	update?:ValueTypes["FrontPageLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["FrontPageLocaleWithoutLinkCreateInput"] | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["PrimaryLinkItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["PrimaryLinkItemUpdateParentEntityRelationInput"]: {
	create?:ValueTypes["PrimaryLinkItemWithoutSubItemsCreateInput"] | null,
	update?:ValueTypes["PrimaryLinkItemWithoutSubItemsUpdateInput"] | null,
	upsert?:ValueTypes["PrimaryLinkItemUpsertParentRelationInput"] | null,
	connect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PrimaryLinkItemWithoutSubItemsUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"] | null,
	parent?:ValueTypes["PrimaryLinkItemUpdateParentEntityRelationInput"] | null,
	header?:ValueTypes["PrimaryLinkItemUpdateHeaderEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrimaryLinkItemUpdateHeaderEntityRelationInput"]: {
	create?:ValueTypes["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"] | null,
	update?:ValueTypes["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"] | null,
	upsert?:ValueTypes["PrimaryLinkItemUpsertHeaderRelationInput"] | null,
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"]: {
	menuButtonText?:string | null,
	root?:ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"] | null,
	secondaryLinks?:ValueTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutHeadersCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutHeadersUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutHeadersUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutHeadersCreateInput"] | null
};
	["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"]: {
	create?:ValueTypes["SecondaryLinkListCreateInput"] | null,
	update?:ValueTypes["SecondaryLinkListUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertSecondaryLinksRelationInput"] | null,
	connect?:ValueTypes["SecondaryLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SecondaryLinkListUpdateInput"]: {
	items?:ValueTypes["SecondaryLinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SecondaryLinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["SecondaryLinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["SecondaryLinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["SecondaryLinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["SecondaryLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["SecondaryLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["SecondaryLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["SecondaryLinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["SecondaryLinkItemUniqueWhere"] | null,
	data?:ValueTypes["SecondaryLinkItemWithoutListUpdateInput"] | null
};
	["SecondaryLinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	iconType?:ValueTypes["IconType"] | null,
	link?:ValueTypes["SecondaryLinkItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SecondaryLinkItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["SecondaryLinkItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SecondaryLinkItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["SecondaryLinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["SecondaryLinkItemUniqueWhere"] | null,
	update?:ValueTypes["SecondaryLinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["SecondaryLinkItemWithoutListCreateInput"] | null
};
	["HeaderLocaleUpsertSecondaryLinksRelationInput"]: {
	update?:ValueTypes["SecondaryLinkListUpdateInput"] | null,
	create?:ValueTypes["SecondaryLinkListCreateInput"] | null
};
	["PrimaryLinkItemUpsertHeaderRelationInput"]: {
	update?:ValueTypes["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"] | null,
	create?:ValueTypes["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"] | null
};
	["PrimaryLinkItemUpsertParentRelationInput"]: {
	update?:ValueTypes["PrimaryLinkItemWithoutSubItemsUpdateInput"] | null,
	create?:ValueTypes["PrimaryLinkItemWithoutSubItemsCreateInput"] | null
};
	["PrimaryLinkItemUpdateSubItemsEntityRelationInput"]: {
	create?:ValueTypes["PrimaryLinkItemWithoutParentCreateInput"] | null,
	update?:ValueTypes["PrimaryLinkItemUpdateSubItemsRelationInput"] | null,
	upsert?:ValueTypes["PrimaryLinkItemUpsertSubItemsRelationInput"] | null,
	connect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["PrimaryLinkItemUpdateSubItemsRelationInput"]: {
	by?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	data?:ValueTypes["PrimaryLinkItemWithoutParentUpdateInput"] | null
};
	["PrimaryLinkItemWithoutParentUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"] | null,
	subItems?:ValueTypes["PrimaryLinkItemUpdateSubItemsEntityRelationInput"][],
	header?:ValueTypes["PrimaryLinkItemUpdateHeaderEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrimaryLinkItemUpsertSubItemsRelationInput"]: {
	by?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	update?:ValueTypes["PrimaryLinkItemWithoutParentUpdateInput"] | null,
	create?:ValueTypes["PrimaryLinkItemWithoutParentCreateInput"] | null
};
	["HeaderLocaleUpsertPrimaryLinkItemsRelationInput"]: {
	by?:ValueTypes["PrimaryLinkItemUniqueWhere"] | null,
	update?:ValueTypes["PrimaryLinkItemWithoutHeaderUpdateInput"] | null,
	create?:ValueTypes["PrimaryLinkItemWithoutHeaderCreateInput"] | null
};
	["LocaleUpsertHeadersRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	update?:ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | null
};
	["BannerLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutBannersUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutBannersCreateInput"] | null
};
	["BannerUpsertLocalesRelationInput"]: {
	by?:ValueTypes["BannerLocaleUniqueWhere"] | null,
	update?:ValueTypes["BannerLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["BannerLocaleWithoutRootCreateInput"] | null
};
	["FrontPageUpsertBannerRelationInput"]: {
	update?:ValueTypes["BannerUpdateInput"] | null,
	create?:ValueTypes["BannerCreateInput"] | null
};
	["FrontPageLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["FrontPageWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["FrontPageWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertFrontPagesRelationInput"]: {
	by?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	update?:ValueTypes["FrontPageLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["FrontPageLocaleWithoutLocaleCreateInput"] | null
};
	["RestaurantLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutRestaurantsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutRestaurantsCreateInput"] | null
};
	["RestaurantUpsertLocalesRelationInput"]: {
	by?:ValueTypes["RestaurantLocaleUniqueWhere"] | null,
	update?:ValueTypes["RestaurantLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["RestaurantLocaleWithoutRootCreateInput"] | null
};
	["SubRestaurantsPageUpsertParentRestaurantRelationInput"]: {
	update?:ValueTypes["RestaurantUpdateInput"] | null,
	create?:ValueTypes["RestaurantCreateInput"] | null
};
	["SubRestaurantsPageLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["SubRestaurantsPageWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["SubRestaurantsPageWithoutLocalesCreateInput"] | null
};
	["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutSubRestaurantsPagesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutSubRestaurantsPagesUpdateInput"] | null,
	upsert?:ValueTypes["SubRestaurantsPageLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutSubRestaurantsPagesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutSubRestaurantsPagesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutSubRestaurantsPagesCreateInput"] | null
};
	["LinkableUpsertSubRestaurantsPageRelationInput"]: {
	update?:ValueTypes["SubRestaurantsPageLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutLinkCreateInput"] | null
};
	["FrontPageLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutFrontPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutFrontPageCreateInput"] | null
};
	["FrontPageUpsertLocalesRelationInput"]: {
	by?:ValueTypes["FrontPageLocaleUniqueWhere"] | null,
	update?:ValueTypes["FrontPageLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["FrontPageLocaleWithoutRootCreateInput"] | null
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: boolean
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: boolean
}>;
	["HeaderCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderCreateLogoEntityRelationInput"] | null,
	locales?:ValueTypes["HeaderCreateLocalesEntityRelationInput"][],
	navigationLogo?:ValueTypes["HeaderCreateNavigationLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	create?:ValueTypes["HeaderLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	menuButtonText?:string | null,
	locale?:ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"] | null,
	primaryLinkItems?:ValueTypes["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"][],
	secondaryLinks?:ValueTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderUpdateLogoEntityRelationInput"] | null,
	locales?:ValueTypes["HeaderUpdateLocalesEntityRelationInput"][],
	navigationLogo?:ValueTypes["HeaderUpdateNavigationLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["HeaderLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["HeaderUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	delete?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["HeaderUpdateLocalesRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	data?:ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | null
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	menuButtonText?:string | null,
	locale?:ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"] | null,
	primaryLinkItems?:ValueTypes["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"][],
	secondaryLinks?:ValueTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpsertLocalesRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	update?:ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["HeaderLocaleWithoutRootCreateInput"] | null
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: boolean
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: boolean
}>;
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: boolean
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: boolean
}>;
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: boolean
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: boolean
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: boolean
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: boolean
}>;
	["LocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LocaleEdge"],
		__typename?: boolean
}>;
	["LocaleEdge"]: AliasType<{
	node?:ValueTypes["Locale"],
		__typename?: boolean
}>;
	["LocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["FrontPageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["FrontPageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FrontPageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleCreateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["FrontPageLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["FrontPageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["FrontPageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FrontPageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["FrontPageLocaleUpdateSeoEntityRelationInput"] | null,
	socialLinks?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkListEdge"],
		__typename?: boolean
}>;
	["LinkListEdge"]: AliasType<{
	node?:ValueTypes["LinkList"],
		__typename?: boolean
}>;
	["LinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["LinkItemCreateListEntityRelationInput"] | null,
	link?:ValueTypes["LinkItemCreateLinkEntityRelationInput"] | null,
	icon?:ValueTypes["LinkItemCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null
};
	["LinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["LinkItemUpdateListEntityRelationInput"] | null,
	link?:ValueTypes["LinkItemUpdateLinkEntityRelationInput"] | null,
	icon?:ValueTypes["LinkItemUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["LinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["LinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["LinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["LinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["LinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["LinkListWithoutItemsCreateInput"] | null
};
	["SocialLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkListEdge"],
		__typename?: boolean
}>;
	["SocialLinkListEdge"]: AliasType<{
	node?:ValueTypes["SocialLinkList"],
		__typename?: boolean
}>;
	["SocialLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["SocialLinkItemCreateListEntityRelationInput"] | null,
	socialLink?:ValueTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null
};
	["SocialLinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["SocialLinkItemUpdateListEntityRelationInput"] | null,
	socialLink?:ValueTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["SocialLinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["SocialLinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null
};
	["PrimaryLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemCreateLinkEntityRelationInput"] | null,
	parent?:ValueTypes["PrimaryLinkItemCreateParentEntityRelationInput"] | null,
	subItems?:ValueTypes["PrimaryLinkItemCreateSubItemsEntityRelationInput"][],
	header?:ValueTypes["PrimaryLinkItemCreateHeaderEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PrimaryLinkItemUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"] | null,
	parent?:ValueTypes["PrimaryLinkItemUpdateParentEntityRelationInput"] | null,
	subItems?:ValueTypes["PrimaryLinkItemUpdateSubItemsEntityRelationInput"][],
	header?:ValueTypes["PrimaryLinkItemUpdateHeaderEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	menuButtonText?:string | null,
	root?:ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"] | null,
	primaryLinkItems?:ValueTypes["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"][],
	secondaryLinks?:ValueTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpdateInput"]: {
	menuButtonText?:string | null,
	root?:ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"] | null,
	primaryLinkItems?:ValueTypes["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"][],
	secondaryLinks?:ValueTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: boolean
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: boolean
}>;
	["FooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterCreateLogoEntityRelationInput"] | null,
	locales?:ValueTypes["FooterCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	create?:ValueTypes["FooterLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locale?:ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | null,
	linksSection?:ValueTypes["FooterLocaleCreateLinksSectionEntityRelationInput"] | null,
	contactSection?:ValueTypes["FooterLocaleCreateContactSectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutFootersCreateInput"] | null
};
	["LocaleWithoutFootersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleCreateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleCreateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleCreateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleCreateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleCreateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterUpdateLogoEntityRelationInput"] | null,
	locales?:ValueTypes["FooterUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["FooterLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["FooterUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["FooterUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	delete?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["FooterUpdateLocalesRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	data?:ValueTypes["FooterLocaleWithoutRootUpdateInput"] | null
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	locale?:ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | null,
	linksSection?:ValueTypes["FooterLocaleUpdateLinksSectionEntityRelationInput"] | null,
	contactSection?:ValueTypes["FooterLocaleUpdateContactSectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutFootersCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutFootersUpdateInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	frontPages?:ValueTypes["LocaleUpdateFrontPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	restaurants?:ValueTypes["LocaleUpdateRestaurantsEntityRelationInput"][],
	restaurantTags?:ValueTypes["LocaleUpdateRestaurantTagsEntityRelationInput"][],
	banners?:ValueTypes["LocaleUpdateBannersEntityRelationInput"][],
	categories?:ValueTypes["LocaleUpdateCategoriesEntityRelationInput"][],
	subRestaurantsPages?:ValueTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutFootersUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutFootersCreateInput"] | null
};
	["FooterUpsertLocalesRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	update?:ValueTypes["FooterLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["FooterLocaleWithoutRootCreateInput"] | null
};
	["FooterLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | null,
	linksSection?:ValueTypes["FooterLocaleCreateLinksSectionEntityRelationInput"] | null,
	contactSection?:ValueTypes["FooterLocaleCreateContactSectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpdateInput"]: {
	root?:ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | null,
	linksSection?:ValueTypes["FooterLocaleUpdateLinksSectionEntityRelationInput"] | null,
	contactSection?:ValueTypes["FooterLocaleUpdateContactSectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterLinksConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLinksEdge"],
		__typename?: boolean
}>;
	["FooterLinksEdge"]: AliasType<{
	node?:ValueTypes["FooterLinks"],
		__typename?: boolean
}>;
	["FooterContactConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterContactEdge"],
		__typename?: boolean
}>;
	["FooterContactEdge"]: AliasType<{
	node?:ValueTypes["FooterContact"],
		__typename?: boolean
}>;
	["TitleListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TitleListEdge"],
		__typename?: boolean
}>;
	["TitleListEdge"]: AliasType<{
	node?:ValueTypes["TitleList"],
		__typename?: boolean
}>;
	["TitleItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["TitleItemCreateListEntityRelationInput"] | null,
	icon?:ValueTypes["TitleItemCreateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TitleItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["TitleListUniqueWhere"] | null,
	create?:ValueTypes["TitleListWithoutItemsCreateInput"] | null
};
	["TitleListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["TitleItemUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["TitleItemUpdateListEntityRelationInput"] | null,
	icon?:ValueTypes["TitleItemUpdateIconEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TitleItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["TitleListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["TitleListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["TitleItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["TitleListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TitleListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["TitleItemUpsertListRelationInput"]: {
	update?:ValueTypes["TitleListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["TitleListWithoutItemsCreateInput"] | null
};
	["SocialLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkEdge"],
		__typename?: boolean
}>;
	["SocialLinkEdge"]: AliasType<{
	node?:ValueTypes["SocialLink"],
		__typename?: boolean
}>;
	["SecondaryLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SecondaryLinkListEdge"],
		__typename?: boolean
}>;
	["SecondaryLinkListEdge"]: AliasType<{
	node?:ValueTypes["SecondaryLinkList"],
		__typename?: boolean
}>;
	["SecondaryLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	iconType?:ValueTypes["IconType"] | null,
	list?:ValueTypes["SecondaryLinkItemCreateListEntityRelationInput"] | null,
	link?:ValueTypes["SecondaryLinkItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SecondaryLinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["SecondaryLinkListUniqueWhere"] | null,
	create?:ValueTypes["SecondaryLinkListWithoutItemsCreateInput"] | null
};
	["SecondaryLinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["SecondaryLinkItemUpdateInput"]: {
	order?:number | null,
	iconType?:ValueTypes["IconType"] | null,
	list?:ValueTypes["SecondaryLinkItemUpdateListEntityRelationInput"] | null,
	link?:ValueTypes["SecondaryLinkItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SecondaryLinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["SecondaryLinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["SecondaryLinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["SecondaryLinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["SecondaryLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SecondaryLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["SecondaryLinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["SecondaryLinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["SecondaryLinkListWithoutItemsCreateInput"] | null
};
	["RestaurantLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["RestaurantLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["RestaurantLocaleCreateLocaleEntityRelationInput"] | null,
	description?:string | null,
	url?:string | null,
	location?:string | null,
	isEshopActive?:boolean | null,
	isDeliveryActive?:boolean | null,
	secondaryUrl?:string | null,
	_dummy_field_?:boolean | null
};
	["RestaurantLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["RestaurantLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["RestaurantLocaleUpdateLocaleEntityRelationInput"] | null,
	description?:string | null,
	url?:string | null,
	location?:string | null,
	isEshopActive?:boolean | null,
	isDeliveryActive?:boolean | null,
	secondaryUrl?:string | null,
	_dummy_field_?:boolean | null
};
	["TranslationDomain"]: AliasType<{
	_meta?:ValueTypes["TranslationDomainMeta"],
	id?:boolean,
	identifier?:boolean,
	name?:boolean,
catalogues?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
keys?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationKey"]],
cataloguesByIdentifier?: [{	by:ValueTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
cataloguesByValues?: [{	by:ValueTypes["TranslationDomainCataloguesByValuesUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
keysByIdentifier?: [{	by:ValueTypes["TranslationDomainKeysByIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
keysByValues?: [{	by:ValueTypes["TranslationDomainKeysByValuesUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
paginateCatalogues?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
paginateKeys?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationKeyConnection"]],
		__typename?: boolean
}>;
	["TranslationDomainMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	catalogues?:ValueTypes["FieldMeta"],
	keys?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TranslationCatalogue"]: AliasType<{
	_meta?:ValueTypes["TranslationCatalogueMeta"],
	id?:boolean,
domain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
identifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifier"]],
fallback?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
values?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
valuesByKey?: [{	by:ValueTypes["TranslationCatalogueValuesByKeyUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
		__typename?: boolean
}>;
	["TranslationCatalogueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	fallback?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TranslationDomainWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	identifier?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	catalogues?:ValueTypes["TranslationCatalogueWhere"] | null,
	keys?:ValueTypes["TranslationKeyWhere"] | null,
	and?:(ValueTypes["TranslationDomainWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationDomainWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationDomainWhere"] | null
};
	["TranslationCatalogueWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	domain?:ValueTypes["TranslationDomainWhere"] | null,
	identifier?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,
	fallback?:ValueTypes["TranslationCatalogueWhere"] | null,
	values?:ValueTypes["TranslationValueWhere"] | null,
	and?:(ValueTypes["TranslationCatalogueWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationCatalogueWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationCatalogueWhere"] | null
};
	["TranslationCataloguesIdentifierWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	code?:ValueTypes["StringCondition"] | null,
	catalogue?:ValueTypes["TranslationCatalogueWhere"] | null,
	and?:(ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null
};
	["TranslationValueWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	value?:ValueTypes["StringCondition"] | null,
	catalogue?:ValueTypes["TranslationCatalogueWhere"] | null,
	key?:ValueTypes["TranslationKeyWhere"] | null,
	and?:(ValueTypes["TranslationValueWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationValueWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationValueWhere"] | null
};
	["TranslationKeyWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	identifier?:ValueTypes["StringCondition"] | null,
	contentType?:ValueTypes["TranslationContentTypeCondition"] | null,
	note?:ValueTypes["StringCondition"] | null,
	domain?:ValueTypes["TranslationDomainWhere"] | null,
	values?:ValueTypes["TranslationValueWhere"] | null,
	and?:(ValueTypes["TranslationKeyWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationKeyWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationKeyWhere"] | null
};
	["TranslationContentTypeCondition"]: {
	and?:ValueTypes["TranslationContentTypeCondition"][],
	or?:ValueTypes["TranslationContentTypeCondition"][],
	not?:ValueTypes["TranslationContentTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["TranslationContentType"] | null,
	notEq?:ValueTypes["TranslationContentType"] | null,
	in?:ValueTypes["TranslationContentType"][],
	notIn?:ValueTypes["TranslationContentType"][],
	lt?:ValueTypes["TranslationContentType"] | null,
	lte?:ValueTypes["TranslationContentType"] | null,
	gt?:ValueTypes["TranslationContentType"] | null,
	gte?:ValueTypes["TranslationContentType"] | null
};
	["TranslationContentType"]:TranslationContentType;
	["TranslationCataloguesIdentifier"]: AliasType<{
	_meta?:ValueTypes["TranslationCataloguesIdentifierMeta"],
	id?:boolean,
	name?:boolean,
	code?:boolean,
catalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
catalogueByDomain?: [{	by:ValueTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
catalogueByValues?: [{	by:ValueTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
paginateCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
		__typename?: boolean
}>;
	["TranslationCataloguesIdentifierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TranslationCatalogueOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	domain?:ValueTypes["TranslationDomainOrderBy"] | null,
	identifier?:ValueTypes["TranslationCataloguesIdentifierOrderBy"] | null,
	fallback?:ValueTypes["TranslationCatalogueOrderBy"] | null
};
	["TranslationDomainOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	identifier?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null
};
	["TranslationCataloguesIdentifierOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	code?:ValueTypes["OrderDirection"] | null
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
	domain?:ValueTypes["TranslationDomainUniqueWhere"] | null
};
	["TranslationDomainUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	catalogues?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	keys?:ValueTypes["TranslationKeyUniqueWhere"] | null
};
	["TranslationCatalogueUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	identifier?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null,
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	catalogue?:ValueTypes["TranslationCatalogueUniqueWhere"] | null
};
	["TranslationValueUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	catalogue?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	key?:ValueTypes["TranslationKeyUniqueWhere"] | null
};
	["TranslationKeyUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	identifier?:string | null,
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationCatalogueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCatalogueEdge"],
		__typename?: boolean
}>;
	["TranslationCatalogueEdge"]: AliasType<{
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: boolean
}>;
	["TranslationValue"]: AliasType<{
	_meta?:ValueTypes["TranslationValueMeta"],
	id?:boolean,
	value?:boolean,
catalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
key?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
		__typename?: boolean
}>;
	["TranslationValueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TranslationKey"]: AliasType<{
	_meta?:ValueTypes["TranslationKeyMeta"],
	id?:boolean,
	identifier?:boolean,
	contentType?:boolean,
	note?:boolean,
domain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
values?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
valuesByCatalogue?: [{	by:ValueTypes["TranslationKeyValuesByCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
		__typename?: boolean
}>;
	["TranslationKeyMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	contentType?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["TranslationValueOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	catalogue?:ValueTypes["TranslationCatalogueOrderBy"] | null,
	key?:ValueTypes["TranslationKeyOrderBy"] | null
};
	["TranslationKeyOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	identifier?:ValueTypes["OrderDirection"] | null,
	contentType?:ValueTypes["OrderDirection"] | null,
	note?:ValueTypes["OrderDirection"] | null,
	domain?:ValueTypes["TranslationDomainOrderBy"] | null
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
	catalogue?:ValueTypes["TranslationCatalogueUniqueWhere"] | null
};
	["TranslationValueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationValueEdge"],
		__typename?: boolean
}>;
	["TranslationValueEdge"]: AliasType<{
	node?:ValueTypes["TranslationValue"],
		__typename?: boolean
}>;
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
	key?:ValueTypes["TranslationKeyUniqueWhere"] | null
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
	identifier?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
	identifier?:string | null
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationKeyConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationKeyEdge"],
		__typename?: boolean
}>;
	["TranslationKeyEdge"]: AliasType<{
	node?:ValueTypes["TranslationKey"],
		__typename?: boolean
}>;
	["TranslationDomainConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationDomainEdge"],
		__typename?: boolean
}>;
	["TranslationDomainEdge"]: AliasType<{
	node?:ValueTypes["TranslationDomain"],
		__typename?: boolean
}>;
	["TranslationDomainCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"][],
	keys?:ValueTypes["TranslationDomainCreateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | null,
	alias?:string | null
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null,
	create?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueCreateInput"] | null
};
	["TranslationCatalogueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	create?:ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | null
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	name?:string | null,
	keys?:ValueTypes["TranslationDomainCreateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	create?:ValueTypes["TranslationKeyWithoutDomainCreateInput"] | null,
	alias?:string | null
};
	["TranslationKeyWithoutDomainCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	values?:ValueTypes["TranslationKeyCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	create?:ValueTypes["TranslationValueWithoutKeyCreateInput"] | null,
	alias?:string | null
};
	["TranslationValueWithoutKeyCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | null
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	create?:ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | null,
	alias?:string | null
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	value?:string | null,
	key?:ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	create?:ValueTypes["TranslationKeyWithoutValuesCreateInput"] | null
};
	["TranslationKeyWithoutValuesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	create?:ValueTypes["TranslationDomainWithoutKeysCreateInput"] | null
};
	["TranslationDomainWithoutKeysCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainUpdateInput"]: {
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"][],
	keys?:ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | null,
	update?:ValueTypes["TranslationDomainUpdateCataloguesRelationInput"] | null,
	upsert?:ValueTypes["TranslationDomainUpsertCataloguesRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	data?:ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | null
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
	identifier?:ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
	create?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | null,
	update?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | null,
	connect?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
	update?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | null,
	create?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | null
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueCreateInput"] | null,
	update?:ValueTypes["TranslationCatalogueUpdateInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertFallbackRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TranslationCatalogueUpdateInput"]: {
	domain?:ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
	create?:ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | null,
	update?:ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertDomainRelationInput"] | null,
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
	identifier?:string | null,
	name?:string | null,
	keys?:ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
	create?:ValueTypes["TranslationKeyWithoutDomainCreateInput"] | null,
	update?:ValueTypes["TranslationDomainUpdateKeysRelationInput"] | null,
	upsert?:ValueTypes["TranslationDomainUpsertKeysRelationInput"] | null,
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	delete?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationDomainUpdateKeysRelationInput"]: {
	by?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	data?:ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | null
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	values?:ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
	create?:ValueTypes["TranslationValueWithoutKeyCreateInput"] | null,
	update?:ValueTypes["TranslationKeyUpdateValuesRelationInput"] | null,
	upsert?:ValueTypes["TranslationKeyUpsertValuesRelationInput"] | null,
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationValueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationKeyUpdateValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	data?:ValueTypes["TranslationValueWithoutKeyUpdateInput"] | null
};
	["TranslationValueWithoutKeyUpdateInput"]: {
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | null,
	update?:ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | null,
	upsert?:ValueTypes["TranslationValueUpsertCatalogueRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
	domain?:ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
	update?:ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | null
};
	["TranslationKeyUpsertValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	update?:ValueTypes["TranslationValueWithoutKeyUpdateInput"] | null,
	create?:ValueTypes["TranslationValueWithoutKeyCreateInput"] | null
};
	["TranslationDomainUpsertKeysRelationInput"]: {
	by?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	update?:ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | null,
	create?:ValueTypes["TranslationKeyWithoutDomainCreateInput"] | null
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
	update?:ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | null,
	create?:ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | null
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
	create?:ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | null,
	update?:ValueTypes["TranslationCatalogueUpdateValuesRelationInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertValuesRelationInput"] | null,
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationValueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	data?:ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | null
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
	value?:string | null,
	key?:ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
	create?:ValueTypes["TranslationKeyWithoutValuesCreateInput"] | null,
	update?:ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | null,
	upsert?:ValueTypes["TranslationValueUpsertKeyRelationInput"] | null,
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
	create?:ValueTypes["TranslationDomainWithoutKeysCreateInput"] | null,
	update?:ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | null,
	upsert?:ValueTypes["TranslationKeyUpsertDomainRelationInput"] | null,
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpsertDomainRelationInput"]: {
	update?:ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | null,
	create?:ValueTypes["TranslationDomainWithoutKeysCreateInput"] | null
};
	["TranslationValueUpsertKeyRelationInput"]: {
	update?:ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | null,
	create?:ValueTypes["TranslationKeyWithoutValuesCreateInput"] | null
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	update?:ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | null,
	create?:ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | null
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
	update?:ValueTypes["TranslationCatalogueUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueCreateInput"] | null
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	update?:ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | null
};
	["TranslationCataloguesIdentifierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCataloguesIdentifierEdge"],
		__typename?: boolean
}>;
	["TranslationCataloguesIdentifierEdge"]: AliasType<{
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean
}>;
	["TranslationCataloguesIdentifierCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	catalogue?:ValueTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | null,
	alias?:string | null
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	catalogue?:ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | null,
	update?:ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | null,
	upsert?:ValueTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	data?:ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | null
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
	domain?:ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	update?:ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | null
};
	["TranslationKeyCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | null,
	values?:ValueTypes["TranslationKeyCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpdateInput"]: {
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | null,
	values?:ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationValueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | null,
	key?:ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpdateInput"]: {
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | null,
	key?:ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	parent?:ValueTypes["RestaurantItemCreateParentEntityRelationInput"] | null,
	order?:number | null,
	restaurant?:ValueTypes["RestaurantItemCreateRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantItemUpdateInput"]: {
	parent?:ValueTypes["RestaurantItemUpdateParentEntityRelationInput"] | null,
	order?:number | null,
	restaurant?:ValueTypes["RestaurantItemUpdateRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["RestaurantTagCreateLocalesEntityRelationInput"][],
	backgroundColor?:string | null,
	titleColor?:string | null,
	restaurants?:ValueTypes["RestaurantTagCreateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantTagUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["RestaurantTagUpdateLocalesEntityRelationInput"][],
	backgroundColor?:string | null,
	titleColor?:string | null,
	restaurants?:ValueTypes["RestaurantTagUpdateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["RestaurantTagLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["RestaurantTagLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["RestaurantTagLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RestaurantTagLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["RestaurantTagLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["RestaurantTagLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BannerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BannerEdge"],
		__typename?: boolean
}>;
	["BannerEdge"]: AliasType<{
	node?:ValueTypes["Banner"],
		__typename?: boolean
}>;
	["BannerLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	text?:string | null,
	root?:ValueTypes["BannerLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["BannerLocaleCreateLocaleEntityRelationInput"] | null,
	title?:string | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["BannerLocaleUpdateInput"]: {
	text?:string | null,
	root?:ValueTypes["BannerLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["BannerLocaleUpdateLocaleEntityRelationInput"] | null,
	title?:string | null,
	url?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["CategoryCreateLocalesEntityRelationInput"][],
	restaurants?:ValueTypes["CategoryCreateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CategoryUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["CategoryUpdateLocalesEntityRelationInput"][],
	restaurants?:ValueTypes["CategoryUpdateRestaurantsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["CategoryLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["CategoryLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["CategoryLocaleCreateLocaleEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["CategoryLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["CategoryLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["CategoryLocaleUpdateLocaleEntityRelationInput"] | null,
	slug?:string | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SubRestaurantsPageEdge"],
		__typename?: boolean
}>;
	["SubRestaurantsPageEdge"]: AliasType<{
	node?:ValueTypes["SubRestaurantsPage"],
		__typename?: boolean
}>;
	["SubRestaurantsPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["SubRestaurantsPageCreateLocalesEntityRelationInput"][],
	order?:number | null,
	parentRestaurant?:ValueTypes["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["SubRestaurantsPageLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageUpdateInput"]: {
	locales?:ValueTypes["SubRestaurantsPageUpdateLocalesEntityRelationInput"][],
	order?:number | null,
	parentRestaurant?:ValueTypes["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["SubRestaurantsPageUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["SubRestaurantsPageUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["SubRestaurantsPageUpdateLocalesRelationInput"]: {
	by?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	data?:ValueTypes["SubRestaurantsPageLocaleWithoutRootUpdateInput"] | null
};
	["SubRestaurantsPageLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageUpsertLocalesRelationInput"]: {
	by?:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"] | null,
	update?:ValueTypes["SubRestaurantsPageLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["SubRestaurantsPageLocaleWithoutRootCreateInput"] | null
};
	["SubRestaurantsPageLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["SubRestaurantsPageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SubRestaurantsPageLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageList"]: AliasType<{
	_meta?:ValueTypes["ImageListMeta"],
	id?:boolean,
items?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageListItem"]],
itemsByImage?: [{	by:ValueTypes["ImageListItemsByImageUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItem"]],
paginateItems?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListItemConnection"]],
		__typename?: boolean
}>;
	["ImageListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ImageListItem"]: AliasType<{
	_meta?:ValueTypes["ImageListItemMeta"],
	id?:boolean,
	order?:boolean,
list?: [{	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: boolean
}>;
	["ImageListItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: boolean
}>;
	["ImageListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ImageListItemWhere"] | null,
	and?:(ValueTypes["ImageListWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageListWhere"] | undefined | null)[],
	not?:ValueTypes["ImageListWhere"] | null
};
	["ImageListItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ImageListWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ImageListItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageListItemWhere"] | undefined | null)[],
	not?:ValueTypes["ImageListItemWhere"] | null
};
	["ImageListItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ImageListOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ImageListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ImageListItemsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageListItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListItemEdge"],
		__typename?: boolean
}>;
	["ImageListItemEdge"]: AliasType<{
	node?:ValueTypes["ImageListItem"],
		__typename?: boolean
}>;
	["ImageListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ImageListItemUniqueWhere"] | null
};
	["ImageListItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageListEdge"],
		__typename?: boolean
}>;
	["ImageListEdge"]: AliasType<{
	node?:ValueTypes["ImageList"],
		__typename?: boolean
}>;
	["ImageListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ImageListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ImageListItemUniqueWhere"] | null,
	create?:ValueTypes["ImageListItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ImageListItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["ImageListItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageListUpdateInput"]: {
	items?:ValueTypes["ImageListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ImageListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ImageListItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ImageListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ImageListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ImageListItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ImageListItemUniqueWhere"] | null,
	delete?:ValueTypes["ImageListItemUniqueWhere"] | null,
	alias?:string | null
};
	["ImageListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ImageListItemUniqueWhere"] | null,
	data?:ValueTypes["ImageListItemWithoutListUpdateInput"] | null
};
	["ImageListItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ImageListItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageListItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ImageListItemUniqueWhere"] | null,
	update?:ValueTypes["ImageListItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ImageListItemWithoutListCreateInput"] | null
};
	["ImageListItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ImageListItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["ImageListItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ImageListUniqueWhere"] | null,
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null
};
	["ImageListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ImageListItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["ImageListItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ImageListItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ImageListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ImageListItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ImageListUniqueWhere"] | null,
	delete?:boolean | null
};
	["ImageListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ImageListItemUpsertListRelationInput"]: {
	update?:ValueTypes["ImageListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ImageListWithoutItemsCreateInput"] | null
};
	["QueryTransaction"]: AliasType<{
getFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPage"]],
listFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPage"]],
paginateFrontPage?: [{	filter?:ValueTypes["FrontPageWhere"] | null,	orderBy?:ValueTypes["FrontPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageConnection"]],
validateCreateFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
listLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocale"]],
listFrontPageLocale?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FrontPageLocale"]],
paginateFrontPageLocale?: [{	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	orderBy?:ValueTypes["FrontPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FrontPageLocaleConnection"]],
validateCreateFrontPageLocale?: [{	data:ValueTypes["FrontPageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	data:ValueTypes["FrontPageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkList"]],
listLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkList"]],
paginateLinkList?: [{	filter?:ValueTypes["LinkListWhere"] | null,	orderBy?:ValueTypes["LinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkListConnection"]],
validateCreateLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItem"]],
listLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LinkItem"]],
paginateLinkItem?: [{	filter?:ValueTypes["LinkItemWhere"] | null,	orderBy?:ValueTypes["LinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkItemConnection"]],
validateCreateLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
listSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkList"]],
paginateSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkListConnection"]],
validateCreateSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
listSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
paginateSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
validateCreateSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getPrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItem"]],
listPrimaryLinkItem?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PrimaryLinkItem"]],
paginatePrimaryLinkItem?: [{	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	orderBy?:ValueTypes["PrimaryLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PrimaryLinkItemConnection"]],
validateCreatePrimaryLinkItem?: [{	data:ValueTypes["PrimaryLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	data:ValueTypes["PrimaryLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null},ValueTypes["FooterLinks"]],
listFooterLinks?: [{	filter?:ValueTypes["FooterLinksWhere"] | null,	orderBy?:ValueTypes["FooterLinksOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLinks"]],
paginateFooterLinks?: [{	filter?:ValueTypes["FooterLinksWhere"] | null,	orderBy?:ValueTypes["FooterLinksOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLinksConnection"]],
validateCreateFooterLinks?: [{	data:ValueTypes["FooterLinksCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	data:ValueTypes["FooterLinksUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null},ValueTypes["FooterContact"]],
listFooterContact?: [{	filter?:ValueTypes["FooterContactWhere"] | null,	orderBy?:ValueTypes["FooterContactOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterContact"]],
paginateFooterContact?: [{	filter?:ValueTypes["FooterContactWhere"] | null,	orderBy?:ValueTypes["FooterContactOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterContactConnection"]],
validateCreateFooterContact?: [{	data:ValueTypes["FooterContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	data:ValueTypes["FooterContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null},ValueTypes["TitleList"]],
listTitleList?: [{	filter?:ValueTypes["TitleListWhere"] | null,	orderBy?:ValueTypes["TitleListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TitleList"]],
paginateTitleList?: [{	filter?:ValueTypes["TitleListWhere"] | null,	orderBy?:ValueTypes["TitleListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TitleListConnection"]],
validateCreateTitleList?: [{	data:ValueTypes["TitleListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	data:ValueTypes["TitleListUpdateInput"]},ValueTypes["_ValidationResult"]],
getTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null},ValueTypes["TitleItem"]],
listTitleItem?: [{	filter?:ValueTypes["TitleItemWhere"] | null,	orderBy?:ValueTypes["TitleItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TitleItem"]],
paginateTitleItem?: [{	filter?:ValueTypes["TitleItemWhere"] | null,	orderBy?:ValueTypes["TitleItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TitleItemConnection"]],
validateCreateTitleItem?: [{	data:ValueTypes["TitleItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	data:ValueTypes["TitleItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null},ValueTypes["SecondaryLinkList"]],
listSecondaryLinkList?: [{	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SecondaryLinkList"]],
paginateSecondaryLinkList?: [{	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SecondaryLinkListConnection"]],
validateCreateSecondaryLinkList?: [{	data:ValueTypes["SecondaryLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	data:ValueTypes["SecondaryLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null},ValueTypes["SecondaryLinkItem"]],
listSecondaryLinkItem?: [{	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SecondaryLinkItem"]],
paginateSecondaryLinkItem?: [{	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	orderBy?:ValueTypes["SecondaryLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SecondaryLinkItemConnection"]],
validateCreateSecondaryLinkItem?: [{	data:ValueTypes["SecondaryLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	data:ValueTypes["SecondaryLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["Restaurant"]],
listRestaurant?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Restaurant"]],
paginateRestaurant?: [{	filter?:ValueTypes["RestaurantWhere"] | null,	orderBy?:ValueTypes["RestaurantOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantConnection"]],
validateCreateRestaurant?: [{	data:ValueTypes["RestaurantCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	data:ValueTypes["RestaurantUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null},ValueTypes["RestaurantLocale"]],
listRestaurantLocale?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantLocale"]],
paginateRestaurantLocale?: [{	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantLocaleConnection"]],
validateCreateRestaurantLocale?: [{	data:ValueTypes["RestaurantLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	data:ValueTypes["RestaurantLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null},ValueTypes["RestaurantItem"]],
listRestaurantItem?: [{	filter?:ValueTypes["RestaurantItemWhere"] | null,	orderBy?:ValueTypes["RestaurantItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantItem"]],
paginateRestaurantItem?: [{	filter?:ValueTypes["RestaurantItemWhere"] | null,	orderBy?:ValueTypes["RestaurantItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantItemConnection"]],
validateCreateRestaurantItem?: [{	data:ValueTypes["RestaurantItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	data:ValueTypes["RestaurantItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null},ValueTypes["RestaurantTag"]],
listRestaurantTag?: [{	filter?:ValueTypes["RestaurantTagWhere"] | null,	orderBy?:ValueTypes["RestaurantTagOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantTag"]],
paginateRestaurantTag?: [{	filter?:ValueTypes["RestaurantTagWhere"] | null,	orderBy?:ValueTypes["RestaurantTagOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantTagConnection"]],
validateCreateRestaurantTag?: [{	data:ValueTypes["RestaurantTagCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	data:ValueTypes["RestaurantTagUpdateInput"]},ValueTypes["_ValidationResult"]],
getRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null},ValueTypes["RestaurantTagLocale"]],
listRestaurantTagLocale?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["RestaurantTagLocale"]],
paginateRestaurantTagLocale?: [{	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	orderBy?:ValueTypes["RestaurantTagLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RestaurantTagLocaleConnection"]],
validateCreateRestaurantTagLocale?: [{	data:ValueTypes["RestaurantTagLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	data:ValueTypes["RestaurantTagLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null},ValueTypes["Banner"]],
listBanner?: [{	filter?:ValueTypes["BannerWhere"] | null,	orderBy?:ValueTypes["BannerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Banner"]],
paginateBanner?: [{	filter?:ValueTypes["BannerWhere"] | null,	orderBy?:ValueTypes["BannerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BannerConnection"]],
validateCreateBanner?: [{	data:ValueTypes["BannerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	data:ValueTypes["BannerUpdateInput"]},ValueTypes["_ValidationResult"]],
getBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null},ValueTypes["BannerLocale"]],
listBannerLocale?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BannerLocale"]],
paginateBannerLocale?: [{	filter?:ValueTypes["BannerLocaleWhere"] | null,	orderBy?:ValueTypes["BannerLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BannerLocaleConnection"]],
validateCreateBannerLocale?: [{	data:ValueTypes["BannerLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	data:ValueTypes["BannerLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["Category"]],
listCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Category"]],
paginateCategory?: [{	filter?:ValueTypes["CategoryWhere"] | null,	orderBy?:ValueTypes["CategoryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryConnection"]],
validateCreateCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["_ValidationResult"]],
getCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocale"]],
listCategoryLocale?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["CategoryLocale"]],
paginateCategoryLocale?: [{	filter?:ValueTypes["CategoryLocaleWhere"] | null,	orderBy?:ValueTypes["CategoryLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["CategoryLocaleConnection"]],
validateCreateCategoryLocale?: [{	data:ValueTypes["CategoryLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	data:ValueTypes["CategoryLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null},ValueTypes["SubRestaurantsPage"]],
listSubRestaurantsPage?: [{	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubRestaurantsPage"]],
paginateSubRestaurantsPage?: [{	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubRestaurantsPageConnection"]],
validateCreateSubRestaurantsPage?: [{	data:ValueTypes["SubRestaurantsPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	data:ValueTypes["SubRestaurantsPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocale"]],
listSubRestaurantsPageLocale?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SubRestaurantsPageLocale"]],
paginateSubRestaurantsPageLocale?: [{	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	orderBy?:ValueTypes["SubRestaurantsPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SubRestaurantsPageLocaleConnection"]],
validateCreateSubRestaurantsPageLocale?: [{	data:ValueTypes["SubRestaurantsPageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	data:ValueTypes["SubRestaurantsPageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageList"]],
listImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageList"]],
paginateImageList?: [{	filter?:ValueTypes["ImageListWhere"] | null,	orderBy?:ValueTypes["ImageListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListConnection"]],
validateCreateImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["_ValidationResult"]],
getImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItem"]],
listImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ImageListItem"]],
paginateImageListItem?: [{	filter?:ValueTypes["ImageListItemWhere"] | null,	orderBy?:ValueTypes["ImageListItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageListItemConnection"]],
validateCreateImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: boolean
}>;
	["Info"]: AliasType<{
	description?:boolean,
		__typename?: boolean
}>;
	["Mutation"]: AliasType<{
createFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageCreateResult"]],
deleteFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPageDeleteResult"]],
updateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["FrontPageUpdateResult"]],
upsertFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	update:ValueTypes["FrontPageUpdateInput"],	create:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	update:ValueTypes["LocaleUpdateInput"],	create:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createFrontPageLocale?: [{	data:ValueTypes["FrontPageLocaleCreateInput"]},ValueTypes["FrontPageLocaleCreateResult"]],
deleteFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocaleDeleteResult"]],
updateFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	data:ValueTypes["FrontPageLocaleUpdateInput"]},ValueTypes["FrontPageLocaleUpdateResult"]],
upsertFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	update:ValueTypes["FrontPageLocaleUpdateInput"],	create:ValueTypes["FrontPageLocaleCreateInput"]},ValueTypes["FrontPageLocaleUpsertResult"]],
createLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	update:ValueTypes["LinkListUpdateInput"],	create:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	update:ValueTypes["LinkItemUpdateInput"],	create:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemUpsertResult"]],
createSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListCreateResult"]],
deleteSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkListDeleteResult"]],
updateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["SocialLinkListUpdateResult"]],
upsertSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	update:ValueTypes["SocialLinkListUpdateInput"],	create:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListUpsertResult"]],
createSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemCreateResult"]],
deleteSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItemDeleteResult"]],
updateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["SocialLinkItemUpdateResult"]],
upsertSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	update:ValueTypes["SocialLinkItemUpdateInput"],	create:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemUpsertResult"]],
createPrimaryLinkItem?: [{	data:ValueTypes["PrimaryLinkItemCreateInput"]},ValueTypes["PrimaryLinkItemCreateResult"]],
deletePrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItemDeleteResult"]],
updatePrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	data:ValueTypes["PrimaryLinkItemUpdateInput"]},ValueTypes["PrimaryLinkItemUpdateResult"]],
upsertPrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	update:ValueTypes["PrimaryLinkItemUpdateInput"],	create:ValueTypes["PrimaryLinkItemCreateInput"]},ValueTypes["PrimaryLinkItemUpsertResult"]],
createHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	update:ValueTypes["HeaderLocaleUpdateInput"],	create:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	update:ValueTypes["FooterLocaleUpdateInput"],	create:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleUpsertResult"]],
createFooterLinks?: [{	data:ValueTypes["FooterLinksCreateInput"]},ValueTypes["FooterLinksCreateResult"]],
deleteFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null},ValueTypes["FooterLinksDeleteResult"]],
updateFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null,	data:ValueTypes["FooterLinksUpdateInput"]},ValueTypes["FooterLinksUpdateResult"]],
upsertFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null,	update:ValueTypes["FooterLinksUpdateInput"],	create:ValueTypes["FooterLinksCreateInput"]},ValueTypes["FooterLinksUpsertResult"]],
createFooterContact?: [{	data:ValueTypes["FooterContactCreateInput"]},ValueTypes["FooterContactCreateResult"]],
deleteFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null},ValueTypes["FooterContactDeleteResult"]],
updateFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null,	data:ValueTypes["FooterContactUpdateInput"]},ValueTypes["FooterContactUpdateResult"]],
upsertFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null,	update:ValueTypes["FooterContactUpdateInput"],	create:ValueTypes["FooterContactCreateInput"]},ValueTypes["FooterContactUpsertResult"]],
createTitleList?: [{	data:ValueTypes["TitleListCreateInput"]},ValueTypes["TitleListCreateResult"]],
deleteTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null},ValueTypes["TitleListDeleteResult"]],
updateTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null,	data:ValueTypes["TitleListUpdateInput"]},ValueTypes["TitleListUpdateResult"]],
upsertTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null,	update:ValueTypes["TitleListUpdateInput"],	create:ValueTypes["TitleListCreateInput"]},ValueTypes["TitleListUpsertResult"]],
createTitleItem?: [{	data:ValueTypes["TitleItemCreateInput"]},ValueTypes["TitleItemCreateResult"]],
deleteTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null},ValueTypes["TitleItemDeleteResult"]],
updateTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null,	data:ValueTypes["TitleItemUpdateInput"]},ValueTypes["TitleItemUpdateResult"]],
upsertTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null,	update:ValueTypes["TitleItemUpdateInput"],	create:ValueTypes["TitleItemCreateInput"]},ValueTypes["TitleItemUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createSecondaryLinkList?: [{	data:ValueTypes["SecondaryLinkListCreateInput"]},ValueTypes["SecondaryLinkListCreateResult"]],
deleteSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null},ValueTypes["SecondaryLinkListDeleteResult"]],
updateSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	data:ValueTypes["SecondaryLinkListUpdateInput"]},ValueTypes["SecondaryLinkListUpdateResult"]],
upsertSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	update:ValueTypes["SecondaryLinkListUpdateInput"],	create:ValueTypes["SecondaryLinkListCreateInput"]},ValueTypes["SecondaryLinkListUpsertResult"]],
createSecondaryLinkItem?: [{	data:ValueTypes["SecondaryLinkItemCreateInput"]},ValueTypes["SecondaryLinkItemCreateResult"]],
deleteSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null},ValueTypes["SecondaryLinkItemDeleteResult"]],
updateSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	data:ValueTypes["SecondaryLinkItemUpdateInput"]},ValueTypes["SecondaryLinkItemUpdateResult"]],
upsertSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	update:ValueTypes["SecondaryLinkItemUpdateInput"],	create:ValueTypes["SecondaryLinkItemCreateInput"]},ValueTypes["SecondaryLinkItemUpsertResult"]],
createRestaurant?: [{	data:ValueTypes["RestaurantCreateInput"]},ValueTypes["RestaurantCreateResult"]],
deleteRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["RestaurantDeleteResult"]],
updateRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null,	data:ValueTypes["RestaurantUpdateInput"]},ValueTypes["RestaurantUpdateResult"]],
upsertRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null,	update:ValueTypes["RestaurantUpdateInput"],	create:ValueTypes["RestaurantCreateInput"]},ValueTypes["RestaurantUpsertResult"]],
createRestaurantLocale?: [{	data:ValueTypes["RestaurantLocaleCreateInput"]},ValueTypes["RestaurantLocaleCreateResult"]],
deleteRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null},ValueTypes["RestaurantLocaleDeleteResult"]],
updateRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	data:ValueTypes["RestaurantLocaleUpdateInput"]},ValueTypes["RestaurantLocaleUpdateResult"]],
upsertRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	update:ValueTypes["RestaurantLocaleUpdateInput"],	create:ValueTypes["RestaurantLocaleCreateInput"]},ValueTypes["RestaurantLocaleUpsertResult"]],
createTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	update:ValueTypes["TranslationDomainUpdateInput"],	create:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	update:ValueTypes["TranslationCatalogueUpdateInput"],	create:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	update:ValueTypes["TranslationCataloguesIdentifierUpdateInput"],	create:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	update:ValueTypes["TranslationKeyUpdateInput"],	create:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	update:ValueTypes["TranslationValueUpdateInput"],	create:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueUpsertResult"]],
createRestaurantItem?: [{	data:ValueTypes["RestaurantItemCreateInput"]},ValueTypes["RestaurantItemCreateResult"]],
deleteRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null},ValueTypes["RestaurantItemDeleteResult"]],
updateRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null,	data:ValueTypes["RestaurantItemUpdateInput"]},ValueTypes["RestaurantItemUpdateResult"]],
upsertRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null,	update:ValueTypes["RestaurantItemUpdateInput"],	create:ValueTypes["RestaurantItemCreateInput"]},ValueTypes["RestaurantItemUpsertResult"]],
createRestaurantTag?: [{	data:ValueTypes["RestaurantTagCreateInput"]},ValueTypes["RestaurantTagCreateResult"]],
deleteRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null},ValueTypes["RestaurantTagDeleteResult"]],
updateRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null,	data:ValueTypes["RestaurantTagUpdateInput"]},ValueTypes["RestaurantTagUpdateResult"]],
upsertRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null,	update:ValueTypes["RestaurantTagUpdateInput"],	create:ValueTypes["RestaurantTagCreateInput"]},ValueTypes["RestaurantTagUpsertResult"]],
createRestaurantTagLocale?: [{	data:ValueTypes["RestaurantTagLocaleCreateInput"]},ValueTypes["RestaurantTagLocaleCreateResult"]],
deleteRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null},ValueTypes["RestaurantTagLocaleDeleteResult"]],
updateRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	data:ValueTypes["RestaurantTagLocaleUpdateInput"]},ValueTypes["RestaurantTagLocaleUpdateResult"]],
upsertRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	update:ValueTypes["RestaurantTagLocaleUpdateInput"],	create:ValueTypes["RestaurantTagLocaleCreateInput"]},ValueTypes["RestaurantTagLocaleUpsertResult"]],
createBanner?: [{	data:ValueTypes["BannerCreateInput"]},ValueTypes["BannerCreateResult"]],
deleteBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null},ValueTypes["BannerDeleteResult"]],
updateBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null,	data:ValueTypes["BannerUpdateInput"]},ValueTypes["BannerUpdateResult"]],
upsertBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null,	update:ValueTypes["BannerUpdateInput"],	create:ValueTypes["BannerCreateInput"]},ValueTypes["BannerUpsertResult"]],
createBannerLocale?: [{	data:ValueTypes["BannerLocaleCreateInput"]},ValueTypes["BannerLocaleCreateResult"]],
deleteBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null},ValueTypes["BannerLocaleDeleteResult"]],
updateBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null,	data:ValueTypes["BannerLocaleUpdateInput"]},ValueTypes["BannerLocaleUpdateResult"]],
upsertBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null,	update:ValueTypes["BannerLocaleUpdateInput"],	create:ValueTypes["BannerLocaleCreateInput"]},ValueTypes["BannerLocaleUpsertResult"]],
createCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryCreateResult"]],
deleteCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["CategoryDeleteResult"]],
updateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["CategoryUpdateResult"]],
upsertCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	update:ValueTypes["CategoryUpdateInput"],	create:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryUpsertResult"]],
createCategoryLocale?: [{	data:ValueTypes["CategoryLocaleCreateInput"]},ValueTypes["CategoryLocaleCreateResult"]],
deleteCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocaleDeleteResult"]],
updateCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null,	data:ValueTypes["CategoryLocaleUpdateInput"]},ValueTypes["CategoryLocaleUpdateResult"]],
upsertCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null,	update:ValueTypes["CategoryLocaleUpdateInput"],	create:ValueTypes["CategoryLocaleCreateInput"]},ValueTypes["CategoryLocaleUpsertResult"]],
createSubRestaurantsPage?: [{	data:ValueTypes["SubRestaurantsPageCreateInput"]},ValueTypes["SubRestaurantsPageCreateResult"]],
deleteSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null},ValueTypes["SubRestaurantsPageDeleteResult"]],
updateSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	data:ValueTypes["SubRestaurantsPageUpdateInput"]},ValueTypes["SubRestaurantsPageUpdateResult"]],
upsertSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	update:ValueTypes["SubRestaurantsPageUpdateInput"],	create:ValueTypes["SubRestaurantsPageCreateInput"]},ValueTypes["SubRestaurantsPageUpsertResult"]],
createSubRestaurantsPageLocale?: [{	data:ValueTypes["SubRestaurantsPageLocaleCreateInput"]},ValueTypes["SubRestaurantsPageLocaleCreateResult"]],
deleteSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocaleDeleteResult"]],
updateSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	data:ValueTypes["SubRestaurantsPageLocaleUpdateInput"]},ValueTypes["SubRestaurantsPageLocaleUpdateResult"]],
upsertSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	update:ValueTypes["SubRestaurantsPageLocaleUpdateInput"],	create:ValueTypes["SubRestaurantsPageLocaleCreateInput"]},ValueTypes["SubRestaurantsPageLocaleUpsertResult"]],
createImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	update:ValueTypes["ImageListUpdateInput"],	create:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	update:ValueTypes["ImageListItemUpdateInput"],	create:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: boolean
}>;
	["FrontPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MutationResult"]:AliasType<{
		ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"];
		['...on FrontPageCreateResult']?: Omit<ValueTypes["FrontPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageDeleteResult']?: Omit<ValueTypes["FrontPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageUpdateResult']?: Omit<ValueTypes["FrontPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageUpsertResult']?: Omit<ValueTypes["FrontPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ValueTypes["LocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ValueTypes["LocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ValueTypes["LocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ValueTypes["LocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageLocaleCreateResult']?: Omit<ValueTypes["FrontPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageLocaleDeleteResult']?: Omit<ValueTypes["FrontPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageLocaleUpdateResult']?: Omit<ValueTypes["FrontPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FrontPageLocaleUpsertResult']?: Omit<ValueTypes["FrontPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListCreateResult']?: Omit<ValueTypes["LinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListDeleteResult']?: Omit<ValueTypes["LinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpdateResult']?: Omit<ValueTypes["LinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkListUpsertResult']?: Omit<ValueTypes["LinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemCreateResult']?: Omit<ValueTypes["LinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemDeleteResult']?: Omit<ValueTypes["LinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpdateResult']?: Omit<ValueTypes["LinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkItemUpsertResult']?: Omit<ValueTypes["LinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListCreateResult']?: Omit<ValueTypes["SocialLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListDeleteResult']?: Omit<ValueTypes["SocialLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListUpdateResult']?: Omit<ValueTypes["SocialLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListUpsertResult']?: Omit<ValueTypes["SocialLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemCreateResult']?: Omit<ValueTypes["SocialLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemDeleteResult']?: Omit<ValueTypes["SocialLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemUpdateResult']?: Omit<ValueTypes["SocialLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemUpsertResult']?: Omit<ValueTypes["SocialLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrimaryLinkItemCreateResult']?: Omit<ValueTypes["PrimaryLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrimaryLinkItemDeleteResult']?: Omit<ValueTypes["PrimaryLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrimaryLinkItemUpdateResult']?: Omit<ValueTypes["PrimaryLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PrimaryLinkItemUpsertResult']?: Omit<ValueTypes["PrimaryLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleCreateResult']?: Omit<ValueTypes["HeaderLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleDeleteResult']?: Omit<ValueTypes["HeaderLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpdateResult']?: Omit<ValueTypes["HeaderLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpsertResult']?: Omit<ValueTypes["HeaderLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleCreateResult']?: Omit<ValueTypes["FooterLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleDeleteResult']?: Omit<ValueTypes["FooterLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpdateResult']?: Omit<ValueTypes["FooterLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpsertResult']?: Omit<ValueTypes["FooterLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinksCreateResult']?: Omit<ValueTypes["FooterLinksCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinksDeleteResult']?: Omit<ValueTypes["FooterLinksDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinksUpdateResult']?: Omit<ValueTypes["FooterLinksUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLinksUpsertResult']?: Omit<ValueTypes["FooterLinksUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterContactCreateResult']?: Omit<ValueTypes["FooterContactCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterContactDeleteResult']?: Omit<ValueTypes["FooterContactDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterContactUpdateResult']?: Omit<ValueTypes["FooterContactUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterContactUpsertResult']?: Omit<ValueTypes["FooterContactUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleListCreateResult']?: Omit<ValueTypes["TitleListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleListDeleteResult']?: Omit<ValueTypes["TitleListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleListUpdateResult']?: Omit<ValueTypes["TitleListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleListUpsertResult']?: Omit<ValueTypes["TitleListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleItemCreateResult']?: Omit<ValueTypes["TitleItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleItemDeleteResult']?: Omit<ValueTypes["TitleItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleItemUpdateResult']?: Omit<ValueTypes["TitleItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TitleItemUpsertResult']?: Omit<ValueTypes["TitleItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkCreateResult']?: Omit<ValueTypes["SocialLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkDeleteResult']?: Omit<ValueTypes["SocialLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpdateResult']?: Omit<ValueTypes["SocialLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpsertResult']?: Omit<ValueTypes["SocialLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkListCreateResult']?: Omit<ValueTypes["SecondaryLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkListDeleteResult']?: Omit<ValueTypes["SecondaryLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkListUpdateResult']?: Omit<ValueTypes["SecondaryLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkListUpsertResult']?: Omit<ValueTypes["SecondaryLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkItemCreateResult']?: Omit<ValueTypes["SecondaryLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkItemDeleteResult']?: Omit<ValueTypes["SecondaryLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkItemUpdateResult']?: Omit<ValueTypes["SecondaryLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SecondaryLinkItemUpsertResult']?: Omit<ValueTypes["SecondaryLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantCreateResult']?: Omit<ValueTypes["RestaurantCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantDeleteResult']?: Omit<ValueTypes["RestaurantDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantUpdateResult']?: Omit<ValueTypes["RestaurantUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantUpsertResult']?: Omit<ValueTypes["RestaurantUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantLocaleCreateResult']?: Omit<ValueTypes["RestaurantLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantLocaleDeleteResult']?: Omit<ValueTypes["RestaurantLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantLocaleUpdateResult']?: Omit<ValueTypes["RestaurantLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantLocaleUpsertResult']?: Omit<ValueTypes["RestaurantLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainCreateResult']?: Omit<ValueTypes["TranslationDomainCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainDeleteResult']?: Omit<ValueTypes["TranslationDomainDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpdateResult']?: Omit<ValueTypes["TranslationDomainUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpsertResult']?: Omit<ValueTypes["TranslationDomainUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueCreateResult']?: Omit<ValueTypes["TranslationCatalogueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueDeleteResult']?: Omit<ValueTypes["TranslationCatalogueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpdateResult']?: Omit<ValueTypes["TranslationCatalogueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpsertResult']?: Omit<ValueTypes["TranslationCatalogueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierCreateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierDeleteResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpdateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpsertResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyCreateResult']?: Omit<ValueTypes["TranslationKeyCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyDeleteResult']?: Omit<ValueTypes["TranslationKeyDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpdateResult']?: Omit<ValueTypes["TranslationKeyUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpsertResult']?: Omit<ValueTypes["TranslationKeyUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueCreateResult']?: Omit<ValueTypes["TranslationValueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueDeleteResult']?: Omit<ValueTypes["TranslationValueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpdateResult']?: Omit<ValueTypes["TranslationValueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpsertResult']?: Omit<ValueTypes["TranslationValueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantItemCreateResult']?: Omit<ValueTypes["RestaurantItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantItemDeleteResult']?: Omit<ValueTypes["RestaurantItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantItemUpdateResult']?: Omit<ValueTypes["RestaurantItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantItemUpsertResult']?: Omit<ValueTypes["RestaurantItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagCreateResult']?: Omit<ValueTypes["RestaurantTagCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagDeleteResult']?: Omit<ValueTypes["RestaurantTagDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagUpdateResult']?: Omit<ValueTypes["RestaurantTagUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagUpsertResult']?: Omit<ValueTypes["RestaurantTagUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagLocaleCreateResult']?: Omit<ValueTypes["RestaurantTagLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagLocaleDeleteResult']?: Omit<ValueTypes["RestaurantTagLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagLocaleUpdateResult']?: Omit<ValueTypes["RestaurantTagLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RestaurantTagLocaleUpsertResult']?: Omit<ValueTypes["RestaurantTagLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerCreateResult']?: Omit<ValueTypes["BannerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerDeleteResult']?: Omit<ValueTypes["BannerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerUpdateResult']?: Omit<ValueTypes["BannerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerUpsertResult']?: Omit<ValueTypes["BannerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerLocaleCreateResult']?: Omit<ValueTypes["BannerLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerLocaleDeleteResult']?: Omit<ValueTypes["BannerLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerLocaleUpdateResult']?: Omit<ValueTypes["BannerLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BannerLocaleUpsertResult']?: Omit<ValueTypes["BannerLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryCreateResult']?: Omit<ValueTypes["CategoryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryDeleteResult']?: Omit<ValueTypes["CategoryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryUpdateResult']?: Omit<ValueTypes["CategoryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryUpsertResult']?: Omit<ValueTypes["CategoryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryLocaleCreateResult']?: Omit<ValueTypes["CategoryLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryLocaleDeleteResult']?: Omit<ValueTypes["CategoryLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryLocaleUpdateResult']?: Omit<ValueTypes["CategoryLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on CategoryLocaleUpsertResult']?: Omit<ValueTypes["CategoryLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageCreateResult']?: Omit<ValueTypes["SubRestaurantsPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageDeleteResult']?: Omit<ValueTypes["SubRestaurantsPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageUpdateResult']?: Omit<ValueTypes["SubRestaurantsPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageUpsertResult']?: Omit<ValueTypes["SubRestaurantsPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageLocaleCreateResult']?: Omit<ValueTypes["SubRestaurantsPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageLocaleDeleteResult']?: Omit<ValueTypes["SubRestaurantsPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageLocaleUpdateResult']?: Omit<ValueTypes["SubRestaurantsPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SubRestaurantsPageLocaleUpsertResult']?: Omit<ValueTypes["SubRestaurantsPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListCreateResult']?: Omit<ValueTypes["ImageListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListDeleteResult']?: Omit<ValueTypes["ImageListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpdateResult']?: Omit<ValueTypes["ImageListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListUpsertResult']?: Omit<ValueTypes["ImageListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemCreateResult']?: Omit<ValueTypes["ImageListItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemDeleteResult']?: Omit<ValueTypes["ImageListItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpdateResult']?: Omit<ValueTypes["ImageListItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageListItemUpsertResult']?: Omit<ValueTypes["ImageListItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: boolean
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:boolean,
	message?:boolean,
		__typename?: boolean
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["FrontPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
		__typename?: boolean
}>;
	["FrontPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FrontPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: boolean
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: boolean
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: boolean
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: boolean
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: boolean
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
		__typename?: boolean
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FrontPageLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FrontPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPageLocale"],
		__typename?: boolean
}>;
	["FrontPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FrontPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FrontPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
		__typename?: boolean
}>;
	["LinkListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
		__typename?: boolean
}>;
	["LinkItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["LinkItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
		__typename?: boolean
}>;
	["SocialLinkListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
		__typename?: boolean
}>;
	["SocialLinkItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PrimaryLinkItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrimaryLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PrimaryLinkItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrimaryLinkItem"],
		__typename?: boolean
}>;
	["PrimaryLinkItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrimaryLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["PrimaryLinkItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PrimaryLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HeaderLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HeaderLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
		__typename?: boolean
}>;
	["HeaderLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["HeaderLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: boolean
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
		__typename?: boolean
}>;
	["FooterLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLinksCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinks"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLinksDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinks"],
		__typename?: boolean
}>;
	["FooterLinksUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinks"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterLinksUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLinks"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterContactCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterContactDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterContact"],
		__typename?: boolean
}>;
	["FooterContactUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["FooterContactUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TitleListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TitleListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleList"],
		__typename?: boolean
}>;
	["TitleListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TitleListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TitleItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TitleItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleItem"],
		__typename?: boolean
}>;
	["TitleItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TitleItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TitleItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
		__typename?: boolean
}>;
	["SocialLinkUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SocialLinkUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SecondaryLinkListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SecondaryLinkListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkList"],
		__typename?: boolean
}>;
	["SecondaryLinkListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SecondaryLinkListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SecondaryLinkItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SecondaryLinkItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkItem"],
		__typename?: boolean
}>;
	["SecondaryLinkItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SecondaryLinkItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SecondaryLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Restaurant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Restaurant"],
		__typename?: boolean
}>;
	["RestaurantUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Restaurant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Restaurant"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantLocale"],
		__typename?: boolean
}>;
	["RestaurantLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationDomainCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationDomainDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
		__typename?: boolean
}>;
	["TranslationDomainUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationDomainUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationCatalogueCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationCatalogueDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: boolean
}>;
	["TranslationCatalogueUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationCatalogueUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationCataloguesIdentifierCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationCataloguesIdentifierDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: boolean
}>;
	["TranslationCataloguesIdentifierUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationCataloguesIdentifierUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationKeyCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationKeyDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
		__typename?: boolean
}>;
	["TranslationKeyUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationKeyUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationValueCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationValueDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
		__typename?: boolean
}>;
	["TranslationValueUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["TranslationValueUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantItem"],
		__typename?: boolean
}>;
	["RestaurantItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantTagCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantTagDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTag"],
		__typename?: boolean
}>;
	["RestaurantTagUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantTagUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTag"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantTagLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTagLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantTagLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTagLocale"],
		__typename?: boolean
}>;
	["RestaurantTagLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTagLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["RestaurantTagLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["RestaurantTagLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BannerCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Banner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BannerDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Banner"],
		__typename?: boolean
}>;
	["BannerUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Banner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BannerUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Banner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BannerLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BannerLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BannerLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BannerLocale"],
		__typename?: boolean
}>;
	["BannerLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BannerLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["BannerLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BannerLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
		__typename?: boolean
}>;
	["CategoryUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Category"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CategoryLocale"],
		__typename?: boolean
}>;
	["CategoryLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["CategoryLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["CategoryLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubRestaurantsPageCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubRestaurantsPageDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPage"],
		__typename?: boolean
}>;
	["SubRestaurantsPageUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubRestaurantsPageUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPageLocale"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["SubRestaurantsPageLocaleUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SubRestaurantsPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageListCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageListDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
		__typename?: boolean
}>;
	["ImageListUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageListUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageListItemCreateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageListItemDeleteResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
		__typename?: boolean
}>;
	["ImageListItemUpdateResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["ImageListItemUpsertResult"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ImageListItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: boolean
}>;
	["MutationTransaction"]: AliasType<{
	ok?:boolean,
	errorMessage?:boolean,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createFrontPage?: [{	data:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageCreateResult"]],
deleteFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null},ValueTypes["FrontPageDeleteResult"]],
updateFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	data:ValueTypes["FrontPageUpdateInput"]},ValueTypes["FrontPageUpdateResult"]],
upsertFrontPage?: [{	by:ValueTypes["FrontPageUniqueWhere"],	filter?:ValueTypes["FrontPageWhere"] | null,	update:ValueTypes["FrontPageUpdateInput"],	create:ValueTypes["FrontPageCreateInput"]},ValueTypes["FrontPageUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	update:ValueTypes["LocaleUpdateInput"],	create:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createFrontPageLocale?: [{	data:ValueTypes["FrontPageLocaleCreateInput"]},ValueTypes["FrontPageLocaleCreateResult"]],
deleteFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null},ValueTypes["FrontPageLocaleDeleteResult"]],
updateFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	data:ValueTypes["FrontPageLocaleUpdateInput"]},ValueTypes["FrontPageLocaleUpdateResult"]],
upsertFrontPageLocale?: [{	by:ValueTypes["FrontPageLocaleUniqueWhere"],	filter?:ValueTypes["FrontPageLocaleWhere"] | null,	update:ValueTypes["FrontPageLocaleUpdateInput"],	create:ValueTypes["FrontPageLocaleCreateInput"]},ValueTypes["FrontPageLocaleUpsertResult"]],
createLinkList?: [{	data:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListCreateResult"]],
deleteLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null},ValueTypes["LinkListDeleteResult"]],
updateLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	data:ValueTypes["LinkListUpdateInput"]},ValueTypes["LinkListUpdateResult"]],
upsertLinkList?: [{	by:ValueTypes["LinkListUniqueWhere"],	filter?:ValueTypes["LinkListWhere"] | null,	update:ValueTypes["LinkListUpdateInput"],	create:ValueTypes["LinkListCreateInput"]},ValueTypes["LinkListUpsertResult"]],
createLinkItem?: [{	data:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemCreateResult"]],
deleteLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null},ValueTypes["LinkItemDeleteResult"]],
updateLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	data:ValueTypes["LinkItemUpdateInput"]},ValueTypes["LinkItemUpdateResult"]],
upsertLinkItem?: [{	by:ValueTypes["LinkItemUniqueWhere"],	filter?:ValueTypes["LinkItemWhere"] | null,	update:ValueTypes["LinkItemUpdateInput"],	create:ValueTypes["LinkItemCreateInput"]},ValueTypes["LinkItemUpsertResult"]],
createSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListCreateResult"]],
deleteSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkListDeleteResult"]],
updateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["SocialLinkListUpdateResult"]],
upsertSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	update:ValueTypes["SocialLinkListUpdateInput"],	create:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListUpsertResult"]],
createSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemCreateResult"]],
deleteSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItemDeleteResult"]],
updateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["SocialLinkItemUpdateResult"]],
upsertSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	update:ValueTypes["SocialLinkItemUpdateInput"],	create:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemUpsertResult"]],
createPrimaryLinkItem?: [{	data:ValueTypes["PrimaryLinkItemCreateInput"]},ValueTypes["PrimaryLinkItemCreateResult"]],
deletePrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null},ValueTypes["PrimaryLinkItemDeleteResult"]],
updatePrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	data:ValueTypes["PrimaryLinkItemUpdateInput"]},ValueTypes["PrimaryLinkItemUpdateResult"]],
upsertPrimaryLinkItem?: [{	by:ValueTypes["PrimaryLinkItemUniqueWhere"],	filter?:ValueTypes["PrimaryLinkItemWhere"] | null,	update:ValueTypes["PrimaryLinkItemUpdateInput"],	create:ValueTypes["PrimaryLinkItemCreateInput"]},ValueTypes["PrimaryLinkItemUpsertResult"]],
createHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	update:ValueTypes["HeaderLocaleUpdateInput"],	create:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	update:ValueTypes["FooterLocaleUpdateInput"],	create:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleUpsertResult"]],
createFooterLinks?: [{	data:ValueTypes["FooterLinksCreateInput"]},ValueTypes["FooterLinksCreateResult"]],
deleteFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null},ValueTypes["FooterLinksDeleteResult"]],
updateFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null,	data:ValueTypes["FooterLinksUpdateInput"]},ValueTypes["FooterLinksUpdateResult"]],
upsertFooterLinks?: [{	by:ValueTypes["FooterLinksUniqueWhere"],	filter?:ValueTypes["FooterLinksWhere"] | null,	update:ValueTypes["FooterLinksUpdateInput"],	create:ValueTypes["FooterLinksCreateInput"]},ValueTypes["FooterLinksUpsertResult"]],
createFooterContact?: [{	data:ValueTypes["FooterContactCreateInput"]},ValueTypes["FooterContactCreateResult"]],
deleteFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null},ValueTypes["FooterContactDeleteResult"]],
updateFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null,	data:ValueTypes["FooterContactUpdateInput"]},ValueTypes["FooterContactUpdateResult"]],
upsertFooterContact?: [{	by:ValueTypes["FooterContactUniqueWhere"],	filter?:ValueTypes["FooterContactWhere"] | null,	update:ValueTypes["FooterContactUpdateInput"],	create:ValueTypes["FooterContactCreateInput"]},ValueTypes["FooterContactUpsertResult"]],
createTitleList?: [{	data:ValueTypes["TitleListCreateInput"]},ValueTypes["TitleListCreateResult"]],
deleteTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null},ValueTypes["TitleListDeleteResult"]],
updateTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null,	data:ValueTypes["TitleListUpdateInput"]},ValueTypes["TitleListUpdateResult"]],
upsertTitleList?: [{	by:ValueTypes["TitleListUniqueWhere"],	filter?:ValueTypes["TitleListWhere"] | null,	update:ValueTypes["TitleListUpdateInput"],	create:ValueTypes["TitleListCreateInput"]},ValueTypes["TitleListUpsertResult"]],
createTitleItem?: [{	data:ValueTypes["TitleItemCreateInput"]},ValueTypes["TitleItemCreateResult"]],
deleteTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null},ValueTypes["TitleItemDeleteResult"]],
updateTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null,	data:ValueTypes["TitleItemUpdateInput"]},ValueTypes["TitleItemUpdateResult"]],
upsertTitleItem?: [{	by:ValueTypes["TitleItemUniqueWhere"],	filter?:ValueTypes["TitleItemWhere"] | null,	update:ValueTypes["TitleItemUpdateInput"],	create:ValueTypes["TitleItemCreateInput"]},ValueTypes["TitleItemUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createSecondaryLinkList?: [{	data:ValueTypes["SecondaryLinkListCreateInput"]},ValueTypes["SecondaryLinkListCreateResult"]],
deleteSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null},ValueTypes["SecondaryLinkListDeleteResult"]],
updateSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	data:ValueTypes["SecondaryLinkListUpdateInput"]},ValueTypes["SecondaryLinkListUpdateResult"]],
upsertSecondaryLinkList?: [{	by:ValueTypes["SecondaryLinkListUniqueWhere"],	filter?:ValueTypes["SecondaryLinkListWhere"] | null,	update:ValueTypes["SecondaryLinkListUpdateInput"],	create:ValueTypes["SecondaryLinkListCreateInput"]},ValueTypes["SecondaryLinkListUpsertResult"]],
createSecondaryLinkItem?: [{	data:ValueTypes["SecondaryLinkItemCreateInput"]},ValueTypes["SecondaryLinkItemCreateResult"]],
deleteSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null},ValueTypes["SecondaryLinkItemDeleteResult"]],
updateSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	data:ValueTypes["SecondaryLinkItemUpdateInput"]},ValueTypes["SecondaryLinkItemUpdateResult"]],
upsertSecondaryLinkItem?: [{	by:ValueTypes["SecondaryLinkItemUniqueWhere"],	filter?:ValueTypes["SecondaryLinkItemWhere"] | null,	update:ValueTypes["SecondaryLinkItemUpdateInput"],	create:ValueTypes["SecondaryLinkItemCreateInput"]},ValueTypes["SecondaryLinkItemUpsertResult"]],
createRestaurant?: [{	data:ValueTypes["RestaurantCreateInput"]},ValueTypes["RestaurantCreateResult"]],
deleteRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null},ValueTypes["RestaurantDeleteResult"]],
updateRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null,	data:ValueTypes["RestaurantUpdateInput"]},ValueTypes["RestaurantUpdateResult"]],
upsertRestaurant?: [{	by:ValueTypes["RestaurantUniqueWhere"],	filter?:ValueTypes["RestaurantWhere"] | null,	update:ValueTypes["RestaurantUpdateInput"],	create:ValueTypes["RestaurantCreateInput"]},ValueTypes["RestaurantUpsertResult"]],
createRestaurantLocale?: [{	data:ValueTypes["RestaurantLocaleCreateInput"]},ValueTypes["RestaurantLocaleCreateResult"]],
deleteRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null},ValueTypes["RestaurantLocaleDeleteResult"]],
updateRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	data:ValueTypes["RestaurantLocaleUpdateInput"]},ValueTypes["RestaurantLocaleUpdateResult"]],
upsertRestaurantLocale?: [{	by:ValueTypes["RestaurantLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantLocaleWhere"] | null,	update:ValueTypes["RestaurantLocaleUpdateInput"],	create:ValueTypes["RestaurantLocaleCreateInput"]},ValueTypes["RestaurantLocaleUpsertResult"]],
createTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	update:ValueTypes["TranslationDomainUpdateInput"],	create:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	update:ValueTypes["TranslationCatalogueUpdateInput"],	create:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	update:ValueTypes["TranslationCataloguesIdentifierUpdateInput"],	create:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	update:ValueTypes["TranslationKeyUpdateInput"],	create:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	update:ValueTypes["TranslationValueUpdateInput"],	create:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueUpsertResult"]],
createRestaurantItem?: [{	data:ValueTypes["RestaurantItemCreateInput"]},ValueTypes["RestaurantItemCreateResult"]],
deleteRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null},ValueTypes["RestaurantItemDeleteResult"]],
updateRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null,	data:ValueTypes["RestaurantItemUpdateInput"]},ValueTypes["RestaurantItemUpdateResult"]],
upsertRestaurantItem?: [{	by:ValueTypes["RestaurantItemUniqueWhere"],	filter?:ValueTypes["RestaurantItemWhere"] | null,	update:ValueTypes["RestaurantItemUpdateInput"],	create:ValueTypes["RestaurantItemCreateInput"]},ValueTypes["RestaurantItemUpsertResult"]],
createRestaurantTag?: [{	data:ValueTypes["RestaurantTagCreateInput"]},ValueTypes["RestaurantTagCreateResult"]],
deleteRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null},ValueTypes["RestaurantTagDeleteResult"]],
updateRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null,	data:ValueTypes["RestaurantTagUpdateInput"]},ValueTypes["RestaurantTagUpdateResult"]],
upsertRestaurantTag?: [{	by:ValueTypes["RestaurantTagUniqueWhere"],	filter?:ValueTypes["RestaurantTagWhere"] | null,	update:ValueTypes["RestaurantTagUpdateInput"],	create:ValueTypes["RestaurantTagCreateInput"]},ValueTypes["RestaurantTagUpsertResult"]],
createRestaurantTagLocale?: [{	data:ValueTypes["RestaurantTagLocaleCreateInput"]},ValueTypes["RestaurantTagLocaleCreateResult"]],
deleteRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null},ValueTypes["RestaurantTagLocaleDeleteResult"]],
updateRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	data:ValueTypes["RestaurantTagLocaleUpdateInput"]},ValueTypes["RestaurantTagLocaleUpdateResult"]],
upsertRestaurantTagLocale?: [{	by:ValueTypes["RestaurantTagLocaleUniqueWhere"],	filter?:ValueTypes["RestaurantTagLocaleWhere"] | null,	update:ValueTypes["RestaurantTagLocaleUpdateInput"],	create:ValueTypes["RestaurantTagLocaleCreateInput"]},ValueTypes["RestaurantTagLocaleUpsertResult"]],
createBanner?: [{	data:ValueTypes["BannerCreateInput"]},ValueTypes["BannerCreateResult"]],
deleteBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null},ValueTypes["BannerDeleteResult"]],
updateBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null,	data:ValueTypes["BannerUpdateInput"]},ValueTypes["BannerUpdateResult"]],
upsertBanner?: [{	by:ValueTypes["BannerUniqueWhere"],	filter?:ValueTypes["BannerWhere"] | null,	update:ValueTypes["BannerUpdateInput"],	create:ValueTypes["BannerCreateInput"]},ValueTypes["BannerUpsertResult"]],
createBannerLocale?: [{	data:ValueTypes["BannerLocaleCreateInput"]},ValueTypes["BannerLocaleCreateResult"]],
deleteBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null},ValueTypes["BannerLocaleDeleteResult"]],
updateBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null,	data:ValueTypes["BannerLocaleUpdateInput"]},ValueTypes["BannerLocaleUpdateResult"]],
upsertBannerLocale?: [{	by:ValueTypes["BannerLocaleUniqueWhere"],	filter?:ValueTypes["BannerLocaleWhere"] | null,	update:ValueTypes["BannerLocaleUpdateInput"],	create:ValueTypes["BannerLocaleCreateInput"]},ValueTypes["BannerLocaleUpsertResult"]],
createCategory?: [{	data:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryCreateResult"]],
deleteCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null},ValueTypes["CategoryDeleteResult"]],
updateCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	data:ValueTypes["CategoryUpdateInput"]},ValueTypes["CategoryUpdateResult"]],
upsertCategory?: [{	by:ValueTypes["CategoryUniqueWhere"],	filter?:ValueTypes["CategoryWhere"] | null,	update:ValueTypes["CategoryUpdateInput"],	create:ValueTypes["CategoryCreateInput"]},ValueTypes["CategoryUpsertResult"]],
createCategoryLocale?: [{	data:ValueTypes["CategoryLocaleCreateInput"]},ValueTypes["CategoryLocaleCreateResult"]],
deleteCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null},ValueTypes["CategoryLocaleDeleteResult"]],
updateCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null,	data:ValueTypes["CategoryLocaleUpdateInput"]},ValueTypes["CategoryLocaleUpdateResult"]],
upsertCategoryLocale?: [{	by:ValueTypes["CategoryLocaleUniqueWhere"],	filter?:ValueTypes["CategoryLocaleWhere"] | null,	update:ValueTypes["CategoryLocaleUpdateInput"],	create:ValueTypes["CategoryLocaleCreateInput"]},ValueTypes["CategoryLocaleUpsertResult"]],
createSubRestaurantsPage?: [{	data:ValueTypes["SubRestaurantsPageCreateInput"]},ValueTypes["SubRestaurantsPageCreateResult"]],
deleteSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null},ValueTypes["SubRestaurantsPageDeleteResult"]],
updateSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	data:ValueTypes["SubRestaurantsPageUpdateInput"]},ValueTypes["SubRestaurantsPageUpdateResult"]],
upsertSubRestaurantsPage?: [{	by:ValueTypes["SubRestaurantsPageUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageWhere"] | null,	update:ValueTypes["SubRestaurantsPageUpdateInput"],	create:ValueTypes["SubRestaurantsPageCreateInput"]},ValueTypes["SubRestaurantsPageUpsertResult"]],
createSubRestaurantsPageLocale?: [{	data:ValueTypes["SubRestaurantsPageLocaleCreateInput"]},ValueTypes["SubRestaurantsPageLocaleCreateResult"]],
deleteSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null},ValueTypes["SubRestaurantsPageLocaleDeleteResult"]],
updateSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	data:ValueTypes["SubRestaurantsPageLocaleUpdateInput"]},ValueTypes["SubRestaurantsPageLocaleUpdateResult"]],
upsertSubRestaurantsPageLocale?: [{	by:ValueTypes["SubRestaurantsPageLocaleUniqueWhere"],	filter?:ValueTypes["SubRestaurantsPageLocaleWhere"] | null,	update:ValueTypes["SubRestaurantsPageLocaleUpdateInput"],	create:ValueTypes["SubRestaurantsPageLocaleCreateInput"]},ValueTypes["SubRestaurantsPageLocaleUpsertResult"]],
createImageList?: [{	data:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListCreateResult"]],
deleteImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null},ValueTypes["ImageListDeleteResult"]],
updateImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	data:ValueTypes["ImageListUpdateInput"]},ValueTypes["ImageListUpdateResult"]],
upsertImageList?: [{	by:ValueTypes["ImageListUniqueWhere"],	filter?:ValueTypes["ImageListWhere"] | null,	update:ValueTypes["ImageListUpdateInput"],	create:ValueTypes["ImageListCreateInput"]},ValueTypes["ImageListUpsertResult"]],
createImageListItem?: [{	data:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemCreateResult"]],
deleteImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null},ValueTypes["ImageListItemDeleteResult"]],
updateImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	data:ValueTypes["ImageListItemUpdateInput"]},ValueTypes["ImageListItemUpdateResult"]],
upsertImageListItem?: [{	by:ValueTypes["ImageListItemUniqueWhere"],	filter?:ValueTypes["ImageListItemWhere"] | null,	update:ValueTypes["ImageListItemUpdateInput"],	create:ValueTypes["ImageListItemCreateInput"]},ValueTypes["ImageListItemUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: boolean
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null
};
	/** Json custom scalar type */
["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: boolean
}>;
	["_Entity"]: AliasType<{
	name?:boolean,
	customPrimaryAllowed?:boolean,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: boolean
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:boolean,
		__typename?: boolean
}>;
	["_Field"]:AliasType<{
		name?:boolean,
	type?:boolean,
	nullable?:boolean,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: boolean
}>;
	["_Column"]: AliasType<{
	name?:boolean,
	type?:boolean,
	enumName?:boolean,
	defaultValue?:boolean,
	nullable?:boolean,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:boolean,
	direction?:boolean,
		__typename?: boolean
}>;
	["_Relation"]: AliasType<{
	name?:boolean,
	type?:boolean,
	side?:boolean,
	targetEntity?:boolean,
	ownedBy?:boolean,
	inversedBy?:boolean,
	nullable?:boolean,
	onDelete?:boolean,
	orphanRemoval?:boolean,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: boolean
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:boolean,
		__typename?: boolean
}>;
	["_Validator"]: AliasType<{
	operation?:boolean,
	arguments?:ValueTypes["_Argument"],
		__typename?: boolean
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: boolean
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:boolean,
		__typename?: boolean
}>;
	["_PathArgument"]: AliasType<{
	path?:boolean,
		__typename?: boolean
}>;
	["_LiteralArgument"]: AliasType<{
	value?:boolean,
		__typename?: boolean
}>;
	["_RuleMessage"]: AliasType<{
	text?:boolean,
		__typename?: boolean
}>;
	["_Enum"]: AliasType<{
	name?:boolean,
	values?:boolean,
		__typename?: boolean
}>;
	["S3SignedUpload"]: AliasType<{
	url?:boolean,
	headers?:ValueTypes["S3Header"],
	method?:boolean,
	/** Allowed patterns:
** */
	objectKey?:boolean,
	bucket?:boolean,
	publicUrl?:boolean,
		__typename?: boolean
}>;
	["S3Header"]: AliasType<{
	key?:boolean,
	value?:boolean,
		__typename?: boolean
}>;
	["S3SignedRead"]: AliasType<{
	url?:boolean,
	headers?:ValueTypes["S3Header"],
	method?:boolean,
	/** Allowed patterns:
** */
	objectKey?:boolean,
	bucket?:boolean,
		__typename?: boolean
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getFrontPage?:ModelTypes["FrontPage"],
	listFrontPage:ModelTypes["FrontPage"][],
	paginateFrontPage:ModelTypes["FrontPageConnection"],
	validateCreateFrontPage:ModelTypes["_ValidationResult"],
	validateUpdateFrontPage:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getLocale?:ModelTypes["Locale"],
	listLocale:ModelTypes["Locale"][],
	paginateLocale:ModelTypes["LocaleConnection"],
	validateCreateLocale:ModelTypes["_ValidationResult"],
	validateUpdateLocale:ModelTypes["_ValidationResult"],
	getFrontPageLocale?:ModelTypes["FrontPageLocale"],
	listFrontPageLocale:ModelTypes["FrontPageLocale"][],
	paginateFrontPageLocale:ModelTypes["FrontPageLocaleConnection"],
	validateCreateFrontPageLocale:ModelTypes["_ValidationResult"],
	validateUpdateFrontPageLocale:ModelTypes["_ValidationResult"],
	getLinkList?:ModelTypes["LinkList"],
	listLinkList:ModelTypes["LinkList"][],
	paginateLinkList:ModelTypes["LinkListConnection"],
	validateCreateLinkList:ModelTypes["_ValidationResult"],
	validateUpdateLinkList:ModelTypes["_ValidationResult"],
	getLinkItem?:ModelTypes["LinkItem"],
	listLinkItem:ModelTypes["LinkItem"][],
	paginateLinkItem:ModelTypes["LinkItemConnection"],
	validateCreateLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateLinkItem:ModelTypes["_ValidationResult"],
	getSocialLinkList?:ModelTypes["SocialLinkList"],
	listSocialLinkList:ModelTypes["SocialLinkList"][],
	paginateSocialLinkList:ModelTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkList:ModelTypes["_ValidationResult"],
	getSocialLinkItem?:ModelTypes["SocialLinkItem"],
	listSocialLinkItem:ModelTypes["SocialLinkItem"][],
	paginateSocialLinkItem:ModelTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkItem:ModelTypes["_ValidationResult"],
	getPrimaryLinkItem?:ModelTypes["PrimaryLinkItem"],
	listPrimaryLinkItem:ModelTypes["PrimaryLinkItem"][],
	paginatePrimaryLinkItem:ModelTypes["PrimaryLinkItemConnection"],
	validateCreatePrimaryLinkItem:ModelTypes["_ValidationResult"],
	validateUpdatePrimaryLinkItem:ModelTypes["_ValidationResult"],
	getHeaderLocale?:ModelTypes["HeaderLocale"],
	listHeaderLocale:ModelTypes["HeaderLocale"][],
	paginateHeaderLocale:ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterLocale?:ModelTypes["FooterLocale"],
	listFooterLocale:ModelTypes["FooterLocale"][],
	paginateFooterLocale:ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale:ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale:ModelTypes["_ValidationResult"],
	getFooterLinks?:ModelTypes["FooterLinks"],
	listFooterLinks:ModelTypes["FooterLinks"][],
	paginateFooterLinks:ModelTypes["FooterLinksConnection"],
	validateCreateFooterLinks:ModelTypes["_ValidationResult"],
	validateUpdateFooterLinks:ModelTypes["_ValidationResult"],
	getFooterContact?:ModelTypes["FooterContact"],
	listFooterContact:ModelTypes["FooterContact"][],
	paginateFooterContact:ModelTypes["FooterContactConnection"],
	validateCreateFooterContact:ModelTypes["_ValidationResult"],
	validateUpdateFooterContact:ModelTypes["_ValidationResult"],
	getTitleList?:ModelTypes["TitleList"],
	listTitleList:ModelTypes["TitleList"][],
	paginateTitleList:ModelTypes["TitleListConnection"],
	validateCreateTitleList:ModelTypes["_ValidationResult"],
	validateUpdateTitleList:ModelTypes["_ValidationResult"],
	getTitleItem?:ModelTypes["TitleItem"],
	listTitleItem:ModelTypes["TitleItem"][],
	paginateTitleItem:ModelTypes["TitleItemConnection"],
	validateCreateTitleItem:ModelTypes["_ValidationResult"],
	validateUpdateTitleItem:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getSecondaryLinkList?:ModelTypes["SecondaryLinkList"],
	listSecondaryLinkList:ModelTypes["SecondaryLinkList"][],
	paginateSecondaryLinkList:ModelTypes["SecondaryLinkListConnection"],
	validateCreateSecondaryLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSecondaryLinkList:ModelTypes["_ValidationResult"],
	getSecondaryLinkItem?:ModelTypes["SecondaryLinkItem"],
	listSecondaryLinkItem:ModelTypes["SecondaryLinkItem"][],
	paginateSecondaryLinkItem:ModelTypes["SecondaryLinkItemConnection"],
	validateCreateSecondaryLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSecondaryLinkItem:ModelTypes["_ValidationResult"],
	getRestaurant?:ModelTypes["Restaurant"],
	listRestaurant:ModelTypes["Restaurant"][],
	paginateRestaurant:ModelTypes["RestaurantConnection"],
	validateCreateRestaurant:ModelTypes["_ValidationResult"],
	validateUpdateRestaurant:ModelTypes["_ValidationResult"],
	getRestaurantLocale?:ModelTypes["RestaurantLocale"],
	listRestaurantLocale:ModelTypes["RestaurantLocale"][],
	paginateRestaurantLocale:ModelTypes["RestaurantLocaleConnection"],
	validateCreateRestaurantLocale:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantLocale:ModelTypes["_ValidationResult"],
	getTranslationDomain?:ModelTypes["TranslationDomain"],
	listTranslationDomain:ModelTypes["TranslationDomain"][],
	paginateTranslationDomain:ModelTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain:ModelTypes["_ValidationResult"],
	validateUpdateTranslationDomain:ModelTypes["_ValidationResult"],
	getTranslationCatalogue?:ModelTypes["TranslationCatalogue"],
	listTranslationCatalogue:ModelTypes["TranslationCatalogue"][],
	paginateTranslationCatalogue:ModelTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue:ModelTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?:ModelTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifier"][],
	paginateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	getTranslationKey?:ModelTypes["TranslationKey"],
	listTranslationKey:ModelTypes["TranslationKey"][],
	paginateTranslationKey:ModelTypes["TranslationKeyConnection"],
	validateCreateTranslationKey:ModelTypes["_ValidationResult"],
	validateUpdateTranslationKey:ModelTypes["_ValidationResult"],
	getTranslationValue?:ModelTypes["TranslationValue"],
	listTranslationValue:ModelTypes["TranslationValue"][],
	paginateTranslationValue:ModelTypes["TranslationValueConnection"],
	validateCreateTranslationValue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationValue:ModelTypes["_ValidationResult"],
	getRestaurantItem?:ModelTypes["RestaurantItem"],
	listRestaurantItem:ModelTypes["RestaurantItem"][],
	paginateRestaurantItem:ModelTypes["RestaurantItemConnection"],
	validateCreateRestaurantItem:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantItem:ModelTypes["_ValidationResult"],
	getRestaurantTag?:ModelTypes["RestaurantTag"],
	listRestaurantTag:ModelTypes["RestaurantTag"][],
	paginateRestaurantTag:ModelTypes["RestaurantTagConnection"],
	validateCreateRestaurantTag:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantTag:ModelTypes["_ValidationResult"],
	getRestaurantTagLocale?:ModelTypes["RestaurantTagLocale"],
	listRestaurantTagLocale:ModelTypes["RestaurantTagLocale"][],
	paginateRestaurantTagLocale:ModelTypes["RestaurantTagLocaleConnection"],
	validateCreateRestaurantTagLocale:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantTagLocale:ModelTypes["_ValidationResult"],
	getBanner?:ModelTypes["Banner"],
	listBanner:ModelTypes["Banner"][],
	paginateBanner:ModelTypes["BannerConnection"],
	validateCreateBanner:ModelTypes["_ValidationResult"],
	validateUpdateBanner:ModelTypes["_ValidationResult"],
	getBannerLocale?:ModelTypes["BannerLocale"],
	listBannerLocale:ModelTypes["BannerLocale"][],
	paginateBannerLocale:ModelTypes["BannerLocaleConnection"],
	validateCreateBannerLocale:ModelTypes["_ValidationResult"],
	validateUpdateBannerLocale:ModelTypes["_ValidationResult"],
	getCategory?:ModelTypes["Category"],
	listCategory:ModelTypes["Category"][],
	paginateCategory:ModelTypes["CategoryConnection"],
	validateCreateCategory:ModelTypes["_ValidationResult"],
	validateUpdateCategory:ModelTypes["_ValidationResult"],
	getCategoryLocale?:ModelTypes["CategoryLocale"],
	listCategoryLocale:ModelTypes["CategoryLocale"][],
	paginateCategoryLocale:ModelTypes["CategoryLocaleConnection"],
	validateCreateCategoryLocale:ModelTypes["_ValidationResult"],
	validateUpdateCategoryLocale:ModelTypes["_ValidationResult"],
	getSubRestaurantsPage?:ModelTypes["SubRestaurantsPage"],
	listSubRestaurantsPage:ModelTypes["SubRestaurantsPage"][],
	paginateSubRestaurantsPage:ModelTypes["SubRestaurantsPageConnection"],
	validateCreateSubRestaurantsPage:ModelTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPage:ModelTypes["_ValidationResult"],
	getSubRestaurantsPageLocale?:ModelTypes["SubRestaurantsPageLocale"],
	listSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocale"][],
	paginateSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleConnection"],
	validateCreateSubRestaurantsPageLocale:ModelTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPageLocale:ModelTypes["_ValidationResult"],
	getImageList?:ModelTypes["ImageList"],
	listImageList:ModelTypes["ImageList"][],
	paginateImageList:ModelTypes["ImageListConnection"],
	validateCreateImageList:ModelTypes["_ValidationResult"],
	validateUpdateImageList:ModelTypes["_ValidationResult"],
	getImageListItem?:ModelTypes["ImageListItem"],
	listImageListItem:ModelTypes["ImageListItem"][],
	paginateImageListItem:ModelTypes["ImageListItemConnection"],
	validateCreateImageListItem:ModelTypes["_ValidationResult"],
	validateUpdateImageListItem:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["FrontPage"]: {
		_meta?:ModelTypes["FrontPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["FrontPageLocale"][],
	banner?:ModelTypes["Banner"],
	localesByLocale?:ModelTypes["FrontPageLocale"],
	localesByLink?:ModelTypes["FrontPageLocale"],
	localesBySeo?:ModelTypes["FrontPageLocale"],
	paginateLocales:ModelTypes["FrontPageLocaleConnection"]
};
	["FrontPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	banner?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:any;
	["One"]: GraphQLTypes["One"];
	["FrontPageLocale"]: {
		_meta?:ModelTypes["FrontPageLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	link?:ModelTypes["Linkable"],
	root?:ModelTypes["FrontPage"],
	locale?:ModelTypes["Locale"],
	seo?:ModelTypes["Seo"],
	socialLinks?:string
};
	["FrontPageLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	socialLinks?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	frontPage?:ModelTypes["FrontPageLocale"],
	subRestaurantsPage?:ModelTypes["SubRestaurantsPageLocale"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	frontPage?:ModelTypes["FieldMeta"],
	subRestaurantsPage?:ModelTypes["FieldMeta"]
};
	["FrontPageLocaleWhere"]: GraphQLTypes["FrontPageLocaleWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["SubRestaurantsPageLocaleWhere"]: GraphQLTypes["SubRestaurantsPageLocaleWhere"];
	["SubRestaurantsPageWhere"]: GraphQLTypes["SubRestaurantsPageWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["RestaurantWhere"]: GraphQLTypes["RestaurantWhere"];
	["RestaurantLocaleWhere"]: GraphQLTypes["RestaurantLocaleWhere"];
	["LocaleWhere"]: GraphQLTypes["LocaleWhere"];
	["HeaderLocaleWhere"]: GraphQLTypes["HeaderLocaleWhere"];
	["HeaderWhere"]: GraphQLTypes["HeaderWhere"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["SocialLinkListWhere"]: GraphQLTypes["SocialLinkListWhere"];
	["SocialLinkItemWhere"]: GraphQLTypes["SocialLinkItemWhere"];
	["SocialLinkWhere"]: GraphQLTypes["SocialLinkWhere"];
	["SocialLinkTypeCondition"]: GraphQLTypes["SocialLinkTypeCondition"];
	["SocialLinkType"]: GraphQLTypes["SocialLinkType"];
	["PrimaryLinkItemWhere"]: GraphQLTypes["PrimaryLinkItemWhere"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["SecondaryLinkListWhere"]: GraphQLTypes["SecondaryLinkListWhere"];
	["SecondaryLinkItemWhere"]: GraphQLTypes["SecondaryLinkItemWhere"];
	["IconTypeCondition"]: GraphQLTypes["IconTypeCondition"];
	["IconType"]: GraphQLTypes["IconType"];
	["FooterLocaleWhere"]: GraphQLTypes["FooterLocaleWhere"];
	["FooterWhere"]: GraphQLTypes["FooterWhere"];
	["FooterLinksWhere"]: GraphQLTypes["FooterLinksWhere"];
	["LinkListWhere"]: GraphQLTypes["LinkListWhere"];
	["LinkItemWhere"]: GraphQLTypes["LinkItemWhere"];
	["TitleListWhere"]: GraphQLTypes["TitleListWhere"];
	["TitleItemWhere"]: GraphQLTypes["TitleItemWhere"];
	["FooterContactWhere"]: GraphQLTypes["FooterContactWhere"];
	["RestaurantTagLocaleWhere"]: GraphQLTypes["RestaurantTagLocaleWhere"];
	["RestaurantTagWhere"]: GraphQLTypes["RestaurantTagWhere"];
	["BannerLocaleWhere"]: GraphQLTypes["BannerLocaleWhere"];
	["BannerWhere"]: GraphQLTypes["BannerWhere"];
	["CategoryLocaleWhere"]: GraphQLTypes["CategoryLocaleWhere"];
	["CategoryWhere"]: GraphQLTypes["CategoryWhere"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["RestaurantItemWhere"]: GraphQLTypes["RestaurantItemWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["FrontPageWhere"]: GraphQLTypes["FrontPageWhere"];
	["SubRestaurantsPageLocale"]: {
		_meta?:ModelTypes["SubRestaurantsPageLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	link?:ModelTypes["Linkable"],
	root?:ModelTypes["SubRestaurantsPage"],
	locale?:ModelTypes["Locale"],
	seo?:ModelTypes["Seo"]
};
	["SubRestaurantsPageLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["SubRestaurantsPage"]: {
		_meta?:ModelTypes["SubRestaurantsPageMeta"],
	id:ModelTypes["UUID"],
	locales:ModelTypes["SubRestaurantsPageLocale"][],
	order:number,
	parentRestaurant?:ModelTypes["Restaurant"],
	localesByLocale?:ModelTypes["SubRestaurantsPageLocale"],
	localesByLink?:ModelTypes["SubRestaurantsPageLocale"],
	localesBySeo?:ModelTypes["SubRestaurantsPageLocale"],
	paginateLocales:ModelTypes["SubRestaurantsPageLocaleConnection"]
};
	["SubRestaurantsPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	parentRestaurant?:ModelTypes["FieldMeta"]
};
	["SubRestaurantsPageLocaleOrderBy"]: GraphQLTypes["SubRestaurantsPageLocaleOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["FrontPageLocaleOrderBy"]: GraphQLTypes["FrontPageLocaleOrderBy"];
	["FrontPageOrderBy"]: GraphQLTypes["FrontPageOrderBy"];
	["BannerOrderBy"]: GraphQLTypes["BannerOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["LocaleOrderBy"]: GraphQLTypes["LocaleOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["SubRestaurantsPageOrderBy"]: GraphQLTypes["SubRestaurantsPageOrderBy"];
	["RestaurantOrderBy"]: GraphQLTypes["RestaurantOrderBy"];
	["RestaurantItemOrderBy"]: GraphQLTypes["RestaurantItemOrderBy"];
	["Restaurant"]: {
		_meta?:ModelTypes["RestaurantMeta"],
	id:ModelTypes["UUID"],
	locales:ModelTypes["RestaurantLocale"][],
	image?:ModelTypes["Image"],
	subItems:ModelTypes["RestaurantItem"][],
	order:number,
	item?:ModelTypes["RestaurantItem"],
	openingHours?:string,
	tags:ModelTypes["RestaurantTag"][],
	categories:ModelTypes["Category"][],
	localesByLocale?:ModelTypes["RestaurantLocale"],
	subItemsByRestaurant?:ModelTypes["RestaurantItem"],
	paginateLocales:ModelTypes["RestaurantLocaleConnection"],
	paginateSubItems:ModelTypes["RestaurantItemConnection"],
	paginateTags:ModelTypes["RestaurantTagConnection"],
	paginateCategories:ModelTypes["CategoryConnection"]
};
	["RestaurantMeta"]: {
		id?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	subItems?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	item?:ModelTypes["FieldMeta"],
	openingHours?:ModelTypes["FieldMeta"],
	tags?:ModelTypes["FieldMeta"],
	categories?:ModelTypes["FieldMeta"]
};
	["RestaurantLocale"]: {
		_meta?:ModelTypes["RestaurantLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["Restaurant"],
	locale?:ModelTypes["Locale"],
	description?:string,
	url?:string,
	location?:string,
	isEshopActive:boolean,
	isDeliveryActive:boolean,
	secondaryUrl?:string
};
	["RestaurantLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	location?:ModelTypes["FieldMeta"],
	isEshopActive?:ModelTypes["FieldMeta"],
	isDeliveryActive?:ModelTypes["FieldMeta"],
	secondaryUrl?:ModelTypes["FieldMeta"]
};
	["Locale"]: {
		_meta?:ModelTypes["LocaleMeta"],
	id:ModelTypes["UUID"],
	code:string,
	label?:string,
	frontPages:ModelTypes["FrontPageLocale"][],
	headers:ModelTypes["HeaderLocale"][],
	footers:ModelTypes["FooterLocale"][],
	restaurants:ModelTypes["RestaurantLocale"][],
	restaurantTags:ModelTypes["RestaurantTagLocale"][],
	banners:ModelTypes["BannerLocale"][],
	categories:ModelTypes["CategoryLocale"][],
	subRestaurantsPages:ModelTypes["SubRestaurantsPageLocale"][],
	frontPagesByRoot?:ModelTypes["FrontPageLocale"],
	frontPagesByLink?:ModelTypes["FrontPageLocale"],
	frontPagesBySeo?:ModelTypes["FrontPageLocale"],
	headersByRoot?:ModelTypes["HeaderLocale"],
	headersBySocialLinks?:ModelTypes["HeaderLocale"],
	headersByPrimaryLinkItems?:ModelTypes["HeaderLocale"],
	headersBySecondaryLinks?:ModelTypes["HeaderLocale"],
	footersByRoot?:ModelTypes["FooterLocale"],
	footersByLinksSection?:ModelTypes["FooterLocale"],
	footersByContactSection?:ModelTypes["FooterLocale"],
	restaurantsByRoot?:ModelTypes["RestaurantLocale"],
	restaurantTagsByRoot?:ModelTypes["RestaurantTagLocale"],
	bannersByRoot?:ModelTypes["BannerLocale"],
	categoriesByRoot?:ModelTypes["CategoryLocale"],
	categoriesBySlug?:ModelTypes["CategoryLocale"],
	subRestaurantsPagesByRoot?:ModelTypes["SubRestaurantsPageLocale"],
	subRestaurantsPagesByLink?:ModelTypes["SubRestaurantsPageLocale"],
	subRestaurantsPagesBySeo?:ModelTypes["SubRestaurantsPageLocale"],
	paginateFrontPages:ModelTypes["FrontPageLocaleConnection"],
	paginateHeaders:ModelTypes["HeaderLocaleConnection"],
	paginateFooters:ModelTypes["FooterLocaleConnection"],
	paginateRestaurants:ModelTypes["RestaurantLocaleConnection"],
	paginateRestaurantTags:ModelTypes["RestaurantTagLocaleConnection"],
	paginateBanners:ModelTypes["BannerLocaleConnection"],
	paginateCategories:ModelTypes["CategoryLocaleConnection"],
	paginateSubRestaurantsPages:ModelTypes["SubRestaurantsPageLocaleConnection"]
};
	["LocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	code?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	frontPages?:ModelTypes["FieldMeta"],
	headers?:ModelTypes["FieldMeta"],
	footers?:ModelTypes["FieldMeta"],
	restaurants?:ModelTypes["FieldMeta"],
	restaurantTags?:ModelTypes["FieldMeta"],
	banners?:ModelTypes["FieldMeta"],
	categories?:ModelTypes["FieldMeta"],
	subRestaurantsPages?:ModelTypes["FieldMeta"]
};
	["HeaderLocale"]: {
		_meta?:ModelTypes["HeaderLocaleMeta"],
	id:ModelTypes["UUID"],
	menuButtonText?:string,
	root?:ModelTypes["Header"],
	locale?:ModelTypes["Locale"],
	socialLinks?:ModelTypes["SocialLinkList"],
	primaryLinkItems:ModelTypes["PrimaryLinkItem"][],
	secondaryLinks?:ModelTypes["SecondaryLinkList"],
	primaryLinkItemsByLink?:ModelTypes["PrimaryLinkItem"],
	primaryLinkItemsBySubItems?:ModelTypes["PrimaryLinkItem"],
	paginatePrimaryLinkItems:ModelTypes["PrimaryLinkItemConnection"]
};
	["HeaderLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	menuButtonText?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	socialLinks?:ModelTypes["FieldMeta"],
	primaryLinkItems?:ModelTypes["FieldMeta"],
	secondaryLinks?:ModelTypes["FieldMeta"]
};
	["Header"]: {
		_meta?:ModelTypes["HeaderMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	logo?:ModelTypes["Image"],
	locales:ModelTypes["HeaderLocale"][],
	navigationLogo?:ModelTypes["Image"],
	localesByLocale?:ModelTypes["HeaderLocale"],
	localesBySocialLinks?:ModelTypes["HeaderLocale"],
	localesByPrimaryLinkItems?:ModelTypes["HeaderLocale"],
	localesBySecondaryLinks?:ModelTypes["HeaderLocale"],
	paginateLocales:ModelTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	navigationLogo?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	alt?:string,
	fileName?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"],
	fileName?:ModelTypes["FieldMeta"]
};
	["HeaderLocaleOrderBy"]: GraphQLTypes["HeaderLocaleOrderBy"];
	["HeaderOrderBy"]: GraphQLTypes["HeaderOrderBy"];
	["SocialLinkListOrderBy"]: GraphQLTypes["SocialLinkListOrderBy"];
	["SecondaryLinkListOrderBy"]: GraphQLTypes["SecondaryLinkListOrderBy"];
	["HeaderLocalesByLocaleUniqueWhere"]: GraphQLTypes["HeaderLocalesByLocaleUniqueWhere"];
	["LocaleUniqueWhere"]: GraphQLTypes["LocaleUniqueWhere"];
	["FrontPageLocaleUniqueWhere"]: GraphQLTypes["FrontPageLocaleUniqueWhere"];
	["FrontPageUniqueWhere"]: GraphQLTypes["FrontPageUniqueWhere"];
	["BannerUniqueWhere"]: GraphQLTypes["BannerUniqueWhere"];
	["BannerLocaleUniqueWhere"]: GraphQLTypes["BannerLocaleUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["SubRestaurantsPageLocaleUniqueWhere"]: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"];
	["SubRestaurantsPageUniqueWhere"]: GraphQLTypes["SubRestaurantsPageUniqueWhere"];
	["RestaurantUniqueWhere"]: GraphQLTypes["RestaurantUniqueWhere"];
	["RestaurantLocaleUniqueWhere"]: GraphQLTypes["RestaurantLocaleUniqueWhere"];
	["RestaurantItemUniqueWhere"]: GraphQLTypes["RestaurantItemUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["HeaderLocaleUniqueWhere"]: GraphQLTypes["HeaderLocaleUniqueWhere"];
	["HeaderUniqueWhere"]: GraphQLTypes["HeaderUniqueWhere"];
	["SocialLinkListUniqueWhere"]: GraphQLTypes["SocialLinkListUniqueWhere"];
	["SocialLinkItemUniqueWhere"]: GraphQLTypes["SocialLinkItemUniqueWhere"];
	["SocialLinkUniqueWhere"]: GraphQLTypes["SocialLinkUniqueWhere"];
	["PrimaryLinkItemUniqueWhere"]: GraphQLTypes["PrimaryLinkItemUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["SecondaryLinkListUniqueWhere"]: GraphQLTypes["SecondaryLinkListUniqueWhere"];
	["SecondaryLinkItemUniqueWhere"]: GraphQLTypes["SecondaryLinkItemUniqueWhere"];
	["FooterLocaleUniqueWhere"]: GraphQLTypes["FooterLocaleUniqueWhere"];
	["FooterUniqueWhere"]: GraphQLTypes["FooterUniqueWhere"];
	["FooterLinksUniqueWhere"]: GraphQLTypes["FooterLinksUniqueWhere"];
	["LinkListUniqueWhere"]: GraphQLTypes["LinkListUniqueWhere"];
	["LinkItemUniqueWhere"]: GraphQLTypes["LinkItemUniqueWhere"];
	["TitleListUniqueWhere"]: GraphQLTypes["TitleListUniqueWhere"];
	["TitleItemUniqueWhere"]: GraphQLTypes["TitleItemUniqueWhere"];
	["FooterContactUniqueWhere"]: GraphQLTypes["FooterContactUniqueWhere"];
	["RestaurantTagLocaleUniqueWhere"]: GraphQLTypes["RestaurantTagLocaleUniqueWhere"];
	["RestaurantTagUniqueWhere"]: GraphQLTypes["RestaurantTagUniqueWhere"];
	["CategoryLocaleUniqueWhere"]: GraphQLTypes["CategoryLocaleUniqueWhere"];
	["CategoryUniqueWhere"]: GraphQLTypes["CategoryUniqueWhere"];
	["HeaderLocalesBySocialLinksUniqueWhere"]: GraphQLTypes["HeaderLocalesBySocialLinksUniqueWhere"];
	["HeaderLocalesByPrimaryLinkItemsUniqueWhere"]: GraphQLTypes["HeaderLocalesByPrimaryLinkItemsUniqueWhere"];
	["HeaderLocalesBySecondaryLinksUniqueWhere"]: GraphQLTypes["HeaderLocalesBySecondaryLinksUniqueWhere"];
	["HeaderLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderLocaleEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["HeaderLocaleEdge"]: {
		node:ModelTypes["HeaderLocale"]
};
	["SocialLinkList"]: {
		_meta?:ModelTypes["SocialLinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["SocialLinkItem"][],
	itemsBySocialLink?:ModelTypes["SocialLinkItem"],
	paginateItems:ModelTypes["SocialLinkItemConnection"]
};
	["SocialLinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["SocialLinkItem"]: {
		_meta?:ModelTypes["SocialLinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["SocialLinkList"],
	socialLink?:ModelTypes["SocialLink"]
};
	["SocialLinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	socialLink?:ModelTypes["FieldMeta"]
};
	["SocialLink"]: {
		_meta?:ModelTypes["SocialLinkMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["SocialLinkType"],
	url?:string
};
	["SocialLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["SocialLinkItemOrderBy"]: GraphQLTypes["SocialLinkItemOrderBy"];
	["SocialLinkOrderBy"]: GraphQLTypes["SocialLinkOrderBy"];
	["SocialLinkListItemsBySocialLinkUniqueWhere"]: GraphQLTypes["SocialLinkListItemsBySocialLinkUniqueWhere"];
	["SocialLinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkItemEdge"][]
};
	["SocialLinkItemEdge"]: {
		node:ModelTypes["SocialLinkItem"]
};
	["PrimaryLinkItem"]: {
		_meta?:ModelTypes["PrimaryLinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"],
	parent?:ModelTypes["PrimaryLinkItem"],
	subItems:ModelTypes["PrimaryLinkItem"][],
	header?:ModelTypes["HeaderLocale"],
	subItemsByLink?:ModelTypes["PrimaryLinkItem"],
	subItemsBySubItems?:ModelTypes["PrimaryLinkItem"],
	paginateSubItems:ModelTypes["PrimaryLinkItemConnection"]
};
	["PrimaryLinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	parent?:ModelTypes["FieldMeta"],
	subItems?:ModelTypes["FieldMeta"],
	header?:ModelTypes["FieldMeta"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	title?:string,
	externalLink?:string,
	internalLink?:ModelTypes["Linkable"]
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	internalLink?:ModelTypes["FieldMeta"]
};
	["PrimaryLinkItemOrderBy"]: GraphQLTypes["PrimaryLinkItemOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["PrimaryLinkItemSubItemsByLinkUniqueWhere"]: GraphQLTypes["PrimaryLinkItemSubItemsByLinkUniqueWhere"];
	["PrimaryLinkItemSubItemsBySubItemsUniqueWhere"]: GraphQLTypes["PrimaryLinkItemSubItemsBySubItemsUniqueWhere"];
	["PrimaryLinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PrimaryLinkItemEdge"][]
};
	["PrimaryLinkItemEdge"]: {
		node:ModelTypes["PrimaryLinkItem"]
};
	["SecondaryLinkList"]: {
		_meta?:ModelTypes["SecondaryLinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["SecondaryLinkItem"][],
	itemsByLink?:ModelTypes["SecondaryLinkItem"],
	paginateItems:ModelTypes["SecondaryLinkItemConnection"]
};
	["SecondaryLinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["SecondaryLinkItem"]: {
		_meta?:ModelTypes["SecondaryLinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	iconType?:ModelTypes["IconType"],
	list?:ModelTypes["SecondaryLinkList"],
	link?:ModelTypes["Link"]
};
	["SecondaryLinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	iconType?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["SecondaryLinkItemOrderBy"]: GraphQLTypes["SecondaryLinkItemOrderBy"];
	["SecondaryLinkListItemsByLinkUniqueWhere"]: GraphQLTypes["SecondaryLinkListItemsByLinkUniqueWhere"];
	["SecondaryLinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SecondaryLinkItemEdge"][]
};
	["SecondaryLinkItemEdge"]: {
		node:ModelTypes["SecondaryLinkItem"]
};
	["HeaderLocalePrimaryLinkItemsByLinkUniqueWhere"]: GraphQLTypes["HeaderLocalePrimaryLinkItemsByLinkUniqueWhere"];
	["HeaderLocalePrimaryLinkItemsBySubItemsUniqueWhere"]: GraphQLTypes["HeaderLocalePrimaryLinkItemsBySubItemsUniqueWhere"];
	["FooterLocale"]: {
		_meta?:ModelTypes["FooterLocaleMeta"],
	id:ModelTypes["UUID"],
	root?:ModelTypes["Footer"],
	locale?:ModelTypes["Locale"],
	linksSection?:ModelTypes["FooterLinks"],
	contactSection?:ModelTypes["FooterContact"]
};
	["FooterLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	linksSection?:ModelTypes["FieldMeta"],
	contactSection?:ModelTypes["FieldMeta"]
};
	["Footer"]: {
		_meta?:ModelTypes["FooterMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	logo?:ModelTypes["Image"],
	locales:ModelTypes["FooterLocale"][],
	localesByLocale?:ModelTypes["FooterLocale"],
	localesByLinksSection?:ModelTypes["FooterLocale"],
	localesByContactSection?:ModelTypes["FooterLocale"],
	paginateLocales:ModelTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["FooterLocaleOrderBy"]: GraphQLTypes["FooterLocaleOrderBy"];
	["FooterOrderBy"]: GraphQLTypes["FooterOrderBy"];
	["FooterLinksOrderBy"]: GraphQLTypes["FooterLinksOrderBy"];
	["LinkListOrderBy"]: GraphQLTypes["LinkListOrderBy"];
	["TitleListOrderBy"]: GraphQLTypes["TitleListOrderBy"];
	["FooterContactOrderBy"]: GraphQLTypes["FooterContactOrderBy"];
	["FooterLocalesByLocaleUniqueWhere"]: GraphQLTypes["FooterLocalesByLocaleUniqueWhere"];
	["FooterLocalesByLinksSectionUniqueWhere"]: GraphQLTypes["FooterLocalesByLinksSectionUniqueWhere"];
	["FooterLocalesByContactSectionUniqueWhere"]: GraphQLTypes["FooterLocalesByContactSectionUniqueWhere"];
	["FooterLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterLocaleEdge"][]
};
	["FooterLocaleEdge"]: {
		node:ModelTypes["FooterLocale"]
};
	["FooterLinks"]: {
		_meta?:ModelTypes["FooterLinksMeta"],
	id:ModelTypes["UUID"],
	buttonsTitle?:string,
	linkList?:ModelTypes["LinkList"],
	buttons?:ModelTypes["LinkList"],
	titleList?:ModelTypes["TitleList"]
};
	["FooterLinksMeta"]: {
		id?:ModelTypes["FieldMeta"],
	buttonsTitle?:ModelTypes["FieldMeta"],
	linkList?:ModelTypes["FieldMeta"],
	buttons?:ModelTypes["FieldMeta"],
	titleList?:ModelTypes["FieldMeta"]
};
	["LinkList"]: {
		_meta?:ModelTypes["LinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["LinkItem"][],
	itemsByLink?:ModelTypes["LinkItem"],
	paginateItems:ModelTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["LinkItem"]: {
		_meta?:ModelTypes["LinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["LinkList"],
	link?:ModelTypes["Link"],
	icon?:ModelTypes["Image"]
};
	["LinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"]
};
	["LinkItemOrderBy"]: GraphQLTypes["LinkItemOrderBy"];
	["LinkListItemsByLinkUniqueWhere"]: GraphQLTypes["LinkListItemsByLinkUniqueWhere"];
	["LinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkItemEdge"][]
};
	["LinkItemEdge"]: {
		node:ModelTypes["LinkItem"]
};
	["TitleList"]: {
		_meta?:ModelTypes["TitleListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["TitleItem"][],
	paginateItems:ModelTypes["TitleItemConnection"]
};
	["TitleListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["TitleItem"]: {
		_meta?:ModelTypes["TitleItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	list?:ModelTypes["TitleList"],
	icon?:ModelTypes["Image"]
};
	["TitleItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"]
};
	["TitleItemOrderBy"]: GraphQLTypes["TitleItemOrderBy"];
	["TitleItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TitleItemEdge"][]
};
	["TitleItemEdge"]: {
		node:ModelTypes["TitleItem"]
};
	["FooterContact"]: {
		_meta?:ModelTypes["FooterContactMeta"],
	id:ModelTypes["UUID"],
	email?:string,
	phone?:string,
	note?:string,
	openingHours?:string,
	identificationNumber?:string,
	valueAddedTaxNumber?:string,
	bussinessRegister?:string,
	phoneImage?:ModelTypes["Image"],
	address?:string
};
	["FooterContactMeta"]: {
		id?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"],
	openingHours?:ModelTypes["FieldMeta"],
	identificationNumber?:ModelTypes["FieldMeta"],
	valueAddedTaxNumber?:ModelTypes["FieldMeta"],
	bussinessRegister?:ModelTypes["FieldMeta"],
	phoneImage?:ModelTypes["FieldMeta"],
	address?:ModelTypes["FieldMeta"]
};
	["RestaurantLocaleOrderBy"]: GraphQLTypes["RestaurantLocaleOrderBy"];
	["RestaurantTagLocale"]: {
		_meta?:ModelTypes["RestaurantTagLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["RestaurantTag"],
	locale?:ModelTypes["Locale"]
};
	["RestaurantTagLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"]
};
	["RestaurantTag"]: {
		_meta?:ModelTypes["RestaurantTagMeta"],
	id:ModelTypes["UUID"],
	order:number,
	locales:ModelTypes["RestaurantTagLocale"][],
	backgroundColor?:string,
	titleColor?:string,
	restaurants:ModelTypes["Restaurant"][],
	localesByLocale?:ModelTypes["RestaurantTagLocale"],
	paginateLocales:ModelTypes["RestaurantTagLocaleConnection"],
	paginateRestaurants:ModelTypes["RestaurantConnection"]
};
	["RestaurantTagMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	backgroundColor?:ModelTypes["FieldMeta"],
	titleColor?:ModelTypes["FieldMeta"],
	restaurants?:ModelTypes["FieldMeta"]
};
	["RestaurantTagLocaleOrderBy"]: GraphQLTypes["RestaurantTagLocaleOrderBy"];
	["RestaurantTagOrderBy"]: GraphQLTypes["RestaurantTagOrderBy"];
	["RestaurantTagLocalesByLocaleUniqueWhere"]: GraphQLTypes["RestaurantTagLocalesByLocaleUniqueWhere"];
	["RestaurantTagLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RestaurantTagLocaleEdge"][]
};
	["RestaurantTagLocaleEdge"]: {
		node:ModelTypes["RestaurantTagLocale"]
};
	["RestaurantConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RestaurantEdge"][]
};
	["RestaurantEdge"]: {
		node:ModelTypes["Restaurant"]
};
	["BannerLocale"]: {
		_meta?:ModelTypes["BannerLocaleMeta"],
	id:ModelTypes["UUID"],
	text?:string,
	root?:ModelTypes["Banner"],
	locale?:ModelTypes["Locale"],
	title?:string,
	url?:string
};
	["BannerLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"]
};
	["Banner"]: {
		_meta?:ModelTypes["BannerMeta"],
	id:ModelTypes["UUID"],
	image?:ModelTypes["Image"],
	locales:ModelTypes["BannerLocale"][],
	order:number,
	textColor?:string,
	localesByLocale?:ModelTypes["BannerLocale"],
	paginateLocales:ModelTypes["BannerLocaleConnection"]
};
	["BannerMeta"]: {
		id?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	textColor?:ModelTypes["FieldMeta"]
};
	["BannerLocaleOrderBy"]: GraphQLTypes["BannerLocaleOrderBy"];
	["BannerLocalesByLocaleUniqueWhere"]: GraphQLTypes["BannerLocalesByLocaleUniqueWhere"];
	["BannerLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BannerLocaleEdge"][]
};
	["BannerLocaleEdge"]: {
		node:ModelTypes["BannerLocale"]
};
	["CategoryLocale"]: {
		_meta?:ModelTypes["CategoryLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["Category"],
	locale?:ModelTypes["Locale"],
	slug:string
};
	["CategoryLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	slug?:ModelTypes["FieldMeta"]
};
	["Category"]: {
		_meta?:ModelTypes["CategoryMeta"],
	id:ModelTypes["UUID"],
	order:number,
	locales:ModelTypes["CategoryLocale"][],
	restaurants:ModelTypes["Restaurant"][],
	localesByLocale?:ModelTypes["CategoryLocale"],
	localesBySlug?:ModelTypes["CategoryLocale"],
	paginateLocales:ModelTypes["CategoryLocaleConnection"],
	paginateRestaurants:ModelTypes["RestaurantConnection"]
};
	["CategoryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	restaurants?:ModelTypes["FieldMeta"]
};
	["CategoryLocaleOrderBy"]: GraphQLTypes["CategoryLocaleOrderBy"];
	["CategoryOrderBy"]: GraphQLTypes["CategoryOrderBy"];
	["CategoryLocalesByLocaleUniqueWhere"]: GraphQLTypes["CategoryLocalesByLocaleUniqueWhere"];
	["CategoryLocalesBySlugUniqueWhere"]: GraphQLTypes["CategoryLocalesBySlugUniqueWhere"];
	["CategoryLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CategoryLocaleEdge"][]
};
	["CategoryLocaleEdge"]: {
		node:ModelTypes["CategoryLocale"]
};
	["LocaleFrontPagesByRootUniqueWhere"]: GraphQLTypes["LocaleFrontPagesByRootUniqueWhere"];
	["LocaleFrontPagesByLinkUniqueWhere"]: GraphQLTypes["LocaleFrontPagesByLinkUniqueWhere"];
	["LocaleFrontPagesBySeoUniqueWhere"]: GraphQLTypes["LocaleFrontPagesBySeoUniqueWhere"];
	["LocaleHeadersByRootUniqueWhere"]: GraphQLTypes["LocaleHeadersByRootUniqueWhere"];
	["LocaleHeadersBySocialLinksUniqueWhere"]: GraphQLTypes["LocaleHeadersBySocialLinksUniqueWhere"];
	["LocaleHeadersByPrimaryLinkItemsUniqueWhere"]: GraphQLTypes["LocaleHeadersByPrimaryLinkItemsUniqueWhere"];
	["LocaleHeadersBySecondaryLinksUniqueWhere"]: GraphQLTypes["LocaleHeadersBySecondaryLinksUniqueWhere"];
	["LocaleFootersByRootUniqueWhere"]: GraphQLTypes["LocaleFootersByRootUniqueWhere"];
	["LocaleFootersByLinksSectionUniqueWhere"]: GraphQLTypes["LocaleFootersByLinksSectionUniqueWhere"];
	["LocaleFootersByContactSectionUniqueWhere"]: GraphQLTypes["LocaleFootersByContactSectionUniqueWhere"];
	["LocaleRestaurantsByRootUniqueWhere"]: GraphQLTypes["LocaleRestaurantsByRootUniqueWhere"];
	["LocaleRestaurantTagsByRootUniqueWhere"]: GraphQLTypes["LocaleRestaurantTagsByRootUniqueWhere"];
	["LocaleBannersByRootUniqueWhere"]: GraphQLTypes["LocaleBannersByRootUniqueWhere"];
	["LocaleCategoriesByRootUniqueWhere"]: GraphQLTypes["LocaleCategoriesByRootUniqueWhere"];
	["LocaleCategoriesBySlugUniqueWhere"]: GraphQLTypes["LocaleCategoriesBySlugUniqueWhere"];
	["LocaleSubRestaurantsPagesByRootUniqueWhere"]: GraphQLTypes["LocaleSubRestaurantsPagesByRootUniqueWhere"];
	["LocaleSubRestaurantsPagesByLinkUniqueWhere"]: GraphQLTypes["LocaleSubRestaurantsPagesByLinkUniqueWhere"];
	["LocaleSubRestaurantsPagesBySeoUniqueWhere"]: GraphQLTypes["LocaleSubRestaurantsPagesBySeoUniqueWhere"];
	["FrontPageLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FrontPageLocaleEdge"][]
};
	["FrontPageLocaleEdge"]: {
		node:ModelTypes["FrontPageLocale"]
};
	["RestaurantLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RestaurantLocaleEdge"][]
};
	["RestaurantLocaleEdge"]: {
		node:ModelTypes["RestaurantLocale"]
};
	["SubRestaurantsPageLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SubRestaurantsPageLocaleEdge"][]
};
	["SubRestaurantsPageLocaleEdge"]: {
		node:ModelTypes["SubRestaurantsPageLocale"]
};
	["RestaurantItem"]: {
		_meta?:ModelTypes["RestaurantItemMeta"],
	id:ModelTypes["UUID"],
	parent?:ModelTypes["Restaurant"],
	order:number,
	restaurant?:ModelTypes["Restaurant"]
};
	["RestaurantItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	parent?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	restaurant?:ModelTypes["FieldMeta"]
};
	["RestaurantLocalesByLocaleUniqueWhere"]: GraphQLTypes["RestaurantLocalesByLocaleUniqueWhere"];
	["RestaurantSubItemsByRestaurantUniqueWhere"]: GraphQLTypes["RestaurantSubItemsByRestaurantUniqueWhere"];
	["RestaurantItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RestaurantItemEdge"][]
};
	["RestaurantItemEdge"]: {
		node:ModelTypes["RestaurantItem"]
};
	["RestaurantTagConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RestaurantTagEdge"][]
};
	["RestaurantTagEdge"]: {
		node:ModelTypes["RestaurantTag"]
};
	["CategoryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["CategoryEdge"][]
};
	["CategoryEdge"]: {
		node:ModelTypes["Category"]
};
	["SubRestaurantsPageLocalesByLocaleUniqueWhere"]: GraphQLTypes["SubRestaurantsPageLocalesByLocaleUniqueWhere"];
	["SubRestaurantsPageLocalesByLinkUniqueWhere"]: GraphQLTypes["SubRestaurantsPageLocalesByLinkUniqueWhere"];
	["SubRestaurantsPageLocalesBySeoUniqueWhere"]: GraphQLTypes["SubRestaurantsPageLocalesBySeoUniqueWhere"];
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	ogImage?:ModelTypes["Image"],
	noIndex?:boolean,
	noFollow?:boolean
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"],
	noIndex?:ModelTypes["FieldMeta"],
	noFollow?:ModelTypes["FieldMeta"]
};
	["FrontPageLocalesByLocaleUniqueWhere"]: GraphQLTypes["FrontPageLocalesByLocaleUniqueWhere"];
	["FrontPageLocalesByLinkUniqueWhere"]: GraphQLTypes["FrontPageLocalesByLinkUniqueWhere"];
	["FrontPageLocalesBySeoUniqueWhere"]: GraphQLTypes["FrontPageLocalesBySeoUniqueWhere"];
	["FrontPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FrontPageEdge"][]
};
	["FrontPageEdge"]: {
		node:ModelTypes["FrontPage"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["FrontPageCreateInput"]: GraphQLTypes["FrontPageCreateInput"];
	["FrontPageCreateLocalesEntityRelationInput"]: GraphQLTypes["FrontPageCreateLocalesEntityRelationInput"];
	["FrontPageLocaleWithoutRootCreateInput"]: GraphQLTypes["FrontPageLocaleWithoutRootCreateInput"];
	["FrontPageLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["FrontPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutFrontPageCreateInput"]: GraphQLTypes["LinkableWithoutFrontPageCreateInput"];
	["LinkableCreateSubRestaurantsPageEntityRelationInput"]: GraphQLTypes["LinkableCreateSubRestaurantsPageEntityRelationInput"];
	["SubRestaurantsPageLocaleWithoutLinkCreateInput"]: GraphQLTypes["SubRestaurantsPageLocaleWithoutLinkCreateInput"];
	["SubRestaurantsPageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleCreateRootEntityRelationInput"];
	["SubRestaurantsPageWithoutLocalesCreateInput"]: GraphQLTypes["SubRestaurantsPageWithoutLocalesCreateInput"];
	["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"];
	["RestaurantCreateInput"]: GraphQLTypes["RestaurantCreateInput"];
	["RestaurantCreateLocalesEntityRelationInput"]: GraphQLTypes["RestaurantCreateLocalesEntityRelationInput"];
	["RestaurantLocaleWithoutRootCreateInput"]: GraphQLTypes["RestaurantLocaleWithoutRootCreateInput"];
	["RestaurantLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["RestaurantLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutRestaurantsCreateInput"]: GraphQLTypes["LocaleWithoutRestaurantsCreateInput"];
	["LocaleCreateFrontPagesEntityRelationInput"]: GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"];
	["FrontPageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["FrontPageLocaleWithoutLocaleCreateInput"];
	["FrontPageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["FrontPageLocaleCreateRootEntityRelationInput"];
	["FrontPageWithoutLocalesCreateInput"]: GraphQLTypes["FrontPageWithoutLocalesCreateInput"];
	["FrontPageCreateBannerEntityRelationInput"]: GraphQLTypes["FrontPageCreateBannerEntityRelationInput"];
	["BannerCreateInput"]: GraphQLTypes["BannerCreateInput"];
	["BannerCreateImageEntityRelationInput"]: GraphQLTypes["BannerCreateImageEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["BannerCreateLocalesEntityRelationInput"]: GraphQLTypes["BannerCreateLocalesEntityRelationInput"];
	["BannerLocaleWithoutRootCreateInput"]: GraphQLTypes["BannerLocaleWithoutRootCreateInput"];
	["BannerLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["BannerLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutBannersCreateInput"]: GraphQLTypes["LocaleWithoutBannersCreateInput"];
	["LocaleCreateHeadersEntityRelationInput"]: GraphQLTypes["LocaleCreateHeadersEntityRelationInput"];
	["HeaderLocaleWithoutLocaleCreateInput"]: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"];
	["HeaderLocaleCreateRootEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"];
	["HeaderWithoutLocalesCreateInput"]: GraphQLTypes["HeaderWithoutLocalesCreateInput"];
	["HeaderCreateLogoEntityRelationInput"]: GraphQLTypes["HeaderCreateLogoEntityRelationInput"];
	["HeaderCreateNavigationLogoEntityRelationInput"]: GraphQLTypes["HeaderCreateNavigationLogoEntityRelationInput"];
	["HeaderLocaleCreateSocialLinksEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"];
	["SocialLinkListCreateInput"]: GraphQLTypes["SocialLinkListCreateInput"];
	["SocialLinkListCreateItemsEntityRelationInput"]: GraphQLTypes["SocialLinkListCreateItemsEntityRelationInput"];
	["SocialLinkItemWithoutListCreateInput"]: GraphQLTypes["SocialLinkItemWithoutListCreateInput"];
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"];
	["SocialLinkCreateInput"]: GraphQLTypes["SocialLinkCreateInput"];
	["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"];
	["PrimaryLinkItemWithoutHeaderCreateInput"]: GraphQLTypes["PrimaryLinkItemWithoutHeaderCreateInput"];
	["PrimaryLinkItemCreateLinkEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateFrontPageEntityRelationInput"]: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"];
	["FrontPageLocaleWithoutLinkCreateInput"]: GraphQLTypes["FrontPageLocaleWithoutLinkCreateInput"];
	["FrontPageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["FrontPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutFrontPagesCreateInput"]: GraphQLTypes["LocaleWithoutFrontPagesCreateInput"];
	["LocaleCreateFootersEntityRelationInput"]: GraphQLTypes["LocaleCreateFootersEntityRelationInput"];
	["FooterLocaleWithoutLocaleCreateInput"]: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"];
	["FooterLocaleCreateRootEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"];
	["FooterWithoutLocalesCreateInput"]: GraphQLTypes["FooterWithoutLocalesCreateInput"];
	["FooterCreateLogoEntityRelationInput"]: GraphQLTypes["FooterCreateLogoEntityRelationInput"];
	["FooterLocaleCreateLinksSectionEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateLinksSectionEntityRelationInput"];
	["FooterLinksCreateInput"]: GraphQLTypes["FooterLinksCreateInput"];
	["FooterLinksCreateLinkListEntityRelationInput"]: GraphQLTypes["FooterLinksCreateLinkListEntityRelationInput"];
	["LinkListCreateInput"]: GraphQLTypes["LinkListCreateInput"];
	["LinkListCreateItemsEntityRelationInput"]: GraphQLTypes["LinkListCreateItemsEntityRelationInput"];
	["LinkItemWithoutListCreateInput"]: GraphQLTypes["LinkItemWithoutListCreateInput"];
	["LinkItemCreateLinkEntityRelationInput"]: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"];
	["LinkItemCreateIconEntityRelationInput"]: GraphQLTypes["LinkItemCreateIconEntityRelationInput"];
	["FooterLinksCreateButtonsEntityRelationInput"]: GraphQLTypes["FooterLinksCreateButtonsEntityRelationInput"];
	["FooterLinksCreateTitleListEntityRelationInput"]: GraphQLTypes["FooterLinksCreateTitleListEntityRelationInput"];
	["TitleListCreateInput"]: GraphQLTypes["TitleListCreateInput"];
	["TitleListCreateItemsEntityRelationInput"]: GraphQLTypes["TitleListCreateItemsEntityRelationInput"];
	["TitleItemWithoutListCreateInput"]: GraphQLTypes["TitleItemWithoutListCreateInput"];
	["TitleItemCreateIconEntityRelationInput"]: GraphQLTypes["TitleItemCreateIconEntityRelationInput"];
	["FooterLocaleCreateContactSectionEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateContactSectionEntityRelationInput"];
	["FooterContactCreateInput"]: GraphQLTypes["FooterContactCreateInput"];
	["FooterContactCreatePhoneImageEntityRelationInput"]: GraphQLTypes["FooterContactCreatePhoneImageEntityRelationInput"];
	["LocaleCreateRestaurantsEntityRelationInput"]: GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"];
	["RestaurantLocaleWithoutLocaleCreateInput"]: GraphQLTypes["RestaurantLocaleWithoutLocaleCreateInput"];
	["RestaurantLocaleCreateRootEntityRelationInput"]: GraphQLTypes["RestaurantLocaleCreateRootEntityRelationInput"];
	["RestaurantWithoutLocalesCreateInput"]: GraphQLTypes["RestaurantWithoutLocalesCreateInput"];
	["RestaurantCreateImageEntityRelationInput"]: GraphQLTypes["RestaurantCreateImageEntityRelationInput"];
	["RestaurantCreateSubItemsEntityRelationInput"]: GraphQLTypes["RestaurantCreateSubItemsEntityRelationInput"];
	["RestaurantItemWithoutParentCreateInput"]: GraphQLTypes["RestaurantItemWithoutParentCreateInput"];
	["RestaurantItemCreateRestaurantEntityRelationInput"]: GraphQLTypes["RestaurantItemCreateRestaurantEntityRelationInput"];
	["RestaurantWithoutItemCreateInput"]: GraphQLTypes["RestaurantWithoutItemCreateInput"];
	["RestaurantCreateTagsEntityRelationInput"]: GraphQLTypes["RestaurantCreateTagsEntityRelationInput"];
	["RestaurantTagWithoutRestaurantsCreateInput"]: GraphQLTypes["RestaurantTagWithoutRestaurantsCreateInput"];
	["RestaurantTagCreateLocalesEntityRelationInput"]: GraphQLTypes["RestaurantTagCreateLocalesEntityRelationInput"];
	["RestaurantTagLocaleWithoutRootCreateInput"]: GraphQLTypes["RestaurantTagLocaleWithoutRootCreateInput"];
	["RestaurantTagLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["RestaurantTagLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutRestaurantTagsCreateInput"]: GraphQLTypes["LocaleWithoutRestaurantTagsCreateInput"];
	["LocaleCreateBannersEntityRelationInput"]: GraphQLTypes["LocaleCreateBannersEntityRelationInput"];
	["BannerLocaleWithoutLocaleCreateInput"]: GraphQLTypes["BannerLocaleWithoutLocaleCreateInput"];
	["BannerLocaleCreateRootEntityRelationInput"]: GraphQLTypes["BannerLocaleCreateRootEntityRelationInput"];
	["BannerWithoutLocalesCreateInput"]: GraphQLTypes["BannerWithoutLocalesCreateInput"];
	["LocaleCreateCategoriesEntityRelationInput"]: GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"];
	["CategoryLocaleWithoutLocaleCreateInput"]: GraphQLTypes["CategoryLocaleWithoutLocaleCreateInput"];
	["CategoryLocaleCreateRootEntityRelationInput"]: GraphQLTypes["CategoryLocaleCreateRootEntityRelationInput"];
	["CategoryWithoutLocalesCreateInput"]: GraphQLTypes["CategoryWithoutLocalesCreateInput"];
	["CategoryCreateRestaurantsEntityRelationInput"]: GraphQLTypes["CategoryCreateRestaurantsEntityRelationInput"];
	["RestaurantWithoutCategoriesCreateInput"]: GraphQLTypes["RestaurantWithoutCategoriesCreateInput"];
	["RestaurantCreateItemEntityRelationInput"]: GraphQLTypes["RestaurantCreateItemEntityRelationInput"];
	["RestaurantItemWithoutRestaurantCreateInput"]: GraphQLTypes["RestaurantItemWithoutRestaurantCreateInput"];
	["RestaurantItemCreateParentEntityRelationInput"]: GraphQLTypes["RestaurantItemCreateParentEntityRelationInput"];
	["RestaurantWithoutSubItemsCreateInput"]: GraphQLTypes["RestaurantWithoutSubItemsCreateInput"];
	["RestaurantCreateCategoriesEntityRelationInput"]: GraphQLTypes["RestaurantCreateCategoriesEntityRelationInput"];
	["CategoryWithoutRestaurantsCreateInput"]: GraphQLTypes["CategoryWithoutRestaurantsCreateInput"];
	["CategoryCreateLocalesEntityRelationInput"]: GraphQLTypes["CategoryCreateLocalesEntityRelationInput"];
	["CategoryLocaleWithoutRootCreateInput"]: GraphQLTypes["CategoryLocaleWithoutRootCreateInput"];
	["CategoryLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["CategoryLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutCategoriesCreateInput"]: GraphQLTypes["LocaleWithoutCategoriesCreateInput"];
	["LocaleCreateRestaurantTagsEntityRelationInput"]: GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"];
	["RestaurantTagLocaleWithoutLocaleCreateInput"]: GraphQLTypes["RestaurantTagLocaleWithoutLocaleCreateInput"];
	["RestaurantTagLocaleCreateRootEntityRelationInput"]: GraphQLTypes["RestaurantTagLocaleCreateRootEntityRelationInput"];
	["RestaurantTagWithoutLocalesCreateInput"]: GraphQLTypes["RestaurantTagWithoutLocalesCreateInput"];
	["RestaurantTagCreateRestaurantsEntityRelationInput"]: GraphQLTypes["RestaurantTagCreateRestaurantsEntityRelationInput"];
	["RestaurantWithoutTagsCreateInput"]: GraphQLTypes["RestaurantWithoutTagsCreateInput"];
	["LocaleCreateSubRestaurantsPagesEntityRelationInput"]: GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"];
	["SubRestaurantsPageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["SubRestaurantsPageLocaleWithoutLocaleCreateInput"];
	["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutSubRestaurantsPageCreateInput"]: GraphQLTypes["LinkableWithoutSubRestaurantsPageCreateInput"];
	["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["FrontPageLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["FrontPageLocaleCreateSeoEntityRelationInput"];
	["PrimaryLinkItemCreateParentEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemCreateParentEntityRelationInput"];
	["PrimaryLinkItemWithoutSubItemsCreateInput"]: GraphQLTypes["PrimaryLinkItemWithoutSubItemsCreateInput"];
	["PrimaryLinkItemCreateHeaderEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemCreateHeaderEntityRelationInput"];
	["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"]: GraphQLTypes["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"];
	["HeaderLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersCreateInput"]: GraphQLTypes["LocaleWithoutHeadersCreateInput"];
	["HeaderLocaleCreateSecondaryLinksEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"];
	["SecondaryLinkListCreateInput"]: GraphQLTypes["SecondaryLinkListCreateInput"];
	["SecondaryLinkListCreateItemsEntityRelationInput"]: GraphQLTypes["SecondaryLinkListCreateItemsEntityRelationInput"];
	["SecondaryLinkItemWithoutListCreateInput"]: GraphQLTypes["SecondaryLinkItemWithoutListCreateInput"];
	["SecondaryLinkItemCreateLinkEntityRelationInput"]: GraphQLTypes["SecondaryLinkItemCreateLinkEntityRelationInput"];
	["PrimaryLinkItemCreateSubItemsEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemCreateSubItemsEntityRelationInput"];
	["PrimaryLinkItemWithoutParentCreateInput"]: GraphQLTypes["PrimaryLinkItemWithoutParentCreateInput"];
	["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutSubRestaurantsPagesCreateInput"]: GraphQLTypes["LocaleWithoutSubRestaurantsPagesCreateInput"];
	["FrontPageUpdateInput"]: GraphQLTypes["FrontPageUpdateInput"];
	["FrontPageUpdateLocalesEntityRelationInput"]: GraphQLTypes["FrontPageUpdateLocalesEntityRelationInput"];
	["FrontPageUpdateLocalesRelationInput"]: GraphQLTypes["FrontPageUpdateLocalesRelationInput"];
	["FrontPageLocaleWithoutRootUpdateInput"]: GraphQLTypes["FrontPageLocaleWithoutRootUpdateInput"];
	["FrontPageLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["FrontPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutFrontPageUpdateInput"]: GraphQLTypes["LinkableWithoutFrontPageUpdateInput"];
	["LinkableUpdateSubRestaurantsPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateSubRestaurantsPageEntityRelationInput"];
	["SubRestaurantsPageLocaleWithoutLinkUpdateInput"]: GraphQLTypes["SubRestaurantsPageLocaleWithoutLinkUpdateInput"];
	["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"];
	["SubRestaurantsPageWithoutLocalesUpdateInput"]: GraphQLTypes["SubRestaurantsPageWithoutLocalesUpdateInput"];
	["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"];
	["RestaurantUpdateInput"]: GraphQLTypes["RestaurantUpdateInput"];
	["RestaurantUpdateLocalesEntityRelationInput"]: GraphQLTypes["RestaurantUpdateLocalesEntityRelationInput"];
	["RestaurantUpdateLocalesRelationInput"]: GraphQLTypes["RestaurantUpdateLocalesRelationInput"];
	["RestaurantLocaleWithoutRootUpdateInput"]: GraphQLTypes["RestaurantLocaleWithoutRootUpdateInput"];
	["RestaurantLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["RestaurantLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutRestaurantsUpdateInput"]: GraphQLTypes["LocaleWithoutRestaurantsUpdateInput"];
	["LocaleUpdateFrontPagesEntityRelationInput"]: GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"];
	["LocaleUpdateFrontPagesRelationInput"]: GraphQLTypes["LocaleUpdateFrontPagesRelationInput"];
	["FrontPageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["FrontPageLocaleWithoutLocaleUpdateInput"];
	["FrontPageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["FrontPageLocaleUpdateRootEntityRelationInput"];
	["FrontPageWithoutLocalesUpdateInput"]: GraphQLTypes["FrontPageWithoutLocalesUpdateInput"];
	["FrontPageUpdateBannerEntityRelationInput"]: GraphQLTypes["FrontPageUpdateBannerEntityRelationInput"];
	["BannerUpdateInput"]: GraphQLTypes["BannerUpdateInput"];
	["BannerUpdateImageEntityRelationInput"]: GraphQLTypes["BannerUpdateImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["BannerUpsertImageRelationInput"]: GraphQLTypes["BannerUpsertImageRelationInput"];
	["BannerUpdateLocalesEntityRelationInput"]: GraphQLTypes["BannerUpdateLocalesEntityRelationInput"];
	["BannerUpdateLocalesRelationInput"]: GraphQLTypes["BannerUpdateLocalesRelationInput"];
	["BannerLocaleWithoutRootUpdateInput"]: GraphQLTypes["BannerLocaleWithoutRootUpdateInput"];
	["BannerLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["BannerLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutBannersUpdateInput"]: GraphQLTypes["LocaleWithoutBannersUpdateInput"];
	["LocaleUpdateHeadersEntityRelationInput"]: GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"];
	["LocaleUpdateHeadersRelationInput"]: GraphQLTypes["LocaleUpdateHeadersRelationInput"];
	["HeaderLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"];
	["HeaderLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"];
	["HeaderWithoutLocalesUpdateInput"]: GraphQLTypes["HeaderWithoutLocalesUpdateInput"];
	["HeaderUpdateLogoEntityRelationInput"]: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"];
	["HeaderUpsertLogoRelationInput"]: GraphQLTypes["HeaderUpsertLogoRelationInput"];
	["HeaderUpdateNavigationLogoEntityRelationInput"]: GraphQLTypes["HeaderUpdateNavigationLogoEntityRelationInput"];
	["HeaderUpsertNavigationLogoRelationInput"]: GraphQLTypes["HeaderUpsertNavigationLogoRelationInput"];
	["HeaderLocaleUpsertRootRelationInput"]: GraphQLTypes["HeaderLocaleUpsertRootRelationInput"];
	["HeaderLocaleUpdateSocialLinksEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"];
	["SocialLinkListUpdateInput"]: GraphQLTypes["SocialLinkListUpdateInput"];
	["SocialLinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["SocialLinkListUpdateItemsEntityRelationInput"];
	["SocialLinkListUpdateItemsRelationInput"]: GraphQLTypes["SocialLinkListUpdateItemsRelationInput"];
	["SocialLinkItemWithoutListUpdateInput"]: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"];
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"];
	["SocialLinkUpdateInput"]: GraphQLTypes["SocialLinkUpdateInput"];
	["SocialLinkItemUpsertSocialLinkRelationInput"]: GraphQLTypes["SocialLinkItemUpsertSocialLinkRelationInput"];
	["SocialLinkListUpsertItemsRelationInput"]: GraphQLTypes["SocialLinkListUpsertItemsRelationInput"];
	["HeaderLocaleUpsertSocialLinksRelationInput"]: GraphQLTypes["HeaderLocaleUpsertSocialLinksRelationInput"];
	["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"];
	["HeaderLocaleUpdatePrimaryLinkItemsRelationInput"]: GraphQLTypes["HeaderLocaleUpdatePrimaryLinkItemsRelationInput"];
	["PrimaryLinkItemWithoutHeaderUpdateInput"]: GraphQLTypes["PrimaryLinkItemWithoutHeaderUpdateInput"];
	["PrimaryLinkItemUpdateLinkEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateFrontPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"];
	["FrontPageLocaleWithoutLinkUpdateInput"]: GraphQLTypes["FrontPageLocaleWithoutLinkUpdateInput"];
	["FrontPageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["FrontPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutFrontPagesUpdateInput"]: GraphQLTypes["LocaleWithoutFrontPagesUpdateInput"];
	["LocaleUpdateFootersEntityRelationInput"]: GraphQLTypes["LocaleUpdateFootersEntityRelationInput"];
	["LocaleUpdateFootersRelationInput"]: GraphQLTypes["LocaleUpdateFootersRelationInput"];
	["FooterLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"];
	["FooterLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"];
	["FooterWithoutLocalesUpdateInput"]: GraphQLTypes["FooterWithoutLocalesUpdateInput"];
	["FooterUpdateLogoEntityRelationInput"]: GraphQLTypes["FooterUpdateLogoEntityRelationInput"];
	["FooterUpsertLogoRelationInput"]: GraphQLTypes["FooterUpsertLogoRelationInput"];
	["FooterLocaleUpsertRootRelationInput"]: GraphQLTypes["FooterLocaleUpsertRootRelationInput"];
	["FooterLocaleUpdateLinksSectionEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateLinksSectionEntityRelationInput"];
	["FooterLinksUpdateInput"]: GraphQLTypes["FooterLinksUpdateInput"];
	["FooterLinksUpdateLinkListEntityRelationInput"]: GraphQLTypes["FooterLinksUpdateLinkListEntityRelationInput"];
	["LinkListUpdateInput"]: GraphQLTypes["LinkListUpdateInput"];
	["LinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["LinkListUpdateItemsEntityRelationInput"];
	["LinkListUpdateItemsRelationInput"]: GraphQLTypes["LinkListUpdateItemsRelationInput"];
	["LinkItemWithoutListUpdateInput"]: GraphQLTypes["LinkItemWithoutListUpdateInput"];
	["LinkItemUpdateLinkEntityRelationInput"]: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"];
	["LinkItemUpsertLinkRelationInput"]: GraphQLTypes["LinkItemUpsertLinkRelationInput"];
	["LinkItemUpdateIconEntityRelationInput"]: GraphQLTypes["LinkItemUpdateIconEntityRelationInput"];
	["LinkItemUpsertIconRelationInput"]: GraphQLTypes["LinkItemUpsertIconRelationInput"];
	["LinkListUpsertItemsRelationInput"]: GraphQLTypes["LinkListUpsertItemsRelationInput"];
	["FooterLinksUpsertLinkListRelationInput"]: GraphQLTypes["FooterLinksUpsertLinkListRelationInput"];
	["FooterLinksUpdateButtonsEntityRelationInput"]: GraphQLTypes["FooterLinksUpdateButtonsEntityRelationInput"];
	["FooterLinksUpsertButtonsRelationInput"]: GraphQLTypes["FooterLinksUpsertButtonsRelationInput"];
	["FooterLinksUpdateTitleListEntityRelationInput"]: GraphQLTypes["FooterLinksUpdateTitleListEntityRelationInput"];
	["TitleListUpdateInput"]: GraphQLTypes["TitleListUpdateInput"];
	["TitleListUpdateItemsEntityRelationInput"]: GraphQLTypes["TitleListUpdateItemsEntityRelationInput"];
	["TitleListUpdateItemsRelationInput"]: GraphQLTypes["TitleListUpdateItemsRelationInput"];
	["TitleItemWithoutListUpdateInput"]: GraphQLTypes["TitleItemWithoutListUpdateInput"];
	["TitleItemUpdateIconEntityRelationInput"]: GraphQLTypes["TitleItemUpdateIconEntityRelationInput"];
	["TitleItemUpsertIconRelationInput"]: GraphQLTypes["TitleItemUpsertIconRelationInput"];
	["TitleListUpsertItemsRelationInput"]: GraphQLTypes["TitleListUpsertItemsRelationInput"];
	["FooterLinksUpsertTitleListRelationInput"]: GraphQLTypes["FooterLinksUpsertTitleListRelationInput"];
	["FooterLocaleUpsertLinksSectionRelationInput"]: GraphQLTypes["FooterLocaleUpsertLinksSectionRelationInput"];
	["FooterLocaleUpdateContactSectionEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateContactSectionEntityRelationInput"];
	["FooterContactUpdateInput"]: GraphQLTypes["FooterContactUpdateInput"];
	["FooterContactUpdatePhoneImageEntityRelationInput"]: GraphQLTypes["FooterContactUpdatePhoneImageEntityRelationInput"];
	["FooterContactUpsertPhoneImageRelationInput"]: GraphQLTypes["FooterContactUpsertPhoneImageRelationInput"];
	["FooterLocaleUpsertContactSectionRelationInput"]: GraphQLTypes["FooterLocaleUpsertContactSectionRelationInput"];
	["LocaleUpsertFootersRelationInput"]: GraphQLTypes["LocaleUpsertFootersRelationInput"];
	["LocaleUpdateRestaurantsEntityRelationInput"]: GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"];
	["LocaleUpdateRestaurantsRelationInput"]: GraphQLTypes["LocaleUpdateRestaurantsRelationInput"];
	["RestaurantLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["RestaurantLocaleWithoutLocaleUpdateInput"];
	["RestaurantLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["RestaurantLocaleUpdateRootEntityRelationInput"];
	["RestaurantWithoutLocalesUpdateInput"]: GraphQLTypes["RestaurantWithoutLocalesUpdateInput"];
	["RestaurantUpdateImageEntityRelationInput"]: GraphQLTypes["RestaurantUpdateImageEntityRelationInput"];
	["RestaurantUpsertImageRelationInput"]: GraphQLTypes["RestaurantUpsertImageRelationInput"];
	["RestaurantUpdateSubItemsEntityRelationInput"]: GraphQLTypes["RestaurantUpdateSubItemsEntityRelationInput"];
	["RestaurantUpdateSubItemsRelationInput"]: GraphQLTypes["RestaurantUpdateSubItemsRelationInput"];
	["RestaurantItemWithoutParentUpdateInput"]: GraphQLTypes["RestaurantItemWithoutParentUpdateInput"];
	["RestaurantItemUpdateRestaurantEntityRelationInput"]: GraphQLTypes["RestaurantItemUpdateRestaurantEntityRelationInput"];
	["RestaurantWithoutItemUpdateInput"]: GraphQLTypes["RestaurantWithoutItemUpdateInput"];
	["RestaurantUpdateTagsEntityRelationInput"]: GraphQLTypes["RestaurantUpdateTagsEntityRelationInput"];
	["RestaurantUpdateTagsRelationInput"]: GraphQLTypes["RestaurantUpdateTagsRelationInput"];
	["RestaurantTagWithoutRestaurantsUpdateInput"]: GraphQLTypes["RestaurantTagWithoutRestaurantsUpdateInput"];
	["RestaurantTagUpdateLocalesEntityRelationInput"]: GraphQLTypes["RestaurantTagUpdateLocalesEntityRelationInput"];
	["RestaurantTagUpdateLocalesRelationInput"]: GraphQLTypes["RestaurantTagUpdateLocalesRelationInput"];
	["RestaurantTagLocaleWithoutRootUpdateInput"]: GraphQLTypes["RestaurantTagLocaleWithoutRootUpdateInput"];
	["RestaurantTagLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["RestaurantTagLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutRestaurantTagsUpdateInput"]: GraphQLTypes["LocaleWithoutRestaurantTagsUpdateInput"];
	["LocaleUpdateBannersEntityRelationInput"]: GraphQLTypes["LocaleUpdateBannersEntityRelationInput"];
	["LocaleUpdateBannersRelationInput"]: GraphQLTypes["LocaleUpdateBannersRelationInput"];
	["BannerLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["BannerLocaleWithoutLocaleUpdateInput"];
	["BannerLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["BannerLocaleUpdateRootEntityRelationInput"];
	["BannerWithoutLocalesUpdateInput"]: GraphQLTypes["BannerWithoutLocalesUpdateInput"];
	["BannerLocaleUpsertRootRelationInput"]: GraphQLTypes["BannerLocaleUpsertRootRelationInput"];
	["LocaleUpsertBannersRelationInput"]: GraphQLTypes["LocaleUpsertBannersRelationInput"];
	["LocaleUpdateCategoriesEntityRelationInput"]: GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"];
	["LocaleUpdateCategoriesRelationInput"]: GraphQLTypes["LocaleUpdateCategoriesRelationInput"];
	["CategoryLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["CategoryLocaleWithoutLocaleUpdateInput"];
	["CategoryLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["CategoryLocaleUpdateRootEntityRelationInput"];
	["CategoryWithoutLocalesUpdateInput"]: GraphQLTypes["CategoryWithoutLocalesUpdateInput"];
	["CategoryUpdateRestaurantsEntityRelationInput"]: GraphQLTypes["CategoryUpdateRestaurantsEntityRelationInput"];
	["CategoryUpdateRestaurantsRelationInput"]: GraphQLTypes["CategoryUpdateRestaurantsRelationInput"];
	["RestaurantWithoutCategoriesUpdateInput"]: GraphQLTypes["RestaurantWithoutCategoriesUpdateInput"];
	["RestaurantUpdateItemEntityRelationInput"]: GraphQLTypes["RestaurantUpdateItemEntityRelationInput"];
	["RestaurantItemWithoutRestaurantUpdateInput"]: GraphQLTypes["RestaurantItemWithoutRestaurantUpdateInput"];
	["RestaurantItemUpdateParentEntityRelationInput"]: GraphQLTypes["RestaurantItemUpdateParentEntityRelationInput"];
	["RestaurantWithoutSubItemsUpdateInput"]: GraphQLTypes["RestaurantWithoutSubItemsUpdateInput"];
	["RestaurantUpdateCategoriesEntityRelationInput"]: GraphQLTypes["RestaurantUpdateCategoriesEntityRelationInput"];
	["RestaurantUpdateCategoriesRelationInput"]: GraphQLTypes["RestaurantUpdateCategoriesRelationInput"];
	["CategoryWithoutRestaurantsUpdateInput"]: GraphQLTypes["CategoryWithoutRestaurantsUpdateInput"];
	["CategoryUpdateLocalesEntityRelationInput"]: GraphQLTypes["CategoryUpdateLocalesEntityRelationInput"];
	["CategoryUpdateLocalesRelationInput"]: GraphQLTypes["CategoryUpdateLocalesRelationInput"];
	["CategoryLocaleWithoutRootUpdateInput"]: GraphQLTypes["CategoryLocaleWithoutRootUpdateInput"];
	["CategoryLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["CategoryLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutCategoriesUpdateInput"]: GraphQLTypes["LocaleWithoutCategoriesUpdateInput"];
	["LocaleUpdateRestaurantTagsEntityRelationInput"]: GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"];
	["LocaleUpdateRestaurantTagsRelationInput"]: GraphQLTypes["LocaleUpdateRestaurantTagsRelationInput"];
	["RestaurantTagLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["RestaurantTagLocaleWithoutLocaleUpdateInput"];
	["RestaurantTagLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["RestaurantTagLocaleUpdateRootEntityRelationInput"];
	["RestaurantTagWithoutLocalesUpdateInput"]: GraphQLTypes["RestaurantTagWithoutLocalesUpdateInput"];
	["RestaurantTagUpdateRestaurantsEntityRelationInput"]: GraphQLTypes["RestaurantTagUpdateRestaurantsEntityRelationInput"];
	["RestaurantTagUpdateRestaurantsRelationInput"]: GraphQLTypes["RestaurantTagUpdateRestaurantsRelationInput"];
	["RestaurantWithoutTagsUpdateInput"]: GraphQLTypes["RestaurantWithoutTagsUpdateInput"];
	["RestaurantTagUpsertRestaurantsRelationInput"]: GraphQLTypes["RestaurantTagUpsertRestaurantsRelationInput"];
	["RestaurantTagLocaleUpsertRootRelationInput"]: GraphQLTypes["RestaurantTagLocaleUpsertRootRelationInput"];
	["LocaleUpsertRestaurantTagsRelationInput"]: GraphQLTypes["LocaleUpsertRestaurantTagsRelationInput"];
	["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]: GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"];
	["LocaleUpdateSubRestaurantsPagesRelationInput"]: GraphQLTypes["LocaleUpdateSubRestaurantsPagesRelationInput"];
	["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"];
	["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutSubRestaurantsPageUpdateInput"]: GraphQLTypes["LinkableWithoutSubRestaurantsPageUpdateInput"];
	["SubRestaurantsPageLocaleUpsertLinkRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpsertLinkRelationInput"];
	["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["SubRestaurantsPageLocaleUpsertSeoRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpsertSeoRelationInput"];
	["LocaleUpsertSubRestaurantsPagesRelationInput"]: GraphQLTypes["LocaleUpsertSubRestaurantsPagesRelationInput"];
	["CategoryLocaleUpsertLocaleRelationInput"]: GraphQLTypes["CategoryLocaleUpsertLocaleRelationInput"];
	["CategoryUpsertLocalesRelationInput"]: GraphQLTypes["CategoryUpsertLocalesRelationInput"];
	["RestaurantUpsertCategoriesRelationInput"]: GraphQLTypes["RestaurantUpsertCategoriesRelationInput"];
	["RestaurantItemUpsertParentRelationInput"]: GraphQLTypes["RestaurantItemUpsertParentRelationInput"];
	["RestaurantUpsertItemRelationInput"]: GraphQLTypes["RestaurantUpsertItemRelationInput"];
	["CategoryUpsertRestaurantsRelationInput"]: GraphQLTypes["CategoryUpsertRestaurantsRelationInput"];
	["CategoryLocaleUpsertRootRelationInput"]: GraphQLTypes["CategoryLocaleUpsertRootRelationInput"];
	["LocaleUpsertCategoriesRelationInput"]: GraphQLTypes["LocaleUpsertCategoriesRelationInput"];
	["RestaurantTagLocaleUpsertLocaleRelationInput"]: GraphQLTypes["RestaurantTagLocaleUpsertLocaleRelationInput"];
	["RestaurantTagUpsertLocalesRelationInput"]: GraphQLTypes["RestaurantTagUpsertLocalesRelationInput"];
	["RestaurantUpsertTagsRelationInput"]: GraphQLTypes["RestaurantUpsertTagsRelationInput"];
	["RestaurantItemUpsertRestaurantRelationInput"]: GraphQLTypes["RestaurantItemUpsertRestaurantRelationInput"];
	["RestaurantUpsertSubItemsRelationInput"]: GraphQLTypes["RestaurantUpsertSubItemsRelationInput"];
	["RestaurantLocaleUpsertRootRelationInput"]: GraphQLTypes["RestaurantLocaleUpsertRootRelationInput"];
	["LocaleUpsertRestaurantsRelationInput"]: GraphQLTypes["LocaleUpsertRestaurantsRelationInput"];
	["FrontPageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["FrontPageLocaleUpsertLocaleRelationInput"];
	["FrontPageLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["FrontPageLocaleUpdateSeoEntityRelationInput"];
	["FrontPageLocaleUpsertSeoRelationInput"]: GraphQLTypes["FrontPageLocaleUpsertSeoRelationInput"];
	["LinkableUpsertFrontPageRelationInput"]: GraphQLTypes["LinkableUpsertFrontPageRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["PrimaryLinkItemUpsertLinkRelationInput"]: GraphQLTypes["PrimaryLinkItemUpsertLinkRelationInput"];
	["PrimaryLinkItemUpdateParentEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemUpdateParentEntityRelationInput"];
	["PrimaryLinkItemWithoutSubItemsUpdateInput"]: GraphQLTypes["PrimaryLinkItemWithoutSubItemsUpdateInput"];
	["PrimaryLinkItemUpdateHeaderEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemUpdateHeaderEntityRelationInput"];
	["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"]: GraphQLTypes["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"];
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersUpdateInput"]: GraphQLTypes["LocaleWithoutHeadersUpdateInput"];
	["HeaderLocaleUpsertLocaleRelationInput"]: GraphQLTypes["HeaderLocaleUpsertLocaleRelationInput"];
	["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"];
	["SecondaryLinkListUpdateInput"]: GraphQLTypes["SecondaryLinkListUpdateInput"];
	["SecondaryLinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["SecondaryLinkListUpdateItemsEntityRelationInput"];
	["SecondaryLinkListUpdateItemsRelationInput"]: GraphQLTypes["SecondaryLinkListUpdateItemsRelationInput"];
	["SecondaryLinkItemWithoutListUpdateInput"]: GraphQLTypes["SecondaryLinkItemWithoutListUpdateInput"];
	["SecondaryLinkItemUpdateLinkEntityRelationInput"]: GraphQLTypes["SecondaryLinkItemUpdateLinkEntityRelationInput"];
	["SecondaryLinkItemUpsertLinkRelationInput"]: GraphQLTypes["SecondaryLinkItemUpsertLinkRelationInput"];
	["SecondaryLinkListUpsertItemsRelationInput"]: GraphQLTypes["SecondaryLinkListUpsertItemsRelationInput"];
	["HeaderLocaleUpsertSecondaryLinksRelationInput"]: GraphQLTypes["HeaderLocaleUpsertSecondaryLinksRelationInput"];
	["PrimaryLinkItemUpsertHeaderRelationInput"]: GraphQLTypes["PrimaryLinkItemUpsertHeaderRelationInput"];
	["PrimaryLinkItemUpsertParentRelationInput"]: GraphQLTypes["PrimaryLinkItemUpsertParentRelationInput"];
	["PrimaryLinkItemUpdateSubItemsEntityRelationInput"]: GraphQLTypes["PrimaryLinkItemUpdateSubItemsEntityRelationInput"];
	["PrimaryLinkItemUpdateSubItemsRelationInput"]: GraphQLTypes["PrimaryLinkItemUpdateSubItemsRelationInput"];
	["PrimaryLinkItemWithoutParentUpdateInput"]: GraphQLTypes["PrimaryLinkItemWithoutParentUpdateInput"];
	["PrimaryLinkItemUpsertSubItemsRelationInput"]: GraphQLTypes["PrimaryLinkItemUpsertSubItemsRelationInput"];
	["HeaderLocaleUpsertPrimaryLinkItemsRelationInput"]: GraphQLTypes["HeaderLocaleUpsertPrimaryLinkItemsRelationInput"];
	["LocaleUpsertHeadersRelationInput"]: GraphQLTypes["LocaleUpsertHeadersRelationInput"];
	["BannerLocaleUpsertLocaleRelationInput"]: GraphQLTypes["BannerLocaleUpsertLocaleRelationInput"];
	["BannerUpsertLocalesRelationInput"]: GraphQLTypes["BannerUpsertLocalesRelationInput"];
	["FrontPageUpsertBannerRelationInput"]: GraphQLTypes["FrontPageUpsertBannerRelationInput"];
	["FrontPageLocaleUpsertRootRelationInput"]: GraphQLTypes["FrontPageLocaleUpsertRootRelationInput"];
	["LocaleUpsertFrontPagesRelationInput"]: GraphQLTypes["LocaleUpsertFrontPagesRelationInput"];
	["RestaurantLocaleUpsertLocaleRelationInput"]: GraphQLTypes["RestaurantLocaleUpsertLocaleRelationInput"];
	["RestaurantUpsertLocalesRelationInput"]: GraphQLTypes["RestaurantUpsertLocalesRelationInput"];
	["SubRestaurantsPageUpsertParentRestaurantRelationInput"]: GraphQLTypes["SubRestaurantsPageUpsertParentRestaurantRelationInput"];
	["SubRestaurantsPageLocaleUpsertRootRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpsertRootRelationInput"];
	["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutSubRestaurantsPagesUpdateInput"]: GraphQLTypes["LocaleWithoutSubRestaurantsPagesUpdateInput"];
	["SubRestaurantsPageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertSubRestaurantsPageRelationInput"]: GraphQLTypes["LinkableUpsertSubRestaurantsPageRelationInput"];
	["FrontPageLocaleUpsertLinkRelationInput"]: GraphQLTypes["FrontPageLocaleUpsertLinkRelationInput"];
	["FrontPageUpsertLocalesRelationInput"]: GraphQLTypes["FrontPageUpsertLocalesRelationInput"];
	["HeaderConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderEdge"][]
};
	["HeaderEdge"]: {
		node:ModelTypes["Header"]
};
	["HeaderCreateInput"]: GraphQLTypes["HeaderCreateInput"];
	["HeaderCreateLocalesEntityRelationInput"]: GraphQLTypes["HeaderCreateLocalesEntityRelationInput"];
	["HeaderLocaleWithoutRootCreateInput"]: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"];
	["HeaderUpdateInput"]: GraphQLTypes["HeaderUpdateInput"];
	["HeaderUpdateLocalesEntityRelationInput"]: GraphQLTypes["HeaderUpdateLocalesEntityRelationInput"];
	["HeaderUpdateLocalesRelationInput"]: GraphQLTypes["HeaderUpdateLocalesRelationInput"];
	["HeaderLocaleWithoutRootUpdateInput"]: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"];
	["HeaderUpsertLocalesRelationInput"]: GraphQLTypes["HeaderUpsertLocalesRelationInput"];
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["LocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LocaleEdge"][]
};
	["LocaleEdge"]: {
		node:ModelTypes["Locale"]
};
	["LocaleCreateInput"]: GraphQLTypes["LocaleCreateInput"];
	["LocaleUpdateInput"]: GraphQLTypes["LocaleUpdateInput"];
	["FrontPageLocaleCreateInput"]: GraphQLTypes["FrontPageLocaleCreateInput"];
	["FrontPageLocaleUpdateInput"]: GraphQLTypes["FrontPageLocaleUpdateInput"];
	["LinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkListEdge"][]
};
	["LinkListEdge"]: {
		node:ModelTypes["LinkList"]
};
	["LinkItemCreateInput"]: GraphQLTypes["LinkItemCreateInput"];
	["LinkItemCreateListEntityRelationInput"]: GraphQLTypes["LinkItemCreateListEntityRelationInput"];
	["LinkListWithoutItemsCreateInput"]: GraphQLTypes["LinkListWithoutItemsCreateInput"];
	["LinkItemUpdateInput"]: GraphQLTypes["LinkItemUpdateInput"];
	["LinkItemUpdateListEntityRelationInput"]: GraphQLTypes["LinkItemUpdateListEntityRelationInput"];
	["LinkListWithoutItemsUpdateInput"]: GraphQLTypes["LinkListWithoutItemsUpdateInput"];
	["LinkItemUpsertListRelationInput"]: GraphQLTypes["LinkItemUpsertListRelationInput"];
	["SocialLinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkListEdge"][]
};
	["SocialLinkListEdge"]: {
		node:ModelTypes["SocialLinkList"]
};
	["SocialLinkItemCreateInput"]: GraphQLTypes["SocialLinkItemCreateInput"];
	["SocialLinkItemCreateListEntityRelationInput"]: GraphQLTypes["SocialLinkItemCreateListEntityRelationInput"];
	["SocialLinkListWithoutItemsCreateInput"]: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"];
	["SocialLinkItemUpdateInput"]: GraphQLTypes["SocialLinkItemUpdateInput"];
	["SocialLinkItemUpdateListEntityRelationInput"]: GraphQLTypes["SocialLinkItemUpdateListEntityRelationInput"];
	["SocialLinkListWithoutItemsUpdateInput"]: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"];
	["SocialLinkItemUpsertListRelationInput"]: GraphQLTypes["SocialLinkItemUpsertListRelationInput"];
	["PrimaryLinkItemCreateInput"]: GraphQLTypes["PrimaryLinkItemCreateInput"];
	["PrimaryLinkItemUpdateInput"]: GraphQLTypes["PrimaryLinkItemUpdateInput"];
	["HeaderLocaleCreateInput"]: GraphQLTypes["HeaderLocaleCreateInput"];
	["HeaderLocaleUpdateInput"]: GraphQLTypes["HeaderLocaleUpdateInput"];
	["FooterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterEdge"][]
};
	["FooterEdge"]: {
		node:ModelTypes["Footer"]
};
	["FooterCreateInput"]: GraphQLTypes["FooterCreateInput"];
	["FooterCreateLocalesEntityRelationInput"]: GraphQLTypes["FooterCreateLocalesEntityRelationInput"];
	["FooterLocaleWithoutRootCreateInput"]: GraphQLTypes["FooterLocaleWithoutRootCreateInput"];
	["FooterLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutFootersCreateInput"]: GraphQLTypes["LocaleWithoutFootersCreateInput"];
	["FooterUpdateInput"]: GraphQLTypes["FooterUpdateInput"];
	["FooterUpdateLocalesEntityRelationInput"]: GraphQLTypes["FooterUpdateLocalesEntityRelationInput"];
	["FooterUpdateLocalesRelationInput"]: GraphQLTypes["FooterUpdateLocalesRelationInput"];
	["FooterLocaleWithoutRootUpdateInput"]: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"];
	["FooterLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutFootersUpdateInput"]: GraphQLTypes["LocaleWithoutFootersUpdateInput"];
	["FooterLocaleUpsertLocaleRelationInput"]: GraphQLTypes["FooterLocaleUpsertLocaleRelationInput"];
	["FooterUpsertLocalesRelationInput"]: GraphQLTypes["FooterUpsertLocalesRelationInput"];
	["FooterLocaleCreateInput"]: GraphQLTypes["FooterLocaleCreateInput"];
	["FooterLocaleUpdateInput"]: GraphQLTypes["FooterLocaleUpdateInput"];
	["FooterLinksConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterLinksEdge"][]
};
	["FooterLinksEdge"]: {
		node:ModelTypes["FooterLinks"]
};
	["FooterContactConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterContactEdge"][]
};
	["FooterContactEdge"]: {
		node:ModelTypes["FooterContact"]
};
	["TitleListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TitleListEdge"][]
};
	["TitleListEdge"]: {
		node:ModelTypes["TitleList"]
};
	["TitleItemCreateInput"]: GraphQLTypes["TitleItemCreateInput"];
	["TitleItemCreateListEntityRelationInput"]: GraphQLTypes["TitleItemCreateListEntityRelationInput"];
	["TitleListWithoutItemsCreateInput"]: GraphQLTypes["TitleListWithoutItemsCreateInput"];
	["TitleItemUpdateInput"]: GraphQLTypes["TitleItemUpdateInput"];
	["TitleItemUpdateListEntityRelationInput"]: GraphQLTypes["TitleItemUpdateListEntityRelationInput"];
	["TitleListWithoutItemsUpdateInput"]: GraphQLTypes["TitleListWithoutItemsUpdateInput"];
	["TitleItemUpsertListRelationInput"]: GraphQLTypes["TitleItemUpsertListRelationInput"];
	["SocialLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkEdge"][]
};
	["SocialLinkEdge"]: {
		node:ModelTypes["SocialLink"]
};
	["SecondaryLinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SecondaryLinkListEdge"][]
};
	["SecondaryLinkListEdge"]: {
		node:ModelTypes["SecondaryLinkList"]
};
	["SecondaryLinkItemCreateInput"]: GraphQLTypes["SecondaryLinkItemCreateInput"];
	["SecondaryLinkItemCreateListEntityRelationInput"]: GraphQLTypes["SecondaryLinkItemCreateListEntityRelationInput"];
	["SecondaryLinkListWithoutItemsCreateInput"]: GraphQLTypes["SecondaryLinkListWithoutItemsCreateInput"];
	["SecondaryLinkItemUpdateInput"]: GraphQLTypes["SecondaryLinkItemUpdateInput"];
	["SecondaryLinkItemUpdateListEntityRelationInput"]: GraphQLTypes["SecondaryLinkItemUpdateListEntityRelationInput"];
	["SecondaryLinkListWithoutItemsUpdateInput"]: GraphQLTypes["SecondaryLinkListWithoutItemsUpdateInput"];
	["SecondaryLinkItemUpsertListRelationInput"]: GraphQLTypes["SecondaryLinkItemUpsertListRelationInput"];
	["RestaurantLocaleCreateInput"]: GraphQLTypes["RestaurantLocaleCreateInput"];
	["RestaurantLocaleUpdateInput"]: GraphQLTypes["RestaurantLocaleUpdateInput"];
	["TranslationDomain"]: {
		_meta?:ModelTypes["TranslationDomainMeta"],
	id:ModelTypes["UUID"],
	identifier:string,
	name:string,
	catalogues:ModelTypes["TranslationCatalogue"][],
	keys:ModelTypes["TranslationKey"][],
	cataloguesByIdentifier?:ModelTypes["TranslationCatalogue"],
	cataloguesByValues?:ModelTypes["TranslationCatalogue"],
	keysByIdentifier?:ModelTypes["TranslationKey"],
	keysByValues?:ModelTypes["TranslationKey"],
	paginateCatalogues:ModelTypes["TranslationCatalogueConnection"],
	paginateKeys:ModelTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
		id?:ModelTypes["FieldMeta"],
	identifier?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	catalogues?:ModelTypes["FieldMeta"],
	keys?:ModelTypes["FieldMeta"]
};
	["TranslationCatalogue"]: {
		_meta?:ModelTypes["TranslationCatalogueMeta"],
	id:ModelTypes["UUID"],
	domain?:ModelTypes["TranslationDomain"],
	identifier?:ModelTypes["TranslationCataloguesIdentifier"],
	fallback?:ModelTypes["TranslationCatalogue"],
	values:ModelTypes["TranslationValue"][],
	valuesByKey?:ModelTypes["TranslationValue"],
	paginateValues:ModelTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
		id?:ModelTypes["FieldMeta"],
	domain?:ModelTypes["FieldMeta"],
	identifier?:ModelTypes["FieldMeta"],
	fallback?:ModelTypes["FieldMeta"],
	values?:ModelTypes["FieldMeta"]
};
	["TranslationDomainWhere"]: GraphQLTypes["TranslationDomainWhere"];
	["TranslationCatalogueWhere"]: GraphQLTypes["TranslationCatalogueWhere"];
	["TranslationCataloguesIdentifierWhere"]: GraphQLTypes["TranslationCataloguesIdentifierWhere"];
	["TranslationValueWhere"]: GraphQLTypes["TranslationValueWhere"];
	["TranslationKeyWhere"]: GraphQLTypes["TranslationKeyWhere"];
	["TranslationContentTypeCondition"]: GraphQLTypes["TranslationContentTypeCondition"];
	["TranslationContentType"]: GraphQLTypes["TranslationContentType"];
	["TranslationCataloguesIdentifier"]: {
		_meta?:ModelTypes["TranslationCataloguesIdentifierMeta"],
	id:ModelTypes["UUID"],
	name:string,
	code:string,
	catalogue:ModelTypes["TranslationCatalogue"][],
	catalogueByDomain?:ModelTypes["TranslationCatalogue"],
	catalogueByValues?:ModelTypes["TranslationCatalogue"],
	paginateCatalogue:ModelTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	code?:ModelTypes["FieldMeta"],
	catalogue?:ModelTypes["FieldMeta"]
};
	["TranslationCatalogueOrderBy"]: GraphQLTypes["TranslationCatalogueOrderBy"];
	["TranslationDomainOrderBy"]: GraphQLTypes["TranslationDomainOrderBy"];
	["TranslationCataloguesIdentifierOrderBy"]: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"];
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"];
	["TranslationDomainUniqueWhere"]: GraphQLTypes["TranslationDomainUniqueWhere"];
	["TranslationCatalogueUniqueWhere"]: GraphQLTypes["TranslationCatalogueUniqueWhere"];
	["TranslationCataloguesIdentifierUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"];
	["TranslationValueUniqueWhere"]: GraphQLTypes["TranslationValueUniqueWhere"];
	["TranslationKeyUniqueWhere"]: GraphQLTypes["TranslationKeyUniqueWhere"];
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"];
	["TranslationCatalogueConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationCatalogueEdge"][]
};
	["TranslationCatalogueEdge"]: {
		node:ModelTypes["TranslationCatalogue"]
};
	["TranslationValue"]: {
		_meta?:ModelTypes["TranslationValueMeta"],
	id:ModelTypes["UUID"],
	value:string,
	catalogue?:ModelTypes["TranslationCatalogue"],
	key?:ModelTypes["TranslationKey"]
};
	["TranslationValueMeta"]: {
		id?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	catalogue?:ModelTypes["FieldMeta"],
	key?:ModelTypes["FieldMeta"]
};
	["TranslationKey"]: {
		_meta?:ModelTypes["TranslationKeyMeta"],
	id:ModelTypes["UUID"],
	identifier:string,
	contentType:ModelTypes["TranslationContentType"],
	note?:string,
	domain?:ModelTypes["TranslationDomain"],
	values:ModelTypes["TranslationValue"][],
	valuesByCatalogue?:ModelTypes["TranslationValue"],
	paginateValues:ModelTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
		id?:ModelTypes["FieldMeta"],
	identifier?:ModelTypes["FieldMeta"],
	contentType?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"],
	domain?:ModelTypes["FieldMeta"],
	values?:ModelTypes["FieldMeta"]
};
	["TranslationValueOrderBy"]: GraphQLTypes["TranslationValueOrderBy"];
	["TranslationKeyOrderBy"]: GraphQLTypes["TranslationKeyOrderBy"];
	["TranslationKeyValuesByCatalogueUniqueWhere"]: GraphQLTypes["TranslationKeyValuesByCatalogueUniqueWhere"];
	["TranslationValueConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationValueEdge"][]
};
	["TranslationValueEdge"]: {
		node:ModelTypes["TranslationValue"]
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: GraphQLTypes["TranslationCatalogueValuesByKeyUniqueWhere"];
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: GraphQLTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"];
	["TranslationDomainCataloguesByValuesUniqueWhere"]: GraphQLTypes["TranslationDomainCataloguesByValuesUniqueWhere"];
	["TranslationDomainKeysByIdentifierUniqueWhere"]: GraphQLTypes["TranslationDomainKeysByIdentifierUniqueWhere"];
	["TranslationDomainKeysByValuesUniqueWhere"]: GraphQLTypes["TranslationDomainKeysByValuesUniqueWhere"];
	["TranslationKeyConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationKeyEdge"][]
};
	["TranslationKeyEdge"]: {
		node:ModelTypes["TranslationKey"]
};
	["TranslationDomainConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationDomainEdge"][]
};
	["TranslationDomainEdge"]: {
		node:ModelTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: GraphQLTypes["TranslationDomainCreateInput"];
	["TranslationDomainCreateCataloguesEntityRelationInput"]: GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"];
	["TranslationCatalogueWithoutDomainCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"];
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"];
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"];
	["TranslationCatalogueCreateInput"]: GraphQLTypes["TranslationCatalogueCreateInput"];
	["TranslationCatalogueCreateDomainEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesCreateInput"]: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"];
	["TranslationDomainCreateKeysEntityRelationInput"]: GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"];
	["TranslationKeyWithoutDomainCreateInput"]: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"];
	["TranslationKeyCreateValuesEntityRelationInput"]: GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"];
	["TranslationValueWithoutKeyCreateInput"]: GraphQLTypes["TranslationValueWithoutKeyCreateInput"];
	["TranslationValueCreateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"];
	["TranslationCatalogueCreateValuesEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"];
	["TranslationValueWithoutCatalogueCreateInput"]: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"];
	["TranslationValueCreateKeyEntityRelationInput"]: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesCreateInput"]: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"];
	["TranslationKeyCreateDomainEntityRelationInput"]: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysCreateInput"]: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"];
	["TranslationDomainUpdateInput"]: GraphQLTypes["TranslationDomainUpdateInput"];
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"];
	["TranslationDomainUpdateCataloguesRelationInput"]: GraphQLTypes["TranslationDomainUpdateCataloguesRelationInput"];
	["TranslationCatalogueWithoutDomainUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"];
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"];
	["TranslationCatalogueUpsertIdentifierRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertIdentifierRelationInput"];
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"];
	["TranslationCatalogueUpdateInput"]: GraphQLTypes["TranslationCatalogueUpdateInput"];
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesUpdateInput"]: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"];
	["TranslationDomainUpdateKeysEntityRelationInput"]: GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"];
	["TranslationDomainUpdateKeysRelationInput"]: GraphQLTypes["TranslationDomainUpdateKeysRelationInput"];
	["TranslationKeyWithoutDomainUpdateInput"]: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"];
	["TranslationKeyUpdateValuesEntityRelationInput"]: GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"];
	["TranslationKeyUpdateValuesRelationInput"]: GraphQLTypes["TranslationKeyUpdateValuesRelationInput"];
	["TranslationValueWithoutKeyUpdateInput"]: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"];
	["TranslationValueUpdateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"];
	["TranslationValueUpsertCatalogueRelationInput"]: GraphQLTypes["TranslationValueUpsertCatalogueRelationInput"];
	["TranslationKeyUpsertValuesRelationInput"]: GraphQLTypes["TranslationKeyUpsertValuesRelationInput"];
	["TranslationDomainUpsertKeysRelationInput"]: GraphQLTypes["TranslationDomainUpsertKeysRelationInput"];
	["TranslationCatalogueUpsertDomainRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertDomainRelationInput"];
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"];
	["TranslationCatalogueUpdateValuesRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateValuesRelationInput"];
	["TranslationValueWithoutCatalogueUpdateInput"]: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"];
	["TranslationValueUpdateKeyEntityRelationInput"]: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesUpdateInput"]: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"];
	["TranslationKeyUpdateDomainEntityRelationInput"]: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysUpdateInput"]: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"];
	["TranslationKeyUpsertDomainRelationInput"]: GraphQLTypes["TranslationKeyUpsertDomainRelationInput"];
	["TranslationValueUpsertKeyRelationInput"]: GraphQLTypes["TranslationValueUpsertKeyRelationInput"];
	["TranslationCatalogueUpsertValuesRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertValuesRelationInput"];
	["TranslationCatalogueUpsertFallbackRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertFallbackRelationInput"];
	["TranslationDomainUpsertCataloguesRelationInput"]: GraphQLTypes["TranslationDomainUpsertCataloguesRelationInput"];
	["TranslationCataloguesIdentifierConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationCataloguesIdentifierEdge"][]
};
	["TranslationCataloguesIdentifierEdge"]: {
		node:ModelTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierCreateInput"]: GraphQLTypes["TranslationCataloguesIdentifierCreateInput"];
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutIdentifierCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"];
	["TranslationCataloguesIdentifierUpdateInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"];
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"];
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"];
	["TranslationKeyCreateInput"]: GraphQLTypes["TranslationKeyCreateInput"];
	["TranslationKeyUpdateInput"]: GraphQLTypes["TranslationKeyUpdateInput"];
	["TranslationValueCreateInput"]: GraphQLTypes["TranslationValueCreateInput"];
	["TranslationValueUpdateInput"]: GraphQLTypes["TranslationValueUpdateInput"];
	["RestaurantItemCreateInput"]: GraphQLTypes["RestaurantItemCreateInput"];
	["RestaurantItemUpdateInput"]: GraphQLTypes["RestaurantItemUpdateInput"];
	["RestaurantTagCreateInput"]: GraphQLTypes["RestaurantTagCreateInput"];
	["RestaurantTagUpdateInput"]: GraphQLTypes["RestaurantTagUpdateInput"];
	["RestaurantTagLocaleCreateInput"]: GraphQLTypes["RestaurantTagLocaleCreateInput"];
	["RestaurantTagLocaleUpdateInput"]: GraphQLTypes["RestaurantTagLocaleUpdateInput"];
	["BannerConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BannerEdge"][]
};
	["BannerEdge"]: {
		node:ModelTypes["Banner"]
};
	["BannerLocaleCreateInput"]: GraphQLTypes["BannerLocaleCreateInput"];
	["BannerLocaleUpdateInput"]: GraphQLTypes["BannerLocaleUpdateInput"];
	["CategoryCreateInput"]: GraphQLTypes["CategoryCreateInput"];
	["CategoryUpdateInput"]: GraphQLTypes["CategoryUpdateInput"];
	["CategoryLocaleCreateInput"]: GraphQLTypes["CategoryLocaleCreateInput"];
	["CategoryLocaleUpdateInput"]: GraphQLTypes["CategoryLocaleUpdateInput"];
	["SubRestaurantsPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SubRestaurantsPageEdge"][]
};
	["SubRestaurantsPageEdge"]: {
		node:ModelTypes["SubRestaurantsPage"]
};
	["SubRestaurantsPageCreateInput"]: GraphQLTypes["SubRestaurantsPageCreateInput"];
	["SubRestaurantsPageCreateLocalesEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageCreateLocalesEntityRelationInput"];
	["SubRestaurantsPageLocaleWithoutRootCreateInput"]: GraphQLTypes["SubRestaurantsPageLocaleWithoutRootCreateInput"];
	["SubRestaurantsPageUpdateInput"]: GraphQLTypes["SubRestaurantsPageUpdateInput"];
	["SubRestaurantsPageUpdateLocalesEntityRelationInput"]: GraphQLTypes["SubRestaurantsPageUpdateLocalesEntityRelationInput"];
	["SubRestaurantsPageUpdateLocalesRelationInput"]: GraphQLTypes["SubRestaurantsPageUpdateLocalesRelationInput"];
	["SubRestaurantsPageLocaleWithoutRootUpdateInput"]: GraphQLTypes["SubRestaurantsPageLocaleWithoutRootUpdateInput"];
	["SubRestaurantsPageUpsertLocalesRelationInput"]: GraphQLTypes["SubRestaurantsPageUpsertLocalesRelationInput"];
	["SubRestaurantsPageLocaleCreateInput"]: GraphQLTypes["SubRestaurantsPageLocaleCreateInput"];
	["SubRestaurantsPageLocaleUpdateInput"]: GraphQLTypes["SubRestaurantsPageLocaleUpdateInput"];
	["ImageList"]: {
		_meta?:ModelTypes["ImageListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ImageListItem"][],
	itemsByImage?:ModelTypes["ImageListItem"],
	paginateItems:ModelTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ImageListItem"]: {
		_meta?:ModelTypes["ImageListItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["ImageList"],
	image?:ModelTypes["Image"]
};
	["ImageListItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ImageListWhere"]: GraphQLTypes["ImageListWhere"];
	["ImageListItemWhere"]: GraphQLTypes["ImageListItemWhere"];
	["ImageListItemOrderBy"]: GraphQLTypes["ImageListItemOrderBy"];
	["ImageListOrderBy"]: GraphQLTypes["ImageListOrderBy"];
	["ImageListItemsByImageUniqueWhere"]: GraphQLTypes["ImageListItemsByImageUniqueWhere"];
	["ImageListItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageListItemEdge"][]
};
	["ImageListItemEdge"]: {
		node:ModelTypes["ImageListItem"]
};
	["ImageListUniqueWhere"]: GraphQLTypes["ImageListUniqueWhere"];
	["ImageListItemUniqueWhere"]: GraphQLTypes["ImageListItemUniqueWhere"];
	["ImageListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageListEdge"][]
};
	["ImageListEdge"]: {
		node:ModelTypes["ImageList"]
};
	["ImageListCreateInput"]: GraphQLTypes["ImageListCreateInput"];
	["ImageListCreateItemsEntityRelationInput"]: GraphQLTypes["ImageListCreateItemsEntityRelationInput"];
	["ImageListItemWithoutListCreateInput"]: GraphQLTypes["ImageListItemWithoutListCreateInput"];
	["ImageListItemCreateImageEntityRelationInput"]: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"];
	["ImageListUpdateInput"]: GraphQLTypes["ImageListUpdateInput"];
	["ImageListUpdateItemsEntityRelationInput"]: GraphQLTypes["ImageListUpdateItemsEntityRelationInput"];
	["ImageListUpdateItemsRelationInput"]: GraphQLTypes["ImageListUpdateItemsRelationInput"];
	["ImageListItemWithoutListUpdateInput"]: GraphQLTypes["ImageListItemWithoutListUpdateInput"];
	["ImageListItemUpdateImageEntityRelationInput"]: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"];
	["ImageListItemUpsertImageRelationInput"]: GraphQLTypes["ImageListItemUpsertImageRelationInput"];
	["ImageListUpsertItemsRelationInput"]: GraphQLTypes["ImageListUpsertItemsRelationInput"];
	["ImageListItemCreateInput"]: GraphQLTypes["ImageListItemCreateInput"];
	["ImageListItemCreateListEntityRelationInput"]: GraphQLTypes["ImageListItemCreateListEntityRelationInput"];
	["ImageListWithoutItemsCreateInput"]: GraphQLTypes["ImageListWithoutItemsCreateInput"];
	["ImageListItemUpdateInput"]: GraphQLTypes["ImageListItemUpdateInput"];
	["ImageListItemUpdateListEntityRelationInput"]: GraphQLTypes["ImageListItemUpdateListEntityRelationInput"];
	["ImageListWithoutItemsUpdateInput"]: GraphQLTypes["ImageListWithoutItemsUpdateInput"];
	["ImageListItemUpsertListRelationInput"]: GraphQLTypes["ImageListItemUpsertListRelationInput"];
	["QueryTransaction"]: {
		getFrontPage?:ModelTypes["FrontPage"],
	listFrontPage:ModelTypes["FrontPage"][],
	paginateFrontPage:ModelTypes["FrontPageConnection"],
	validateCreateFrontPage:ModelTypes["_ValidationResult"],
	validateUpdateFrontPage:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getLocale?:ModelTypes["Locale"],
	listLocale:ModelTypes["Locale"][],
	paginateLocale:ModelTypes["LocaleConnection"],
	validateCreateLocale:ModelTypes["_ValidationResult"],
	validateUpdateLocale:ModelTypes["_ValidationResult"],
	getFrontPageLocale?:ModelTypes["FrontPageLocale"],
	listFrontPageLocale:ModelTypes["FrontPageLocale"][],
	paginateFrontPageLocale:ModelTypes["FrontPageLocaleConnection"],
	validateCreateFrontPageLocale:ModelTypes["_ValidationResult"],
	validateUpdateFrontPageLocale:ModelTypes["_ValidationResult"],
	getLinkList?:ModelTypes["LinkList"],
	listLinkList:ModelTypes["LinkList"][],
	paginateLinkList:ModelTypes["LinkListConnection"],
	validateCreateLinkList:ModelTypes["_ValidationResult"],
	validateUpdateLinkList:ModelTypes["_ValidationResult"],
	getLinkItem?:ModelTypes["LinkItem"],
	listLinkItem:ModelTypes["LinkItem"][],
	paginateLinkItem:ModelTypes["LinkItemConnection"],
	validateCreateLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateLinkItem:ModelTypes["_ValidationResult"],
	getSocialLinkList?:ModelTypes["SocialLinkList"],
	listSocialLinkList:ModelTypes["SocialLinkList"][],
	paginateSocialLinkList:ModelTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkList:ModelTypes["_ValidationResult"],
	getSocialLinkItem?:ModelTypes["SocialLinkItem"],
	listSocialLinkItem:ModelTypes["SocialLinkItem"][],
	paginateSocialLinkItem:ModelTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkItem:ModelTypes["_ValidationResult"],
	getPrimaryLinkItem?:ModelTypes["PrimaryLinkItem"],
	listPrimaryLinkItem:ModelTypes["PrimaryLinkItem"][],
	paginatePrimaryLinkItem:ModelTypes["PrimaryLinkItemConnection"],
	validateCreatePrimaryLinkItem:ModelTypes["_ValidationResult"],
	validateUpdatePrimaryLinkItem:ModelTypes["_ValidationResult"],
	getHeaderLocale?:ModelTypes["HeaderLocale"],
	listHeaderLocale:ModelTypes["HeaderLocale"][],
	paginateHeaderLocale:ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterLocale?:ModelTypes["FooterLocale"],
	listFooterLocale:ModelTypes["FooterLocale"][],
	paginateFooterLocale:ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale:ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale:ModelTypes["_ValidationResult"],
	getFooterLinks?:ModelTypes["FooterLinks"],
	listFooterLinks:ModelTypes["FooterLinks"][],
	paginateFooterLinks:ModelTypes["FooterLinksConnection"],
	validateCreateFooterLinks:ModelTypes["_ValidationResult"],
	validateUpdateFooterLinks:ModelTypes["_ValidationResult"],
	getFooterContact?:ModelTypes["FooterContact"],
	listFooterContact:ModelTypes["FooterContact"][],
	paginateFooterContact:ModelTypes["FooterContactConnection"],
	validateCreateFooterContact:ModelTypes["_ValidationResult"],
	validateUpdateFooterContact:ModelTypes["_ValidationResult"],
	getTitleList?:ModelTypes["TitleList"],
	listTitleList:ModelTypes["TitleList"][],
	paginateTitleList:ModelTypes["TitleListConnection"],
	validateCreateTitleList:ModelTypes["_ValidationResult"],
	validateUpdateTitleList:ModelTypes["_ValidationResult"],
	getTitleItem?:ModelTypes["TitleItem"],
	listTitleItem:ModelTypes["TitleItem"][],
	paginateTitleItem:ModelTypes["TitleItemConnection"],
	validateCreateTitleItem:ModelTypes["_ValidationResult"],
	validateUpdateTitleItem:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getSecondaryLinkList?:ModelTypes["SecondaryLinkList"],
	listSecondaryLinkList:ModelTypes["SecondaryLinkList"][],
	paginateSecondaryLinkList:ModelTypes["SecondaryLinkListConnection"],
	validateCreateSecondaryLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSecondaryLinkList:ModelTypes["_ValidationResult"],
	getSecondaryLinkItem?:ModelTypes["SecondaryLinkItem"],
	listSecondaryLinkItem:ModelTypes["SecondaryLinkItem"][],
	paginateSecondaryLinkItem:ModelTypes["SecondaryLinkItemConnection"],
	validateCreateSecondaryLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSecondaryLinkItem:ModelTypes["_ValidationResult"],
	getRestaurant?:ModelTypes["Restaurant"],
	listRestaurant:ModelTypes["Restaurant"][],
	paginateRestaurant:ModelTypes["RestaurantConnection"],
	validateCreateRestaurant:ModelTypes["_ValidationResult"],
	validateUpdateRestaurant:ModelTypes["_ValidationResult"],
	getRestaurantLocale?:ModelTypes["RestaurantLocale"],
	listRestaurantLocale:ModelTypes["RestaurantLocale"][],
	paginateRestaurantLocale:ModelTypes["RestaurantLocaleConnection"],
	validateCreateRestaurantLocale:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantLocale:ModelTypes["_ValidationResult"],
	getTranslationDomain?:ModelTypes["TranslationDomain"],
	listTranslationDomain:ModelTypes["TranslationDomain"][],
	paginateTranslationDomain:ModelTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain:ModelTypes["_ValidationResult"],
	validateUpdateTranslationDomain:ModelTypes["_ValidationResult"],
	getTranslationCatalogue?:ModelTypes["TranslationCatalogue"],
	listTranslationCatalogue:ModelTypes["TranslationCatalogue"][],
	paginateTranslationCatalogue:ModelTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue:ModelTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?:ModelTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifier"][],
	paginateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	getTranslationKey?:ModelTypes["TranslationKey"],
	listTranslationKey:ModelTypes["TranslationKey"][],
	paginateTranslationKey:ModelTypes["TranslationKeyConnection"],
	validateCreateTranslationKey:ModelTypes["_ValidationResult"],
	validateUpdateTranslationKey:ModelTypes["_ValidationResult"],
	getTranslationValue?:ModelTypes["TranslationValue"],
	listTranslationValue:ModelTypes["TranslationValue"][],
	paginateTranslationValue:ModelTypes["TranslationValueConnection"],
	validateCreateTranslationValue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationValue:ModelTypes["_ValidationResult"],
	getRestaurantItem?:ModelTypes["RestaurantItem"],
	listRestaurantItem:ModelTypes["RestaurantItem"][],
	paginateRestaurantItem:ModelTypes["RestaurantItemConnection"],
	validateCreateRestaurantItem:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantItem:ModelTypes["_ValidationResult"],
	getRestaurantTag?:ModelTypes["RestaurantTag"],
	listRestaurantTag:ModelTypes["RestaurantTag"][],
	paginateRestaurantTag:ModelTypes["RestaurantTagConnection"],
	validateCreateRestaurantTag:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantTag:ModelTypes["_ValidationResult"],
	getRestaurantTagLocale?:ModelTypes["RestaurantTagLocale"],
	listRestaurantTagLocale:ModelTypes["RestaurantTagLocale"][],
	paginateRestaurantTagLocale:ModelTypes["RestaurantTagLocaleConnection"],
	validateCreateRestaurantTagLocale:ModelTypes["_ValidationResult"],
	validateUpdateRestaurantTagLocale:ModelTypes["_ValidationResult"],
	getBanner?:ModelTypes["Banner"],
	listBanner:ModelTypes["Banner"][],
	paginateBanner:ModelTypes["BannerConnection"],
	validateCreateBanner:ModelTypes["_ValidationResult"],
	validateUpdateBanner:ModelTypes["_ValidationResult"],
	getBannerLocale?:ModelTypes["BannerLocale"],
	listBannerLocale:ModelTypes["BannerLocale"][],
	paginateBannerLocale:ModelTypes["BannerLocaleConnection"],
	validateCreateBannerLocale:ModelTypes["_ValidationResult"],
	validateUpdateBannerLocale:ModelTypes["_ValidationResult"],
	getCategory?:ModelTypes["Category"],
	listCategory:ModelTypes["Category"][],
	paginateCategory:ModelTypes["CategoryConnection"],
	validateCreateCategory:ModelTypes["_ValidationResult"],
	validateUpdateCategory:ModelTypes["_ValidationResult"],
	getCategoryLocale?:ModelTypes["CategoryLocale"],
	listCategoryLocale:ModelTypes["CategoryLocale"][],
	paginateCategoryLocale:ModelTypes["CategoryLocaleConnection"],
	validateCreateCategoryLocale:ModelTypes["_ValidationResult"],
	validateUpdateCategoryLocale:ModelTypes["_ValidationResult"],
	getSubRestaurantsPage?:ModelTypes["SubRestaurantsPage"],
	listSubRestaurantsPage:ModelTypes["SubRestaurantsPage"][],
	paginateSubRestaurantsPage:ModelTypes["SubRestaurantsPageConnection"],
	validateCreateSubRestaurantsPage:ModelTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPage:ModelTypes["_ValidationResult"],
	getSubRestaurantsPageLocale?:ModelTypes["SubRestaurantsPageLocale"],
	listSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocale"][],
	paginateSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleConnection"],
	validateCreateSubRestaurantsPageLocale:ModelTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPageLocale:ModelTypes["_ValidationResult"],
	getImageList?:ModelTypes["ImageList"],
	listImageList:ModelTypes["ImageList"][],
	paginateImageList:ModelTypes["ImageListConnection"],
	validateCreateImageList:ModelTypes["_ValidationResult"],
	validateUpdateImageList:ModelTypes["_ValidationResult"],
	getImageListItem?:ModelTypes["ImageListItem"],
	listImageListItem:ModelTypes["ImageListItem"][],
	paginateImageListItem:ModelTypes["ImageListItemConnection"],
	validateCreateImageListItem:ModelTypes["_ValidationResult"],
	validateUpdateImageListItem:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createFrontPage:ModelTypes["FrontPageCreateResult"],
	deleteFrontPage:ModelTypes["FrontPageDeleteResult"],
	updateFrontPage:ModelTypes["FrontPageUpdateResult"],
	upsertFrontPage:ModelTypes["FrontPageUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createLocale:ModelTypes["LocaleCreateResult"],
	deleteLocale:ModelTypes["LocaleDeleteResult"],
	updateLocale:ModelTypes["LocaleUpdateResult"],
	upsertLocale:ModelTypes["LocaleUpsertResult"],
	createFrontPageLocale:ModelTypes["FrontPageLocaleCreateResult"],
	deleteFrontPageLocale:ModelTypes["FrontPageLocaleDeleteResult"],
	updateFrontPageLocale:ModelTypes["FrontPageLocaleUpdateResult"],
	upsertFrontPageLocale:ModelTypes["FrontPageLocaleUpsertResult"],
	createLinkList:ModelTypes["LinkListCreateResult"],
	deleteLinkList:ModelTypes["LinkListDeleteResult"],
	updateLinkList:ModelTypes["LinkListUpdateResult"],
	upsertLinkList:ModelTypes["LinkListUpsertResult"],
	createLinkItem:ModelTypes["LinkItemCreateResult"],
	deleteLinkItem:ModelTypes["LinkItemDeleteResult"],
	updateLinkItem:ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem:ModelTypes["LinkItemUpsertResult"],
	createSocialLinkList:ModelTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList:ModelTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList:ModelTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList:ModelTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem:ModelTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem:ModelTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem:ModelTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem:ModelTypes["SocialLinkItemUpsertResult"],
	createPrimaryLinkItem:ModelTypes["PrimaryLinkItemCreateResult"],
	deletePrimaryLinkItem:ModelTypes["PrimaryLinkItemDeleteResult"],
	updatePrimaryLinkItem:ModelTypes["PrimaryLinkItemUpdateResult"],
	upsertPrimaryLinkItem:ModelTypes["PrimaryLinkItemUpsertResult"],
	createHeaderLocale:ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale:ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale:ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale:ModelTypes["HeaderLocaleUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterLocale:ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale:ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale:ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale:ModelTypes["FooterLocaleUpsertResult"],
	createFooterLinks:ModelTypes["FooterLinksCreateResult"],
	deleteFooterLinks:ModelTypes["FooterLinksDeleteResult"],
	updateFooterLinks:ModelTypes["FooterLinksUpdateResult"],
	upsertFooterLinks:ModelTypes["FooterLinksUpsertResult"],
	createFooterContact:ModelTypes["FooterContactCreateResult"],
	deleteFooterContact:ModelTypes["FooterContactDeleteResult"],
	updateFooterContact:ModelTypes["FooterContactUpdateResult"],
	upsertFooterContact:ModelTypes["FooterContactUpsertResult"],
	createTitleList:ModelTypes["TitleListCreateResult"],
	deleteTitleList:ModelTypes["TitleListDeleteResult"],
	updateTitleList:ModelTypes["TitleListUpdateResult"],
	upsertTitleList:ModelTypes["TitleListUpsertResult"],
	createTitleItem:ModelTypes["TitleItemCreateResult"],
	deleteTitleItem:ModelTypes["TitleItemDeleteResult"],
	updateTitleItem:ModelTypes["TitleItemUpdateResult"],
	upsertTitleItem:ModelTypes["TitleItemUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createSecondaryLinkList:ModelTypes["SecondaryLinkListCreateResult"],
	deleteSecondaryLinkList:ModelTypes["SecondaryLinkListDeleteResult"],
	updateSecondaryLinkList:ModelTypes["SecondaryLinkListUpdateResult"],
	upsertSecondaryLinkList:ModelTypes["SecondaryLinkListUpsertResult"],
	createSecondaryLinkItem:ModelTypes["SecondaryLinkItemCreateResult"],
	deleteSecondaryLinkItem:ModelTypes["SecondaryLinkItemDeleteResult"],
	updateSecondaryLinkItem:ModelTypes["SecondaryLinkItemUpdateResult"],
	upsertSecondaryLinkItem:ModelTypes["SecondaryLinkItemUpsertResult"],
	createRestaurant:ModelTypes["RestaurantCreateResult"],
	deleteRestaurant:ModelTypes["RestaurantDeleteResult"],
	updateRestaurant:ModelTypes["RestaurantUpdateResult"],
	upsertRestaurant:ModelTypes["RestaurantUpsertResult"],
	createRestaurantLocale:ModelTypes["RestaurantLocaleCreateResult"],
	deleteRestaurantLocale:ModelTypes["RestaurantLocaleDeleteResult"],
	updateRestaurantLocale:ModelTypes["RestaurantLocaleUpdateResult"],
	upsertRestaurantLocale:ModelTypes["RestaurantLocaleUpsertResult"],
	createTranslationDomain:ModelTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain:ModelTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain:ModelTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain:ModelTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue:ModelTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue:ModelTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue:ModelTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue:ModelTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey:ModelTypes["TranslationKeyCreateResult"],
	deleteTranslationKey:ModelTypes["TranslationKeyDeleteResult"],
	updateTranslationKey:ModelTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey:ModelTypes["TranslationKeyUpsertResult"],
	createTranslationValue:ModelTypes["TranslationValueCreateResult"],
	deleteTranslationValue:ModelTypes["TranslationValueDeleteResult"],
	updateTranslationValue:ModelTypes["TranslationValueUpdateResult"],
	upsertTranslationValue:ModelTypes["TranslationValueUpsertResult"],
	createRestaurantItem:ModelTypes["RestaurantItemCreateResult"],
	deleteRestaurantItem:ModelTypes["RestaurantItemDeleteResult"],
	updateRestaurantItem:ModelTypes["RestaurantItemUpdateResult"],
	upsertRestaurantItem:ModelTypes["RestaurantItemUpsertResult"],
	createRestaurantTag:ModelTypes["RestaurantTagCreateResult"],
	deleteRestaurantTag:ModelTypes["RestaurantTagDeleteResult"],
	updateRestaurantTag:ModelTypes["RestaurantTagUpdateResult"],
	upsertRestaurantTag:ModelTypes["RestaurantTagUpsertResult"],
	createRestaurantTagLocale:ModelTypes["RestaurantTagLocaleCreateResult"],
	deleteRestaurantTagLocale:ModelTypes["RestaurantTagLocaleDeleteResult"],
	updateRestaurantTagLocale:ModelTypes["RestaurantTagLocaleUpdateResult"],
	upsertRestaurantTagLocale:ModelTypes["RestaurantTagLocaleUpsertResult"],
	createBanner:ModelTypes["BannerCreateResult"],
	deleteBanner:ModelTypes["BannerDeleteResult"],
	updateBanner:ModelTypes["BannerUpdateResult"],
	upsertBanner:ModelTypes["BannerUpsertResult"],
	createBannerLocale:ModelTypes["BannerLocaleCreateResult"],
	deleteBannerLocale:ModelTypes["BannerLocaleDeleteResult"],
	updateBannerLocale:ModelTypes["BannerLocaleUpdateResult"],
	upsertBannerLocale:ModelTypes["BannerLocaleUpsertResult"],
	createCategory:ModelTypes["CategoryCreateResult"],
	deleteCategory:ModelTypes["CategoryDeleteResult"],
	updateCategory:ModelTypes["CategoryUpdateResult"],
	upsertCategory:ModelTypes["CategoryUpsertResult"],
	createCategoryLocale:ModelTypes["CategoryLocaleCreateResult"],
	deleteCategoryLocale:ModelTypes["CategoryLocaleDeleteResult"],
	updateCategoryLocale:ModelTypes["CategoryLocaleUpdateResult"],
	upsertCategoryLocale:ModelTypes["CategoryLocaleUpsertResult"],
	createSubRestaurantsPage:ModelTypes["SubRestaurantsPageCreateResult"],
	deleteSubRestaurantsPage:ModelTypes["SubRestaurantsPageDeleteResult"],
	updateSubRestaurantsPage:ModelTypes["SubRestaurantsPageUpdateResult"],
	upsertSubRestaurantsPage:ModelTypes["SubRestaurantsPageUpsertResult"],
	createSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleCreateResult"],
	deleteSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleDeleteResult"],
	updateSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleUpdateResult"],
	upsertSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleUpsertResult"],
	createImageList:ModelTypes["ImageListCreateResult"],
	deleteImageList:ModelTypes["ImageListDeleteResult"],
	updateImageList:ModelTypes["ImageListUpdateResult"],
	upsertImageList:ModelTypes["ImageListUpsertResult"],
	createImageListItem:ModelTypes["ImageListItemCreateResult"],
	deleteImageListItem:ModelTypes["ImageListItemDeleteResult"],
	updateImageListItem:ModelTypes["ImageListItemUpdateResult"],
	upsertImageListItem:ModelTypes["ImageListItemUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["FrontPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["FrontPageCreateResult"] | ModelTypes["FrontPageDeleteResult"] | ModelTypes["FrontPageUpdateResult"] | ModelTypes["FrontPageUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["LocaleCreateResult"] | ModelTypes["LocaleDeleteResult"] | ModelTypes["LocaleUpdateResult"] | ModelTypes["LocaleUpsertResult"] | ModelTypes["FrontPageLocaleCreateResult"] | ModelTypes["FrontPageLocaleDeleteResult"] | ModelTypes["FrontPageLocaleUpdateResult"] | ModelTypes["FrontPageLocaleUpsertResult"] | ModelTypes["LinkListCreateResult"] | ModelTypes["LinkListDeleteResult"] | ModelTypes["LinkListUpdateResult"] | ModelTypes["LinkListUpsertResult"] | ModelTypes["LinkItemCreateResult"] | ModelTypes["LinkItemDeleteResult"] | ModelTypes["LinkItemUpdateResult"] | ModelTypes["LinkItemUpsertResult"] | ModelTypes["SocialLinkListCreateResult"] | ModelTypes["SocialLinkListDeleteResult"] | ModelTypes["SocialLinkListUpdateResult"] | ModelTypes["SocialLinkListUpsertResult"] | ModelTypes["SocialLinkItemCreateResult"] | ModelTypes["SocialLinkItemDeleteResult"] | ModelTypes["SocialLinkItemUpdateResult"] | ModelTypes["SocialLinkItemUpsertResult"] | ModelTypes["PrimaryLinkItemCreateResult"] | ModelTypes["PrimaryLinkItemDeleteResult"] | ModelTypes["PrimaryLinkItemUpdateResult"] | ModelTypes["PrimaryLinkItemUpsertResult"] | ModelTypes["HeaderLocaleCreateResult"] | ModelTypes["HeaderLocaleDeleteResult"] | ModelTypes["HeaderLocaleUpdateResult"] | ModelTypes["HeaderLocaleUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["FooterLocaleCreateResult"] | ModelTypes["FooterLocaleDeleteResult"] | ModelTypes["FooterLocaleUpdateResult"] | ModelTypes["FooterLocaleUpsertResult"] | ModelTypes["FooterLinksCreateResult"] | ModelTypes["FooterLinksDeleteResult"] | ModelTypes["FooterLinksUpdateResult"] | ModelTypes["FooterLinksUpsertResult"] | ModelTypes["FooterContactCreateResult"] | ModelTypes["FooterContactDeleteResult"] | ModelTypes["FooterContactUpdateResult"] | ModelTypes["FooterContactUpsertResult"] | ModelTypes["TitleListCreateResult"] | ModelTypes["TitleListDeleteResult"] | ModelTypes["TitleListUpdateResult"] | ModelTypes["TitleListUpsertResult"] | ModelTypes["TitleItemCreateResult"] | ModelTypes["TitleItemDeleteResult"] | ModelTypes["TitleItemUpdateResult"] | ModelTypes["TitleItemUpsertResult"] | ModelTypes["SocialLinkCreateResult"] | ModelTypes["SocialLinkDeleteResult"] | ModelTypes["SocialLinkUpdateResult"] | ModelTypes["SocialLinkUpsertResult"] | ModelTypes["SecondaryLinkListCreateResult"] | ModelTypes["SecondaryLinkListDeleteResult"] | ModelTypes["SecondaryLinkListUpdateResult"] | ModelTypes["SecondaryLinkListUpsertResult"] | ModelTypes["SecondaryLinkItemCreateResult"] | ModelTypes["SecondaryLinkItemDeleteResult"] | ModelTypes["SecondaryLinkItemUpdateResult"] | ModelTypes["SecondaryLinkItemUpsertResult"] | ModelTypes["RestaurantCreateResult"] | ModelTypes["RestaurantDeleteResult"] | ModelTypes["RestaurantUpdateResult"] | ModelTypes["RestaurantUpsertResult"] | ModelTypes["RestaurantLocaleCreateResult"] | ModelTypes["RestaurantLocaleDeleteResult"] | ModelTypes["RestaurantLocaleUpdateResult"] | ModelTypes["RestaurantLocaleUpsertResult"] | ModelTypes["TranslationDomainCreateResult"] | ModelTypes["TranslationDomainDeleteResult"] | ModelTypes["TranslationDomainUpdateResult"] | ModelTypes["TranslationDomainUpsertResult"] | ModelTypes["TranslationCatalogueCreateResult"] | ModelTypes["TranslationCatalogueDeleteResult"] | ModelTypes["TranslationCatalogueUpdateResult"] | ModelTypes["TranslationCatalogueUpsertResult"] | ModelTypes["TranslationCataloguesIdentifierCreateResult"] | ModelTypes["TranslationCataloguesIdentifierDeleteResult"] | ModelTypes["TranslationCataloguesIdentifierUpdateResult"] | ModelTypes["TranslationCataloguesIdentifierUpsertResult"] | ModelTypes["TranslationKeyCreateResult"] | ModelTypes["TranslationKeyDeleteResult"] | ModelTypes["TranslationKeyUpdateResult"] | ModelTypes["TranslationKeyUpsertResult"] | ModelTypes["TranslationValueCreateResult"] | ModelTypes["TranslationValueDeleteResult"] | ModelTypes["TranslationValueUpdateResult"] | ModelTypes["TranslationValueUpsertResult"] | ModelTypes["RestaurantItemCreateResult"] | ModelTypes["RestaurantItemDeleteResult"] | ModelTypes["RestaurantItemUpdateResult"] | ModelTypes["RestaurantItemUpsertResult"] | ModelTypes["RestaurantTagCreateResult"] | ModelTypes["RestaurantTagDeleteResult"] | ModelTypes["RestaurantTagUpdateResult"] | ModelTypes["RestaurantTagUpsertResult"] | ModelTypes["RestaurantTagLocaleCreateResult"] | ModelTypes["RestaurantTagLocaleDeleteResult"] | ModelTypes["RestaurantTagLocaleUpdateResult"] | ModelTypes["RestaurantTagLocaleUpsertResult"] | ModelTypes["BannerCreateResult"] | ModelTypes["BannerDeleteResult"] | ModelTypes["BannerUpdateResult"] | ModelTypes["BannerUpsertResult"] | ModelTypes["BannerLocaleCreateResult"] | ModelTypes["BannerLocaleDeleteResult"] | ModelTypes["BannerLocaleUpdateResult"] | ModelTypes["BannerLocaleUpsertResult"] | ModelTypes["CategoryCreateResult"] | ModelTypes["CategoryDeleteResult"] | ModelTypes["CategoryUpdateResult"] | ModelTypes["CategoryUpsertResult"] | ModelTypes["CategoryLocaleCreateResult"] | ModelTypes["CategoryLocaleDeleteResult"] | ModelTypes["CategoryLocaleUpdateResult"] | ModelTypes["CategoryLocaleUpsertResult"] | ModelTypes["SubRestaurantsPageCreateResult"] | ModelTypes["SubRestaurantsPageDeleteResult"] | ModelTypes["SubRestaurantsPageUpdateResult"] | ModelTypes["SubRestaurantsPageUpsertResult"] | ModelTypes["SubRestaurantsPageLocaleCreateResult"] | ModelTypes["SubRestaurantsPageLocaleDeleteResult"] | ModelTypes["SubRestaurantsPageLocaleUpdateResult"] | ModelTypes["SubRestaurantsPageLocaleUpsertResult"] | ModelTypes["ImageListCreateResult"] | ModelTypes["ImageListDeleteResult"] | ModelTypes["ImageListUpdateResult"] | ModelTypes["ImageListUpsertResult"] | ModelTypes["ImageListItemCreateResult"] | ModelTypes["ImageListItemDeleteResult"] | ModelTypes["ImageListItemUpdateResult"] | ModelTypes["ImageListItemUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["FrontPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"]
};
	["FrontPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["FrontPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"]
};
	["HeaderUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"]
};
	["LocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FrontPageLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FrontPageLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPageLocale"]
};
	["FrontPageLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FrontPageLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FrontPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"]
};
	["LinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"]
};
	["LinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"]
};
	["SocialLinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"]
};
	["SocialLinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrimaryLinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrimaryLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrimaryLinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrimaryLinkItem"]
};
	["PrimaryLinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrimaryLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["PrimaryLinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PrimaryLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"]
};
	["HeaderLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"]
};
	["FooterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"]
};
	["FooterLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinksCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinks"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinksDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinks"]
};
	["FooterLinksUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinks"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLinksUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLinks"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterContactCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterContact"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterContactDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterContact"]
};
	["FooterContactUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterContact"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterContactUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterContact"],
	validation:ModelTypes["_ValidationResult"]
};
	["TitleListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleList"],
	validation:ModelTypes["_ValidationResult"]
};
	["TitleListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleList"]
};
	["TitleListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleList"],
	validation:ModelTypes["_ValidationResult"]
};
	["TitleListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleList"],
	validation:ModelTypes["_ValidationResult"]
};
	["TitleItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["TitleItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleItem"]
};
	["TitleItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["TitleItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TitleItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SecondaryLinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SecondaryLinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkList"]
};
	["SecondaryLinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SecondaryLinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SecondaryLinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SecondaryLinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkItem"]
};
	["SecondaryLinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SecondaryLinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SecondaryLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Restaurant"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Restaurant"]
};
	["RestaurantUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Restaurant"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Restaurant"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantLocale"]
};
	["RestaurantLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"]
};
	["TranslationDomainUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"]
};
	["TranslationCatalogueUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"]
};
	["TranslationKeyUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"]
};
	["TranslationValueUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantItem"]
};
	["RestaurantItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantTagCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantTagDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTag"]
};
	["RestaurantTagUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantTagUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTag"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantTagLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTagLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantTagLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTagLocale"]
};
	["RestaurantTagLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTagLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["RestaurantTagLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["RestaurantTagLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["BannerCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Banner"],
	validation:ModelTypes["_ValidationResult"]
};
	["BannerDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Banner"]
};
	["BannerUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Banner"],
	validation:ModelTypes["_ValidationResult"]
};
	["BannerUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Banner"],
	validation:ModelTypes["_ValidationResult"]
};
	["BannerLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BannerLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["BannerLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BannerLocale"]
};
	["BannerLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BannerLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["BannerLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BannerLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"]
};
	["CategoryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Category"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CategoryLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CategoryLocale"]
};
	["CategoryLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CategoryLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["CategoryLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["CategoryLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubRestaurantsPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubRestaurantsPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPage"]
};
	["SubRestaurantsPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubRestaurantsPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubRestaurantsPageLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubRestaurantsPageLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPageLocale"]
};
	["SubRestaurantsPageLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SubRestaurantsPageLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SubRestaurantsPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"]
};
	["ImageListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"]
};
	["ImageListItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ImageListItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createFrontPage:ModelTypes["FrontPageCreateResult"],
	deleteFrontPage:ModelTypes["FrontPageDeleteResult"],
	updateFrontPage:ModelTypes["FrontPageUpdateResult"],
	upsertFrontPage:ModelTypes["FrontPageUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createLocale:ModelTypes["LocaleCreateResult"],
	deleteLocale:ModelTypes["LocaleDeleteResult"],
	updateLocale:ModelTypes["LocaleUpdateResult"],
	upsertLocale:ModelTypes["LocaleUpsertResult"],
	createFrontPageLocale:ModelTypes["FrontPageLocaleCreateResult"],
	deleteFrontPageLocale:ModelTypes["FrontPageLocaleDeleteResult"],
	updateFrontPageLocale:ModelTypes["FrontPageLocaleUpdateResult"],
	upsertFrontPageLocale:ModelTypes["FrontPageLocaleUpsertResult"],
	createLinkList:ModelTypes["LinkListCreateResult"],
	deleteLinkList:ModelTypes["LinkListDeleteResult"],
	updateLinkList:ModelTypes["LinkListUpdateResult"],
	upsertLinkList:ModelTypes["LinkListUpsertResult"],
	createLinkItem:ModelTypes["LinkItemCreateResult"],
	deleteLinkItem:ModelTypes["LinkItemDeleteResult"],
	updateLinkItem:ModelTypes["LinkItemUpdateResult"],
	upsertLinkItem:ModelTypes["LinkItemUpsertResult"],
	createSocialLinkList:ModelTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList:ModelTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList:ModelTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList:ModelTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem:ModelTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem:ModelTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem:ModelTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem:ModelTypes["SocialLinkItemUpsertResult"],
	createPrimaryLinkItem:ModelTypes["PrimaryLinkItemCreateResult"],
	deletePrimaryLinkItem:ModelTypes["PrimaryLinkItemDeleteResult"],
	updatePrimaryLinkItem:ModelTypes["PrimaryLinkItemUpdateResult"],
	upsertPrimaryLinkItem:ModelTypes["PrimaryLinkItemUpsertResult"],
	createHeaderLocale:ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale:ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale:ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale:ModelTypes["HeaderLocaleUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterLocale:ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale:ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale:ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale:ModelTypes["FooterLocaleUpsertResult"],
	createFooterLinks:ModelTypes["FooterLinksCreateResult"],
	deleteFooterLinks:ModelTypes["FooterLinksDeleteResult"],
	updateFooterLinks:ModelTypes["FooterLinksUpdateResult"],
	upsertFooterLinks:ModelTypes["FooterLinksUpsertResult"],
	createFooterContact:ModelTypes["FooterContactCreateResult"],
	deleteFooterContact:ModelTypes["FooterContactDeleteResult"],
	updateFooterContact:ModelTypes["FooterContactUpdateResult"],
	upsertFooterContact:ModelTypes["FooterContactUpsertResult"],
	createTitleList:ModelTypes["TitleListCreateResult"],
	deleteTitleList:ModelTypes["TitleListDeleteResult"],
	updateTitleList:ModelTypes["TitleListUpdateResult"],
	upsertTitleList:ModelTypes["TitleListUpsertResult"],
	createTitleItem:ModelTypes["TitleItemCreateResult"],
	deleteTitleItem:ModelTypes["TitleItemDeleteResult"],
	updateTitleItem:ModelTypes["TitleItemUpdateResult"],
	upsertTitleItem:ModelTypes["TitleItemUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createSecondaryLinkList:ModelTypes["SecondaryLinkListCreateResult"],
	deleteSecondaryLinkList:ModelTypes["SecondaryLinkListDeleteResult"],
	updateSecondaryLinkList:ModelTypes["SecondaryLinkListUpdateResult"],
	upsertSecondaryLinkList:ModelTypes["SecondaryLinkListUpsertResult"],
	createSecondaryLinkItem:ModelTypes["SecondaryLinkItemCreateResult"],
	deleteSecondaryLinkItem:ModelTypes["SecondaryLinkItemDeleteResult"],
	updateSecondaryLinkItem:ModelTypes["SecondaryLinkItemUpdateResult"],
	upsertSecondaryLinkItem:ModelTypes["SecondaryLinkItemUpsertResult"],
	createRestaurant:ModelTypes["RestaurantCreateResult"],
	deleteRestaurant:ModelTypes["RestaurantDeleteResult"],
	updateRestaurant:ModelTypes["RestaurantUpdateResult"],
	upsertRestaurant:ModelTypes["RestaurantUpsertResult"],
	createRestaurantLocale:ModelTypes["RestaurantLocaleCreateResult"],
	deleteRestaurantLocale:ModelTypes["RestaurantLocaleDeleteResult"],
	updateRestaurantLocale:ModelTypes["RestaurantLocaleUpdateResult"],
	upsertRestaurantLocale:ModelTypes["RestaurantLocaleUpsertResult"],
	createTranslationDomain:ModelTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain:ModelTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain:ModelTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain:ModelTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue:ModelTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue:ModelTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue:ModelTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue:ModelTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey:ModelTypes["TranslationKeyCreateResult"],
	deleteTranslationKey:ModelTypes["TranslationKeyDeleteResult"],
	updateTranslationKey:ModelTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey:ModelTypes["TranslationKeyUpsertResult"],
	createTranslationValue:ModelTypes["TranslationValueCreateResult"],
	deleteTranslationValue:ModelTypes["TranslationValueDeleteResult"],
	updateTranslationValue:ModelTypes["TranslationValueUpdateResult"],
	upsertTranslationValue:ModelTypes["TranslationValueUpsertResult"],
	createRestaurantItem:ModelTypes["RestaurantItemCreateResult"],
	deleteRestaurantItem:ModelTypes["RestaurantItemDeleteResult"],
	updateRestaurantItem:ModelTypes["RestaurantItemUpdateResult"],
	upsertRestaurantItem:ModelTypes["RestaurantItemUpsertResult"],
	createRestaurantTag:ModelTypes["RestaurantTagCreateResult"],
	deleteRestaurantTag:ModelTypes["RestaurantTagDeleteResult"],
	updateRestaurantTag:ModelTypes["RestaurantTagUpdateResult"],
	upsertRestaurantTag:ModelTypes["RestaurantTagUpsertResult"],
	createRestaurantTagLocale:ModelTypes["RestaurantTagLocaleCreateResult"],
	deleteRestaurantTagLocale:ModelTypes["RestaurantTagLocaleDeleteResult"],
	updateRestaurantTagLocale:ModelTypes["RestaurantTagLocaleUpdateResult"],
	upsertRestaurantTagLocale:ModelTypes["RestaurantTagLocaleUpsertResult"],
	createBanner:ModelTypes["BannerCreateResult"],
	deleteBanner:ModelTypes["BannerDeleteResult"],
	updateBanner:ModelTypes["BannerUpdateResult"],
	upsertBanner:ModelTypes["BannerUpsertResult"],
	createBannerLocale:ModelTypes["BannerLocaleCreateResult"],
	deleteBannerLocale:ModelTypes["BannerLocaleDeleteResult"],
	updateBannerLocale:ModelTypes["BannerLocaleUpdateResult"],
	upsertBannerLocale:ModelTypes["BannerLocaleUpsertResult"],
	createCategory:ModelTypes["CategoryCreateResult"],
	deleteCategory:ModelTypes["CategoryDeleteResult"],
	updateCategory:ModelTypes["CategoryUpdateResult"],
	upsertCategory:ModelTypes["CategoryUpsertResult"],
	createCategoryLocale:ModelTypes["CategoryLocaleCreateResult"],
	deleteCategoryLocale:ModelTypes["CategoryLocaleDeleteResult"],
	updateCategoryLocale:ModelTypes["CategoryLocaleUpdateResult"],
	upsertCategoryLocale:ModelTypes["CategoryLocaleUpsertResult"],
	createSubRestaurantsPage:ModelTypes["SubRestaurantsPageCreateResult"],
	deleteSubRestaurantsPage:ModelTypes["SubRestaurantsPageDeleteResult"],
	updateSubRestaurantsPage:ModelTypes["SubRestaurantsPageUpdateResult"],
	upsertSubRestaurantsPage:ModelTypes["SubRestaurantsPageUpsertResult"],
	createSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleCreateResult"],
	deleteSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleDeleteResult"],
	updateSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleUpdateResult"],
	upsertSubRestaurantsPageLocale:ModelTypes["SubRestaurantsPageLocaleUpsertResult"],
	createImageList:ModelTypes["ImageListCreateResult"],
	deleteImageList:ModelTypes["ImageListDeleteResult"],
	updateImageList:ModelTypes["ImageListUpdateResult"],
	upsertImageList:ModelTypes["ImageListUpsertResult"],
	createImageListItem:ModelTypes["ImageListItemCreateResult"],
	deleteImageListItem:ModelTypes["ImageListItemDeleteResult"],
	updateImageListItem:ModelTypes["ImageListItemUpdateResult"],
	upsertImageListItem:ModelTypes["ImageListItemUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getFrontPage?: GraphQLTypes["FrontPage"],
	listFrontPage: Array<GraphQLTypes["FrontPage"]>,
	paginateFrontPage: GraphQLTypes["FrontPageConnection"],
	validateCreateFrontPage: GraphQLTypes["_ValidationResult"],
	validateUpdateFrontPage: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"],
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getFrontPageLocale?: GraphQLTypes["FrontPageLocale"],
	listFrontPageLocale: Array<GraphQLTypes["FrontPageLocale"]>,
	paginateFrontPageLocale: GraphQLTypes["FrontPageLocaleConnection"],
	validateCreateFrontPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFrontPageLocale: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"],
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"],
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getSocialLinkList?: GraphQLTypes["SocialLinkList"],
	listSocialLinkList: Array<GraphQLTypes["SocialLinkList"]>,
	paginateSocialLinkList: GraphQLTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkList: GraphQLTypes["_ValidationResult"],
	getSocialLinkItem?: GraphQLTypes["SocialLinkItem"],
	listSocialLinkItem: Array<GraphQLTypes["SocialLinkItem"]>,
	paginateSocialLinkItem: GraphQLTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	getPrimaryLinkItem?: GraphQLTypes["PrimaryLinkItem"],
	listPrimaryLinkItem: Array<GraphQLTypes["PrimaryLinkItem"]>,
	paginatePrimaryLinkItem: GraphQLTypes["PrimaryLinkItemConnection"],
	validateCreatePrimaryLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePrimaryLinkItem: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"],
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"],
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getFooterLinks?: GraphQLTypes["FooterLinks"],
	listFooterLinks: Array<GraphQLTypes["FooterLinks"]>,
	paginateFooterLinks: GraphQLTypes["FooterLinksConnection"],
	validateCreateFooterLinks: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLinks: GraphQLTypes["_ValidationResult"],
	getFooterContact?: GraphQLTypes["FooterContact"],
	listFooterContact: Array<GraphQLTypes["FooterContact"]>,
	paginateFooterContact: GraphQLTypes["FooterContactConnection"],
	validateCreateFooterContact: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterContact: GraphQLTypes["_ValidationResult"],
	getTitleList?: GraphQLTypes["TitleList"],
	listTitleList: Array<GraphQLTypes["TitleList"]>,
	paginateTitleList: GraphQLTypes["TitleListConnection"],
	validateCreateTitleList: GraphQLTypes["_ValidationResult"],
	validateUpdateTitleList: GraphQLTypes["_ValidationResult"],
	getTitleItem?: GraphQLTypes["TitleItem"],
	listTitleItem: Array<GraphQLTypes["TitleItem"]>,
	paginateTitleItem: GraphQLTypes["TitleItemConnection"],
	validateCreateTitleItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTitleItem: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getSecondaryLinkList?: GraphQLTypes["SecondaryLinkList"],
	listSecondaryLinkList: Array<GraphQLTypes["SecondaryLinkList"]>,
	paginateSecondaryLinkList: GraphQLTypes["SecondaryLinkListConnection"],
	validateCreateSecondaryLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSecondaryLinkList: GraphQLTypes["_ValidationResult"],
	getSecondaryLinkItem?: GraphQLTypes["SecondaryLinkItem"],
	listSecondaryLinkItem: Array<GraphQLTypes["SecondaryLinkItem"]>,
	paginateSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemConnection"],
	validateCreateSecondaryLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSecondaryLinkItem: GraphQLTypes["_ValidationResult"],
	getRestaurant?: GraphQLTypes["Restaurant"],
	listRestaurant: Array<GraphQLTypes["Restaurant"]>,
	paginateRestaurant: GraphQLTypes["RestaurantConnection"],
	validateCreateRestaurant: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurant: GraphQLTypes["_ValidationResult"],
	getRestaurantLocale?: GraphQLTypes["RestaurantLocale"],
	listRestaurantLocale: Array<GraphQLTypes["RestaurantLocale"]>,
	paginateRestaurantLocale: GraphQLTypes["RestaurantLocaleConnection"],
	validateCreateRestaurantLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantLocale: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"],
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"],
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"],
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"],
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getRestaurantItem?: GraphQLTypes["RestaurantItem"],
	listRestaurantItem: Array<GraphQLTypes["RestaurantItem"]>,
	paginateRestaurantItem: GraphQLTypes["RestaurantItemConnection"],
	validateCreateRestaurantItem: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantItem: GraphQLTypes["_ValidationResult"],
	getRestaurantTag?: GraphQLTypes["RestaurantTag"],
	listRestaurantTag: Array<GraphQLTypes["RestaurantTag"]>,
	paginateRestaurantTag: GraphQLTypes["RestaurantTagConnection"],
	validateCreateRestaurantTag: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantTag: GraphQLTypes["_ValidationResult"],
	getRestaurantTagLocale?: GraphQLTypes["RestaurantTagLocale"],
	listRestaurantTagLocale: Array<GraphQLTypes["RestaurantTagLocale"]>,
	paginateRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleConnection"],
	validateCreateRestaurantTagLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantTagLocale: GraphQLTypes["_ValidationResult"],
	getBanner?: GraphQLTypes["Banner"],
	listBanner: Array<GraphQLTypes["Banner"]>,
	paginateBanner: GraphQLTypes["BannerConnection"],
	validateCreateBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateBanner: GraphQLTypes["_ValidationResult"],
	getBannerLocale?: GraphQLTypes["BannerLocale"],
	listBannerLocale: Array<GraphQLTypes["BannerLocale"]>,
	paginateBannerLocale: GraphQLTypes["BannerLocaleConnection"],
	validateCreateBannerLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBannerLocale: GraphQLTypes["_ValidationResult"],
	getCategory?: GraphQLTypes["Category"],
	listCategory: Array<GraphQLTypes["Category"]>,
	paginateCategory: GraphQLTypes["CategoryConnection"],
	validateCreateCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateCategory: GraphQLTypes["_ValidationResult"],
	getCategoryLocale?: GraphQLTypes["CategoryLocale"],
	listCategoryLocale: Array<GraphQLTypes["CategoryLocale"]>,
	paginateCategoryLocale: GraphQLTypes["CategoryLocaleConnection"],
	validateCreateCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateCategoryLocale: GraphQLTypes["_ValidationResult"],
	getSubRestaurantsPage?: GraphQLTypes["SubRestaurantsPage"],
	listSubRestaurantsPage: Array<GraphQLTypes["SubRestaurantsPage"]>,
	paginateSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageConnection"],
	validateCreateSubRestaurantsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPage: GraphQLTypes["_ValidationResult"],
	getSubRestaurantsPageLocale?: GraphQLTypes["SubRestaurantsPageLocale"],
	listSubRestaurantsPageLocale: Array<GraphQLTypes["SubRestaurantsPageLocale"]>,
	paginateSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleConnection"],
	validateCreateSubRestaurantsPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPageLocale: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"],
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"],
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["FrontPage"]: {
	__typename: "FrontPage",
	_meta?: GraphQLTypes["FrontPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["FrontPageLocale"]>,
	banner?: GraphQLTypes["Banner"],
	localesByLocale?: GraphQLTypes["FrontPageLocale"],
	localesByLink?: GraphQLTypes["FrontPageLocale"],
	localesBySeo?: GraphQLTypes["FrontPageLocale"],
	paginateLocales: GraphQLTypes["FrontPageLocaleConnection"]
};
	["FrontPageMeta"]: {
	__typename: "FrontPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	banner?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:any;
	["One"]: One;
	["FrontPageLocale"]: {
	__typename: "FrontPageLocale",
	_meta?: GraphQLTypes["FrontPageLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	root?: GraphQLTypes["FrontPage"],
	locale?: GraphQLTypes["Locale"],
	seo?: GraphQLTypes["Seo"],
	socialLinks?: string
};
	["FrontPageLocaleMeta"]: {
	__typename: "FrontPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	socialLinks?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	frontPage?: GraphQLTypes["FrontPageLocale"],
	subRestaurantsPage?: GraphQLTypes["SubRestaurantsPageLocale"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	frontPage?: GraphQLTypes["FieldMeta"],
	subRestaurantsPage?: GraphQLTypes["FieldMeta"]
};
	["FrontPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	root?: GraphQLTypes["FrontPageWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	socialLinks?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["FrontPageLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["FrontPageLocaleWhere"] | undefined>,
	not?: GraphQLTypes["FrontPageLocaleWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	frontPage?: GraphQLTypes["FrontPageLocaleWhere"],
	subRestaurantsPage?: GraphQLTypes["SubRestaurantsPageLocaleWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["SubRestaurantsPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	root?: GraphQLTypes["SubRestaurantsPageWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["SubRestaurantsPageLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["SubRestaurantsPageLocaleWhere"] | undefined>,
	not?: GraphQLTypes["SubRestaurantsPageLocaleWhere"]
};
	["SubRestaurantsPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	locales?: GraphQLTypes["SubRestaurantsPageLocaleWhere"],
	order?: GraphQLTypes["IntCondition"],
	parentRestaurant?: GraphQLTypes["RestaurantWhere"],
	and?: Array<GraphQLTypes["SubRestaurantsPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["SubRestaurantsPageWhere"] | undefined>,
	not?: GraphQLTypes["SubRestaurantsPageWhere"]
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["RestaurantWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	locales?: GraphQLTypes["RestaurantLocaleWhere"],
	image?: GraphQLTypes["ImageWhere"],
	subItems?: GraphQLTypes["RestaurantItemWhere"],
	order?: GraphQLTypes["IntCondition"],
	item?: GraphQLTypes["RestaurantItemWhere"],
	openingHours?: GraphQLTypes["StringCondition"],
	tags?: GraphQLTypes["RestaurantTagWhere"],
	categories?: GraphQLTypes["CategoryWhere"],
	and?: Array<GraphQLTypes["RestaurantWhere"] | undefined>,
	or?: Array<GraphQLTypes["RestaurantWhere"] | undefined>,
	not?: GraphQLTypes["RestaurantWhere"]
};
	["RestaurantLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["RestaurantWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	description?: GraphQLTypes["StringCondition"],
	url?: GraphQLTypes["StringCondition"],
	location?: GraphQLTypes["StringCondition"],
	isEshopActive?: GraphQLTypes["BooleanCondition"],
	isDeliveryActive?: GraphQLTypes["BooleanCondition"],
	secondaryUrl?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["RestaurantLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["RestaurantLocaleWhere"] | undefined>,
	not?: GraphQLTypes["RestaurantLocaleWhere"]
};
	["LocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	code?: GraphQLTypes["StringCondition"],
	label?: GraphQLTypes["StringCondition"],
	frontPages?: GraphQLTypes["FrontPageLocaleWhere"],
	headers?: GraphQLTypes["HeaderLocaleWhere"],
	footers?: GraphQLTypes["FooterLocaleWhere"],
	restaurants?: GraphQLTypes["RestaurantLocaleWhere"],
	restaurantTags?: GraphQLTypes["RestaurantTagLocaleWhere"],
	banners?: GraphQLTypes["BannerLocaleWhere"],
	categories?: GraphQLTypes["CategoryLocaleWhere"],
	subRestaurantsPages?: GraphQLTypes["SubRestaurantsPageLocaleWhere"],
	and?: Array<GraphQLTypes["LocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["LocaleWhere"] | undefined>,
	not?: GraphQLTypes["LocaleWhere"]
};
	["HeaderLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	menuButtonText?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["HeaderWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	socialLinks?: GraphQLTypes["SocialLinkListWhere"],
	primaryLinkItems?: GraphQLTypes["PrimaryLinkItemWhere"],
	secondaryLinks?: GraphQLTypes["SecondaryLinkListWhere"],
	and?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined>,
	not?: GraphQLTypes["HeaderLocaleWhere"]
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	logo?: GraphQLTypes["ImageWhere"],
	locales?: GraphQLTypes["HeaderLocaleWhere"],
	navigationLogo?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	not?: GraphQLTypes["HeaderWhere"]
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	fileName?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["SocialLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["SocialLinkItemWhere"],
	and?: Array<GraphQLTypes["SocialLinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkListWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkListWhere"]
};
	["SocialLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["SocialLinkListWhere"],
	socialLink?: GraphQLTypes["SocialLinkWhere"],
	and?: Array<GraphQLTypes["SocialLinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkItemWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkItemWhere"]
};
	["SocialLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["SocialLinkTypeCondition"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkWhere"]
};
	["SocialLinkTypeCondition"]: {
		and?: Array<GraphQLTypes["SocialLinkTypeCondition"]>,
	or?: Array<GraphQLTypes["SocialLinkTypeCondition"]>,
	not?: GraphQLTypes["SocialLinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["SocialLinkType"],
	notEq?: GraphQLTypes["SocialLinkType"],
	in?: Array<GraphQLTypes["SocialLinkType"]>,
	notIn?: Array<GraphQLTypes["SocialLinkType"]>,
	lt?: GraphQLTypes["SocialLinkType"],
	lte?: GraphQLTypes["SocialLinkType"],
	gt?: GraphQLTypes["SocialLinkType"],
	gte?: GraphQLTypes["SocialLinkType"]
};
	["SocialLinkType"]: SocialLinkType;
	["PrimaryLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	parent?: GraphQLTypes["PrimaryLinkItemWhere"],
	subItems?: GraphQLTypes["PrimaryLinkItemWhere"],
	header?: GraphQLTypes["HeaderLocaleWhere"],
	and?: Array<GraphQLTypes["PrimaryLinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["PrimaryLinkItemWhere"] | undefined>,
	not?: GraphQLTypes["PrimaryLinkItemWhere"]
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	title?: GraphQLTypes["StringCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	internalLink?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["SecondaryLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["SecondaryLinkItemWhere"],
	and?: Array<GraphQLTypes["SecondaryLinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["SecondaryLinkListWhere"] | undefined>,
	not?: GraphQLTypes["SecondaryLinkListWhere"]
};
	["SecondaryLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	iconType?: GraphQLTypes["IconTypeCondition"],
	list?: GraphQLTypes["SecondaryLinkListWhere"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["SecondaryLinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["SecondaryLinkItemWhere"] | undefined>,
	not?: GraphQLTypes["SecondaryLinkItemWhere"]
};
	["IconTypeCondition"]: {
		and?: Array<GraphQLTypes["IconTypeCondition"]>,
	or?: Array<GraphQLTypes["IconTypeCondition"]>,
	not?: GraphQLTypes["IconTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["IconType"],
	notEq?: GraphQLTypes["IconType"],
	in?: Array<GraphQLTypes["IconType"]>,
	notIn?: Array<GraphQLTypes["IconType"]>,
	lt?: GraphQLTypes["IconType"],
	lte?: GraphQLTypes["IconType"],
	gt?: GraphQLTypes["IconType"],
	gte?: GraphQLTypes["IconType"]
};
	["IconType"]: IconType;
	["FooterLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	root?: GraphQLTypes["FooterWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	linksSection?: GraphQLTypes["FooterLinksWhere"],
	contactSection?: GraphQLTypes["FooterContactWhere"],
	and?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined>,
	not?: GraphQLTypes["FooterLocaleWhere"]
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	logo?: GraphQLTypes["ImageWhere"],
	locales?: GraphQLTypes["FooterLocaleWhere"],
	and?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	not?: GraphQLTypes["FooterWhere"]
};
	["FooterLinksWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	buttonsTitle?: GraphQLTypes["StringCondition"],
	linkList?: GraphQLTypes["LinkListWhere"],
	buttons?: GraphQLTypes["LinkListWhere"],
	titleList?: GraphQLTypes["TitleListWhere"],
	and?: Array<GraphQLTypes["FooterLinksWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterLinksWhere"] | undefined>,
	not?: GraphQLTypes["FooterLinksWhere"]
};
	["LinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["LinkItemWhere"],
	and?: Array<GraphQLTypes["LinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkListWhere"] | undefined>,
	not?: GraphQLTypes["LinkListWhere"]
};
	["LinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["LinkListWhere"],
	link?: GraphQLTypes["LinkWhere"],
	icon?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["LinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkItemWhere"] | undefined>,
	not?: GraphQLTypes["LinkItemWhere"]
};
	["TitleListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["TitleItemWhere"],
	and?: Array<GraphQLTypes["TitleListWhere"] | undefined>,
	or?: Array<GraphQLTypes["TitleListWhere"] | undefined>,
	not?: GraphQLTypes["TitleListWhere"]
};
	["TitleItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["TitleListWhere"],
	icon?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["TitleItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["TitleItemWhere"] | undefined>,
	not?: GraphQLTypes["TitleItemWhere"]
};
	["FooterContactWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	email?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	note?: GraphQLTypes["StringCondition"],
	openingHours?: GraphQLTypes["StringCondition"],
	identificationNumber?: GraphQLTypes["StringCondition"],
	valueAddedTaxNumber?: GraphQLTypes["StringCondition"],
	bussinessRegister?: GraphQLTypes["StringCondition"],
	phoneImage?: GraphQLTypes["ImageWhere"],
	address?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["FooterContactWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterContactWhere"] | undefined>,
	not?: GraphQLTypes["FooterContactWhere"]
};
	["RestaurantTagLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["RestaurantTagWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	and?: Array<GraphQLTypes["RestaurantTagLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["RestaurantTagLocaleWhere"] | undefined>,
	not?: GraphQLTypes["RestaurantTagLocaleWhere"]
};
	["RestaurantTagWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	locales?: GraphQLTypes["RestaurantTagLocaleWhere"],
	backgroundColor?: GraphQLTypes["StringCondition"],
	titleColor?: GraphQLTypes["StringCondition"],
	restaurants?: GraphQLTypes["RestaurantWhere"],
	and?: Array<GraphQLTypes["RestaurantTagWhere"] | undefined>,
	or?: Array<GraphQLTypes["RestaurantTagWhere"] | undefined>,
	not?: GraphQLTypes["RestaurantTagWhere"]
};
	["BannerLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	text?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["BannerWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	title?: GraphQLTypes["StringCondition"],
	url?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["BannerLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["BannerLocaleWhere"] | undefined>,
	not?: GraphQLTypes["BannerLocaleWhere"]
};
	["BannerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	image?: GraphQLTypes["ImageWhere"],
	locales?: GraphQLTypes["BannerLocaleWhere"],
	order?: GraphQLTypes["IntCondition"],
	textColor?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["BannerWhere"] | undefined>,
	or?: Array<GraphQLTypes["BannerWhere"] | undefined>,
	not?: GraphQLTypes["BannerWhere"]
};
	["CategoryLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["CategoryWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	slug?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["CategoryLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["CategoryLocaleWhere"] | undefined>,
	not?: GraphQLTypes["CategoryLocaleWhere"]
};
	["CategoryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	locales?: GraphQLTypes["CategoryLocaleWhere"],
	restaurants?: GraphQLTypes["RestaurantWhere"],
	and?: Array<GraphQLTypes["CategoryWhere"] | undefined>,
	or?: Array<GraphQLTypes["CategoryWhere"] | undefined>,
	not?: GraphQLTypes["CategoryWhere"]
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["RestaurantItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	parent?: GraphQLTypes["RestaurantWhere"],
	order?: GraphQLTypes["IntCondition"],
	restaurant?: GraphQLTypes["RestaurantWhere"],
	and?: Array<GraphQLTypes["RestaurantItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["RestaurantItemWhere"] | undefined>,
	not?: GraphQLTypes["RestaurantItemWhere"]
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	noIndex?: GraphQLTypes["BooleanCondition"],
	noFollow?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["FrontPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["FrontPageLocaleWhere"],
	banner?: GraphQLTypes["BannerWhere"],
	and?: Array<GraphQLTypes["FrontPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["FrontPageWhere"] | undefined>,
	not?: GraphQLTypes["FrontPageWhere"]
};
	["SubRestaurantsPageLocale"]: {
	__typename: "SubRestaurantsPageLocale",
	_meta?: GraphQLTypes["SubRestaurantsPageLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	root?: GraphQLTypes["SubRestaurantsPage"],
	locale?: GraphQLTypes["Locale"],
	seo?: GraphQLTypes["Seo"]
};
	["SubRestaurantsPageLocaleMeta"]: {
	__typename: "SubRestaurantsPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["SubRestaurantsPage"]: {
	__typename: "SubRestaurantsPage",
	_meta?: GraphQLTypes["SubRestaurantsPageMeta"],
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["SubRestaurantsPageLocale"]>,
	order: number,
	parentRestaurant?: GraphQLTypes["Restaurant"],
	localesByLocale?: GraphQLTypes["SubRestaurantsPageLocale"],
	localesByLink?: GraphQLTypes["SubRestaurantsPageLocale"],
	localesBySeo?: GraphQLTypes["SubRestaurantsPageLocale"],
	paginateLocales: GraphQLTypes["SubRestaurantsPageLocaleConnection"]
};
	["SubRestaurantsPageMeta"]: {
	__typename: "SubRestaurantsPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	parentRestaurant?: GraphQLTypes["FieldMeta"]
};
	["SubRestaurantsPageLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	root?: GraphQLTypes["SubRestaurantsPageOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["OrderDirection"]: OrderDirection;
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	frontPage?: GraphQLTypes["FrontPageLocaleOrderBy"],
	subRestaurantsPage?: GraphQLTypes["SubRestaurantsPageLocaleOrderBy"]
};
	["FrontPageLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	root?: GraphQLTypes["FrontPageOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	socialLinks?: GraphQLTypes["OrderDirection"]
};
	["FrontPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	banner?: GraphQLTypes["BannerOrderBy"]
};
	["BannerOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	textColor?: GraphQLTypes["OrderDirection"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"],
	fileName?: GraphQLTypes["OrderDirection"]
};
	["LocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	code?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"],
	noIndex?: GraphQLTypes["OrderDirection"],
	noFollow?: GraphQLTypes["OrderDirection"]
};
	["SubRestaurantsPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	parentRestaurant?: GraphQLTypes["RestaurantOrderBy"]
};
	["RestaurantOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	item?: GraphQLTypes["RestaurantItemOrderBy"],
	openingHours?: GraphQLTypes["OrderDirection"]
};
	["RestaurantItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	parent?: GraphQLTypes["RestaurantOrderBy"],
	order?: GraphQLTypes["OrderDirection"],
	restaurant?: GraphQLTypes["RestaurantOrderBy"]
};
	["Restaurant"]: {
	__typename: "Restaurant",
	_meta?: GraphQLTypes["RestaurantMeta"],
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["RestaurantLocale"]>,
	image?: GraphQLTypes["Image"],
	subItems: Array<GraphQLTypes["RestaurantItem"]>,
	order: number,
	item?: GraphQLTypes["RestaurantItem"],
	openingHours?: string,
	tags: Array<GraphQLTypes["RestaurantTag"]>,
	categories: Array<GraphQLTypes["Category"]>,
	localesByLocale?: GraphQLTypes["RestaurantLocale"],
	subItemsByRestaurant?: GraphQLTypes["RestaurantItem"],
	paginateLocales: GraphQLTypes["RestaurantLocaleConnection"],
	paginateSubItems: GraphQLTypes["RestaurantItemConnection"],
	paginateTags: GraphQLTypes["RestaurantTagConnection"],
	paginateCategories: GraphQLTypes["CategoryConnection"]
};
	["RestaurantMeta"]: {
	__typename: "RestaurantMeta",
	id?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	subItems?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	item?: GraphQLTypes["FieldMeta"],
	openingHours?: GraphQLTypes["FieldMeta"],
	tags?: GraphQLTypes["FieldMeta"],
	categories?: GraphQLTypes["FieldMeta"]
};
	["RestaurantLocale"]: {
	__typename: "RestaurantLocale",
	_meta?: GraphQLTypes["RestaurantLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["Restaurant"],
	locale?: GraphQLTypes["Locale"],
	description?: string,
	url?: string,
	location?: string,
	isEshopActive: boolean,
	isDeliveryActive: boolean,
	secondaryUrl?: string
};
	["RestaurantLocaleMeta"]: {
	__typename: "RestaurantLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	location?: GraphQLTypes["FieldMeta"],
	isEshopActive?: GraphQLTypes["FieldMeta"],
	isDeliveryActive?: GraphQLTypes["FieldMeta"],
	secondaryUrl?: GraphQLTypes["FieldMeta"]
};
	["Locale"]: {
	__typename: "Locale",
	_meta?: GraphQLTypes["LocaleMeta"],
	id: GraphQLTypes["UUID"],
	code: string,
	label?: string,
	frontPages: Array<GraphQLTypes["FrontPageLocale"]>,
	headers: Array<GraphQLTypes["HeaderLocale"]>,
	footers: Array<GraphQLTypes["FooterLocale"]>,
	restaurants: Array<GraphQLTypes["RestaurantLocale"]>,
	restaurantTags: Array<GraphQLTypes["RestaurantTagLocale"]>,
	banners: Array<GraphQLTypes["BannerLocale"]>,
	categories: Array<GraphQLTypes["CategoryLocale"]>,
	subRestaurantsPages: Array<GraphQLTypes["SubRestaurantsPageLocale"]>,
	frontPagesByRoot?: GraphQLTypes["FrontPageLocale"],
	frontPagesByLink?: GraphQLTypes["FrontPageLocale"],
	frontPagesBySeo?: GraphQLTypes["FrontPageLocale"],
	headersByRoot?: GraphQLTypes["HeaderLocale"],
	headersBySocialLinks?: GraphQLTypes["HeaderLocale"],
	headersByPrimaryLinkItems?: GraphQLTypes["HeaderLocale"],
	headersBySecondaryLinks?: GraphQLTypes["HeaderLocale"],
	footersByRoot?: GraphQLTypes["FooterLocale"],
	footersByLinksSection?: GraphQLTypes["FooterLocale"],
	footersByContactSection?: GraphQLTypes["FooterLocale"],
	restaurantsByRoot?: GraphQLTypes["RestaurantLocale"],
	restaurantTagsByRoot?: GraphQLTypes["RestaurantTagLocale"],
	bannersByRoot?: GraphQLTypes["BannerLocale"],
	categoriesByRoot?: GraphQLTypes["CategoryLocale"],
	categoriesBySlug?: GraphQLTypes["CategoryLocale"],
	subRestaurantsPagesByRoot?: GraphQLTypes["SubRestaurantsPageLocale"],
	subRestaurantsPagesByLink?: GraphQLTypes["SubRestaurantsPageLocale"],
	subRestaurantsPagesBySeo?: GraphQLTypes["SubRestaurantsPageLocale"],
	paginateFrontPages: GraphQLTypes["FrontPageLocaleConnection"],
	paginateHeaders: GraphQLTypes["HeaderLocaleConnection"],
	paginateFooters: GraphQLTypes["FooterLocaleConnection"],
	paginateRestaurants: GraphQLTypes["RestaurantLocaleConnection"],
	paginateRestaurantTags: GraphQLTypes["RestaurantTagLocaleConnection"],
	paginateBanners: GraphQLTypes["BannerLocaleConnection"],
	paginateCategories: GraphQLTypes["CategoryLocaleConnection"],
	paginateSubRestaurantsPages: GraphQLTypes["SubRestaurantsPageLocaleConnection"]
};
	["LocaleMeta"]: {
	__typename: "LocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	code?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	frontPages?: GraphQLTypes["FieldMeta"],
	headers?: GraphQLTypes["FieldMeta"],
	footers?: GraphQLTypes["FieldMeta"],
	restaurants?: GraphQLTypes["FieldMeta"],
	restaurantTags?: GraphQLTypes["FieldMeta"],
	banners?: GraphQLTypes["FieldMeta"],
	categories?: GraphQLTypes["FieldMeta"],
	subRestaurantsPages?: GraphQLTypes["FieldMeta"]
};
	["HeaderLocale"]: {
	__typename: "HeaderLocale",
	_meta?: GraphQLTypes["HeaderLocaleMeta"],
	id: GraphQLTypes["UUID"],
	menuButtonText?: string,
	root?: GraphQLTypes["Header"],
	locale?: GraphQLTypes["Locale"],
	socialLinks?: GraphQLTypes["SocialLinkList"],
	primaryLinkItems: Array<GraphQLTypes["PrimaryLinkItem"]>,
	secondaryLinks?: GraphQLTypes["SecondaryLinkList"],
	primaryLinkItemsByLink?: GraphQLTypes["PrimaryLinkItem"],
	primaryLinkItemsBySubItems?: GraphQLTypes["PrimaryLinkItem"],
	paginatePrimaryLinkItems: GraphQLTypes["PrimaryLinkItemConnection"]
};
	["HeaderLocaleMeta"]: {
	__typename: "HeaderLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	menuButtonText?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	socialLinks?: GraphQLTypes["FieldMeta"],
	primaryLinkItems?: GraphQLTypes["FieldMeta"],
	secondaryLinks?: GraphQLTypes["FieldMeta"]
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	logo?: GraphQLTypes["Image"],
	locales: Array<GraphQLTypes["HeaderLocale"]>,
	navigationLogo?: GraphQLTypes["Image"],
	localesByLocale?: GraphQLTypes["HeaderLocale"],
	localesBySocialLinks?: GraphQLTypes["HeaderLocale"],
	localesByPrimaryLinkItems?: GraphQLTypes["HeaderLocale"],
	localesBySecondaryLinks?: GraphQLTypes["HeaderLocale"],
	paginateLocales: GraphQLTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	navigationLogo?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	fileName?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"],
	fileName?: GraphQLTypes["FieldMeta"]
};
	["HeaderLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	menuButtonText?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["HeaderOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	socialLinks?: GraphQLTypes["SocialLinkListOrderBy"],
	secondaryLinks?: GraphQLTypes["SecondaryLinkListOrderBy"]
};
	["HeaderOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"],
	navigationLogo?: GraphQLTypes["ImageOrderBy"]
};
	["SocialLinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["SecondaryLinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["LocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	frontPages?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	headers?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	footers?: GraphQLTypes["FooterLocaleUniqueWhere"],
	restaurants?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	restaurantTags?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	banners?: GraphQLTypes["BannerLocaleUniqueWhere"],
	categories?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	subRestaurantsPages?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"]
};
	["FrontPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["FrontPageUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["FrontPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	banner?: GraphQLTypes["BannerUniqueWhere"]
};
	["BannerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["BannerLocaleUniqueWhere"]
};
	["BannerLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["BannerUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	frontPage?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	subRestaurantsPage?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"]
};
	["SubRestaurantsPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SubRestaurantsPageUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SubRestaurantsPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	parentRestaurant?: GraphQLTypes["RestaurantUniqueWhere"]
};
	["RestaurantUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	subItems?: GraphQLTypes["RestaurantItemUniqueWhere"],
	item?: GraphQLTypes["RestaurantItemUniqueWhere"]
};
	["RestaurantLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["RestaurantUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["RestaurantItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	restaurant?: GraphQLTypes["RestaurantUniqueWhere"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["HeaderLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["HeaderUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	socialLinks?: GraphQLTypes["SocialLinkListUniqueWhere"],
	primaryLinkItems?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	secondaryLinks?: GraphQLTypes["SecondaryLinkListUniqueWhere"]
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["HeaderLocaleUniqueWhere"]
};
	["SocialLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["SocialLinkItemUniqueWhere"]
};
	["SocialLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	socialLink?: GraphQLTypes["SocialLinkUniqueWhere"]
};
	["SocialLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["PrimaryLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"],
	subItems?: GraphQLTypes["PrimaryLinkItemUniqueWhere"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SecondaryLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["SecondaryLinkItemUniqueWhere"]
};
	["SecondaryLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["FooterLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["FooterUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	linksSection?: GraphQLTypes["FooterLinksUniqueWhere"],
	contactSection?: GraphQLTypes["FooterContactUniqueWhere"]
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["FooterLocaleUniqueWhere"]
};
	["FooterLinksUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	linkList?: GraphQLTypes["LinkListUniqueWhere"],
	buttons?: GraphQLTypes["LinkListUniqueWhere"],
	titleList?: GraphQLTypes["TitleListUniqueWhere"]
};
	["LinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["LinkItemUniqueWhere"]
};
	["LinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["TitleListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["TitleItemUniqueWhere"]
};
	["TitleItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FooterContactUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["RestaurantTagLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["RestaurantTagUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["RestaurantTagUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"]
};
	["CategoryLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["CategoryUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	slug?: string
};
	["CategoryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["CategoryLocaleUniqueWhere"]
};
	["HeaderLocalesBySocialLinksUniqueWhere"]: {
		socialLinks?: GraphQLTypes["SocialLinkListUniqueWhere"]
};
	["HeaderLocalesByPrimaryLinkItemsUniqueWhere"]: {
		primaryLinkItems?: GraphQLTypes["PrimaryLinkItemUniqueWhere"]
};
	["HeaderLocalesBySecondaryLinksUniqueWhere"]: {
		secondaryLinks?: GraphQLTypes["SecondaryLinkListUniqueWhere"]
};
	["HeaderLocaleConnection"]: {
	__typename: "HeaderLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderLocaleEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["HeaderLocaleEdge"]: {
	__typename: "HeaderLocaleEdge",
	node: GraphQLTypes["HeaderLocale"]
};
	["SocialLinkList"]: {
	__typename: "SocialLinkList",
	_meta?: GraphQLTypes["SocialLinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["SocialLinkItem"]>,
	itemsBySocialLink?: GraphQLTypes["SocialLinkItem"],
	paginateItems: GraphQLTypes["SocialLinkItemConnection"]
};
	["SocialLinkListMeta"]: {
	__typename: "SocialLinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkItem"]: {
	__typename: "SocialLinkItem",
	_meta?: GraphQLTypes["SocialLinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["SocialLinkList"],
	socialLink?: GraphQLTypes["SocialLink"]
};
	["SocialLinkItemMeta"]: {
	__typename: "SocialLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	socialLink?: GraphQLTypes["FieldMeta"]
};
	["SocialLink"]: {
	__typename: "SocialLink",
	_meta?: GraphQLTypes["SocialLinkMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["SocialLinkType"],
	url?: string
};
	["SocialLinkMeta"]: {
	__typename: "SocialLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["SocialLinkListOrderBy"],
	socialLink?: GraphQLTypes["SocialLinkOrderBy"]
};
	["SocialLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["SocialLinkListItemsBySocialLinkUniqueWhere"]: {
		socialLink?: GraphQLTypes["SocialLinkUniqueWhere"]
};
	["SocialLinkItemConnection"]: {
	__typename: "SocialLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkItemEdge"]>
};
	["SocialLinkItemEdge"]: {
	__typename: "SocialLinkItemEdge",
	node: GraphQLTypes["SocialLinkItem"]
};
	["PrimaryLinkItem"]: {
	__typename: "PrimaryLinkItem",
	_meta?: GraphQLTypes["PrimaryLinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"],
	parent?: GraphQLTypes["PrimaryLinkItem"],
	subItems: Array<GraphQLTypes["PrimaryLinkItem"]>,
	header?: GraphQLTypes["HeaderLocale"],
	subItemsByLink?: GraphQLTypes["PrimaryLinkItem"],
	subItemsBySubItems?: GraphQLTypes["PrimaryLinkItem"],
	paginateSubItems: GraphQLTypes["PrimaryLinkItemConnection"]
};
	["PrimaryLinkItemMeta"]: {
	__typename: "PrimaryLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	parent?: GraphQLTypes["FieldMeta"],
	subItems?: GraphQLTypes["FieldMeta"],
	header?: GraphQLTypes["FieldMeta"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["Linkable"]
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	internalLink?: GraphQLTypes["FieldMeta"]
};
	["PrimaryLinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"],
	parent?: GraphQLTypes["PrimaryLinkItemOrderBy"],
	header?: GraphQLTypes["HeaderLocaleOrderBy"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	internalLink?: GraphQLTypes["LinkableOrderBy"]
};
	["PrimaryLinkItemSubItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["PrimaryLinkItemSubItemsBySubItemsUniqueWhere"]: {
		subItems?: GraphQLTypes["PrimaryLinkItemUniqueWhere"]
};
	["PrimaryLinkItemConnection"]: {
	__typename: "PrimaryLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PrimaryLinkItemEdge"]>
};
	["PrimaryLinkItemEdge"]: {
	__typename: "PrimaryLinkItemEdge",
	node: GraphQLTypes["PrimaryLinkItem"]
};
	["SecondaryLinkList"]: {
	__typename: "SecondaryLinkList",
	_meta?: GraphQLTypes["SecondaryLinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["SecondaryLinkItem"]>,
	itemsByLink?: GraphQLTypes["SecondaryLinkItem"],
	paginateItems: GraphQLTypes["SecondaryLinkItemConnection"]
};
	["SecondaryLinkListMeta"]: {
	__typename: "SecondaryLinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["SecondaryLinkItem"]: {
	__typename: "SecondaryLinkItem",
	_meta?: GraphQLTypes["SecondaryLinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	iconType?: GraphQLTypes["IconType"],
	list?: GraphQLTypes["SecondaryLinkList"],
	link?: GraphQLTypes["Link"]
};
	["SecondaryLinkItemMeta"]: {
	__typename: "SecondaryLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	iconType?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["SecondaryLinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	iconType?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["SecondaryLinkListOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["SecondaryLinkListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["SecondaryLinkItemConnection"]: {
	__typename: "SecondaryLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SecondaryLinkItemEdge"]>
};
	["SecondaryLinkItemEdge"]: {
	__typename: "SecondaryLinkItemEdge",
	node: GraphQLTypes["SecondaryLinkItem"]
};
	["HeaderLocalePrimaryLinkItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["HeaderLocalePrimaryLinkItemsBySubItemsUniqueWhere"]: {
		subItems?: GraphQLTypes["PrimaryLinkItemUniqueWhere"]
};
	["FooterLocale"]: {
	__typename: "FooterLocale",
	_meta?: GraphQLTypes["FooterLocaleMeta"],
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["Footer"],
	locale?: GraphQLTypes["Locale"],
	linksSection?: GraphQLTypes["FooterLinks"],
	contactSection?: GraphQLTypes["FooterContact"]
};
	["FooterLocaleMeta"]: {
	__typename: "FooterLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	linksSection?: GraphQLTypes["FieldMeta"],
	contactSection?: GraphQLTypes["FieldMeta"]
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	logo?: GraphQLTypes["Image"],
	locales: Array<GraphQLTypes["FooterLocale"]>,
	localesByLocale?: GraphQLTypes["FooterLocale"],
	localesByLinksSection?: GraphQLTypes["FooterLocale"],
	localesByContactSection?: GraphQLTypes["FooterLocale"],
	paginateLocales: GraphQLTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["FooterLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["FooterOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	linksSection?: GraphQLTypes["FooterLinksOrderBy"],
	contactSection?: GraphQLTypes["FooterContactOrderBy"]
};
	["FooterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"]
};
	["FooterLinksOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	buttonsTitle?: GraphQLTypes["OrderDirection"],
	linkList?: GraphQLTypes["LinkListOrderBy"],
	buttons?: GraphQLTypes["LinkListOrderBy"],
	titleList?: GraphQLTypes["TitleListOrderBy"]
};
	["LinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["TitleListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["FooterContactOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	note?: GraphQLTypes["OrderDirection"],
	openingHours?: GraphQLTypes["OrderDirection"],
	identificationNumber?: GraphQLTypes["OrderDirection"],
	valueAddedTaxNumber?: GraphQLTypes["OrderDirection"],
	bussinessRegister?: GraphQLTypes["OrderDirection"],
	phoneImage?: GraphQLTypes["ImageOrderBy"],
	address?: GraphQLTypes["OrderDirection"]
};
	["FooterLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["FooterLocalesByLinksSectionUniqueWhere"]: {
		linksSection?: GraphQLTypes["FooterLinksUniqueWhere"]
};
	["FooterLocalesByContactSectionUniqueWhere"]: {
		contactSection?: GraphQLTypes["FooterContactUniqueWhere"]
};
	["FooterLocaleConnection"]: {
	__typename: "FooterLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLocaleEdge"]>
};
	["FooterLocaleEdge"]: {
	__typename: "FooterLocaleEdge",
	node: GraphQLTypes["FooterLocale"]
};
	["FooterLinks"]: {
	__typename: "FooterLinks",
	_meta?: GraphQLTypes["FooterLinksMeta"],
	id: GraphQLTypes["UUID"],
	buttonsTitle?: string,
	linkList?: GraphQLTypes["LinkList"],
	buttons?: GraphQLTypes["LinkList"],
	titleList?: GraphQLTypes["TitleList"]
};
	["FooterLinksMeta"]: {
	__typename: "FooterLinksMeta",
	id?: GraphQLTypes["FieldMeta"],
	buttonsTitle?: GraphQLTypes["FieldMeta"],
	linkList?: GraphQLTypes["FieldMeta"],
	buttons?: GraphQLTypes["FieldMeta"],
	titleList?: GraphQLTypes["FieldMeta"]
};
	["LinkList"]: {
	__typename: "LinkList",
	_meta?: GraphQLTypes["LinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["LinkItem"]>,
	itemsByLink?: GraphQLTypes["LinkItem"],
	paginateItems: GraphQLTypes["LinkItemConnection"]
};
	["LinkListMeta"]: {
	__typename: "LinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["LinkItem"]: {
	__typename: "LinkItem",
	_meta?: GraphQLTypes["LinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["LinkList"],
	link?: GraphQLTypes["Link"],
	icon?: GraphQLTypes["Image"]
};
	["LinkItemMeta"]: {
	__typename: "LinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"]
};
	["LinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["LinkListOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	icon?: GraphQLTypes["ImageOrderBy"]
};
	["LinkListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["LinkItemConnection"]: {
	__typename: "LinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkItemEdge"]>
};
	["LinkItemEdge"]: {
	__typename: "LinkItemEdge",
	node: GraphQLTypes["LinkItem"]
};
	["TitleList"]: {
	__typename: "TitleList",
	_meta?: GraphQLTypes["TitleListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["TitleItem"]>,
	paginateItems: GraphQLTypes["TitleItemConnection"]
};
	["TitleListMeta"]: {
	__typename: "TitleListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["TitleItem"]: {
	__typename: "TitleItem",
	_meta?: GraphQLTypes["TitleItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	list?: GraphQLTypes["TitleList"],
	icon?: GraphQLTypes["Image"]
};
	["TitleItemMeta"]: {
	__typename: "TitleItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"]
};
	["TitleItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["TitleListOrderBy"],
	icon?: GraphQLTypes["ImageOrderBy"]
};
	["TitleItemConnection"]: {
	__typename: "TitleItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TitleItemEdge"]>
};
	["TitleItemEdge"]: {
	__typename: "TitleItemEdge",
	node: GraphQLTypes["TitleItem"]
};
	["FooterContact"]: {
	__typename: "FooterContact",
	_meta?: GraphQLTypes["FooterContactMeta"],
	id: GraphQLTypes["UUID"],
	email?: string,
	phone?: string,
	note?: string,
	openingHours?: string,
	identificationNumber?: string,
	valueAddedTaxNumber?: string,
	bussinessRegister?: string,
	phoneImage?: GraphQLTypes["Image"],
	address?: string
};
	["FooterContactMeta"]: {
	__typename: "FooterContactMeta",
	id?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"],
	openingHours?: GraphQLTypes["FieldMeta"],
	identificationNumber?: GraphQLTypes["FieldMeta"],
	valueAddedTaxNumber?: GraphQLTypes["FieldMeta"],
	bussinessRegister?: GraphQLTypes["FieldMeta"],
	phoneImage?: GraphQLTypes["FieldMeta"],
	address?: GraphQLTypes["FieldMeta"]
};
	["RestaurantLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["RestaurantOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	description?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	location?: GraphQLTypes["OrderDirection"],
	isEshopActive?: GraphQLTypes["OrderDirection"],
	isDeliveryActive?: GraphQLTypes["OrderDirection"],
	secondaryUrl?: GraphQLTypes["OrderDirection"]
};
	["RestaurantTagLocale"]: {
	__typename: "RestaurantTagLocale",
	_meta?: GraphQLTypes["RestaurantTagLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["RestaurantTag"],
	locale?: GraphQLTypes["Locale"]
};
	["RestaurantTagLocaleMeta"]: {
	__typename: "RestaurantTagLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"]
};
	["RestaurantTag"]: {
	__typename: "RestaurantTag",
	_meta?: GraphQLTypes["RestaurantTagMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["RestaurantTagLocale"]>,
	backgroundColor?: string,
	titleColor?: string,
	restaurants: Array<GraphQLTypes["Restaurant"]>,
	localesByLocale?: GraphQLTypes["RestaurantTagLocale"],
	paginateLocales: GraphQLTypes["RestaurantTagLocaleConnection"],
	paginateRestaurants: GraphQLTypes["RestaurantConnection"]
};
	["RestaurantTagMeta"]: {
	__typename: "RestaurantTagMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	backgroundColor?: GraphQLTypes["FieldMeta"],
	titleColor?: GraphQLTypes["FieldMeta"],
	restaurants?: GraphQLTypes["FieldMeta"]
};
	["RestaurantTagLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["RestaurantTagOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"]
};
	["RestaurantTagOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	backgroundColor?: GraphQLTypes["OrderDirection"],
	titleColor?: GraphQLTypes["OrderDirection"]
};
	["RestaurantTagLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["RestaurantTagLocaleConnection"]: {
	__typename: "RestaurantTagLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RestaurantTagLocaleEdge"]>
};
	["RestaurantTagLocaleEdge"]: {
	__typename: "RestaurantTagLocaleEdge",
	node: GraphQLTypes["RestaurantTagLocale"]
};
	["RestaurantConnection"]: {
	__typename: "RestaurantConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RestaurantEdge"]>
};
	["RestaurantEdge"]: {
	__typename: "RestaurantEdge",
	node: GraphQLTypes["Restaurant"]
};
	["BannerLocale"]: {
	__typename: "BannerLocale",
	_meta?: GraphQLTypes["BannerLocaleMeta"],
	id: GraphQLTypes["UUID"],
	text?: string,
	root?: GraphQLTypes["Banner"],
	locale?: GraphQLTypes["Locale"],
	title?: string,
	url?: string
};
	["BannerLocaleMeta"]: {
	__typename: "BannerLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"]
};
	["Banner"]: {
	__typename: "Banner",
	_meta?: GraphQLTypes["BannerMeta"],
	id: GraphQLTypes["UUID"],
	image?: GraphQLTypes["Image"],
	locales: Array<GraphQLTypes["BannerLocale"]>,
	order: number,
	textColor?: string,
	localesByLocale?: GraphQLTypes["BannerLocale"],
	paginateLocales: GraphQLTypes["BannerLocaleConnection"]
};
	["BannerMeta"]: {
	__typename: "BannerMeta",
	id?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	textColor?: GraphQLTypes["FieldMeta"]
};
	["BannerLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["BannerOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	title?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"]
};
	["BannerLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["BannerLocaleConnection"]: {
	__typename: "BannerLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BannerLocaleEdge"]>
};
	["BannerLocaleEdge"]: {
	__typename: "BannerLocaleEdge",
	node: GraphQLTypes["BannerLocale"]
};
	["CategoryLocale"]: {
	__typename: "CategoryLocale",
	_meta?: GraphQLTypes["CategoryLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["Category"],
	locale?: GraphQLTypes["Locale"],
	slug: string
};
	["CategoryLocaleMeta"]: {
	__typename: "CategoryLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	slug?: GraphQLTypes["FieldMeta"]
};
	["Category"]: {
	__typename: "Category",
	_meta?: GraphQLTypes["CategoryMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["CategoryLocale"]>,
	restaurants: Array<GraphQLTypes["Restaurant"]>,
	localesByLocale?: GraphQLTypes["CategoryLocale"],
	localesBySlug?: GraphQLTypes["CategoryLocale"],
	paginateLocales: GraphQLTypes["CategoryLocaleConnection"],
	paginateRestaurants: GraphQLTypes["RestaurantConnection"]
};
	["CategoryMeta"]: {
	__typename: "CategoryMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	restaurants?: GraphQLTypes["FieldMeta"]
};
	["CategoryLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["CategoryOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	slug?: GraphQLTypes["OrderDirection"]
};
	["CategoryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"]
};
	["CategoryLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["CategoryLocalesBySlugUniqueWhere"]: {
		slug?: string
};
	["CategoryLocaleConnection"]: {
	__typename: "CategoryLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CategoryLocaleEdge"]>
};
	["CategoryLocaleEdge"]: {
	__typename: "CategoryLocaleEdge",
	node: GraphQLTypes["CategoryLocale"]
};
	["LocaleFrontPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["FrontPageUniqueWhere"]
};
	["LocaleFrontPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleFrontPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleHeadersByRootUniqueWhere"]: {
		root?: GraphQLTypes["HeaderUniqueWhere"]
};
	["LocaleHeadersBySocialLinksUniqueWhere"]: {
		socialLinks?: GraphQLTypes["SocialLinkListUniqueWhere"]
};
	["LocaleHeadersByPrimaryLinkItemsUniqueWhere"]: {
		primaryLinkItems?: GraphQLTypes["PrimaryLinkItemUniqueWhere"]
};
	["LocaleHeadersBySecondaryLinksUniqueWhere"]: {
		secondaryLinks?: GraphQLTypes["SecondaryLinkListUniqueWhere"]
};
	["LocaleFootersByRootUniqueWhere"]: {
		root?: GraphQLTypes["FooterUniqueWhere"]
};
	["LocaleFootersByLinksSectionUniqueWhere"]: {
		linksSection?: GraphQLTypes["FooterLinksUniqueWhere"]
};
	["LocaleFootersByContactSectionUniqueWhere"]: {
		contactSection?: GraphQLTypes["FooterContactUniqueWhere"]
};
	["LocaleRestaurantsByRootUniqueWhere"]: {
		root?: GraphQLTypes["RestaurantUniqueWhere"]
};
	["LocaleRestaurantTagsByRootUniqueWhere"]: {
		root?: GraphQLTypes["RestaurantTagUniqueWhere"]
};
	["LocaleBannersByRootUniqueWhere"]: {
		root?: GraphQLTypes["BannerUniqueWhere"]
};
	["LocaleCategoriesByRootUniqueWhere"]: {
		root?: GraphQLTypes["CategoryUniqueWhere"]
};
	["LocaleCategoriesBySlugUniqueWhere"]: {
		slug?: string
};
	["LocaleSubRestaurantsPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["SubRestaurantsPageUniqueWhere"]
};
	["LocaleSubRestaurantsPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleSubRestaurantsPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["FrontPageLocaleConnection"]: {
	__typename: "FrontPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FrontPageLocaleEdge"]>
};
	["FrontPageLocaleEdge"]: {
	__typename: "FrontPageLocaleEdge",
	node: GraphQLTypes["FrontPageLocale"]
};
	["RestaurantLocaleConnection"]: {
	__typename: "RestaurantLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RestaurantLocaleEdge"]>
};
	["RestaurantLocaleEdge"]: {
	__typename: "RestaurantLocaleEdge",
	node: GraphQLTypes["RestaurantLocale"]
};
	["SubRestaurantsPageLocaleConnection"]: {
	__typename: "SubRestaurantsPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubRestaurantsPageLocaleEdge"]>
};
	["SubRestaurantsPageLocaleEdge"]: {
	__typename: "SubRestaurantsPageLocaleEdge",
	node: GraphQLTypes["SubRestaurantsPageLocale"]
};
	["RestaurantItem"]: {
	__typename: "RestaurantItem",
	_meta?: GraphQLTypes["RestaurantItemMeta"],
	id: GraphQLTypes["UUID"],
	parent?: GraphQLTypes["Restaurant"],
	order: number,
	restaurant?: GraphQLTypes["Restaurant"]
};
	["RestaurantItemMeta"]: {
	__typename: "RestaurantItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	parent?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	restaurant?: GraphQLTypes["FieldMeta"]
};
	["RestaurantLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["RestaurantSubItemsByRestaurantUniqueWhere"]: {
		restaurant?: GraphQLTypes["RestaurantUniqueWhere"]
};
	["RestaurantItemConnection"]: {
	__typename: "RestaurantItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RestaurantItemEdge"]>
};
	["RestaurantItemEdge"]: {
	__typename: "RestaurantItemEdge",
	node: GraphQLTypes["RestaurantItem"]
};
	["RestaurantTagConnection"]: {
	__typename: "RestaurantTagConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RestaurantTagEdge"]>
};
	["RestaurantTagEdge"]: {
	__typename: "RestaurantTagEdge",
	node: GraphQLTypes["RestaurantTag"]
};
	["CategoryConnection"]: {
	__typename: "CategoryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["CategoryEdge"]>
};
	["CategoryEdge"]: {
	__typename: "CategoryEdge",
	node: GraphQLTypes["Category"]
};
	["SubRestaurantsPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["SubRestaurantsPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["SubRestaurantsPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["Image"],
	noIndex?: boolean,
	noFollow?: boolean
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"],
	noIndex?: GraphQLTypes["FieldMeta"],
	noFollow?: GraphQLTypes["FieldMeta"]
};
	["FrontPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["FrontPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["FrontPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["FrontPageConnection"]: {
	__typename: "FrontPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FrontPageEdge"]>
};
	["FrontPageEdge"]: {
	__typename: "FrontPageEdge",
	node: GraphQLTypes["FrontPage"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["FrontPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["FrontPageCreateLocalesEntityRelationInput"]>,
	banner?: GraphQLTypes["FrontPageCreateBannerEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	create?: GraphQLTypes["FrontPageLocaleWithoutRootCreateInput"],
	alias?: string
};
	["FrontPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["FrontPageLocaleCreateLinkEntityRelationInput"],
	locale?: GraphQLTypes["FrontPageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleCreateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["FrontPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutFrontPageCreateInput"]
};
	["LinkableWithoutFrontPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	subRestaurantsPage?: GraphQLTypes["LinkableCreateSubRestaurantsPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateSubRestaurantsPageEntityRelationInput"]: {
		connect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLinkCreateInput"]
};
	["SubRestaurantsPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["SubRestaurantsPageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SubRestaurantsPageUniqueWhere"],
	create?: GraphQLTypes["SubRestaurantsPageWithoutLocalesCreateInput"]
};
	["SubRestaurantsPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	parentRestaurant?: GraphQLTypes["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantUniqueWhere"],
	create?: GraphQLTypes["RestaurantCreateInput"]
};
	["RestaurantCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["RestaurantCreateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantCreateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantCreateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantCreateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantCreateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantCreateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	create?: GraphQLTypes["RestaurantLocaleWithoutRootCreateInput"],
	alias?: string
};
	["RestaurantLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["RestaurantLocaleCreateLocaleEntityRelationInput"],
	description?: string,
	url?: string,
	location?: string,
	isEshopActive?: boolean,
	isDeliveryActive?: boolean,
	secondaryUrl?: string,
	_dummy_field_?: boolean
};
	["RestaurantLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutRestaurantsCreateInput"]
};
	["LocaleWithoutRestaurantsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateFrontPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	create?: GraphQLTypes["FrontPageLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["FrontPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["FrontPageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["FrontPageLocaleCreateRootEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleCreateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["FrontPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FrontPageUniqueWhere"],
	create?: GraphQLTypes["FrontPageWithoutLocalesCreateInput"]
};
	["FrontPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	banner?: GraphQLTypes["FrontPageCreateBannerEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageCreateBannerEntityRelationInput"]: {
		connect?: GraphQLTypes["BannerUniqueWhere"],
	create?: GraphQLTypes["BannerCreateInput"]
};
	["BannerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["BannerCreateImageEntityRelationInput"],
	locales?: Array<GraphQLTypes["BannerCreateLocalesEntityRelationInput"]>,
	order?: number,
	textColor?: string,
	_dummy_field_?: boolean
};
	["BannerCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	fileName?: string,
	_dummy_field_?: boolean
};
	["BannerCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["BannerLocaleUniqueWhere"],
	create?: GraphQLTypes["BannerLocaleWithoutRootCreateInput"],
	alias?: string
};
	["BannerLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	locale?: GraphQLTypes["BannerLocaleCreateLocaleEntityRelationInput"],
	title?: string,
	url?: string,
	_dummy_field_?: boolean
};
	["BannerLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutBannersCreateInput"]
};
	["LocaleWithoutBannersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateHeadersEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	menuButtonText?: string,
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"],
	primaryLinkItems?: Array<GraphQLTypes["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"]>,
	secondaryLinks?: GraphQLTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderUniqueWhere"],
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"],
	navigationLogo?: GraphQLTypes["HeaderCreateNavigationLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderCreateNavigationLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderLocaleCreateSocialLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["SocialLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["SocialLinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SocialLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"],
	alias?: string
};
	["SocialLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	socialLink?: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	create?: GraphQLTypes["SocialLinkCreateInput"]
};
	["SocialLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["SocialLinkType"],
	url?: string,
	_dummy_field_?: boolean
};
	["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	create?: GraphQLTypes["PrimaryLinkItemWithoutHeaderCreateInput"],
	alias?: string
};
	["PrimaryLinkItemWithoutHeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["PrimaryLinkItemCreateLinkEntityRelationInput"],
	parent?: GraphQLTypes["PrimaryLinkItemCreateParentEntityRelationInput"],
	subItems?: Array<GraphQLTypes["PrimaryLinkItemCreateSubItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PrimaryLinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	subRestaurantsPage?: GraphQLTypes["LinkableCreateSubRestaurantsPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateFrontPageEntityRelationInput"]: {
		connect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	create?: GraphQLTypes["FrontPageLocaleWithoutLinkCreateInput"]
};
	["FrontPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["FrontPageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["FrontPageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleCreateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["FrontPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutFrontPagesCreateInput"]
};
	["LocaleWithoutFrontPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateFootersEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"],
	linksSection?: GraphQLTypes["FooterLocaleCreateLinksSectionEntityRelationInput"],
	contactSection?: GraphQLTypes["FooterLocaleCreateContactSectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"],
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleCreateLinksSectionEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLinksUniqueWhere"],
	create?: GraphQLTypes["FooterLinksCreateInput"]
};
	["FooterLinksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	buttonsTitle?: string,
	linkList?: GraphQLTypes["FooterLinksCreateLinkListEntityRelationInput"],
	buttons?: GraphQLTypes["FooterLinksCreateButtonsEntityRelationInput"],
	titleList?: GraphQLTypes["FooterLinksCreateTitleListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLinksCreateLinkListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["LinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["LinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkItemUniqueWhere"],
	create?: GraphQLTypes["LinkItemWithoutListCreateInput"],
	alias?: string
};
	["LinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"],
	icon?: GraphQLTypes["LinkItemCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkItemCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterLinksCreateButtonsEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["FooterLinksCreateTitleListEntityRelationInput"]: {
		connect?: GraphQLTypes["TitleListUniqueWhere"],
	create?: GraphQLTypes["TitleListCreateInput"]
};
	["TitleListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["TitleListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TitleListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["TitleItemUniqueWhere"],
	create?: GraphQLTypes["TitleItemWithoutListCreateInput"],
	alias?: string
};
	["TitleItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	icon?: GraphQLTypes["TitleItemCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TitleItemCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleCreateContactSectionEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterContactUniqueWhere"],
	create?: GraphQLTypes["FooterContactCreateInput"]
};
	["FooterContactCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	email?: string,
	phone?: string,
	note?: string,
	openingHours?: string,
	identificationNumber?: string,
	valueAddedTaxNumber?: string,
	bussinessRegister?: string,
	phoneImage?: GraphQLTypes["FooterContactCreatePhoneImageEntityRelationInput"],
	address?: string,
	_dummy_field_?: boolean
};
	["FooterContactCreatePhoneImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LocaleCreateRestaurantsEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	create?: GraphQLTypes["RestaurantLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["RestaurantLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["RestaurantLocaleCreateRootEntityRelationInput"],
	description?: string,
	url?: string,
	location?: string,
	isEshopActive?: boolean,
	isDeliveryActive?: boolean,
	secondaryUrl?: string,
	_dummy_field_?: boolean
};
	["RestaurantLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantUniqueWhere"],
	create?: GraphQLTypes["RestaurantWithoutLocalesCreateInput"]
};
	["RestaurantWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["RestaurantCreateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantCreateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantCreateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantCreateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantCreateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["RestaurantCreateSubItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantItemUniqueWhere"],
	create?: GraphQLTypes["RestaurantItemWithoutParentCreateInput"],
	alias?: string
};
	["RestaurantItemWithoutParentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	restaurant?: GraphQLTypes["RestaurantItemCreateRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantItemCreateRestaurantEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantUniqueWhere"],
	create?: GraphQLTypes["RestaurantWithoutItemCreateInput"]
};
	["RestaurantWithoutItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["RestaurantCreateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantCreateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantCreateSubItemsEntityRelationInput"]>,
	order?: number,
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantCreateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantCreateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantCreateTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantTagUniqueWhere"],
	create?: GraphQLTypes["RestaurantTagWithoutRestaurantsCreateInput"],
	alias?: string
};
	["RestaurantTagWithoutRestaurantsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["RestaurantTagCreateLocalesEntityRelationInput"]>,
	backgroundColor?: string,
	titleColor?: string,
	_dummy_field_?: boolean
};
	["RestaurantTagCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	create?: GraphQLTypes["RestaurantTagLocaleWithoutRootCreateInput"],
	alias?: string
};
	["RestaurantTagLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["RestaurantTagLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantTagLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutRestaurantTagsCreateInput"]
};
	["LocaleWithoutRestaurantTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateBannersEntityRelationInput"]: {
		connect?: GraphQLTypes["BannerLocaleUniqueWhere"],
	create?: GraphQLTypes["BannerLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["BannerLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	root?: GraphQLTypes["BannerLocaleCreateRootEntityRelationInput"],
	title?: string,
	url?: string,
	_dummy_field_?: boolean
};
	["BannerLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["BannerUniqueWhere"],
	create?: GraphQLTypes["BannerWithoutLocalesCreateInput"]
};
	["BannerWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["BannerCreateImageEntityRelationInput"],
	order?: number,
	textColor?: string,
	_dummy_field_?: boolean
};
	["LocaleCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	create?: GraphQLTypes["CategoryLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["CategoryLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["CategoryLocaleCreateRootEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["CategoryLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["CategoryUniqueWhere"],
	create?: GraphQLTypes["CategoryWithoutLocalesCreateInput"]
};
	["CategoryWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	restaurants?: Array<GraphQLTypes["CategoryCreateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CategoryCreateRestaurantsEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantUniqueWhere"],
	create?: GraphQLTypes["RestaurantWithoutCategoriesCreateInput"],
	alias?: string
};
	["RestaurantWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["RestaurantCreateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantCreateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantCreateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantCreateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantCreateTagsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantCreateItemEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantItemUniqueWhere"],
	create?: GraphQLTypes["RestaurantItemWithoutRestaurantCreateInput"]
};
	["RestaurantItemWithoutRestaurantCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	parent?: GraphQLTypes["RestaurantItemCreateParentEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["RestaurantItemCreateParentEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantUniqueWhere"],
	create?: GraphQLTypes["RestaurantWithoutSubItemsCreateInput"]
};
	["RestaurantWithoutSubItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["RestaurantCreateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantCreateImageEntityRelationInput"],
	order?: number,
	item?: GraphQLTypes["RestaurantCreateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantCreateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantCreateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantCreateCategoriesEntityRelationInput"]: {
		connect?: GraphQLTypes["CategoryUniqueWhere"],
	create?: GraphQLTypes["CategoryWithoutRestaurantsCreateInput"],
	alias?: string
};
	["CategoryWithoutRestaurantsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["CategoryCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CategoryCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	create?: GraphQLTypes["CategoryLocaleWithoutRootCreateInput"],
	alias?: string
};
	["CategoryLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["CategoryLocaleCreateLocaleEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["CategoryLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutCategoriesCreateInput"]
};
	["LocaleWithoutCategoriesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateRestaurantTagsEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	create?: GraphQLTypes["RestaurantTagLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["RestaurantTagLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["RestaurantTagLocaleCreateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantTagLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantTagUniqueWhere"],
	create?: GraphQLTypes["RestaurantTagWithoutLocalesCreateInput"]
};
	["RestaurantTagWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	backgroundColor?: string,
	titleColor?: string,
	restaurants?: Array<GraphQLTypes["RestaurantTagCreateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantTagCreateRestaurantsEntityRelationInput"]: {
		connect?: GraphQLTypes["RestaurantUniqueWhere"],
	create?: GraphQLTypes["RestaurantWithoutTagsCreateInput"],
	alias?: string
};
	["RestaurantWithoutTagsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["RestaurantCreateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantCreateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantCreateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantCreateItemEntityRelationInput"],
	openingHours?: string,
	categories?: Array<GraphQLTypes["RestaurantCreateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateSubRestaurantsPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["SubRestaurantsPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["SubRestaurantsPageLocaleCreateRootEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutSubRestaurantsPageCreateInput"]
};
	["LinkableWithoutSubRestaurantsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	frontPage?: GraphQLTypes["LinkableCreateFrontPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	noIndex?: boolean,
	noFollow?: boolean,
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FrontPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["PrimaryLinkItemCreateParentEntityRelationInput"]: {
		connect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	create?: GraphQLTypes["PrimaryLinkItemWithoutSubItemsCreateInput"]
};
	["PrimaryLinkItemWithoutSubItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["PrimaryLinkItemCreateLinkEntityRelationInput"],
	parent?: GraphQLTypes["PrimaryLinkItemCreateParentEntityRelationInput"],
	header?: GraphQLTypes["PrimaryLinkItemCreateHeaderEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrimaryLinkItemCreateHeaderEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create?: GraphQLTypes["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"]
};
	["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	menuButtonText?: string,
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"],
	secondaryLinks?: GraphQLTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["LocaleWithoutHeadersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderLocaleCreateSecondaryLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["SecondaryLinkListUniqueWhere"],
	create?: GraphQLTypes["SecondaryLinkListCreateInput"]
};
	["SecondaryLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["SecondaryLinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SecondaryLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["SecondaryLinkItemUniqueWhere"],
	create?: GraphQLTypes["SecondaryLinkItemWithoutListCreateInput"],
	alias?: string
};
	["SecondaryLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	iconType?: GraphQLTypes["IconType"],
	link?: GraphQLTypes["SecondaryLinkItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SecondaryLinkItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["PrimaryLinkItemCreateSubItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	create?: GraphQLTypes["PrimaryLinkItemWithoutParentCreateInput"],
	alias?: string
};
	["PrimaryLinkItemWithoutParentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["PrimaryLinkItemCreateLinkEntityRelationInput"],
	subItems?: Array<GraphQLTypes["PrimaryLinkItemCreateSubItemsEntityRelationInput"]>,
	header?: GraphQLTypes["PrimaryLinkItemCreateHeaderEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutSubRestaurantsPagesCreateInput"]
};
	["LocaleWithoutSubRestaurantsPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FrontPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["FrontPageUpdateLocalesEntityRelationInput"]>,
	banner?: GraphQLTypes["FrontPageUpdateBannerEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["FrontPageLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["FrontPageUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["FrontPageUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	delete?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	alias?: string
};
	["FrontPageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	data?: GraphQLTypes["FrontPageLocaleWithoutRootUpdateInput"]
};
	["FrontPageLocaleWithoutRootUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["FrontPageLocaleUpdateLinkEntityRelationInput"],
	locale?: GraphQLTypes["FrontPageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleUpdateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["FrontPageLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutFrontPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutFrontPageUpdateInput"],
	upsert?: GraphQLTypes["FrontPageLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutFrontPageUpdateInput"]: {
		url?: string,
	subRestaurantsPage?: GraphQLTypes["LinkableUpdateSubRestaurantsPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateSubRestaurantsPageEntityRelationInput"]: {
		create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertSubRestaurantsPageRelationInput"],
	connect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SubRestaurantsPageLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["SubRestaurantsPageWithoutLocalesCreateInput"],
	update?: GraphQLTypes["SubRestaurantsPageWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["SubRestaurantsPageLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["SubRestaurantsPageUniqueWhere"],
	delete?: boolean
};
	["SubRestaurantsPageWithoutLocalesUpdateInput"]: {
		order?: number,
	parentRestaurant?: GraphQLTypes["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantCreateInput"],
	update?: GraphQLTypes["RestaurantUpdateInput"],
	upsert?: GraphQLTypes["SubRestaurantsPageUpsertParentRestaurantRelationInput"],
	connect?: GraphQLTypes["RestaurantUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RestaurantUpdateInput"]: {
		locales?: Array<GraphQLTypes["RestaurantUpdateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantUpdateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantUpdateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantUpdateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantUpdateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantUpdateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["RestaurantUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["RestaurantUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	delete?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	alias?: string
};
	["RestaurantUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	data?: GraphQLTypes["RestaurantLocaleWithoutRootUpdateInput"]
};
	["RestaurantLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["RestaurantLocaleUpdateLocaleEntityRelationInput"],
	description?: string,
	url?: string,
	location?: string,
	isEshopActive?: boolean,
	isDeliveryActive?: boolean,
	secondaryUrl?: string,
	_dummy_field_?: boolean
};
	["RestaurantLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutRestaurantsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutRestaurantsUpdateInput"],
	upsert?: GraphQLTypes["RestaurantLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutRestaurantsUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateFrontPagesEntityRelationInput"]: {
		create?: GraphQLTypes["FrontPageLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateFrontPagesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertFrontPagesRelationInput"],
	connect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	delete?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateFrontPagesRelationInput"]: {
		by?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	data?: GraphQLTypes["FrontPageLocaleWithoutLocaleUpdateInput"]
};
	["FrontPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["FrontPageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["FrontPageLocaleUpdateRootEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleUpdateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["FrontPageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["FrontPageWithoutLocalesCreateInput"],
	update?: GraphQLTypes["FrontPageWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["FrontPageLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["FrontPageUniqueWhere"],
	delete?: boolean
};
	["FrontPageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	banner?: GraphQLTypes["FrontPageUpdateBannerEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FrontPageUpdateBannerEntityRelationInput"]: {
		create?: GraphQLTypes["BannerCreateInput"],
	update?: GraphQLTypes["BannerUpdateInput"],
	upsert?: GraphQLTypes["FrontPageUpsertBannerRelationInput"],
	connect?: GraphQLTypes["BannerUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["BannerUpdateInput"]: {
		image?: GraphQLTypes["BannerUpdateImageEntityRelationInput"],
	locales?: Array<GraphQLTypes["BannerUpdateLocalesEntityRelationInput"]>,
	order?: number,
	textColor?: string,
	_dummy_field_?: boolean
};
	["BannerUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["BannerUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	fileName?: string,
	_dummy_field_?: boolean
};
	["BannerUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["BannerUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["BannerLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["BannerUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["BannerUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["BannerLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["BannerLocaleUniqueWhere"],
	delete?: GraphQLTypes["BannerLocaleUniqueWhere"],
	alias?: string
};
	["BannerUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["BannerLocaleUniqueWhere"],
	data?: GraphQLTypes["BannerLocaleWithoutRootUpdateInput"]
};
	["BannerLocaleWithoutRootUpdateInput"]: {
		text?: string,
	locale?: GraphQLTypes["BannerLocaleUpdateLocaleEntityRelationInput"],
	title?: string,
	url?: string,
	_dummy_field_?: boolean
};
	["BannerLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutBannersCreateInput"],
	update?: GraphQLTypes["LocaleWithoutBannersUpdateInput"],
	upsert?: GraphQLTypes["BannerLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutBannersUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateHeadersRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertHeadersRelationInput"],
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateHeadersRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data?: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
		menuButtonText?: string,
	root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"],
	primaryLinkItems?: Array<GraphQLTypes["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"]>,
	secondaryLinks?: GraphQLTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"],
	update?: GraphQLTypes["HeaderWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["HeaderUniqueWhere"],
	delete?: boolean
};
	["HeaderWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"],
	navigationLogo?: GraphQLTypes["HeaderUpdateNavigationLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderUpdateNavigationLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertNavigationLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertNavigationLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["HeaderWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateSocialLinksEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkListCreateInput"],
	update?: GraphQLTypes["SocialLinkListUpdateInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertSocialLinksRelationInput"],
	connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["SocialLinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SocialLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["SocialLinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["SocialLinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	delete?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	alias?: string
};
	["SocialLinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	data?: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"]
};
	["SocialLinkItemWithoutListUpdateInput"]: {
		order?: number,
	socialLink?: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkCreateInput"],
	update?: GraphQLTypes["SocialLinkUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkItemUpsertSocialLinkRelationInput"],
	connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkUpdateInput"]: {
		type?: GraphQLTypes["SocialLinkType"],
	url?: string,
	_dummy_field_?: boolean
};
	["SocialLinkItemUpsertSocialLinkRelationInput"]: {
		update?: GraphQLTypes["SocialLinkUpdateInput"],
	create?: GraphQLTypes["SocialLinkCreateInput"]
};
	["SocialLinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	update?: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"]
};
	["HeaderLocaleUpsertSocialLinksRelationInput"]: {
		update?: GraphQLTypes["SocialLinkListUpdateInput"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"]: {
		create?: GraphQLTypes["PrimaryLinkItemWithoutHeaderCreateInput"],
	update?: GraphQLTypes["HeaderLocaleUpdatePrimaryLinkItemsRelationInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertPrimaryLinkItemsRelationInput"],
	connect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	delete?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	alias?: string
};
	["HeaderLocaleUpdatePrimaryLinkItemsRelationInput"]: {
		by?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	data?: GraphQLTypes["PrimaryLinkItemWithoutHeaderUpdateInput"]
};
	["PrimaryLinkItemWithoutHeaderUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"],
	parent?: GraphQLTypes["PrimaryLinkItemUpdateParentEntityRelationInput"],
	subItems?: Array<GraphQLTypes["PrimaryLinkItemUpdateSubItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PrimaryLinkItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["PrimaryLinkItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableUpdateInput"]: {
		url?: string,
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	subRestaurantsPage?: GraphQLTypes["LinkableUpdateSubRestaurantsPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateFrontPageEntityRelationInput"]: {
		create?: GraphQLTypes["FrontPageLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["FrontPageLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertFrontPageRelationInput"],
	connect?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FrontPageLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["FrontPageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["FrontPageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleUpdateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["FrontPageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutFrontPagesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutFrontPagesUpdateInput"],
	upsert?: GraphQLTypes["FrontPageLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutFrontPagesUpdateInput"]: {
		code?: string,
	label?: string,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateFootersEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateFootersRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertFootersRelationInput"],
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateFootersRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	data?: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"],
	linksSection?: GraphQLTypes["FooterLocaleUpdateLinksSectionEntityRelationInput"],
	contactSection?: GraphQLTypes["FooterLocaleUpdateContactSectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["FooterWithoutLocalesCreateInput"],
	update?: GraphQLTypes["FooterWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["FooterUniqueWhere"],
	delete?: boolean
};
	["FooterWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["FooterWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateLinksSectionEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLinksCreateInput"],
	update?: GraphQLTypes["FooterLinksUpdateInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertLinksSectionRelationInput"],
	connect?: GraphQLTypes["FooterLinksUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterLinksUpdateInput"]: {
		buttonsTitle?: string,
	linkList?: GraphQLTypes["FooterLinksUpdateLinkListEntityRelationInput"],
	buttons?: GraphQLTypes["FooterLinksUpdateButtonsEntityRelationInput"],
	titleList?: GraphQLTypes["FooterLinksUpdateTitleListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLinksUpdateLinkListEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateInput"],
	upsert?: GraphQLTypes["FooterLinksUpsertLinkListRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["LinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["LinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["LinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["LinkItemUniqueWhere"],
	delete?: GraphQLTypes["LinkItemUniqueWhere"],
	alias?: string
};
	["LinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["LinkItemUniqueWhere"],
	data?: GraphQLTypes["LinkItemWithoutListUpdateInput"]
};
	["LinkItemWithoutListUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"],
	icon?: GraphQLTypes["LinkItemUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkItemUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertIconRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkItemUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["LinkItemUniqueWhere"],
	update?: GraphQLTypes["LinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["LinkItemWithoutListCreateInput"]
};
	["FooterLinksUpsertLinkListRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["FooterLinksUpdateButtonsEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListCreateInput"],
	update?: GraphQLTypes["LinkListUpdateInput"],
	upsert?: GraphQLTypes["FooterLinksUpsertButtonsRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterLinksUpsertButtonsRelationInput"]: {
		update?: GraphQLTypes["LinkListUpdateInput"],
	create?: GraphQLTypes["LinkListCreateInput"]
};
	["FooterLinksUpdateTitleListEntityRelationInput"]: {
		create?: GraphQLTypes["TitleListCreateInput"],
	update?: GraphQLTypes["TitleListUpdateInput"],
	upsert?: GraphQLTypes["FooterLinksUpsertTitleListRelationInput"],
	connect?: GraphQLTypes["TitleListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TitleListUpdateInput"]: {
		items?: Array<GraphQLTypes["TitleListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TitleListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["TitleItemWithoutListCreateInput"],
	update?: GraphQLTypes["TitleListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["TitleListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["TitleItemUniqueWhere"],
	disconnect?: GraphQLTypes["TitleItemUniqueWhere"],
	delete?: GraphQLTypes["TitleItemUniqueWhere"],
	alias?: string
};
	["TitleListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["TitleItemUniqueWhere"],
	data?: GraphQLTypes["TitleItemWithoutListUpdateInput"]
};
	["TitleItemWithoutListUpdateInput"]: {
		order?: number,
	title?: string,
	icon?: GraphQLTypes["TitleItemUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TitleItemUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["TitleItemUpsertIconRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TitleItemUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["TitleListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["TitleItemUniqueWhere"],
	update?: GraphQLTypes["TitleItemWithoutListUpdateInput"],
	create?: GraphQLTypes["TitleItemWithoutListCreateInput"]
};
	["FooterLinksUpsertTitleListRelationInput"]: {
		update?: GraphQLTypes["TitleListUpdateInput"],
	create?: GraphQLTypes["TitleListCreateInput"]
};
	["FooterLocaleUpsertLinksSectionRelationInput"]: {
		update?: GraphQLTypes["FooterLinksUpdateInput"],
	create?: GraphQLTypes["FooterLinksCreateInput"]
};
	["FooterLocaleUpdateContactSectionEntityRelationInput"]: {
		create?: GraphQLTypes["FooterContactCreateInput"],
	update?: GraphQLTypes["FooterContactUpdateInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertContactSectionRelationInput"],
	connect?: GraphQLTypes["FooterContactUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterContactUpdateInput"]: {
		email?: string,
	phone?: string,
	note?: string,
	openingHours?: string,
	identificationNumber?: string,
	valueAddedTaxNumber?: string,
	bussinessRegister?: string,
	phoneImage?: GraphQLTypes["FooterContactUpdatePhoneImageEntityRelationInput"],
	address?: string,
	_dummy_field_?: boolean
};
	["FooterContactUpdatePhoneImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FooterContactUpsertPhoneImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterContactUpsertPhoneImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleUpsertContactSectionRelationInput"]: {
		update?: GraphQLTypes["FooterContactUpdateInput"],
	create?: GraphQLTypes["FooterContactCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	update?: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateRestaurantsEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateRestaurantsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertRestaurantsRelationInput"],
	connect?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	delete?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateRestaurantsRelationInput"]: {
		by?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	data?: GraphQLTypes["RestaurantLocaleWithoutLocaleUpdateInput"]
};
	["RestaurantLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["RestaurantLocaleUpdateRootEntityRelationInput"],
	description?: string,
	url?: string,
	location?: string,
	isEshopActive?: boolean,
	isDeliveryActive?: boolean,
	secondaryUrl?: string,
	_dummy_field_?: boolean
};
	["RestaurantLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantWithoutLocalesCreateInput"],
	update?: GraphQLTypes["RestaurantWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["RestaurantLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["RestaurantUniqueWhere"],
	delete?: boolean
};
	["RestaurantWithoutLocalesUpdateInput"]: {
		image?: GraphQLTypes["RestaurantUpdateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantUpdateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantUpdateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantUpdateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantUpdateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["RestaurantUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RestaurantUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["RestaurantUpdateSubItemsEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantItemWithoutParentCreateInput"],
	update?: GraphQLTypes["RestaurantUpdateSubItemsRelationInput"],
	upsert?: GraphQLTypes["RestaurantUpsertSubItemsRelationInput"],
	connect?: GraphQLTypes["RestaurantItemUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantItemUniqueWhere"],
	delete?: GraphQLTypes["RestaurantItemUniqueWhere"],
	alias?: string
};
	["RestaurantUpdateSubItemsRelationInput"]: {
		by?: GraphQLTypes["RestaurantItemUniqueWhere"],
	data?: GraphQLTypes["RestaurantItemWithoutParentUpdateInput"]
};
	["RestaurantItemWithoutParentUpdateInput"]: {
		order?: number,
	restaurant?: GraphQLTypes["RestaurantItemUpdateRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantItemUpdateRestaurantEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantWithoutItemCreateInput"],
	update?: GraphQLTypes["RestaurantWithoutItemUpdateInput"],
	upsert?: GraphQLTypes["RestaurantItemUpsertRestaurantRelationInput"],
	connect?: GraphQLTypes["RestaurantUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RestaurantWithoutItemUpdateInput"]: {
		locales?: Array<GraphQLTypes["RestaurantUpdateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantUpdateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantUpdateSubItemsEntityRelationInput"]>,
	order?: number,
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantUpdateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantUpdateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantUpdateTagsEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantTagWithoutRestaurantsCreateInput"],
	update?: GraphQLTypes["RestaurantUpdateTagsRelationInput"],
	upsert?: GraphQLTypes["RestaurantUpsertTagsRelationInput"],
	connect?: GraphQLTypes["RestaurantTagUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantTagUniqueWhere"],
	delete?: GraphQLTypes["RestaurantTagUniqueWhere"],
	alias?: string
};
	["RestaurantUpdateTagsRelationInput"]: {
		by?: GraphQLTypes["RestaurantTagUniqueWhere"],
	data?: GraphQLTypes["RestaurantTagWithoutRestaurantsUpdateInput"]
};
	["RestaurantTagWithoutRestaurantsUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["RestaurantTagUpdateLocalesEntityRelationInput"]>,
	backgroundColor?: string,
	titleColor?: string,
	_dummy_field_?: boolean
};
	["RestaurantTagUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantTagLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["RestaurantTagUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["RestaurantTagUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	delete?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	alias?: string
};
	["RestaurantTagUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	data?: GraphQLTypes["RestaurantTagLocaleWithoutRootUpdateInput"]
};
	["RestaurantTagLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["RestaurantTagLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantTagLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutRestaurantTagsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutRestaurantTagsUpdateInput"],
	upsert?: GraphQLTypes["RestaurantTagLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutRestaurantTagsUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateBannersEntityRelationInput"]: {
		create?: GraphQLTypes["BannerLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateBannersRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertBannersRelationInput"],
	connect?: GraphQLTypes["BannerLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["BannerLocaleUniqueWhere"],
	delete?: GraphQLTypes["BannerLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateBannersRelationInput"]: {
		by?: GraphQLTypes["BannerLocaleUniqueWhere"],
	data?: GraphQLTypes["BannerLocaleWithoutLocaleUpdateInput"]
};
	["BannerLocaleWithoutLocaleUpdateInput"]: {
		text?: string,
	root?: GraphQLTypes["BannerLocaleUpdateRootEntityRelationInput"],
	title?: string,
	url?: string,
	_dummy_field_?: boolean
};
	["BannerLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["BannerWithoutLocalesCreateInput"],
	update?: GraphQLTypes["BannerWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["BannerLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["BannerUniqueWhere"],
	delete?: boolean
};
	["BannerWithoutLocalesUpdateInput"]: {
		image?: GraphQLTypes["BannerUpdateImageEntityRelationInput"],
	order?: number,
	textColor?: string,
	_dummy_field_?: boolean
};
	["BannerLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["BannerWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["BannerWithoutLocalesCreateInput"]
};
	["LocaleUpsertBannersRelationInput"]: {
		by?: GraphQLTypes["BannerLocaleUniqueWhere"],
	update?: GraphQLTypes["BannerLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["BannerLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["CategoryLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateCategoriesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertCategoriesRelationInput"],
	connect?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	delete?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	data?: GraphQLTypes["CategoryLocaleWithoutLocaleUpdateInput"]
};
	["CategoryLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["CategoryLocaleUpdateRootEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["CategoryLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["CategoryWithoutLocalesCreateInput"],
	update?: GraphQLTypes["CategoryWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["CategoryLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["CategoryUniqueWhere"],
	delete?: boolean
};
	["CategoryWithoutLocalesUpdateInput"]: {
		order?: number,
	restaurants?: Array<GraphQLTypes["CategoryUpdateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CategoryUpdateRestaurantsEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantWithoutCategoriesCreateInput"],
	update?: GraphQLTypes["CategoryUpdateRestaurantsRelationInput"],
	upsert?: GraphQLTypes["CategoryUpsertRestaurantsRelationInput"],
	connect?: GraphQLTypes["RestaurantUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantUniqueWhere"],
	delete?: GraphQLTypes["RestaurantUniqueWhere"],
	alias?: string
};
	["CategoryUpdateRestaurantsRelationInput"]: {
		by?: GraphQLTypes["RestaurantUniqueWhere"],
	data?: GraphQLTypes["RestaurantWithoutCategoriesUpdateInput"]
};
	["RestaurantWithoutCategoriesUpdateInput"]: {
		locales?: Array<GraphQLTypes["RestaurantUpdateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantUpdateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantUpdateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantUpdateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantUpdateTagsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantUpdateItemEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantItemWithoutRestaurantCreateInput"],
	update?: GraphQLTypes["RestaurantItemWithoutRestaurantUpdateInput"],
	upsert?: GraphQLTypes["RestaurantUpsertItemRelationInput"],
	connect?: GraphQLTypes["RestaurantItemUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RestaurantItemWithoutRestaurantUpdateInput"]: {
		parent?: GraphQLTypes["RestaurantItemUpdateParentEntityRelationInput"],
	order?: number,
	_dummy_field_?: boolean
};
	["RestaurantItemUpdateParentEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantWithoutSubItemsCreateInput"],
	update?: GraphQLTypes["RestaurantWithoutSubItemsUpdateInput"],
	upsert?: GraphQLTypes["RestaurantItemUpsertParentRelationInput"],
	connect?: GraphQLTypes["RestaurantUniqueWhere"],
	delete?: boolean
};
	["RestaurantWithoutSubItemsUpdateInput"]: {
		locales?: Array<GraphQLTypes["RestaurantUpdateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantUpdateImageEntityRelationInput"],
	order?: number,
	item?: GraphQLTypes["RestaurantUpdateItemEntityRelationInput"],
	openingHours?: string,
	tags?: Array<GraphQLTypes["RestaurantUpdateTagsEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["RestaurantUpdateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantUpdateCategoriesEntityRelationInput"]: {
		create?: GraphQLTypes["CategoryWithoutRestaurantsCreateInput"],
	update?: GraphQLTypes["RestaurantUpdateCategoriesRelationInput"],
	upsert?: GraphQLTypes["RestaurantUpsertCategoriesRelationInput"],
	connect?: GraphQLTypes["CategoryUniqueWhere"],
	disconnect?: GraphQLTypes["CategoryUniqueWhere"],
	delete?: GraphQLTypes["CategoryUniqueWhere"],
	alias?: string
};
	["RestaurantUpdateCategoriesRelationInput"]: {
		by?: GraphQLTypes["CategoryUniqueWhere"],
	data?: GraphQLTypes["CategoryWithoutRestaurantsUpdateInput"]
};
	["CategoryWithoutRestaurantsUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["CategoryUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CategoryUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["CategoryLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["CategoryUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["CategoryUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	delete?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	alias?: string
};
	["CategoryUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	data?: GraphQLTypes["CategoryLocaleWithoutRootUpdateInput"]
};
	["CategoryLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["CategoryLocaleUpdateLocaleEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["CategoryLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutCategoriesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutCategoriesUpdateInput"],
	upsert?: GraphQLTypes["CategoryLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutCategoriesUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateRestaurantTagsEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantTagLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateRestaurantTagsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertRestaurantTagsRelationInput"],
	connect?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	delete?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateRestaurantTagsRelationInput"]: {
		by?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	data?: GraphQLTypes["RestaurantTagLocaleWithoutLocaleUpdateInput"]
};
	["RestaurantTagLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["RestaurantTagLocaleUpdateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantTagLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantTagWithoutLocalesCreateInput"],
	update?: GraphQLTypes["RestaurantTagWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["RestaurantTagLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["RestaurantTagUniqueWhere"],
	delete?: boolean
};
	["RestaurantTagWithoutLocalesUpdateInput"]: {
		order?: number,
	backgroundColor?: string,
	titleColor?: string,
	restaurants?: Array<GraphQLTypes["RestaurantTagUpdateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantTagUpdateRestaurantsEntityRelationInput"]: {
		create?: GraphQLTypes["RestaurantWithoutTagsCreateInput"],
	update?: GraphQLTypes["RestaurantTagUpdateRestaurantsRelationInput"],
	upsert?: GraphQLTypes["RestaurantTagUpsertRestaurantsRelationInput"],
	connect?: GraphQLTypes["RestaurantUniqueWhere"],
	disconnect?: GraphQLTypes["RestaurantUniqueWhere"],
	delete?: GraphQLTypes["RestaurantUniqueWhere"],
	alias?: string
};
	["RestaurantTagUpdateRestaurantsRelationInput"]: {
		by?: GraphQLTypes["RestaurantUniqueWhere"],
	data?: GraphQLTypes["RestaurantWithoutTagsUpdateInput"]
};
	["RestaurantWithoutTagsUpdateInput"]: {
		locales?: Array<GraphQLTypes["RestaurantUpdateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["RestaurantUpdateImageEntityRelationInput"],
	subItems?: Array<GraphQLTypes["RestaurantUpdateSubItemsEntityRelationInput"]>,
	order?: number,
	item?: GraphQLTypes["RestaurantUpdateItemEntityRelationInput"],
	openingHours?: string,
	categories?: Array<GraphQLTypes["RestaurantUpdateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantTagUpsertRestaurantsRelationInput"]: {
		by?: GraphQLTypes["RestaurantUniqueWhere"],
	update?: GraphQLTypes["RestaurantWithoutTagsUpdateInput"],
	create?: GraphQLTypes["RestaurantWithoutTagsCreateInput"]
};
	["RestaurantTagLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["RestaurantTagWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["RestaurantTagWithoutLocalesCreateInput"]
};
	["LocaleUpsertRestaurantTagsRelationInput"]: {
		by?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	update?: GraphQLTypes["RestaurantTagLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["RestaurantTagLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]: {
		create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateSubRestaurantsPagesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertSubRestaurantsPagesRelationInput"],
	connect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	delete?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateSubRestaurantsPagesRelationInput"]: {
		by?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	data?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"]
};
	["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutSubRestaurantsPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutSubRestaurantsPageUpdateInput"],
	upsert?: GraphQLTypes["SubRestaurantsPageLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutSubRestaurantsPageUpdateInput"]: {
		url?: string,
	frontPage?: GraphQLTypes["LinkableUpdateFrontPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutSubRestaurantsPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutSubRestaurantsPageCreateInput"]
};
	["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["SubRestaurantsPageLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	noIndex?: boolean,
	noFollow?: boolean,
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SubRestaurantsPageLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LocaleUpsertSubRestaurantsPagesRelationInput"]: {
		by?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	update?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLocaleCreateInput"]
};
	["CategoryLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutCategoriesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutCategoriesCreateInput"]
};
	["CategoryUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	update?: GraphQLTypes["CategoryLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["CategoryLocaleWithoutRootCreateInput"]
};
	["RestaurantUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["CategoryUniqueWhere"],
	update?: GraphQLTypes["CategoryWithoutRestaurantsUpdateInput"],
	create?: GraphQLTypes["CategoryWithoutRestaurantsCreateInput"]
};
	["RestaurantItemUpsertParentRelationInput"]: {
		update?: GraphQLTypes["RestaurantWithoutSubItemsUpdateInput"],
	create?: GraphQLTypes["RestaurantWithoutSubItemsCreateInput"]
};
	["RestaurantUpsertItemRelationInput"]: {
		update?: GraphQLTypes["RestaurantItemWithoutRestaurantUpdateInput"],
	create?: GraphQLTypes["RestaurantItemWithoutRestaurantCreateInput"]
};
	["CategoryUpsertRestaurantsRelationInput"]: {
		by?: GraphQLTypes["RestaurantUniqueWhere"],
	update?: GraphQLTypes["RestaurantWithoutCategoriesUpdateInput"],
	create?: GraphQLTypes["RestaurantWithoutCategoriesCreateInput"]
};
	["CategoryLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["CategoryWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["CategoryWithoutLocalesCreateInput"]
};
	["LocaleUpsertCategoriesRelationInput"]: {
		by?: GraphQLTypes["CategoryLocaleUniqueWhere"],
	update?: GraphQLTypes["CategoryLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["CategoryLocaleWithoutLocaleCreateInput"]
};
	["RestaurantTagLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutRestaurantTagsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutRestaurantTagsCreateInput"]
};
	["RestaurantTagUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["RestaurantTagLocaleUniqueWhere"],
	update?: GraphQLTypes["RestaurantTagLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["RestaurantTagLocaleWithoutRootCreateInput"]
};
	["RestaurantUpsertTagsRelationInput"]: {
		by?: GraphQLTypes["RestaurantTagUniqueWhere"],
	update?: GraphQLTypes["RestaurantTagWithoutRestaurantsUpdateInput"],
	create?: GraphQLTypes["RestaurantTagWithoutRestaurantsCreateInput"]
};
	["RestaurantItemUpsertRestaurantRelationInput"]: {
		update?: GraphQLTypes["RestaurantWithoutItemUpdateInput"],
	create?: GraphQLTypes["RestaurantWithoutItemCreateInput"]
};
	["RestaurantUpsertSubItemsRelationInput"]: {
		by?: GraphQLTypes["RestaurantItemUniqueWhere"],
	update?: GraphQLTypes["RestaurantItemWithoutParentUpdateInput"],
	create?: GraphQLTypes["RestaurantItemWithoutParentCreateInput"]
};
	["RestaurantLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["RestaurantWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["RestaurantWithoutLocalesCreateInput"]
};
	["LocaleUpsertRestaurantsRelationInput"]: {
		by?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	update?: GraphQLTypes["RestaurantLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["RestaurantLocaleWithoutLocaleCreateInput"]
};
	["FrontPageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutFrontPagesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutFrontPagesCreateInput"]
};
	["FrontPageLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["FrontPageLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FrontPageLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertFrontPageRelationInput"]: {
		update?: GraphQLTypes["FrontPageLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["FrontPageLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["PrimaryLinkItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["PrimaryLinkItemUpdateParentEntityRelationInput"]: {
		create?: GraphQLTypes["PrimaryLinkItemWithoutSubItemsCreateInput"],
	update?: GraphQLTypes["PrimaryLinkItemWithoutSubItemsUpdateInput"],
	upsert?: GraphQLTypes["PrimaryLinkItemUpsertParentRelationInput"],
	connect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PrimaryLinkItemWithoutSubItemsUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"],
	parent?: GraphQLTypes["PrimaryLinkItemUpdateParentEntityRelationInput"],
	header?: GraphQLTypes["PrimaryLinkItemUpdateHeaderEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrimaryLinkItemUpdateHeaderEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"],
	update?: GraphQLTypes["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"],
	upsert?: GraphQLTypes["PrimaryLinkItemUpsertHeaderRelationInput"],
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"]: {
		menuButtonText?: string,
	root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"],
	secondaryLinks?: GraphQLTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"],
	update?: GraphQLTypes["LocaleWithoutHeadersUpdateInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutHeadersUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutHeadersUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"]: {
		create?: GraphQLTypes["SecondaryLinkListCreateInput"],
	update?: GraphQLTypes["SecondaryLinkListUpdateInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertSecondaryLinksRelationInput"],
	connect?: GraphQLTypes["SecondaryLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SecondaryLinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["SecondaryLinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SecondaryLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["SecondaryLinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["SecondaryLinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["SecondaryLinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["SecondaryLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["SecondaryLinkItemUniqueWhere"],
	delete?: GraphQLTypes["SecondaryLinkItemUniqueWhere"],
	alias?: string
};
	["SecondaryLinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["SecondaryLinkItemUniqueWhere"],
	data?: GraphQLTypes["SecondaryLinkItemWithoutListUpdateInput"]
};
	["SecondaryLinkItemWithoutListUpdateInput"]: {
		order?: number,
	iconType?: GraphQLTypes["IconType"],
	link?: GraphQLTypes["SecondaryLinkItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SecondaryLinkItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["SecondaryLinkItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SecondaryLinkItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["SecondaryLinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["SecondaryLinkItemUniqueWhere"],
	update?: GraphQLTypes["SecondaryLinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["SecondaryLinkItemWithoutListCreateInput"]
};
	["HeaderLocaleUpsertSecondaryLinksRelationInput"]: {
		update?: GraphQLTypes["SecondaryLinkListUpdateInput"],
	create?: GraphQLTypes["SecondaryLinkListCreateInput"]
};
	["PrimaryLinkItemUpsertHeaderRelationInput"]: {
		update?: GraphQLTypes["HeaderLocaleWithoutPrimaryLinkItemsUpdateInput"],
	create?: GraphQLTypes["HeaderLocaleWithoutPrimaryLinkItemsCreateInput"]
};
	["PrimaryLinkItemUpsertParentRelationInput"]: {
		update?: GraphQLTypes["PrimaryLinkItemWithoutSubItemsUpdateInput"],
	create?: GraphQLTypes["PrimaryLinkItemWithoutSubItemsCreateInput"]
};
	["PrimaryLinkItemUpdateSubItemsEntityRelationInput"]: {
		create?: GraphQLTypes["PrimaryLinkItemWithoutParentCreateInput"],
	update?: GraphQLTypes["PrimaryLinkItemUpdateSubItemsRelationInput"],
	upsert?: GraphQLTypes["PrimaryLinkItemUpsertSubItemsRelationInput"],
	connect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	delete?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	alias?: string
};
	["PrimaryLinkItemUpdateSubItemsRelationInput"]: {
		by?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	data?: GraphQLTypes["PrimaryLinkItemWithoutParentUpdateInput"]
};
	["PrimaryLinkItemWithoutParentUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"],
	subItems?: Array<GraphQLTypes["PrimaryLinkItemUpdateSubItemsEntityRelationInput"]>,
	header?: GraphQLTypes["PrimaryLinkItemUpdateHeaderEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrimaryLinkItemUpsertSubItemsRelationInput"]: {
		by?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	update?: GraphQLTypes["PrimaryLinkItemWithoutParentUpdateInput"],
	create?: GraphQLTypes["PrimaryLinkItemWithoutParentCreateInput"]
};
	["HeaderLocaleUpsertPrimaryLinkItemsRelationInput"]: {
		by?: GraphQLTypes["PrimaryLinkItemUniqueWhere"],
	update?: GraphQLTypes["PrimaryLinkItemWithoutHeaderUpdateInput"],
	create?: GraphQLTypes["PrimaryLinkItemWithoutHeaderCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update?: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["BannerLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutBannersUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutBannersCreateInput"]
};
	["BannerUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["BannerLocaleUniqueWhere"],
	update?: GraphQLTypes["BannerLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["BannerLocaleWithoutRootCreateInput"]
};
	["FrontPageUpsertBannerRelationInput"]: {
		update?: GraphQLTypes["BannerUpdateInput"],
	create?: GraphQLTypes["BannerCreateInput"]
};
	["FrontPageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["FrontPageWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["FrontPageWithoutLocalesCreateInput"]
};
	["LocaleUpsertFrontPagesRelationInput"]: {
		by?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	update?: GraphQLTypes["FrontPageLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["FrontPageLocaleWithoutLocaleCreateInput"]
};
	["RestaurantLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutRestaurantsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutRestaurantsCreateInput"]
};
	["RestaurantUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["RestaurantLocaleUniqueWhere"],
	update?: GraphQLTypes["RestaurantLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["RestaurantLocaleWithoutRootCreateInput"]
};
	["SubRestaurantsPageUpsertParentRestaurantRelationInput"]: {
		update?: GraphQLTypes["RestaurantUpdateInput"],
	create?: GraphQLTypes["RestaurantCreateInput"]
};
	["SubRestaurantsPageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["SubRestaurantsPageWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["SubRestaurantsPageWithoutLocalesCreateInput"]
};
	["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutSubRestaurantsPagesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutSubRestaurantsPagesUpdateInput"],
	upsert?: GraphQLTypes["SubRestaurantsPageLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutSubRestaurantsPagesUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutSubRestaurantsPagesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutSubRestaurantsPagesCreateInput"]
};
	["LinkableUpsertSubRestaurantsPageRelationInput"]: {
		update?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutLinkCreateInput"]
};
	["FrontPageLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutFrontPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutFrontPageCreateInput"]
};
	["FrontPageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["FrontPageLocaleUniqueWhere"],
	update?: GraphQLTypes["FrontPageLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["FrontPageLocaleWithoutRootCreateInput"]
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"],
	locales?: Array<GraphQLTypes["HeaderCreateLocalesEntityRelationInput"]>,
	navigationLogo?: GraphQLTypes["HeaderCreateNavigationLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"],
	alias?: string
};
	["HeaderLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	menuButtonText?: string,
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"],
	primaryLinkItems?: Array<GraphQLTypes["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"]>,
	secondaryLinks?: GraphQLTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"],
	locales?: Array<GraphQLTypes["HeaderUpdateLocalesEntityRelationInput"]>,
	navigationLogo?: GraphQLTypes["HeaderUpdateNavigationLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["HeaderUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["HeaderUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	alias?: string
};
	["HeaderUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data?: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
		menuButtonText?: string,
	locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"],
	primaryLinkItems?: Array<GraphQLTypes["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"]>,
	secondaryLinks?: GraphQLTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update?: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["LocaleConnection"]: {
	__typename: "LocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
	__typename: "LocaleEdge",
	node: GraphQLTypes["Locale"]
};
	["LocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FrontPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["FrontPageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["FrontPageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["FrontPageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleCreateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["FrontPageLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["FrontPageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["FrontPageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["FrontPageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["FrontPageLocaleUpdateSeoEntityRelationInput"],
	socialLinks?: string,
	_dummy_field_?: boolean
};
	["LinkListConnection"]: {
	__typename: "LinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkListEdge"]>
};
	["LinkListEdge"]: {
	__typename: "LinkListEdge",
	node: GraphQLTypes["LinkList"]
};
	["LinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["LinkItemCreateListEntityRelationInput"],
	link?: GraphQLTypes["LinkItemCreateLinkEntityRelationInput"],
	icon?: GraphQLTypes["LinkItemCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkListUniqueWhere"],
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["LinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["LinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["LinkItemUpdateListEntityRelationInput"],
	link?: GraphQLTypes["LinkItemUpdateLinkEntityRelationInput"],
	icon?: GraphQLTypes["LinkItemUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["LinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["LinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["LinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["LinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["LinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["LinkListWithoutItemsCreateInput"]
};
	["SocialLinkListConnection"]: {
	__typename: "SocialLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkListEdge"]>
};
	["SocialLinkListEdge"]: {
	__typename: "SocialLinkListEdge",
	node: GraphQLTypes["SocialLinkList"]
};
	["SocialLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["SocialLinkItemCreateListEntityRelationInput"],
	socialLink?: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"]
};
	["SocialLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["SocialLinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["SocialLinkItemUpdateListEntityRelationInput"],
	socialLink?: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["SocialLinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"]
};
	["PrimaryLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["PrimaryLinkItemCreateLinkEntityRelationInput"],
	parent?: GraphQLTypes["PrimaryLinkItemCreateParentEntityRelationInput"],
	subItems?: Array<GraphQLTypes["PrimaryLinkItemCreateSubItemsEntityRelationInput"]>,
	header?: GraphQLTypes["PrimaryLinkItemCreateHeaderEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PrimaryLinkItemUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["PrimaryLinkItemUpdateLinkEntityRelationInput"],
	parent?: GraphQLTypes["PrimaryLinkItemUpdateParentEntityRelationInput"],
	subItems?: Array<GraphQLTypes["PrimaryLinkItemUpdateSubItemsEntityRelationInput"]>,
	header?: GraphQLTypes["PrimaryLinkItemUpdateHeaderEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	menuButtonText?: string,
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleCreateSocialLinksEntityRelationInput"],
	primaryLinkItems?: Array<GraphQLTypes["HeaderLocaleCreatePrimaryLinkItemsEntityRelationInput"]>,
	secondaryLinks?: GraphQLTypes["HeaderLocaleCreateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleUpdateInput"]: {
		menuButtonText?: string,
	root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderLocaleUpdateSocialLinksEntityRelationInput"],
	primaryLinkItems?: Array<GraphQLTypes["HeaderLocaleUpdatePrimaryLinkItemsEntityRelationInput"]>,
	secondaryLinks?: GraphQLTypes["HeaderLocaleUpdateSecondaryLinksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"],
	locales?: Array<GraphQLTypes["FooterCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"],
	alias?: string
};
	["FooterLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"],
	linksSection?: GraphQLTypes["FooterLocaleCreateLinksSectionEntityRelationInput"],
	contactSection?: GraphQLTypes["FooterLocaleCreateContactSectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["LocaleWithoutFootersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleCreateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleCreateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleCreateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleCreateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleCreateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleCreateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"],
	locales?: Array<GraphQLTypes["FooterUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["FooterUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["FooterUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"],
	alias?: string
};
	["FooterUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	data?: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"],
	linksSection?: GraphQLTypes["FooterLocaleUpdateLinksSectionEntityRelationInput"],
	contactSection?: GraphQLTypes["FooterLocaleUpdateContactSectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutFootersCreateInput"],
	update?: GraphQLTypes["LocaleWithoutFootersUpdateInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutFootersUpdateInput"]: {
		code?: string,
	label?: string,
	frontPages?: Array<GraphQLTypes["LocaleUpdateFrontPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["LocaleUpdateRestaurantsEntityRelationInput"]>,
	restaurantTags?: Array<GraphQLTypes["LocaleUpdateRestaurantTagsEntityRelationInput"]>,
	banners?: Array<GraphQLTypes["LocaleUpdateBannersEntityRelationInput"]>,
	categories?: Array<GraphQLTypes["LocaleUpdateCategoriesEntityRelationInput"]>,
	subRestaurantsPages?: Array<GraphQLTypes["LocaleUpdateSubRestaurantsPagesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutFootersUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	update?: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"],
	linksSection?: GraphQLTypes["FooterLocaleCreateLinksSectionEntityRelationInput"],
	contactSection?: GraphQLTypes["FooterLocaleCreateContactSectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLocaleUpdateInput"]: {
		root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"],
	linksSection?: GraphQLTypes["FooterLocaleUpdateLinksSectionEntityRelationInput"],
	contactSection?: GraphQLTypes["FooterLocaleUpdateContactSectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterLinksConnection"]: {
	__typename: "FooterLinksConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLinksEdge"]>
};
	["FooterLinksEdge"]: {
	__typename: "FooterLinksEdge",
	node: GraphQLTypes["FooterLinks"]
};
	["FooterContactConnection"]: {
	__typename: "FooterContactConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterContactEdge"]>
};
	["FooterContactEdge"]: {
	__typename: "FooterContactEdge",
	node: GraphQLTypes["FooterContact"]
};
	["TitleListConnection"]: {
	__typename: "TitleListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TitleListEdge"]>
};
	["TitleListEdge"]: {
	__typename: "TitleListEdge",
	node: GraphQLTypes["TitleList"]
};
	["TitleItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	list?: GraphQLTypes["TitleItemCreateListEntityRelationInput"],
	icon?: GraphQLTypes["TitleItemCreateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TitleItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["TitleListUniqueWhere"],
	create?: GraphQLTypes["TitleListWithoutItemsCreateInput"]
};
	["TitleListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["TitleItemUpdateInput"]: {
		order?: number,
	title?: string,
	list?: GraphQLTypes["TitleItemUpdateListEntityRelationInput"],
	icon?: GraphQLTypes["TitleItemUpdateIconEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TitleItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["TitleListWithoutItemsCreateInput"],
	update?: GraphQLTypes["TitleListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["TitleItemUpsertListRelationInput"],
	connect?: GraphQLTypes["TitleListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TitleListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["TitleItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["TitleListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["TitleListWithoutItemsCreateInput"]
};
	["SocialLinkConnection"]: {
	__typename: "SocialLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkEdge"]>
};
	["SocialLinkEdge"]: {
	__typename: "SocialLinkEdge",
	node: GraphQLTypes["SocialLink"]
};
	["SecondaryLinkListConnection"]: {
	__typename: "SecondaryLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SecondaryLinkListEdge"]>
};
	["SecondaryLinkListEdge"]: {
	__typename: "SecondaryLinkListEdge",
	node: GraphQLTypes["SecondaryLinkList"]
};
	["SecondaryLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	iconType?: GraphQLTypes["IconType"],
	list?: GraphQLTypes["SecondaryLinkItemCreateListEntityRelationInput"],
	link?: GraphQLTypes["SecondaryLinkItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SecondaryLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["SecondaryLinkListUniqueWhere"],
	create?: GraphQLTypes["SecondaryLinkListWithoutItemsCreateInput"]
};
	["SecondaryLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["SecondaryLinkItemUpdateInput"]: {
		order?: number,
	iconType?: GraphQLTypes["IconType"],
	list?: GraphQLTypes["SecondaryLinkItemUpdateListEntityRelationInput"],
	link?: GraphQLTypes["SecondaryLinkItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SecondaryLinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["SecondaryLinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["SecondaryLinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["SecondaryLinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["SecondaryLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SecondaryLinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["SecondaryLinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["SecondaryLinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["SecondaryLinkListWithoutItemsCreateInput"]
};
	["RestaurantLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["RestaurantLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["RestaurantLocaleCreateLocaleEntityRelationInput"],
	description?: string,
	url?: string,
	location?: string,
	isEshopActive?: boolean,
	isDeliveryActive?: boolean,
	secondaryUrl?: string,
	_dummy_field_?: boolean
};
	["RestaurantLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["RestaurantLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["RestaurantLocaleUpdateLocaleEntityRelationInput"],
	description?: string,
	url?: string,
	location?: string,
	isEshopActive?: boolean,
	isDeliveryActive?: boolean,
	secondaryUrl?: string,
	_dummy_field_?: boolean
};
	["TranslationDomain"]: {
	__typename: "TranslationDomain",
	_meta?: GraphQLTypes["TranslationDomainMeta"],
	id: GraphQLTypes["UUID"],
	identifier: string,
	name: string,
	catalogues: Array<GraphQLTypes["TranslationCatalogue"]>,
	keys: Array<GraphQLTypes["TranslationKey"]>,
	cataloguesByIdentifier?: GraphQLTypes["TranslationCatalogue"],
	cataloguesByValues?: GraphQLTypes["TranslationCatalogue"],
	keysByIdentifier?: GraphQLTypes["TranslationKey"],
	keysByValues?: GraphQLTypes["TranslationKey"],
	paginateCatalogues: GraphQLTypes["TranslationCatalogueConnection"],
	paginateKeys: GraphQLTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
	__typename: "TranslationDomainMeta",
	id?: GraphQLTypes["FieldMeta"],
	identifier?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	catalogues?: GraphQLTypes["FieldMeta"],
	keys?: GraphQLTypes["FieldMeta"]
};
	["TranslationCatalogue"]: {
	__typename: "TranslationCatalogue",
	_meta?: GraphQLTypes["TranslationCatalogueMeta"],
	id: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomain"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifier"],
	fallback?: GraphQLTypes["TranslationCatalogue"],
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByKey?: GraphQLTypes["TranslationValue"],
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
	__typename: "TranslationCatalogueMeta",
	id?: GraphQLTypes["FieldMeta"],
	domain?: GraphQLTypes["FieldMeta"],
	identifier?: GraphQLTypes["FieldMeta"],
	fallback?: GraphQLTypes["FieldMeta"],
	values?: GraphQLTypes["FieldMeta"]
};
	["TranslationDomainWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	identifier?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	catalogues?: GraphQLTypes["TranslationCatalogueWhere"],
	keys?: GraphQLTypes["TranslationKeyWhere"],
	and?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined>,
	not?: GraphQLTypes["TranslationDomainWhere"]
};
	["TranslationCatalogueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	domain?: GraphQLTypes["TranslationDomainWhere"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierWhere"],
	fallback?: GraphQLTypes["TranslationCatalogueWhere"],
	values?: GraphQLTypes["TranslationValueWhere"],
	and?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined>,
	not?: GraphQLTypes["TranslationCatalogueWhere"]
};
	["TranslationCataloguesIdentifierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	code?: GraphQLTypes["StringCondition"],
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"],
	and?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined>,
	not?: GraphQLTypes["TranslationCataloguesIdentifierWhere"]
};
	["TranslationValueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	value?: GraphQLTypes["StringCondition"],
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"],
	key?: GraphQLTypes["TranslationKeyWhere"],
	and?: Array<GraphQLTypes["TranslationValueWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationValueWhere"] | undefined>,
	not?: GraphQLTypes["TranslationValueWhere"]
};
	["TranslationKeyWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	identifier?: GraphQLTypes["StringCondition"],
	contentType?: GraphQLTypes["TranslationContentTypeCondition"],
	note?: GraphQLTypes["StringCondition"],
	domain?: GraphQLTypes["TranslationDomainWhere"],
	values?: GraphQLTypes["TranslationValueWhere"],
	and?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined>,
	not?: GraphQLTypes["TranslationKeyWhere"]
};
	["TranslationContentTypeCondition"]: {
		and?: Array<GraphQLTypes["TranslationContentTypeCondition"]>,
	or?: Array<GraphQLTypes["TranslationContentTypeCondition"]>,
	not?: GraphQLTypes["TranslationContentTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["TranslationContentType"],
	notEq?: GraphQLTypes["TranslationContentType"],
	in?: Array<GraphQLTypes["TranslationContentType"]>,
	notIn?: Array<GraphQLTypes["TranslationContentType"]>,
	lt?: GraphQLTypes["TranslationContentType"],
	lte?: GraphQLTypes["TranslationContentType"],
	gt?: GraphQLTypes["TranslationContentType"],
	gte?: GraphQLTypes["TranslationContentType"]
};
	["TranslationContentType"]: TranslationContentType;
	["TranslationCataloguesIdentifier"]: {
	__typename: "TranslationCataloguesIdentifier",
	_meta?: GraphQLTypes["TranslationCataloguesIdentifierMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	catalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	catalogueByDomain?: GraphQLTypes["TranslationCatalogue"],
	catalogueByValues?: GraphQLTypes["TranslationCatalogue"],
	paginateCatalogue: GraphQLTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
	__typename: "TranslationCataloguesIdentifierMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	code?: GraphQLTypes["FieldMeta"],
	catalogue?: GraphQLTypes["FieldMeta"]
};
	["TranslationCatalogueOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	domain?: GraphQLTypes["TranslationDomainOrderBy"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"],
	fallback?: GraphQLTypes["TranslationCatalogueOrderBy"]
};
	["TranslationDomainOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	identifier?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"]
};
	["TranslationCataloguesIdentifierOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	code?: GraphQLTypes["OrderDirection"]
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
		domain?: GraphQLTypes["TranslationDomainUniqueWhere"]
};
	["TranslationDomainUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	catalogues?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	keys?: GraphQLTypes["TranslationKeyUniqueWhere"]
};
	["TranslationCatalogueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"],
	values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"]
};
	["TranslationValueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	key?: GraphQLTypes["TranslationKeyUniqueWhere"]
};
	["TranslationKeyUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"],
	identifier?: string,
	values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationCatalogueConnection"]: {
	__typename: "TranslationCatalogueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCatalogueEdge"]>
};
	["TranslationCatalogueEdge"]: {
	__typename: "TranslationCatalogueEdge",
	node: GraphQLTypes["TranslationCatalogue"]
};
	["TranslationValue"]: {
	__typename: "TranslationValue",
	_meta?: GraphQLTypes["TranslationValueMeta"],
	id: GraphQLTypes["UUID"],
	value: string,
	catalogue?: GraphQLTypes["TranslationCatalogue"],
	key?: GraphQLTypes["TranslationKey"]
};
	["TranslationValueMeta"]: {
	__typename: "TranslationValueMeta",
	id?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	catalogue?: GraphQLTypes["FieldMeta"],
	key?: GraphQLTypes["FieldMeta"]
};
	["TranslationKey"]: {
	__typename: "TranslationKey",
	_meta?: GraphQLTypes["TranslationKeyMeta"],
	id: GraphQLTypes["UUID"],
	identifier: string,
	contentType: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationDomain"],
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByCatalogue?: GraphQLTypes["TranslationValue"],
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
	__typename: "TranslationKeyMeta",
	id?: GraphQLTypes["FieldMeta"],
	identifier?: GraphQLTypes["FieldMeta"],
	contentType?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"],
	domain?: GraphQLTypes["FieldMeta"],
	values?: GraphQLTypes["FieldMeta"]
};
	["TranslationValueOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"],
	catalogue?: GraphQLTypes["TranslationCatalogueOrderBy"],
	key?: GraphQLTypes["TranslationKeyOrderBy"]
};
	["TranslationKeyOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	identifier?: GraphQLTypes["OrderDirection"],
	contentType?: GraphQLTypes["OrderDirection"],
	note?: GraphQLTypes["OrderDirection"],
	domain?: GraphQLTypes["TranslationDomainOrderBy"]
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
		catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"]
};
	["TranslationValueConnection"]: {
	__typename: "TranslationValueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationValueEdge"]>
};
	["TranslationValueEdge"]: {
	__typename: "TranslationValueEdge",
	node: GraphQLTypes["TranslationValue"]
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
		key?: GraphQLTypes["TranslationKeyUniqueWhere"]
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"]
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
		identifier?: string
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationKeyConnection"]: {
	__typename: "TranslationKeyConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationKeyEdge"]>
};
	["TranslationKeyEdge"]: {
	__typename: "TranslationKeyEdge",
	node: GraphQLTypes["TranslationKey"]
};
	["TranslationDomainConnection"]: {
	__typename: "TranslationDomainConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationDomainEdge"]>
};
	["TranslationDomainEdge"]: {
	__typename: "TranslationDomainEdge",
	node: GraphQLTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]>,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"],
	alias?: string
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"],
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueCreateInput"]
};
	["TranslationCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	name?: string,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"],
	alias?: string
};
	["TranslationKeyWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"],
	alias?: string
};
	["TranslationValueWithoutKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	value?: string,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"],
	alias?: string
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	value?: string,
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationKeyWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationDomainWithoutKeysCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainUpdateInput"]: {
		identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]>,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"],
	update?: GraphQLTypes["TranslationDomainUpdateCataloguesRelationInput"],
	upsert?: GraphQLTypes["TranslationDomainUpsertCataloguesRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	alias?: string
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	data?: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"]
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
		identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"],
	update?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertIdentifierRelationInput"],
	connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"],
	delete?: boolean
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
		name?: string,
	code?: string,
	_dummy_field_?: boolean
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
		update?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"],
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueCreateInput"],
	update?: GraphQLTypes["TranslationCatalogueUpdateInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertFallbackRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TranslationCatalogueUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"],
	update?: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertDomainRelationInput"],
	connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	delete?: boolean
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
		identifier?: string,
	name?: string,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"],
	update?: GraphQLTypes["TranslationDomainUpdateKeysRelationInput"],
	upsert?: GraphQLTypes["TranslationDomainUpsertKeysRelationInput"],
	connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	delete?: GraphQLTypes["TranslationKeyUniqueWhere"],
	alias?: string
};
	["TranslationDomainUpdateKeysRelationInput"]: {
		by?: GraphQLTypes["TranslationKeyUniqueWhere"],
	data?: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"]
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
		identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"],
	update?: GraphQLTypes["TranslationKeyUpdateValuesRelationInput"],
	upsert?: GraphQLTypes["TranslationKeyUpsertValuesRelationInput"],
	connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"],
	delete?: GraphQLTypes["TranslationValueUniqueWhere"],
	alias?: string
};
	["TranslationKeyUpdateValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	data?: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"]
};
	["TranslationValueWithoutKeyUpdateInput"]: {
		value?: string,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"],
	update?: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"],
	upsert?: GraphQLTypes["TranslationValueUpsertCatalogueRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	delete?: boolean
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
		update?: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyUpsertValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	update?: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"],
	create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainUpsertKeysRelationInput"]: {
		by?: GraphQLTypes["TranslationKeyUniqueWhere"],
	update?: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"],
	create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
		update?: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"],
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"],
	update?: GraphQLTypes["TranslationCatalogueUpdateValuesRelationInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertValuesRelationInput"],
	connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"],
	delete?: GraphQLTypes["TranslationValueUniqueWhere"],
	alias?: string
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	data?: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"]
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
		value?: string,
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"],
	update?: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"],
	upsert?: GraphQLTypes["TranslationValueUpsertKeyRelationInput"],
	connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	delete?: boolean
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
		identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"],
	update?: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"],
	upsert?: GraphQLTypes["TranslationKeyUpsertDomainRelationInput"],
	connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	delete?: boolean
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
		identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyUpsertDomainRelationInput"]: {
		update?: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"],
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueUpsertKeyRelationInput"]: {
		update?: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"],
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	update?: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"],
	create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
		update?: GraphQLTypes["TranslationCatalogueUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueCreateInput"]
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	update?: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationCataloguesIdentifierConnection"]: {
	__typename: "TranslationCataloguesIdentifierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCataloguesIdentifierEdge"]>
};
	["TranslationCataloguesIdentifierEdge"]: {
	__typename: "TranslationCataloguesIdentifierEdge",
	node: GraphQLTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"],
	alias?: string
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
		name?: string,
	code?: string,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"],
	update?: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"],
	upsert?: GraphQLTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	alias?: string
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	data?: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"]
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	update?: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyUpdateInput"]: {
		identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationValueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	value?: string,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"],
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpdateInput"]: {
		value?: string,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"],
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	parent?: GraphQLTypes["RestaurantItemCreateParentEntityRelationInput"],
	order?: number,
	restaurant?: GraphQLTypes["RestaurantItemCreateRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantItemUpdateInput"]: {
		parent?: GraphQLTypes["RestaurantItemUpdateParentEntityRelationInput"],
	order?: number,
	restaurant?: GraphQLTypes["RestaurantItemUpdateRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantTagCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["RestaurantTagCreateLocalesEntityRelationInput"]>,
	backgroundColor?: string,
	titleColor?: string,
	restaurants?: Array<GraphQLTypes["RestaurantTagCreateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantTagUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["RestaurantTagUpdateLocalesEntityRelationInput"]>,
	backgroundColor?: string,
	titleColor?: string,
	restaurants?: Array<GraphQLTypes["RestaurantTagUpdateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["RestaurantTagLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["RestaurantTagLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["RestaurantTagLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RestaurantTagLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["RestaurantTagLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["RestaurantTagLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BannerConnection"]: {
	__typename: "BannerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BannerEdge"]>
};
	["BannerEdge"]: {
	__typename: "BannerEdge",
	node: GraphQLTypes["Banner"]
};
	["BannerLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	text?: string,
	root?: GraphQLTypes["BannerLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["BannerLocaleCreateLocaleEntityRelationInput"],
	title?: string,
	url?: string,
	_dummy_field_?: boolean
};
	["BannerLocaleUpdateInput"]: {
		text?: string,
	root?: GraphQLTypes["BannerLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["BannerLocaleUpdateLocaleEntityRelationInput"],
	title?: string,
	url?: string,
	_dummy_field_?: boolean
};
	["CategoryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["CategoryCreateLocalesEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["CategoryCreateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CategoryUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["CategoryUpdateLocalesEntityRelationInput"]>,
	restaurants?: Array<GraphQLTypes["CategoryUpdateRestaurantsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["CategoryLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["CategoryLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["CategoryLocaleCreateLocaleEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["CategoryLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["CategoryLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["CategoryLocaleUpdateLocaleEntityRelationInput"],
	slug?: string,
	_dummy_field_?: boolean
};
	["SubRestaurantsPageConnection"]: {
	__typename: "SubRestaurantsPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SubRestaurantsPageEdge"]>
};
	["SubRestaurantsPageEdge"]: {
	__typename: "SubRestaurantsPageEdge",
	node: GraphQLTypes["SubRestaurantsPage"]
};
	["SubRestaurantsPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["SubRestaurantsPageCreateLocalesEntityRelationInput"]>,
	order?: number,
	parentRestaurant?: GraphQLTypes["SubRestaurantsPageCreateParentRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutRootCreateInput"],
	alias?: string
};
	["SubRestaurantsPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"],
	locale?: GraphQLTypes["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageUpdateInput"]: {
		locales?: Array<GraphQLTypes["SubRestaurantsPageUpdateLocalesEntityRelationInput"]>,
	order?: number,
	parentRestaurant?: GraphQLTypes["SubRestaurantsPageUpdateParentRestaurantEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["SubRestaurantsPageUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["SubRestaurantsPageUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	delete?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	alias?: string
};
	["SubRestaurantsPageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	data?: GraphQLTypes["SubRestaurantsPageLocaleWithoutRootUpdateInput"]
};
	["SubRestaurantsPageLocaleWithoutRootUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"],
	locale?: GraphQLTypes["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["SubRestaurantsPageLocaleUniqueWhere"],
	update?: GraphQLTypes["SubRestaurantsPageLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["SubRestaurantsPageLocaleWithoutRootCreateInput"]
};
	["SubRestaurantsPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["SubRestaurantsPageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["SubRestaurantsPageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["SubRestaurantsPageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SubRestaurantsPageLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["SubRestaurantsPageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["SubRestaurantsPageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["SubRestaurantsPageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SubRestaurantsPageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageList"]: {
	__typename: "ImageList",
	_meta?: GraphQLTypes["ImageListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ImageListItem"]>,
	itemsByImage?: GraphQLTypes["ImageListItem"],
	paginateItems: GraphQLTypes["ImageListItemConnection"]
};
	["ImageListMeta"]: {
	__typename: "ImageListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ImageListItem"]: {
	__typename: "ImageListItem",
	_meta?: GraphQLTypes["ImageListItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ImageList"],
	image?: GraphQLTypes["Image"]
};
	["ImageListItemMeta"]: {
	__typename: "ImageListItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ImageListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ImageListItemWhere"],
	and?: Array<GraphQLTypes["ImageListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageListWhere"] | undefined>,
	not?: GraphQLTypes["ImageListWhere"]
};
	["ImageListItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ImageListWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ImageListItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageListItemWhere"] | undefined>,
	not?: GraphQLTypes["ImageListItemWhere"]
};
	["ImageListItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ImageListOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ImageListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ImageListItemsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageListItemConnection"]: {
	__typename: "ImageListItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListItemEdge"]>
};
	["ImageListItemEdge"]: {
	__typename: "ImageListItemEdge",
	node: GraphQLTypes["ImageListItem"]
};
	["ImageListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ImageListItemUniqueWhere"]
};
	["ImageListItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageListConnection"]: {
	__typename: "ImageListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageListEdge"]>
};
	["ImageListEdge"]: {
	__typename: "ImageListEdge",
	node: GraphQLTypes["ImageList"]
};
	["ImageListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ImageListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListItemUniqueWhere"],
	create?: GraphQLTypes["ImageListItemWithoutListCreateInput"],
	alias?: string
};
	["ImageListItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageListUpdateInput"]: {
		items?: Array<GraphQLTypes["ImageListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ImageListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListItemWithoutListCreateInput"],
	update?: GraphQLTypes["ImageListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ImageListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ImageListItemUniqueWhere"],
	disconnect?: GraphQLTypes["ImageListItemUniqueWhere"],
	delete?: GraphQLTypes["ImageListItemUniqueWhere"],
	alias?: string
};
	["ImageListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ImageListItemUniqueWhere"],
	data?: GraphQLTypes["ImageListItemWithoutListUpdateInput"]
};
	["ImageListItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ImageListItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageListItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ImageListItemUniqueWhere"],
	update?: GraphQLTypes["ImageListItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ImageListItemWithoutListCreateInput"]
};
	["ImageListItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ImageListItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["ImageListItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageListUniqueWhere"],
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["ImageListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ImageListItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ImageListItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["ImageListItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ImageListItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ImageListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ImageListItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ImageListUniqueWhere"],
	delete?: boolean
};
	["ImageListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ImageListItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ImageListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ImageListWithoutItemsCreateInput"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getFrontPage?: GraphQLTypes["FrontPage"],
	listFrontPage: Array<GraphQLTypes["FrontPage"]>,
	paginateFrontPage: GraphQLTypes["FrontPageConnection"],
	validateCreateFrontPage: GraphQLTypes["_ValidationResult"],
	validateUpdateFrontPage: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"],
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getFrontPageLocale?: GraphQLTypes["FrontPageLocale"],
	listFrontPageLocale: Array<GraphQLTypes["FrontPageLocale"]>,
	paginateFrontPageLocale: GraphQLTypes["FrontPageLocaleConnection"],
	validateCreateFrontPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFrontPageLocale: GraphQLTypes["_ValidationResult"],
	getLinkList?: GraphQLTypes["LinkList"],
	listLinkList: Array<GraphQLTypes["LinkList"]>,
	paginateLinkList: GraphQLTypes["LinkListConnection"],
	validateCreateLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkList: GraphQLTypes["_ValidationResult"],
	getLinkItem?: GraphQLTypes["LinkItem"],
	listLinkItem: Array<GraphQLTypes["LinkItem"]>,
	paginateLinkItem: GraphQLTypes["LinkItemConnection"],
	validateCreateLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkItem: GraphQLTypes["_ValidationResult"],
	getSocialLinkList?: GraphQLTypes["SocialLinkList"],
	listSocialLinkList: Array<GraphQLTypes["SocialLinkList"]>,
	paginateSocialLinkList: GraphQLTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkList: GraphQLTypes["_ValidationResult"],
	getSocialLinkItem?: GraphQLTypes["SocialLinkItem"],
	listSocialLinkItem: Array<GraphQLTypes["SocialLinkItem"]>,
	paginateSocialLinkItem: GraphQLTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	getPrimaryLinkItem?: GraphQLTypes["PrimaryLinkItem"],
	listPrimaryLinkItem: Array<GraphQLTypes["PrimaryLinkItem"]>,
	paginatePrimaryLinkItem: GraphQLTypes["PrimaryLinkItemConnection"],
	validateCreatePrimaryLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdatePrimaryLinkItem: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"],
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"],
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getFooterLinks?: GraphQLTypes["FooterLinks"],
	listFooterLinks: Array<GraphQLTypes["FooterLinks"]>,
	paginateFooterLinks: GraphQLTypes["FooterLinksConnection"],
	validateCreateFooterLinks: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLinks: GraphQLTypes["_ValidationResult"],
	getFooterContact?: GraphQLTypes["FooterContact"],
	listFooterContact: Array<GraphQLTypes["FooterContact"]>,
	paginateFooterContact: GraphQLTypes["FooterContactConnection"],
	validateCreateFooterContact: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterContact: GraphQLTypes["_ValidationResult"],
	getTitleList?: GraphQLTypes["TitleList"],
	listTitleList: Array<GraphQLTypes["TitleList"]>,
	paginateTitleList: GraphQLTypes["TitleListConnection"],
	validateCreateTitleList: GraphQLTypes["_ValidationResult"],
	validateUpdateTitleList: GraphQLTypes["_ValidationResult"],
	getTitleItem?: GraphQLTypes["TitleItem"],
	listTitleItem: Array<GraphQLTypes["TitleItem"]>,
	paginateTitleItem: GraphQLTypes["TitleItemConnection"],
	validateCreateTitleItem: GraphQLTypes["_ValidationResult"],
	validateUpdateTitleItem: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getSecondaryLinkList?: GraphQLTypes["SecondaryLinkList"],
	listSecondaryLinkList: Array<GraphQLTypes["SecondaryLinkList"]>,
	paginateSecondaryLinkList: GraphQLTypes["SecondaryLinkListConnection"],
	validateCreateSecondaryLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSecondaryLinkList: GraphQLTypes["_ValidationResult"],
	getSecondaryLinkItem?: GraphQLTypes["SecondaryLinkItem"],
	listSecondaryLinkItem: Array<GraphQLTypes["SecondaryLinkItem"]>,
	paginateSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemConnection"],
	validateCreateSecondaryLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSecondaryLinkItem: GraphQLTypes["_ValidationResult"],
	getRestaurant?: GraphQLTypes["Restaurant"],
	listRestaurant: Array<GraphQLTypes["Restaurant"]>,
	paginateRestaurant: GraphQLTypes["RestaurantConnection"],
	validateCreateRestaurant: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurant: GraphQLTypes["_ValidationResult"],
	getRestaurantLocale?: GraphQLTypes["RestaurantLocale"],
	listRestaurantLocale: Array<GraphQLTypes["RestaurantLocale"]>,
	paginateRestaurantLocale: GraphQLTypes["RestaurantLocaleConnection"],
	validateCreateRestaurantLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantLocale: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"],
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"],
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"],
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"],
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getRestaurantItem?: GraphQLTypes["RestaurantItem"],
	listRestaurantItem: Array<GraphQLTypes["RestaurantItem"]>,
	paginateRestaurantItem: GraphQLTypes["RestaurantItemConnection"],
	validateCreateRestaurantItem: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantItem: GraphQLTypes["_ValidationResult"],
	getRestaurantTag?: GraphQLTypes["RestaurantTag"],
	listRestaurantTag: Array<GraphQLTypes["RestaurantTag"]>,
	paginateRestaurantTag: GraphQLTypes["RestaurantTagConnection"],
	validateCreateRestaurantTag: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantTag: GraphQLTypes["_ValidationResult"],
	getRestaurantTagLocale?: GraphQLTypes["RestaurantTagLocale"],
	listRestaurantTagLocale: Array<GraphQLTypes["RestaurantTagLocale"]>,
	paginateRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleConnection"],
	validateCreateRestaurantTagLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateRestaurantTagLocale: GraphQLTypes["_ValidationResult"],
	getBanner?: GraphQLTypes["Banner"],
	listBanner: Array<GraphQLTypes["Banner"]>,
	paginateBanner: GraphQLTypes["BannerConnection"],
	validateCreateBanner: GraphQLTypes["_ValidationResult"],
	validateUpdateBanner: GraphQLTypes["_ValidationResult"],
	getBannerLocale?: GraphQLTypes["BannerLocale"],
	listBannerLocale: Array<GraphQLTypes["BannerLocale"]>,
	paginateBannerLocale: GraphQLTypes["BannerLocaleConnection"],
	validateCreateBannerLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateBannerLocale: GraphQLTypes["_ValidationResult"],
	getCategory?: GraphQLTypes["Category"],
	listCategory: Array<GraphQLTypes["Category"]>,
	paginateCategory: GraphQLTypes["CategoryConnection"],
	validateCreateCategory: GraphQLTypes["_ValidationResult"],
	validateUpdateCategory: GraphQLTypes["_ValidationResult"],
	getCategoryLocale?: GraphQLTypes["CategoryLocale"],
	listCategoryLocale: Array<GraphQLTypes["CategoryLocale"]>,
	paginateCategoryLocale: GraphQLTypes["CategoryLocaleConnection"],
	validateCreateCategoryLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateCategoryLocale: GraphQLTypes["_ValidationResult"],
	getSubRestaurantsPage?: GraphQLTypes["SubRestaurantsPage"],
	listSubRestaurantsPage: Array<GraphQLTypes["SubRestaurantsPage"]>,
	paginateSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageConnection"],
	validateCreateSubRestaurantsPage: GraphQLTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPage: GraphQLTypes["_ValidationResult"],
	getSubRestaurantsPageLocale?: GraphQLTypes["SubRestaurantsPageLocale"],
	listSubRestaurantsPageLocale: Array<GraphQLTypes["SubRestaurantsPageLocale"]>,
	paginateSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleConnection"],
	validateCreateSubRestaurantsPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSubRestaurantsPageLocale: GraphQLTypes["_ValidationResult"],
	getImageList?: GraphQLTypes["ImageList"],
	listImageList: Array<GraphQLTypes["ImageList"]>,
	paginateImageList: GraphQLTypes["ImageListConnection"],
	validateCreateImageList: GraphQLTypes["_ValidationResult"],
	validateUpdateImageList: GraphQLTypes["_ValidationResult"],
	getImageListItem?: GraphQLTypes["ImageListItem"],
	listImageListItem: Array<GraphQLTypes["ImageListItem"]>,
	paginateImageListItem: GraphQLTypes["ImageListItemConnection"],
	validateCreateImageListItem: GraphQLTypes["_ValidationResult"],
	validateUpdateImageListItem: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createFrontPage: GraphQLTypes["FrontPageCreateResult"],
	deleteFrontPage: GraphQLTypes["FrontPageDeleteResult"],
	updateFrontPage: GraphQLTypes["FrontPageUpdateResult"],
	upsertFrontPage: GraphQLTypes["FrontPageUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createFrontPageLocale: GraphQLTypes["FrontPageLocaleCreateResult"],
	deleteFrontPageLocale: GraphQLTypes["FrontPageLocaleDeleteResult"],
	updateFrontPageLocale: GraphQLTypes["FrontPageLocaleUpdateResult"],
	upsertFrontPageLocale: GraphQLTypes["FrontPageLocaleUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createSocialLinkList: GraphQLTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList: GraphQLTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList: GraphQLTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList: GraphQLTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem: GraphQLTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem: GraphQLTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem: GraphQLTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem: GraphQLTypes["SocialLinkItemUpsertResult"],
	createPrimaryLinkItem: GraphQLTypes["PrimaryLinkItemCreateResult"],
	deletePrimaryLinkItem: GraphQLTypes["PrimaryLinkItemDeleteResult"],
	updatePrimaryLinkItem: GraphQLTypes["PrimaryLinkItemUpdateResult"],
	upsertPrimaryLinkItem: GraphQLTypes["PrimaryLinkItemUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createFooterLinks: GraphQLTypes["FooterLinksCreateResult"],
	deleteFooterLinks: GraphQLTypes["FooterLinksDeleteResult"],
	updateFooterLinks: GraphQLTypes["FooterLinksUpdateResult"],
	upsertFooterLinks: GraphQLTypes["FooterLinksUpsertResult"],
	createFooterContact: GraphQLTypes["FooterContactCreateResult"],
	deleteFooterContact: GraphQLTypes["FooterContactDeleteResult"],
	updateFooterContact: GraphQLTypes["FooterContactUpdateResult"],
	upsertFooterContact: GraphQLTypes["FooterContactUpsertResult"],
	createTitleList: GraphQLTypes["TitleListCreateResult"],
	deleteTitleList: GraphQLTypes["TitleListDeleteResult"],
	updateTitleList: GraphQLTypes["TitleListUpdateResult"],
	upsertTitleList: GraphQLTypes["TitleListUpsertResult"],
	createTitleItem: GraphQLTypes["TitleItemCreateResult"],
	deleteTitleItem: GraphQLTypes["TitleItemDeleteResult"],
	updateTitleItem: GraphQLTypes["TitleItemUpdateResult"],
	upsertTitleItem: GraphQLTypes["TitleItemUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createSecondaryLinkList: GraphQLTypes["SecondaryLinkListCreateResult"],
	deleteSecondaryLinkList: GraphQLTypes["SecondaryLinkListDeleteResult"],
	updateSecondaryLinkList: GraphQLTypes["SecondaryLinkListUpdateResult"],
	upsertSecondaryLinkList: GraphQLTypes["SecondaryLinkListUpsertResult"],
	createSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemCreateResult"],
	deleteSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemDeleteResult"],
	updateSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemUpdateResult"],
	upsertSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemUpsertResult"],
	createRestaurant: GraphQLTypes["RestaurantCreateResult"],
	deleteRestaurant: GraphQLTypes["RestaurantDeleteResult"],
	updateRestaurant: GraphQLTypes["RestaurantUpdateResult"],
	upsertRestaurant: GraphQLTypes["RestaurantUpsertResult"],
	createRestaurantLocale: GraphQLTypes["RestaurantLocaleCreateResult"],
	deleteRestaurantLocale: GraphQLTypes["RestaurantLocaleDeleteResult"],
	updateRestaurantLocale: GraphQLTypes["RestaurantLocaleUpdateResult"],
	upsertRestaurantLocale: GraphQLTypes["RestaurantLocaleUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createRestaurantItem: GraphQLTypes["RestaurantItemCreateResult"],
	deleteRestaurantItem: GraphQLTypes["RestaurantItemDeleteResult"],
	updateRestaurantItem: GraphQLTypes["RestaurantItemUpdateResult"],
	upsertRestaurantItem: GraphQLTypes["RestaurantItemUpsertResult"],
	createRestaurantTag: GraphQLTypes["RestaurantTagCreateResult"],
	deleteRestaurantTag: GraphQLTypes["RestaurantTagDeleteResult"],
	updateRestaurantTag: GraphQLTypes["RestaurantTagUpdateResult"],
	upsertRestaurantTag: GraphQLTypes["RestaurantTagUpsertResult"],
	createRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleCreateResult"],
	deleteRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleDeleteResult"],
	updateRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleUpdateResult"],
	upsertRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleUpsertResult"],
	createBanner: GraphQLTypes["BannerCreateResult"],
	deleteBanner: GraphQLTypes["BannerDeleteResult"],
	updateBanner: GraphQLTypes["BannerUpdateResult"],
	upsertBanner: GraphQLTypes["BannerUpsertResult"],
	createBannerLocale: GraphQLTypes["BannerLocaleCreateResult"],
	deleteBannerLocale: GraphQLTypes["BannerLocaleDeleteResult"],
	updateBannerLocale: GraphQLTypes["BannerLocaleUpdateResult"],
	upsertBannerLocale: GraphQLTypes["BannerLocaleUpsertResult"],
	createCategory: GraphQLTypes["CategoryCreateResult"],
	deleteCategory: GraphQLTypes["CategoryDeleteResult"],
	updateCategory: GraphQLTypes["CategoryUpdateResult"],
	upsertCategory: GraphQLTypes["CategoryUpsertResult"],
	createCategoryLocale: GraphQLTypes["CategoryLocaleCreateResult"],
	deleteCategoryLocale: GraphQLTypes["CategoryLocaleDeleteResult"],
	updateCategoryLocale: GraphQLTypes["CategoryLocaleUpdateResult"],
	upsertCategoryLocale: GraphQLTypes["CategoryLocaleUpsertResult"],
	createSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageCreateResult"],
	deleteSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageDeleteResult"],
	updateSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageUpdateResult"],
	upsertSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageUpsertResult"],
	createSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleCreateResult"],
	deleteSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleDeleteResult"],
	updateSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleUpdateResult"],
	upsertSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["FrontPageCreateResult"]: {
	__typename: "FrontPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"FrontPageCreateResult" | "FrontPageDeleteResult" | "FrontPageUpdateResult" | "FrontPageUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "LocaleCreateResult" | "LocaleDeleteResult" | "LocaleUpdateResult" | "LocaleUpsertResult" | "FrontPageLocaleCreateResult" | "FrontPageLocaleDeleteResult" | "FrontPageLocaleUpdateResult" | "FrontPageLocaleUpsertResult" | "LinkListCreateResult" | "LinkListDeleteResult" | "LinkListUpdateResult" | "LinkListUpsertResult" | "LinkItemCreateResult" | "LinkItemDeleteResult" | "LinkItemUpdateResult" | "LinkItemUpsertResult" | "SocialLinkListCreateResult" | "SocialLinkListDeleteResult" | "SocialLinkListUpdateResult" | "SocialLinkListUpsertResult" | "SocialLinkItemCreateResult" | "SocialLinkItemDeleteResult" | "SocialLinkItemUpdateResult" | "SocialLinkItemUpsertResult" | "PrimaryLinkItemCreateResult" | "PrimaryLinkItemDeleteResult" | "PrimaryLinkItemUpdateResult" | "PrimaryLinkItemUpsertResult" | "HeaderLocaleCreateResult" | "HeaderLocaleDeleteResult" | "HeaderLocaleUpdateResult" | "HeaderLocaleUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "FooterLocaleCreateResult" | "FooterLocaleDeleteResult" | "FooterLocaleUpdateResult" | "FooterLocaleUpsertResult" | "FooterLinksCreateResult" | "FooterLinksDeleteResult" | "FooterLinksUpdateResult" | "FooterLinksUpsertResult" | "FooterContactCreateResult" | "FooterContactDeleteResult" | "FooterContactUpdateResult" | "FooterContactUpsertResult" | "TitleListCreateResult" | "TitleListDeleteResult" | "TitleListUpdateResult" | "TitleListUpsertResult" | "TitleItemCreateResult" | "TitleItemDeleteResult" | "TitleItemUpdateResult" | "TitleItemUpsertResult" | "SocialLinkCreateResult" | "SocialLinkDeleteResult" | "SocialLinkUpdateResult" | "SocialLinkUpsertResult" | "SecondaryLinkListCreateResult" | "SecondaryLinkListDeleteResult" | "SecondaryLinkListUpdateResult" | "SecondaryLinkListUpsertResult" | "SecondaryLinkItemCreateResult" | "SecondaryLinkItemDeleteResult" | "SecondaryLinkItemUpdateResult" | "SecondaryLinkItemUpsertResult" | "RestaurantCreateResult" | "RestaurantDeleteResult" | "RestaurantUpdateResult" | "RestaurantUpsertResult" | "RestaurantLocaleCreateResult" | "RestaurantLocaleDeleteResult" | "RestaurantLocaleUpdateResult" | "RestaurantLocaleUpsertResult" | "TranslationDomainCreateResult" | "TranslationDomainDeleteResult" | "TranslationDomainUpdateResult" | "TranslationDomainUpsertResult" | "TranslationCatalogueCreateResult" | "TranslationCatalogueDeleteResult" | "TranslationCatalogueUpdateResult" | "TranslationCatalogueUpsertResult" | "TranslationCataloguesIdentifierCreateResult" | "TranslationCataloguesIdentifierDeleteResult" | "TranslationCataloguesIdentifierUpdateResult" | "TranslationCataloguesIdentifierUpsertResult" | "TranslationKeyCreateResult" | "TranslationKeyDeleteResult" | "TranslationKeyUpdateResult" | "TranslationKeyUpsertResult" | "TranslationValueCreateResult" | "TranslationValueDeleteResult" | "TranslationValueUpdateResult" | "TranslationValueUpsertResult" | "RestaurantItemCreateResult" | "RestaurantItemDeleteResult" | "RestaurantItemUpdateResult" | "RestaurantItemUpsertResult" | "RestaurantTagCreateResult" | "RestaurantTagDeleteResult" | "RestaurantTagUpdateResult" | "RestaurantTagUpsertResult" | "RestaurantTagLocaleCreateResult" | "RestaurantTagLocaleDeleteResult" | "RestaurantTagLocaleUpdateResult" | "RestaurantTagLocaleUpsertResult" | "BannerCreateResult" | "BannerDeleteResult" | "BannerUpdateResult" | "BannerUpsertResult" | "BannerLocaleCreateResult" | "BannerLocaleDeleteResult" | "BannerLocaleUpdateResult" | "BannerLocaleUpsertResult" | "CategoryCreateResult" | "CategoryDeleteResult" | "CategoryUpdateResult" | "CategoryUpsertResult" | "CategoryLocaleCreateResult" | "CategoryLocaleDeleteResult" | "CategoryLocaleUpdateResult" | "CategoryLocaleUpsertResult" | "SubRestaurantsPageCreateResult" | "SubRestaurantsPageDeleteResult" | "SubRestaurantsPageUpdateResult" | "SubRestaurantsPageUpsertResult" | "SubRestaurantsPageLocaleCreateResult" | "SubRestaurantsPageLocaleDeleteResult" | "SubRestaurantsPageLocaleUpdateResult" | "SubRestaurantsPageLocaleUpsertResult" | "ImageListCreateResult" | "ImageListDeleteResult" | "ImageListUpdateResult" | "ImageListUpsertResult" | "ImageListItemCreateResult" | "ImageListItemDeleteResult" | "ImageListItemUpdateResult" | "ImageListItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on FrontPageCreateResult']: '__union' & GraphQLTypes["FrontPageCreateResult"];
	['...on FrontPageDeleteResult']: '__union' & GraphQLTypes["FrontPageDeleteResult"];
	['...on FrontPageUpdateResult']: '__union' & GraphQLTypes["FrontPageUpdateResult"];
	['...on FrontPageUpsertResult']: '__union' & GraphQLTypes["FrontPageUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on LocaleCreateResult']: '__union' & GraphQLTypes["LocaleCreateResult"];
	['...on LocaleDeleteResult']: '__union' & GraphQLTypes["LocaleDeleteResult"];
	['...on LocaleUpdateResult']: '__union' & GraphQLTypes["LocaleUpdateResult"];
	['...on LocaleUpsertResult']: '__union' & GraphQLTypes["LocaleUpsertResult"];
	['...on FrontPageLocaleCreateResult']: '__union' & GraphQLTypes["FrontPageLocaleCreateResult"];
	['...on FrontPageLocaleDeleteResult']: '__union' & GraphQLTypes["FrontPageLocaleDeleteResult"];
	['...on FrontPageLocaleUpdateResult']: '__union' & GraphQLTypes["FrontPageLocaleUpdateResult"];
	['...on FrontPageLocaleUpsertResult']: '__union' & GraphQLTypes["FrontPageLocaleUpsertResult"];
	['...on LinkListCreateResult']: '__union' & GraphQLTypes["LinkListCreateResult"];
	['...on LinkListDeleteResult']: '__union' & GraphQLTypes["LinkListDeleteResult"];
	['...on LinkListUpdateResult']: '__union' & GraphQLTypes["LinkListUpdateResult"];
	['...on LinkListUpsertResult']: '__union' & GraphQLTypes["LinkListUpsertResult"];
	['...on LinkItemCreateResult']: '__union' & GraphQLTypes["LinkItemCreateResult"];
	['...on LinkItemDeleteResult']: '__union' & GraphQLTypes["LinkItemDeleteResult"];
	['...on LinkItemUpdateResult']: '__union' & GraphQLTypes["LinkItemUpdateResult"];
	['...on LinkItemUpsertResult']: '__union' & GraphQLTypes["LinkItemUpsertResult"];
	['...on SocialLinkListCreateResult']: '__union' & GraphQLTypes["SocialLinkListCreateResult"];
	['...on SocialLinkListDeleteResult']: '__union' & GraphQLTypes["SocialLinkListDeleteResult"];
	['...on SocialLinkListUpdateResult']: '__union' & GraphQLTypes["SocialLinkListUpdateResult"];
	['...on SocialLinkListUpsertResult']: '__union' & GraphQLTypes["SocialLinkListUpsertResult"];
	['...on SocialLinkItemCreateResult']: '__union' & GraphQLTypes["SocialLinkItemCreateResult"];
	['...on SocialLinkItemDeleteResult']: '__union' & GraphQLTypes["SocialLinkItemDeleteResult"];
	['...on SocialLinkItemUpdateResult']: '__union' & GraphQLTypes["SocialLinkItemUpdateResult"];
	['...on SocialLinkItemUpsertResult']: '__union' & GraphQLTypes["SocialLinkItemUpsertResult"];
	['...on PrimaryLinkItemCreateResult']: '__union' & GraphQLTypes["PrimaryLinkItemCreateResult"];
	['...on PrimaryLinkItemDeleteResult']: '__union' & GraphQLTypes["PrimaryLinkItemDeleteResult"];
	['...on PrimaryLinkItemUpdateResult']: '__union' & GraphQLTypes["PrimaryLinkItemUpdateResult"];
	['...on PrimaryLinkItemUpsertResult']: '__union' & GraphQLTypes["PrimaryLinkItemUpsertResult"];
	['...on HeaderLocaleCreateResult']: '__union' & GraphQLTypes["HeaderLocaleCreateResult"];
	['...on HeaderLocaleDeleteResult']: '__union' & GraphQLTypes["HeaderLocaleDeleteResult"];
	['...on HeaderLocaleUpdateResult']: '__union' & GraphQLTypes["HeaderLocaleUpdateResult"];
	['...on HeaderLocaleUpsertResult']: '__union' & GraphQLTypes["HeaderLocaleUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on FooterLocaleCreateResult']: '__union' & GraphQLTypes["FooterLocaleCreateResult"];
	['...on FooterLocaleDeleteResult']: '__union' & GraphQLTypes["FooterLocaleDeleteResult"];
	['...on FooterLocaleUpdateResult']: '__union' & GraphQLTypes["FooterLocaleUpdateResult"];
	['...on FooterLocaleUpsertResult']: '__union' & GraphQLTypes["FooterLocaleUpsertResult"];
	['...on FooterLinksCreateResult']: '__union' & GraphQLTypes["FooterLinksCreateResult"];
	['...on FooterLinksDeleteResult']: '__union' & GraphQLTypes["FooterLinksDeleteResult"];
	['...on FooterLinksUpdateResult']: '__union' & GraphQLTypes["FooterLinksUpdateResult"];
	['...on FooterLinksUpsertResult']: '__union' & GraphQLTypes["FooterLinksUpsertResult"];
	['...on FooterContactCreateResult']: '__union' & GraphQLTypes["FooterContactCreateResult"];
	['...on FooterContactDeleteResult']: '__union' & GraphQLTypes["FooterContactDeleteResult"];
	['...on FooterContactUpdateResult']: '__union' & GraphQLTypes["FooterContactUpdateResult"];
	['...on FooterContactUpsertResult']: '__union' & GraphQLTypes["FooterContactUpsertResult"];
	['...on TitleListCreateResult']: '__union' & GraphQLTypes["TitleListCreateResult"];
	['...on TitleListDeleteResult']: '__union' & GraphQLTypes["TitleListDeleteResult"];
	['...on TitleListUpdateResult']: '__union' & GraphQLTypes["TitleListUpdateResult"];
	['...on TitleListUpsertResult']: '__union' & GraphQLTypes["TitleListUpsertResult"];
	['...on TitleItemCreateResult']: '__union' & GraphQLTypes["TitleItemCreateResult"];
	['...on TitleItemDeleteResult']: '__union' & GraphQLTypes["TitleItemDeleteResult"];
	['...on TitleItemUpdateResult']: '__union' & GraphQLTypes["TitleItemUpdateResult"];
	['...on TitleItemUpsertResult']: '__union' & GraphQLTypes["TitleItemUpsertResult"];
	['...on SocialLinkCreateResult']: '__union' & GraphQLTypes["SocialLinkCreateResult"];
	['...on SocialLinkDeleteResult']: '__union' & GraphQLTypes["SocialLinkDeleteResult"];
	['...on SocialLinkUpdateResult']: '__union' & GraphQLTypes["SocialLinkUpdateResult"];
	['...on SocialLinkUpsertResult']: '__union' & GraphQLTypes["SocialLinkUpsertResult"];
	['...on SecondaryLinkListCreateResult']: '__union' & GraphQLTypes["SecondaryLinkListCreateResult"];
	['...on SecondaryLinkListDeleteResult']: '__union' & GraphQLTypes["SecondaryLinkListDeleteResult"];
	['...on SecondaryLinkListUpdateResult']: '__union' & GraphQLTypes["SecondaryLinkListUpdateResult"];
	['...on SecondaryLinkListUpsertResult']: '__union' & GraphQLTypes["SecondaryLinkListUpsertResult"];
	['...on SecondaryLinkItemCreateResult']: '__union' & GraphQLTypes["SecondaryLinkItemCreateResult"];
	['...on SecondaryLinkItemDeleteResult']: '__union' & GraphQLTypes["SecondaryLinkItemDeleteResult"];
	['...on SecondaryLinkItemUpdateResult']: '__union' & GraphQLTypes["SecondaryLinkItemUpdateResult"];
	['...on SecondaryLinkItemUpsertResult']: '__union' & GraphQLTypes["SecondaryLinkItemUpsertResult"];
	['...on RestaurantCreateResult']: '__union' & GraphQLTypes["RestaurantCreateResult"];
	['...on RestaurantDeleteResult']: '__union' & GraphQLTypes["RestaurantDeleteResult"];
	['...on RestaurantUpdateResult']: '__union' & GraphQLTypes["RestaurantUpdateResult"];
	['...on RestaurantUpsertResult']: '__union' & GraphQLTypes["RestaurantUpsertResult"];
	['...on RestaurantLocaleCreateResult']: '__union' & GraphQLTypes["RestaurantLocaleCreateResult"];
	['...on RestaurantLocaleDeleteResult']: '__union' & GraphQLTypes["RestaurantLocaleDeleteResult"];
	['...on RestaurantLocaleUpdateResult']: '__union' & GraphQLTypes["RestaurantLocaleUpdateResult"];
	['...on RestaurantLocaleUpsertResult']: '__union' & GraphQLTypes["RestaurantLocaleUpsertResult"];
	['...on TranslationDomainCreateResult']: '__union' & GraphQLTypes["TranslationDomainCreateResult"];
	['...on TranslationDomainDeleteResult']: '__union' & GraphQLTypes["TranslationDomainDeleteResult"];
	['...on TranslationDomainUpdateResult']: '__union' & GraphQLTypes["TranslationDomainUpdateResult"];
	['...on TranslationDomainUpsertResult']: '__union' & GraphQLTypes["TranslationDomainUpsertResult"];
	['...on TranslationCatalogueCreateResult']: '__union' & GraphQLTypes["TranslationCatalogueCreateResult"];
	['...on TranslationCatalogueDeleteResult']: '__union' & GraphQLTypes["TranslationCatalogueDeleteResult"];
	['...on TranslationCatalogueUpdateResult']: '__union' & GraphQLTypes["TranslationCatalogueUpdateResult"];
	['...on TranslationCatalogueUpsertResult']: '__union' & GraphQLTypes["TranslationCatalogueUpsertResult"];
	['...on TranslationCataloguesIdentifierCreateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierCreateResult"];
	['...on TranslationCataloguesIdentifierDeleteResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"];
	['...on TranslationCataloguesIdentifierUpdateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"];
	['...on TranslationCataloguesIdentifierUpsertResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"];
	['...on TranslationKeyCreateResult']: '__union' & GraphQLTypes["TranslationKeyCreateResult"];
	['...on TranslationKeyDeleteResult']: '__union' & GraphQLTypes["TranslationKeyDeleteResult"];
	['...on TranslationKeyUpdateResult']: '__union' & GraphQLTypes["TranslationKeyUpdateResult"];
	['...on TranslationKeyUpsertResult']: '__union' & GraphQLTypes["TranslationKeyUpsertResult"];
	['...on TranslationValueCreateResult']: '__union' & GraphQLTypes["TranslationValueCreateResult"];
	['...on TranslationValueDeleteResult']: '__union' & GraphQLTypes["TranslationValueDeleteResult"];
	['...on TranslationValueUpdateResult']: '__union' & GraphQLTypes["TranslationValueUpdateResult"];
	['...on TranslationValueUpsertResult']: '__union' & GraphQLTypes["TranslationValueUpsertResult"];
	['...on RestaurantItemCreateResult']: '__union' & GraphQLTypes["RestaurantItemCreateResult"];
	['...on RestaurantItemDeleteResult']: '__union' & GraphQLTypes["RestaurantItemDeleteResult"];
	['...on RestaurantItemUpdateResult']: '__union' & GraphQLTypes["RestaurantItemUpdateResult"];
	['...on RestaurantItemUpsertResult']: '__union' & GraphQLTypes["RestaurantItemUpsertResult"];
	['...on RestaurantTagCreateResult']: '__union' & GraphQLTypes["RestaurantTagCreateResult"];
	['...on RestaurantTagDeleteResult']: '__union' & GraphQLTypes["RestaurantTagDeleteResult"];
	['...on RestaurantTagUpdateResult']: '__union' & GraphQLTypes["RestaurantTagUpdateResult"];
	['...on RestaurantTagUpsertResult']: '__union' & GraphQLTypes["RestaurantTagUpsertResult"];
	['...on RestaurantTagLocaleCreateResult']: '__union' & GraphQLTypes["RestaurantTagLocaleCreateResult"];
	['...on RestaurantTagLocaleDeleteResult']: '__union' & GraphQLTypes["RestaurantTagLocaleDeleteResult"];
	['...on RestaurantTagLocaleUpdateResult']: '__union' & GraphQLTypes["RestaurantTagLocaleUpdateResult"];
	['...on RestaurantTagLocaleUpsertResult']: '__union' & GraphQLTypes["RestaurantTagLocaleUpsertResult"];
	['...on BannerCreateResult']: '__union' & GraphQLTypes["BannerCreateResult"];
	['...on BannerDeleteResult']: '__union' & GraphQLTypes["BannerDeleteResult"];
	['...on BannerUpdateResult']: '__union' & GraphQLTypes["BannerUpdateResult"];
	['...on BannerUpsertResult']: '__union' & GraphQLTypes["BannerUpsertResult"];
	['...on BannerLocaleCreateResult']: '__union' & GraphQLTypes["BannerLocaleCreateResult"];
	['...on BannerLocaleDeleteResult']: '__union' & GraphQLTypes["BannerLocaleDeleteResult"];
	['...on BannerLocaleUpdateResult']: '__union' & GraphQLTypes["BannerLocaleUpdateResult"];
	['...on BannerLocaleUpsertResult']: '__union' & GraphQLTypes["BannerLocaleUpsertResult"];
	['...on CategoryCreateResult']: '__union' & GraphQLTypes["CategoryCreateResult"];
	['...on CategoryDeleteResult']: '__union' & GraphQLTypes["CategoryDeleteResult"];
	['...on CategoryUpdateResult']: '__union' & GraphQLTypes["CategoryUpdateResult"];
	['...on CategoryUpsertResult']: '__union' & GraphQLTypes["CategoryUpsertResult"];
	['...on CategoryLocaleCreateResult']: '__union' & GraphQLTypes["CategoryLocaleCreateResult"];
	['...on CategoryLocaleDeleteResult']: '__union' & GraphQLTypes["CategoryLocaleDeleteResult"];
	['...on CategoryLocaleUpdateResult']: '__union' & GraphQLTypes["CategoryLocaleUpdateResult"];
	['...on CategoryLocaleUpsertResult']: '__union' & GraphQLTypes["CategoryLocaleUpsertResult"];
	['...on SubRestaurantsPageCreateResult']: '__union' & GraphQLTypes["SubRestaurantsPageCreateResult"];
	['...on SubRestaurantsPageDeleteResult']: '__union' & GraphQLTypes["SubRestaurantsPageDeleteResult"];
	['...on SubRestaurantsPageUpdateResult']: '__union' & GraphQLTypes["SubRestaurantsPageUpdateResult"];
	['...on SubRestaurantsPageUpsertResult']: '__union' & GraphQLTypes["SubRestaurantsPageUpsertResult"];
	['...on SubRestaurantsPageLocaleCreateResult']: '__union' & GraphQLTypes["SubRestaurantsPageLocaleCreateResult"];
	['...on SubRestaurantsPageLocaleDeleteResult']: '__union' & GraphQLTypes["SubRestaurantsPageLocaleDeleteResult"];
	['...on SubRestaurantsPageLocaleUpdateResult']: '__union' & GraphQLTypes["SubRestaurantsPageLocaleUpdateResult"];
	['...on SubRestaurantsPageLocaleUpsertResult']: '__union' & GraphQLTypes["SubRestaurantsPageLocaleUpsertResult"];
	['...on ImageListCreateResult']: '__union' & GraphQLTypes["ImageListCreateResult"];
	['...on ImageListDeleteResult']: '__union' & GraphQLTypes["ImageListDeleteResult"];
	['...on ImageListUpdateResult']: '__union' & GraphQLTypes["ImageListUpdateResult"];
	['...on ImageListUpsertResult']: '__union' & GraphQLTypes["ImageListUpsertResult"];
	['...on ImageListItemCreateResult']: '__union' & GraphQLTypes["ImageListItemCreateResult"];
	['...on ImageListItemDeleteResult']: '__union' & GraphQLTypes["ImageListItemDeleteResult"];
	['...on ImageListItemUpdateResult']: '__union' & GraphQLTypes["ImageListItemUpdateResult"];
	['...on ImageListItemUpsertResult']: '__union' & GraphQLTypes["ImageListItemUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["FrontPageDeleteResult"]: {
	__typename: "FrontPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"]
};
	["FrontPageUpdateResult"]: {
	__typename: "FrontPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FrontPageUpsertResult"]: {
	__typename: "FrontPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"]
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
	__typename: "LocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
	__typename: "LocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"]
};
	["LocaleUpdateResult"]: {
	__typename: "LocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
	__typename: "LocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FrontPageLocaleCreateResult"]: {
	__typename: "FrontPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FrontPageLocaleDeleteResult"]: {
	__typename: "FrontPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPageLocale"]
};
	["FrontPageLocaleUpdateResult"]: {
	__typename: "FrontPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FrontPageLocaleUpsertResult"]: {
	__typename: "FrontPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FrontPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListCreateResult"]: {
	__typename: "LinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListDeleteResult"]: {
	__typename: "LinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"]
};
	["LinkListUpdateResult"]: {
	__typename: "LinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkListUpsertResult"]: {
	__typename: "LinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemCreateResult"]: {
	__typename: "LinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemDeleteResult"]: {
	__typename: "LinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"]
};
	["LinkItemUpdateResult"]: {
	__typename: "LinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkItemUpsertResult"]: {
	__typename: "LinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListCreateResult"]: {
	__typename: "SocialLinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListDeleteResult"]: {
	__typename: "SocialLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"]
};
	["SocialLinkListUpdateResult"]: {
	__typename: "SocialLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListUpsertResult"]: {
	__typename: "SocialLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemCreateResult"]: {
	__typename: "SocialLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemDeleteResult"]: {
	__typename: "SocialLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"]
};
	["SocialLinkItemUpdateResult"]: {
	__typename: "SocialLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemUpsertResult"]: {
	__typename: "SocialLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrimaryLinkItemCreateResult"]: {
	__typename: "PrimaryLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrimaryLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrimaryLinkItemDeleteResult"]: {
	__typename: "PrimaryLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrimaryLinkItem"]
};
	["PrimaryLinkItemUpdateResult"]: {
	__typename: "PrimaryLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrimaryLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PrimaryLinkItemUpsertResult"]: {
	__typename: "PrimaryLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PrimaryLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
	__typename: "HeaderLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
	__typename: "HeaderLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"]
};
	["HeaderLocaleUpdateResult"]: {
	__typename: "HeaderLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
	__typename: "HeaderLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"]
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
	__typename: "FooterLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
	__typename: "FooterLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"]
};
	["FooterLocaleUpdateResult"]: {
	__typename: "FooterLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
	__typename: "FooterLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinksCreateResult"]: {
	__typename: "FooterLinksCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinks"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinksDeleteResult"]: {
	__typename: "FooterLinksDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinks"]
};
	["FooterLinksUpdateResult"]: {
	__typename: "FooterLinksUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinks"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLinksUpsertResult"]: {
	__typename: "FooterLinksUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLinks"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterContactCreateResult"]: {
	__typename: "FooterContactCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterContact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterContactDeleteResult"]: {
	__typename: "FooterContactDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterContact"]
};
	["FooterContactUpdateResult"]: {
	__typename: "FooterContactUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterContact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterContactUpsertResult"]: {
	__typename: "FooterContactUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterContact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TitleListCreateResult"]: {
	__typename: "TitleListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TitleListDeleteResult"]: {
	__typename: "TitleListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleList"]
};
	["TitleListUpdateResult"]: {
	__typename: "TitleListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TitleListUpsertResult"]: {
	__typename: "TitleListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TitleItemCreateResult"]: {
	__typename: "TitleItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TitleItemDeleteResult"]: {
	__typename: "TitleItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleItem"]
};
	["TitleItemUpdateResult"]: {
	__typename: "TitleItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TitleItemUpsertResult"]: {
	__typename: "TitleItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TitleItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
	__typename: "SocialLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
	__typename: "SocialLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
	__typename: "SocialLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
	__typename: "SocialLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SecondaryLinkListCreateResult"]: {
	__typename: "SecondaryLinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SecondaryLinkListDeleteResult"]: {
	__typename: "SecondaryLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkList"]
};
	["SecondaryLinkListUpdateResult"]: {
	__typename: "SecondaryLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SecondaryLinkListUpsertResult"]: {
	__typename: "SecondaryLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SecondaryLinkItemCreateResult"]: {
	__typename: "SecondaryLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SecondaryLinkItemDeleteResult"]: {
	__typename: "SecondaryLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkItem"]
};
	["SecondaryLinkItemUpdateResult"]: {
	__typename: "SecondaryLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SecondaryLinkItemUpsertResult"]: {
	__typename: "SecondaryLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SecondaryLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantCreateResult"]: {
	__typename: "RestaurantCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Restaurant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantDeleteResult"]: {
	__typename: "RestaurantDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Restaurant"]
};
	["RestaurantUpdateResult"]: {
	__typename: "RestaurantUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Restaurant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantUpsertResult"]: {
	__typename: "RestaurantUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Restaurant"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantLocaleCreateResult"]: {
	__typename: "RestaurantLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantLocaleDeleteResult"]: {
	__typename: "RestaurantLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantLocale"]
};
	["RestaurantLocaleUpdateResult"]: {
	__typename: "RestaurantLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantLocaleUpsertResult"]: {
	__typename: "RestaurantLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
	__typename: "TranslationDomainCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
	__typename: "TranslationDomainDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"]
};
	["TranslationDomainUpdateResult"]: {
	__typename: "TranslationDomainUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
	__typename: "TranslationDomainUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
	__typename: "TranslationCatalogueCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
	__typename: "TranslationCatalogueDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"]
};
	["TranslationCatalogueUpdateResult"]: {
	__typename: "TranslationCatalogueUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
	__typename: "TranslationCatalogueUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
	__typename: "TranslationCataloguesIdentifierCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
	__typename: "TranslationCataloguesIdentifierDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
	__typename: "TranslationCataloguesIdentifierUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
	__typename: "TranslationCataloguesIdentifierUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
	__typename: "TranslationKeyCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
	__typename: "TranslationKeyDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"]
};
	["TranslationKeyUpdateResult"]: {
	__typename: "TranslationKeyUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
	__typename: "TranslationKeyUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
	__typename: "TranslationValueCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
	__typename: "TranslationValueDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"]
};
	["TranslationValueUpdateResult"]: {
	__typename: "TranslationValueUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
	__typename: "TranslationValueUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantItemCreateResult"]: {
	__typename: "RestaurantItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantItemDeleteResult"]: {
	__typename: "RestaurantItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantItem"]
};
	["RestaurantItemUpdateResult"]: {
	__typename: "RestaurantItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantItemUpsertResult"]: {
	__typename: "RestaurantItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantTagCreateResult"]: {
	__typename: "RestaurantTagCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantTagDeleteResult"]: {
	__typename: "RestaurantTagDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTag"]
};
	["RestaurantTagUpdateResult"]: {
	__typename: "RestaurantTagUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantTagUpsertResult"]: {
	__typename: "RestaurantTagUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTag"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantTagLocaleCreateResult"]: {
	__typename: "RestaurantTagLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTagLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantTagLocaleDeleteResult"]: {
	__typename: "RestaurantTagLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTagLocale"]
};
	["RestaurantTagLocaleUpdateResult"]: {
	__typename: "RestaurantTagLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTagLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RestaurantTagLocaleUpsertResult"]: {
	__typename: "RestaurantTagLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["RestaurantTagLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BannerCreateResult"]: {
	__typename: "BannerCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Banner"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BannerDeleteResult"]: {
	__typename: "BannerDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Banner"]
};
	["BannerUpdateResult"]: {
	__typename: "BannerUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Banner"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BannerUpsertResult"]: {
	__typename: "BannerUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Banner"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BannerLocaleCreateResult"]: {
	__typename: "BannerLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BannerLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BannerLocaleDeleteResult"]: {
	__typename: "BannerLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BannerLocale"]
};
	["BannerLocaleUpdateResult"]: {
	__typename: "BannerLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BannerLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BannerLocaleUpsertResult"]: {
	__typename: "BannerLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BannerLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryCreateResult"]: {
	__typename: "CategoryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryDeleteResult"]: {
	__typename: "CategoryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"]
};
	["CategoryUpdateResult"]: {
	__typename: "CategoryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryUpsertResult"]: {
	__typename: "CategoryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Category"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryLocaleCreateResult"]: {
	__typename: "CategoryLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CategoryLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryLocaleDeleteResult"]: {
	__typename: "CategoryLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CategoryLocale"]
};
	["CategoryLocaleUpdateResult"]: {
	__typename: "CategoryLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CategoryLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["CategoryLocaleUpsertResult"]: {
	__typename: "CategoryLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["CategoryLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubRestaurantsPageCreateResult"]: {
	__typename: "SubRestaurantsPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubRestaurantsPageDeleteResult"]: {
	__typename: "SubRestaurantsPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPage"]
};
	["SubRestaurantsPageUpdateResult"]: {
	__typename: "SubRestaurantsPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubRestaurantsPageUpsertResult"]: {
	__typename: "SubRestaurantsPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubRestaurantsPageLocaleCreateResult"]: {
	__typename: "SubRestaurantsPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubRestaurantsPageLocaleDeleteResult"]: {
	__typename: "SubRestaurantsPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPageLocale"]
};
	["SubRestaurantsPageLocaleUpdateResult"]: {
	__typename: "SubRestaurantsPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SubRestaurantsPageLocaleUpsertResult"]: {
	__typename: "SubRestaurantsPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SubRestaurantsPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListCreateResult"]: {
	__typename: "ImageListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListDeleteResult"]: {
	__typename: "ImageListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"]
};
	["ImageListUpdateResult"]: {
	__typename: "ImageListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListUpsertResult"]: {
	__typename: "ImageListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemCreateResult"]: {
	__typename: "ImageListItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemDeleteResult"]: {
	__typename: "ImageListItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"]
};
	["ImageListItemUpdateResult"]: {
	__typename: "ImageListItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageListItemUpsertResult"]: {
	__typename: "ImageListItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ImageListItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createFrontPage: GraphQLTypes["FrontPageCreateResult"],
	deleteFrontPage: GraphQLTypes["FrontPageDeleteResult"],
	updateFrontPage: GraphQLTypes["FrontPageUpdateResult"],
	upsertFrontPage: GraphQLTypes["FrontPageUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createFrontPageLocale: GraphQLTypes["FrontPageLocaleCreateResult"],
	deleteFrontPageLocale: GraphQLTypes["FrontPageLocaleDeleteResult"],
	updateFrontPageLocale: GraphQLTypes["FrontPageLocaleUpdateResult"],
	upsertFrontPageLocale: GraphQLTypes["FrontPageLocaleUpsertResult"],
	createLinkList: GraphQLTypes["LinkListCreateResult"],
	deleteLinkList: GraphQLTypes["LinkListDeleteResult"],
	updateLinkList: GraphQLTypes["LinkListUpdateResult"],
	upsertLinkList: GraphQLTypes["LinkListUpsertResult"],
	createLinkItem: GraphQLTypes["LinkItemCreateResult"],
	deleteLinkItem: GraphQLTypes["LinkItemDeleteResult"],
	updateLinkItem: GraphQLTypes["LinkItemUpdateResult"],
	upsertLinkItem: GraphQLTypes["LinkItemUpsertResult"],
	createSocialLinkList: GraphQLTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList: GraphQLTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList: GraphQLTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList: GraphQLTypes["SocialLinkListUpsertResult"],
	createSocialLinkItem: GraphQLTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem: GraphQLTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem: GraphQLTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem: GraphQLTypes["SocialLinkItemUpsertResult"],
	createPrimaryLinkItem: GraphQLTypes["PrimaryLinkItemCreateResult"],
	deletePrimaryLinkItem: GraphQLTypes["PrimaryLinkItemDeleteResult"],
	updatePrimaryLinkItem: GraphQLTypes["PrimaryLinkItemUpdateResult"],
	upsertPrimaryLinkItem: GraphQLTypes["PrimaryLinkItemUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createFooterLinks: GraphQLTypes["FooterLinksCreateResult"],
	deleteFooterLinks: GraphQLTypes["FooterLinksDeleteResult"],
	updateFooterLinks: GraphQLTypes["FooterLinksUpdateResult"],
	upsertFooterLinks: GraphQLTypes["FooterLinksUpsertResult"],
	createFooterContact: GraphQLTypes["FooterContactCreateResult"],
	deleteFooterContact: GraphQLTypes["FooterContactDeleteResult"],
	updateFooterContact: GraphQLTypes["FooterContactUpdateResult"],
	upsertFooterContact: GraphQLTypes["FooterContactUpsertResult"],
	createTitleList: GraphQLTypes["TitleListCreateResult"],
	deleteTitleList: GraphQLTypes["TitleListDeleteResult"],
	updateTitleList: GraphQLTypes["TitleListUpdateResult"],
	upsertTitleList: GraphQLTypes["TitleListUpsertResult"],
	createTitleItem: GraphQLTypes["TitleItemCreateResult"],
	deleteTitleItem: GraphQLTypes["TitleItemDeleteResult"],
	updateTitleItem: GraphQLTypes["TitleItemUpdateResult"],
	upsertTitleItem: GraphQLTypes["TitleItemUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createSecondaryLinkList: GraphQLTypes["SecondaryLinkListCreateResult"],
	deleteSecondaryLinkList: GraphQLTypes["SecondaryLinkListDeleteResult"],
	updateSecondaryLinkList: GraphQLTypes["SecondaryLinkListUpdateResult"],
	upsertSecondaryLinkList: GraphQLTypes["SecondaryLinkListUpsertResult"],
	createSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemCreateResult"],
	deleteSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemDeleteResult"],
	updateSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemUpdateResult"],
	upsertSecondaryLinkItem: GraphQLTypes["SecondaryLinkItemUpsertResult"],
	createRestaurant: GraphQLTypes["RestaurantCreateResult"],
	deleteRestaurant: GraphQLTypes["RestaurantDeleteResult"],
	updateRestaurant: GraphQLTypes["RestaurantUpdateResult"],
	upsertRestaurant: GraphQLTypes["RestaurantUpsertResult"],
	createRestaurantLocale: GraphQLTypes["RestaurantLocaleCreateResult"],
	deleteRestaurantLocale: GraphQLTypes["RestaurantLocaleDeleteResult"],
	updateRestaurantLocale: GraphQLTypes["RestaurantLocaleUpdateResult"],
	upsertRestaurantLocale: GraphQLTypes["RestaurantLocaleUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createRestaurantItem: GraphQLTypes["RestaurantItemCreateResult"],
	deleteRestaurantItem: GraphQLTypes["RestaurantItemDeleteResult"],
	updateRestaurantItem: GraphQLTypes["RestaurantItemUpdateResult"],
	upsertRestaurantItem: GraphQLTypes["RestaurantItemUpsertResult"],
	createRestaurantTag: GraphQLTypes["RestaurantTagCreateResult"],
	deleteRestaurantTag: GraphQLTypes["RestaurantTagDeleteResult"],
	updateRestaurantTag: GraphQLTypes["RestaurantTagUpdateResult"],
	upsertRestaurantTag: GraphQLTypes["RestaurantTagUpsertResult"],
	createRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleCreateResult"],
	deleteRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleDeleteResult"],
	updateRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleUpdateResult"],
	upsertRestaurantTagLocale: GraphQLTypes["RestaurantTagLocaleUpsertResult"],
	createBanner: GraphQLTypes["BannerCreateResult"],
	deleteBanner: GraphQLTypes["BannerDeleteResult"],
	updateBanner: GraphQLTypes["BannerUpdateResult"],
	upsertBanner: GraphQLTypes["BannerUpsertResult"],
	createBannerLocale: GraphQLTypes["BannerLocaleCreateResult"],
	deleteBannerLocale: GraphQLTypes["BannerLocaleDeleteResult"],
	updateBannerLocale: GraphQLTypes["BannerLocaleUpdateResult"],
	upsertBannerLocale: GraphQLTypes["BannerLocaleUpsertResult"],
	createCategory: GraphQLTypes["CategoryCreateResult"],
	deleteCategory: GraphQLTypes["CategoryDeleteResult"],
	updateCategory: GraphQLTypes["CategoryUpdateResult"],
	upsertCategory: GraphQLTypes["CategoryUpsertResult"],
	createCategoryLocale: GraphQLTypes["CategoryLocaleCreateResult"],
	deleteCategoryLocale: GraphQLTypes["CategoryLocaleDeleteResult"],
	updateCategoryLocale: GraphQLTypes["CategoryLocaleUpdateResult"],
	upsertCategoryLocale: GraphQLTypes["CategoryLocaleUpsertResult"],
	createSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageCreateResult"],
	deleteSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageDeleteResult"],
	updateSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageUpdateResult"],
	upsertSubRestaurantsPage: GraphQLTypes["SubRestaurantsPageUpsertResult"],
	createSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleCreateResult"],
	deleteSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleDeleteResult"],
	updateSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleUpdateResult"],
	upsertSubRestaurantsPageLocale: GraphQLTypes["SubRestaurantsPageLocaleUpsertResult"],
	createImageList: GraphQLTypes["ImageListCreateResult"],
	deleteImageList: GraphQLTypes["ImageListDeleteResult"],
	updateImageList: GraphQLTypes["ImageListUpdateResult"],
	upsertImageList: GraphQLTypes["ImageListUpsertResult"],
	createImageListItem: GraphQLTypes["ImageListItemCreateResult"],
	deleteImageListItem: GraphQLTypes["ImageListItemDeleteResult"],
	updateImageListItem: GraphQLTypes["ImageListItemUpdateResult"],
	upsertImageListItem: GraphQLTypes["ImageListItemUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean
};
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum One {
	One = "One"
}
export const enum SocialLinkType {
	Facebook = "Facebook",
	Instagram = "Instagram"
}
export const enum LinkType {
	internal = "internal",
	external = "external"
}
export const enum IconType {
	shoppingBag = "shoppingBag",
	arrow = "arrow"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export const enum TranslationContentType {
	textPlain = "textPlain",
	textHtml = "textHtml"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: boolean;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends boolean ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends boolean ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type SubscriptionToGraphQL<Z, T> = {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?: string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => any;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

export const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});


export const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };



const allOperations = {
    "query": "Query",
    "mutation": "Mutation"
}

export type GenericOperation<O> = O extends 'query'
  ? "Query"
  : O extends 'mutation'
  ? "Mutation"
  : never

export const Thunder = (fn: FetchFunction) => <
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(o: Z | ValueTypes[R], ops?: OperationOptions) =>
  fullChainConstruct(fn)(operation, allOperations[operation])(o as any, ops) as Promise<InputType<GraphQLTypes[R], Z>>;

export const Chain = (...options: chainOptions) => Thunder(apiFetch(options));  
  
export const SubscriptionThunder = (fn: SubscriptionFunction) => <
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
) => <Z extends ValueTypes[R]>(
  o: Z | ValueTypes[R],
  ops?: OperationOptions
)=>
  fullSubscriptionConstruct(fn)(operation, allOperations[operation])(
    o as any,
    ops,
  ) as SubscriptionToGraphQL<Z, GraphQLTypes[R]>;

export const Subscription = (...options: chainOptions) => SubscriptionThunder(apiSubscription(options));
export const Zeus = <
  Z extends ValueTypes[R],
  O extends 'query' | 'mutation',
  R extends keyof ValueTypes = GenericOperation<O>
>(
  operation: O,
  o: Z | ValueTypes[R],
  operationName?: string,
) => queryConstruct(operation, allOperations[operation], operationName)(o as any);
export const Selector = <T extends keyof ValueTypes>(key: T) => ZeusSelect<ValueTypes[T]>();
  
export type FragmentResult<K extends keyof GraphQLTypes, Q extends unknown | ((...args: any[]) => unknown)> = InputType<
	GraphQLTypes[K],
	Q extends (...args: any[]) => unknown ? ReturnType<Q> : Q
>